export const nl = {
  // Navigation — the worlds in the bar (docs/navigatie-design-briefing-ronde2.md)
  "nav.world.today": "Vandaag",
  "nav.world.transport": "Transport",
  "nav.world.resources": "Resources",
  "nav.world.organizations": "Organisaties",
  "nav.world.warehouse": "Warehouse",
  "nav.world.commerce": "Commercie",
  "nav.world.finance": "Finance",
  "nav.world.admin": "Beheer",
  "nav.worldsLabel": "Werelden",
  "nav.backTo": "Terug naar {{module}}",
  "nav.comingSoon": "binnenkort",
  "nav.placeholderTitle": "{{module}} wordt nog gebouwd",
  // Navigation — your favourites in the bar, one click away (29-10-2026)
  "nav.favorites": "Favorieten",
  "nav.favoriteAdd": "Aan favorieten toevoegen",
  "nav.favoriteRemove": "Uit favorieten halen",
  "nav.favoritesFull": "Je hebt al {{count}} favorieten: haal er eerst een weg",
  "nav.favoritesHint": "Zet een ster bij een scherm in het menu, dan staat het hier",
  "nav.favoriteDragHint": "{{screen}} — sleep om de volgorde te veranderen",
  // Navigation — the menu of a world: its subjects, what waits and the lists, its setup
  "nav.setup": "Inrichting",
  "nav.waiting": "{{count}} wachten",
  "nav.group.orders": "Orders",
  "nav.group.planning": "Planning",
  "nav.group.documents": "Documenten",
  "nav.group.resources": "Resources",
  "nav.group.execution": "Uitvoering",
  "nav.group.stock": "Voorraad",
  "nav.group.relations": "Relaties",
  "nav.group.locations": "Locaties",
  "nav.group.invoicing": "Facturatie",
  "nav.group.prices": "Prijzen",
  "nav.group.purchasing": "Inkoop",
  "nav.group.system": "Systeem",
  "nav.group.project": "Project",
  "nav.orderIntake": "Orderintake",
  "nav.ordersBlocked": "Aandacht nodig",
  "nav.ordersPrenotify": "Aanmelden",
  "nav.ordersPrices": "Prijs akkoord",
  "nav.transportOrders": "Transportorders",
  "nav.ordersDrafts": "Concepten",
  "nav.scanInbox": "Scans zonder zending",
  "nav.allDocuments": "Alle documenten",
  // Navigation — the modules
  "nav.dashboard": "Dagstart",
  "nav.dossiers": "Dossiers",
  "nav.documents": "Documenten",
  "nav.palletCheck": "Palletcontrole",
  "nav.documentCheck": "Documentcontrole",
  "nav.reservations": "Reserveren",
  "nav.tasks": "Taken",
  "nav.mail": "Mail",
  "nav.calendar": "Agenda",
  "nav.users": "Gebruikers",
  "nav.orders": "Orders",
  "nav.warehouseOrders": "Magazijnorders",
  "nav.standingOrders": "Vaste orders",
  "nav.carryOver": "Doorzetten",
  "carryOver.tab.notIn": "Niet binnen",
  "carryOver.tab.done": "Doorgezet",
  "carryOver.unloadDay": "Losdag",
  "carryOver.intro": "De Hager-orders voor deze losdag waarvan niet alle colli in Haps binnen zijn gescand. Is er niets binnen en niets manco, dan gaat de hele order naar de volgende leverdag; anders gaan de colli die niet binnen zijn naar een nieuwe order, en blijft de rest op deze dag. Een collo dat bij de ontvangst manco is gemeld, gaat niet mee.",
  "carryOver.carry_one": "{{count}} order doorzetten",
  "carryOver.carry_other": "{{count}} orders doorzetten",
  "carryOver.busy": "Bezig met doorzetten…",
  "carryOver.pickAll": "Alles aanvinken",
  "carryOver.col.order": "Order",
  "carryOver.col.reference": "Referentie",
  "carryOver.col.in": "Binnen",
  "carryOver.col.missing": "Niet binnen",
  "carryOver.col.trip": "Rit",
  "carryOver.col.kind": "Doorzetten",
  "carryOver.col.toDay": "Naar losdag",
  "carryOver.col.place": "Afnemer",
  "carryOver.col.colli": "Colli",
  "carryOver.col.manco": "Manco",
  "carryOver.mancosAt": "Manco's uit Scoretrace bijgewerkt om {{at}}; die blijven op de order.",
  "carryOver.mancosNever": "Nog geen manco's uit Scoretrace ontvangen.",
  "carryOver.inOf": "{{in}} van {{total}}",
  "carryOver.more": "+{{count}}",
  "carryOver.kind.order": "Hele order",
  "carryOver.kind.split": "Deel naar nieuwe order",
  "carryOver.deliveryDays": "Levert op {{days}}",
  "carryOver.none": "Alles van Hager voor {{day}} is binnen.",
  "carryOver.result_one": "{{count}} order doorgezet, {{colli}} colli.",
  "carryOver.result_other": "{{count}} orders doorgezet, {{colli}} colli.",
  "carryOver.resultSplit": "{{number}}: {{colli}} colli naar {{newNumber}}, {{day}}",
  "carryOver.resultMoved": "{{number}}: hele order naar {{day}}",
  "carryOver.resultSkipped": "{{number}} niet doorgezet: {{reason}}",
  "carryOver.reason.all_in": "alles is inmiddels binnen",
  "carryOver.reason.not_on_day": "de order lost niet meer op deze dag",
  "carryOver.reason.closed": "de order is afgesloten",
  "carryOver.reason.to_day_not_after": "de nieuwe losdag ligt niet na deze dag",
  "carryOver.reason.colli_changed": "er is intussen een collo binnen gescand; probeer het opnieuw",
  "carryOver.reason.failed": "er ging iets mis",
  "carryOver.mailedTo": "Gemaild aan {{to}}",
  "carryOver.notMailed": "Niet gemaild (geen adres ingesteld)",
  "carryOver.mailFailed": "Mail niet gelukt: {{error}}",
  "carryOver.showDone": "Bekijk wat er is doorgezet",
  "carryOver.doneIntro": "Wat er de afgelopen twee weken is doorgezet, per keer. De csv is wat het magazijn in Haps kreeg.",
  "carryOver.noneDone": "Er is nog niets doorgezet.",
  "carryOver.batchTitle": "Losdag {{day}}",
  "carryOver.batchBy": "{{at}} door {{by}} · {{orders}} orders · {{colli}} colli",
  "carryOver.mailAgain": "Opnieuw mailen",
  "carryOver.csv": "Csv",
  "nav.planning": "Planbord",
  "nav.trips": "Ritten",
  "nav.tracking": "Ritopvolging",
  "nav.exceptions": "Afwijkingen",
  "nav.drivers": "Chauffeurs",
  "nav.transportUnits": "Transportmiddelen",
  "nav.locations": "Locaties",
  "nav.mailboxes": "Postvakken",
  "nav.resources": "Reserveringsbronnen",
  "nav.taskCategories": "Taakcategorieën",
  "nav.focusAreas": "Aandachtsgebieden",
  "focus.empty": "Nog geen aandachtsgebieden — iedereen ziet alle mail.",
  "focus.create": "Aandachtsgebied toevoegen",
  "focus.nameLabel": "Naam aandachtsgebied",
  "focus.namePlaceholder": "bijv. Customer service 1",
  "focus.delete": "Verwijderen",
  "focus.deleteConfirm": "Dit aandachtsgebied verwijderen? De toegewezen domeinen staan daarna weer in ieders lijst.",
  "error.crashTitle": "Er ging iets mis",
  "error.crashBody":
    "Dit scherm kon niet worden geladen. Probeer het opnieuw, of ga terug naar de start. Blijft het gebeuren, geef dan even door wat je deed.",
  "error.notFoundTitle": "Deze pagina bestaat niet",
  "error.notFoundBody": "Misschien is de link verouderd of staat er een typefout in het adres.",
  "error.backToStart": "Naar de start",
  "error.reload": "Opnieuw proberen",
  "focus.noMembersWarning":
    "Niemand toegewezen. De domeinen hieronder filteren daarom niets: die mail blijft bij iedereen in de lijst staan.",
  "focus.noRulesWarning": "Geen domeinen toegewezen. Wie dit gebied kiest ziet alles behalve wat aan de ándere gebieden hangt.",
  "focus.members": "Wie mag hierin werken",
  "focus.noMembers": "Nog niemand toegewezen.",
  "focus.addMemberLabel": "Medewerker toevoegen",
  "focus.addMemberPlaceholder": "Kies een medewerker…",
  "focus.add": "Toevoegen",
  "focus.rules": "Domeinen & adressen",
  "focus.noRules": "Nog geen domeinen toegewezen.",
  "focus.rulePlaceholder": "bijv. axxent.nl of jan@klant.nl",
  "focus.addRuleLabel": "Domein of adres toevoegen",
  "focus.removeRule": "Verwijder {{pattern}}",
  "focus.kindDomain": "domein",
  "focus.kindAddress": "adres",
  "nav.performance": "Snelheid",
  "perf.since": "Gemeten sinds {{when}} (sinds de API draait of sinds Opnieuw beginnen)",
  "perf.over_one": "{{count}} route over zijn budget",
  "perf.over_other": "{{count}} routes over hun budget",
  "perf.allWithin": "alles binnen het budget",
  "perf.search": "Zoek een route",
  "perf.reset": "Opnieuw beginnen",
  "perf.col.route": "Route",
  "perf.col.count": "Aanroepen",
  "perf.col.average": "Gemiddeld",
  "perf.col.p50": "Mediaan",
  "perf.col.p95": "95%",
  "perf.col.max": "Traagst",
  "perf.col.budget": "Budget",
  "perf.col.slow": "Te traag",
  "perf.none": "Nog niets gemeten.",
  "perf.slowRequests": "Laatste trage aanroepen",
  "perf.slowQueries": "Laatste trage databasequeries (boven 200 ms)",
  "perf.noSlowRequests": "Geen aanroep boven zijn budget.",
  "perf.noSlowQueries": "Geen trage query.",
  "perf.footnote": "Budget: de scanner 200 ms (onder 200 ms toont hij geen laadbalk), de rest een seconde. De mediaan en 95% zijn bovengrenzen uit vaste stappen. Elk API-proces meet voor zich; na een herstart begint het opnieuw. Trage aanroepen en queries staan ook als waarschuwing in het log.",
  "nav.permissions": "Rechten",
  "nav.parties": "Relaties",
  "nav.branches": "Vestigingen",
  "nav.integrations": "Koppelingen",
  // Permissions matrix (Beheer → Rechten)
  "perm.modDashboard": "Dagstart",
  "perm.modMail": "Mail",
  "perm.modMailPersonal": "Eigen postvak",
  "perm.modCalendar": "Agenda",
  "perm.modTasks": "Taken",
  "perm.modReservations": "Reserveren",
  "perm.modParties": "Relaties",
  "perm.modDossiers": "Dossiers",
  "perm.modDocuments": "Documenten",
  "perm.modRequirements": "Requirements",
  "perm.modAi": "AI-hulpjes",
  "perm.modWorklists": "Werklijsten",
  "perm.modTmsLocations": "Locaties",
  "perm.modTmsDrivers": "Chauffeurs",
  "perm.modTmsTransportUnits": "Transportmiddelen",
  "perm.modTmsResourcesWrite": "Resources beheren",
  "perm.colPart": "Onderdeel",
  "perm.search": "Zoek een onderdeel",
  "perm.worldLabel": "Wereld",
  "perm.group.all": "Alles",
  "perm.group.other": "Overig",
  "perm.none": "Geen onderdeel gevonden.",
  "perm.level.read": "Bekijken",
  "perm.level.write": "Wijzigen",
  "perm.writeImpliesRead": "Wijzigen geeft ook Bekijken.",
  "perm.adminAll": "altijd alles",
  "perm.row.orders": "Orders",
  "perm.row.planning": "Planbord en ritten",
  "perm.row.stock": "Voorraad",
  "perm.row.stockBook": "Afboeken en ophogen",
  "perm.row.inbound": "Ontvangsten",
  "perm.row.outbound": "Orders en verzending",
  "perm.row.crossdock": "Crossdock",
  "perm.row.masterdata": "Plekken en artikelen",
  "perm.hint.mail": "De gedeelde postvakken waar iemand lid van is",
  "perm.hint.mailPersonal": "Het eigen Outlook-postvak en de agenda koppelen",
  "perm.hint.orders": "Wijzigen: invoeren, accepteren en afwijzen",
  "perm.hint.planning": "Wijzigen: ritten maken en zendingen erop plannen",
  "perm.hint.resourcesWrite": "Transportmiddelen aanmaken en wijzigen, en bij chauffeurs de bevoegdheden",
  "perm.hint.parties": "Wijzigen: de velden die WLX zelf beheert; de rest komt uit AFAS",
  "perm.hint.stock": "Wijzigen: pallets blokkeren en vrijgeven, aantallen aanpassen en lost & found",
  "perm.hint.stockBook": "De voorraad van de klant wijzigen: afboeken en ophogen, met de reden voor de klant",
  "perm.hint.inbound": "Wijzigen: aanmelden, afsluiten en de eigen labels",
  "perm.hint.outbound": "Wijzigen: adres koppelen, annuleren, verzendvorm en vervoerder",
  "perm.hint.crossdock": "Wijzigen: dock, gelost en geladen",
  "perm.hint.masterdata": "Wijzigen: plekken en artikelen toevoegen en blokkeren; de instellingen blijven voor admins",
  "perm.hint.scanner": "Inloggen en scannen in de scanner-app",
  "perm.hint.scannerLogins": "Wachtwoord opnieuw, blokkeren en uitzetten; aanmaken doet nu alleen een admin",
  "perm.hint.partnerUsers": "Mensen van een klant uitnodigen voor het klantenportaal, hun toegang opnieuw instellen en uitzetten (tab Portaal op een relatie)",
  "perm.toggleLabel": "{{role}} toegang tot {{module}}",
  "perm.footnote":
    "Beheerfuncties (gebruikers, rechten, postvakken, ruimtes) blijven altijd alleen voor admins. Mail en taken van een gedeeld postvak vereisen daarnaast lidmaatschap van dat postvak.",
  "nav.requirements": "Requirements",
  "nav.worklists": "Werklijsten",
  "nav.diesel": "Diesel",
  "nav.invoices": "Facturen",
  "nav.warehouseBilling": "Warehouse",
  "nav.tariffs": "Tarieven",
  "nav.purchaseInvoices": "Inkoopfacturen",
  "perm.row.billing": "Facturatie",
  "perm.hint.billing": "Wijzigen: de factuurrun, facturen tegenhouden, definitief maken en crediteren, de nummering, de dieselprijs en de methodes",
  "perm.row.purchaseInvoices": "Inkoopfacturen",
  "perm.hint.purchaseInvoices": "Wijzigen: een pdf toevoegen, de factuur invullen en coderen, en naar AFAS sturen. Goedkeuren gebeurt in AFAS",
  "perm.row.agreementsWrite": "Prijsafspraken wijzigen",
  "perm.row.agreementsApprove": "Prijsafspraken goedkeuren",
  "perm.hint.agreementsWrite": "Een prijsafspraak in een concept wijzigen met een ingangsdatum, een proefberekening maken, aanbieden ter goedkeuring, en verhogen met een percentage",
  "perm.hint.agreementsApprove": "Een gewijzigde prijsafspraak goedkeuren of afwijzen; nooit een die je zelf wijzigde",
  "diesel.tab.months": "Per maand",
  "diesel.tab.prices": "Prijzen",
  "diesel.tab.methods": "Methodes",
  "diesel.monthsIntro": "Per losmaand het dieseltoeslagpercentage van elke methode, uit het gemiddelde van de maand ervoor. Schuin: nog voorlopig, het laatst bekende.",
  "diesel.allMethods": "Ook methodes zonder klanten",
  "diesel.colUnloading": "Lossen in",
  "diesel.colAverage": "Gemiddelde maand ervoor",
  "diesel.provisional": "Voorlopig: het gemiddelde van {{month}}, tot de maand ervoor voorbij is",
  "diesel.previousMonth": "maand ervoor",
  "diesel.sameMonth": "zelfde maand",
  "diesel.summarySteps": "basis € {{base}} · stap € {{step}} · {{rounding}} · {{month}}",
  "diesel.summaryLinear": "basis € {{base}} · {{perEuro}} % per euro · plus {{offset}} % · {{month}}",
  "diesel.kindSteps": "In stappen",
  "diesel.kindLinear": "Lineair",
  "diesel.kindManual": "Met de hand",
  "diesel.roundingDown": "naar beneden op hele procenten",
  "diesel.roundingTenth": "op een tiende",
  "diesel.roundingUp": "naar boven op hele procenten",
  "diesel.pricesIntro": "De dieselprijs zoals Van Kessel hem mailt, in centen per liter. Een prijs geldt vanaf zijn dag tot de volgende; het maandgemiddelde telt elke kalenderdag.",
  "diesel.colFrom": "Vanaf",
  "diesel.colTo": "Tot en met",
  "diesel.colPrice": "Prijs (ct/l)",
  "diesel.colNote": "Opmerking",
  "diesel.colChangedBy": "Door",
  "diesel.addPrice": "Prijs toevoegen",
  "diesel.priceRequired": "Vul een prijs in, in centen per liter.",
  "diesel.deletePriceConfirm": "De prijs vanaf {{date}} verwijderen? De prijs ervoor loopt dan door.",
  "diesel.pricesShown": "De laatste {{shown}} van {{count}} prijzen.",
  "diesel.methodsIntro": "Een methode maakt van het maandgemiddelde het percentage; op de relatiekaart kies je de methode van een klant.",
  "diesel.newMethod": "Nieuwe methode",
  "diesel.colName": "Naam",
  "diesel.colKind": "Soort",
  "diesel.colRule": "Regel",
  "diesel.colCustomers": "Klanten",
  "diesel.colStatus": "Status",
  "diesel.colPercent": "Percentage",
  "diesel.groupNumber": "groep {{group}}",
  "diesel.active": "Actief",
  "diesel.inactive": "Niet meer in gebruik",
  "diesel.basePrice": "Basisprijs (€ per liter)",
  "diesel.step": "Stap (€ per liter voor 1 %)",
  "diesel.rounding": "Afronden",
  "diesel.minimum": "Minimum (%)",
  "diesel.perEuro": "Procent per euro boven de basis",
  "diesel.offset": "Procent bij de basisprijs",
  "diesel.sameMonthLabel": "Het gemiddelde van de losmaand zelf, niet van de maand ervoor (zoals AEEA)",
  "diesel.activeLabel": "In gebruik",
  "diesel.manualRates": "Percentages van de klant",
  "diesel.manualRatesHelp": "Wat de klant doorgeeft, voor losdatums van en tot. Na de laatste geldt die door tot er een nieuwe is.",
  "diesel.addRate": "Percentage toevoegen",
  "diesel.percentRequired": "Vul een percentage in.",
  "parties.cmrTitle": "CMR",
  "parties.cmrPrintLabel": "CMR printen",
  "parties.cmrPrintHelp": "Uit: de afzender maakt zelf de CMR, en WLX print er geen bij de rit.",
  "parties.cmrGoodsLinesLabel": "Ladingregels op de CMR",
  "parties.cmrGoodsLinesHelp": "Per drager een regel met SSCC, inhoud, batch en aantal. Uit: een regel per soort lading.",
  "parties.cmrCombineLabel": "Meer zendingen op één CMR",
  "parties.deliveryNotePrintLabel": "Pakbon bij ritten printen",
  "parties.deliveryNotePrintHelp": "Achter de CMR van een zending die in Haps laadt, de pakbon uit het WMS, zoals het warehouse hem print.",
  "parties.cmrCombineHelp": "De zendingen die een rit op hetzelfde adres en tijdstip lost, samen op één CMR onder het nummer van de eerste. De scan ervan komt bij elke zending erop.",
  "parties.cmrSenderLabel": "Vaste afzender (vak 1)",
  "parties.cmrSenderHelp": "Leeg: het laadadres staat als afzender op de CMR.",
  "parties.cmrSenderNone": "Het laadadres",
  "parties.cmrSenderClear": "Weghalen",
  "parties.cmrRemarkLabel": "Opmerking op de CMR",
  "parties.cmrRemarkHelp": "Op elke CMR van deze klant, bijvoorbeeld over palletruil.",
  "parties.tripReportTitle": "Ritbericht",
  "parties.tripReportLabel": "Ritbericht (IFCSUM)",
  "parties.tripReportHelp": "Welke zendingen van deze klant samen één rit zijn, met de plaatscodes van de klant. Vooraf: een order van deze klant wacht in Aandacht nodig, order entry deelt de rit in en verstuurt het, en het ritnummer dat de klant terugstuurt wordt het ritkenmerk. Achteraf: per rit, WLX verstuurt het vanzelf zodra de rit voorbij is.",
  "parties.tripReportNone": "Geen",
  "parties.tripReportBefore": "Vooraf, vanuit Aandacht nodig",
  "parties.tripReportAfter": "Achteraf, vanzelf na de rit",
  "parties.dossiersTitle": "Dossiers en documenten",
  "parties.dossierPerOrderLabel": "Een dossier per order",
  "parties.dossierPerOrderHelp": "Standaard delen de orders van deze klant met dezelfde referentie één dossier: de transportorder, de magazijnorders en de order in het WMS. Zet dit aan als deze klant zijn referenties opnieuw gebruikt; dan krijgt elke order een eigen dossier.",
  "parties.dossiersWithLabel": "Dossiers samen met",
  "parties.dossiersWithHelp": "Dezelfde klant onder een ander VR-nummer, bijvoorbeeld de magazijnorders op het ene en de transportorders op het andere. Hun orders met dezelfde referentie komen in één dossier, op de relatie van de eerste order. Dat geldt voor beide kanten.",
  "parties.dossiersWithNone": "Geen",
  "parties.dossiersWithRemove": "Weghalen",
  "parties.pendelWithLabel": "Fabriekspendels samen met",
  "parties.pendelWithHelp": "Dezelfde klant onder een ander VR-nummer voor fabriekspendels, bijvoorbeeld de leveringen op het ene en de pendels terug op het andere. Waar geen pendelschema voor is, zet de planning hun fabriekspendels samen heen en weer op één rit. Dat geldt voor beide kanten.",
  "parties.dossiersWithPerOrder": "Een dossier per order: deelt niet",
  "parties.cargosnapLabel": "Gescande CMR naar Cargosnap",
  "parties.cargosnapHelp": "Een gescande CMR of magazijnset in een dossier van deze klant gaat naar Cargosnap, als het magazijn de order met Cargosnap heeft geladen.",
  "parties.dieselMethodLabel": "Dieselmethode",
  "parties.dieselMethodHelp": "Hoe het dieseltoeslagpercentage van deze klant wordt bepaald (Commercie → Diesel). Leeg: de percentages van de toeslaggroep.",
  "parties.dieselMethodNone": "Geen",
  "parties.invoiceRhythmLabel": "Factuurritme",
  "parties.invoiceRhythmHelp": "Hoe vaak deze klant een factuur krijgt. Per week is maandag tot en met zondag, per maand de kalendermaand; wat later klaar is, gaat mee op de volgende.",
  "parties.invoiceSplitLabel": "Verzamelfactuur splitsen",
  "parties.invoiceSplitNone": "Niet splitsen",
  "parties.invoiceSplitReference": "Per factuurreferentie",
  "parties.invoiceLanguageLabel": "Taal van de factuur",
  "parties.invoiceLanguageHelp": "De taal van de factuur en de mail erbij. Niet het land: een klant in Nederland kan een Engelse factuur willen.",
  "parties.invoiceLanguageNl": "Nederlands",
  "parties.invoiceLanguageEn": "Engels",
  "parties.invoiceSpecificationLabel": "Specificatie (csv) bij de factuur",
  "parties.invoiceSpecificationHelp": "Met de factuurmail een csv met per zending de laad- en losgegevens en de bedragen, in vaste kolommen.",
  "parties.invoiceAttachCmrLabel": "Getekende CMR's bij de factuur",
  "parties.invoiceAttachCmrHelp": "Werkt zodra de getekende CMR's uit Scansys in WLX staan; tot dan gaat de factuur zonder.",
  "parties.transportViaWarehouseLabel": "Transport via de warehousefactuur",
  "parties.transportViaWarehouseHelp": "Het transport van deze klant staat op de factuur van de warehouseweek. Zijn zendingen krijgen geen eigen factuur en staan niet onder Niet te factureren; een zending met een prijs met de hand wel.",

  // Commercie → Facturen (docs/tms-facturatie.md §18)
  "invoices.until": "Tot en met",
  "invoices.run": "Voorstel maken",
  "invoices.running": "Bezig…",
  "invoices.runHelp": "Maakt de voorstellen opnieuw van wat tot en met die dag gelost en geprijsd is, per klant in zijn ritme. Tegengehouden facturen blijven zoals ze zijn.",
  "invoices.ranSummary_one": "1 voorstel, samen {{net}} netto, tot en met {{until}}. {{held}} tegengehouden, {{blocked}} zendingen nog niet te factureren.",
  "invoices.ranSummary_other": "{{count}} voorstellen, samen {{net}} netto, tot en met {{until}}. {{held}} tegengehouden, {{blocked}} zendingen nog niet te factureren.",
  "invoices.tab.proposals": "Voorstel",
  "invoices.tab.final": "Definitief",
  "invoices.tab.blocked": "Niet te factureren",
  "invoices.tab.numbers": "Nummering",
  "invoices.search": "Zoek op klant, debiteurnummer, nummer of referentie",
  "invoices.proposalCount_one": "1 voorstel, {{net}} netto",
  "invoices.proposalCount_other": "{{count}} voorstellen, {{net}} netto",
  "invoices.finalizeConfirm_one": "Deze factuur definitief maken met factuurdatum {{date}}? Hij krijgt een nummer en verandert daarna niet meer.",
  "invoices.finalizeConfirm_other": "{{count}} facturen definitief maken met factuurdatum {{date}}? Ze krijgen een nummer en veranderen daarna niet meer.",
  "invoices.finalizedOne": "{{name}}: factuur {{number}}",
  "invoices.failedOne": "{{name}}: niet definitief. {{reason}}",
  "invoices.finalizePicked": "Definitief maken ({{count}})",
  "invoices.noProposals": "Geen voorstellen. Maak een voorstel tot en met een dag.",
  "invoices.pickAll": "Alle voorstellen kiezen",
  "invoices.colCustomer": "Klant",
  "invoices.colRhythm": "Ritme",
  "invoices.colPeriod": "Periode",
  "invoices.colReference": "Referentie",
  "invoices.colLines": "Regels",
  "invoices.colNet": "Netto",
  "invoices.colGross": "Totaal",
  "invoices.colStatus": "Status",
  "invoices.colNumber": "Nummer",
  "invoices.colDate": "Factuurdatum",
  "invoices.colDue": "Vervaldatum",
  "invoices.colUnloaded": "Gelost",
  "invoices.colOrder": "Zending",
  "invoices.colRoute": "Van → naar",
  "invoices.colDescription": "Omschrijving",
  "invoices.colQuantity": "Aantal",
  "invoices.colPrice": "Prijs",
  "invoices.colAmount": "Bedrag",
  "invoices.colVat": "Btw",
  "invoices.colLedger": "Grootboek",
  "invoices.colReason": "Waarom nog niet",
  "invoices.creditOf": "credit van {{number}}",
  "invoices.rhythm.per_order": "Per order",
  "invoices.rhythm.weekly": "Per week",
  "invoices.rhythm.monthly": "Per maand",
  "invoices.warehouseWork": "Warehouse, per week of maand",
  "invoices.status.draft": "Voorstel",
  "invoices.status.held": "Tegengehouden",
  "invoices.status.final": "Definitief",
  "invoices.noFinals": "Nog geen definitieve facturen.",
  "invoices.dueUnknown": "Betaaltermijn onbekend",
  "invoices.invoiceTitle": "Factuur {{number}}",
  "invoices.creditTitle": "Creditfactuur {{number}}",
  "invoices.draftTitle": "Voorstel",
  "invoices.draftCreditTitle": "Voorstel creditfactuur",
  "invoices.hold": "Tegenhouden",
  "invoices.holdPrompt": "Waarom houd je deze factuur tegen? Mag leeg.",
  "invoices.release": "Vrijgeven",
  "invoices.deleteCreditConfirm": "Dit voorstel voor een creditfactuur weggooien?",
  "invoices.finalize": "Definitief maken",
  "invoices.credit": "Crediteren",
  "invoices.creditConfirm_one": "Een creditfactuur maken voor 1 zending van factuur {{number}}? Eerst als voorstel.",
  "invoices.creditConfirm_other": "Een creditfactuur maken voor {{count}} zendingen van factuur {{number}}? Eerst als voorstel.",
  "invoices.creditPick": "{{count}} van {{of}} zendingen gekozen om te crediteren",
  "invoices.reinvoiceLabel": "Opnieuw factureren",
  "invoices.reinvoiceHelp": "De zendingen worden opnieuw geprijsd en de volgende run factureert ze weer: om een prijs recht te zetten.",
  "invoices.closeHelp": "De zendingen worden niet meer gefactureerd: bijvoorbeeld bij schade of een tegemoetkoming.",
  "invoices.makeCredit": "Creditfactuur maken ({{count}})",
  "invoices.afterCredit": "Na crediteren",
  "invoices.reinvoiced": "opnieuw factureren",
  "invoices.closed": "afgesloten",
  "invoices.creditedMark": "gecrediteerd",
  "invoices.selfBilling": "Zelffacturering",
  "invoices.selfBillingHelp": "De klant maakt de factuur zelf; deze is om met die van de klant te vergelijken.",
  "invoices.heldBy": "Tegengehouden door {{name}}: {{reason}}",
  "invoices.noReason": "geen reden opgegeven",
  "invoices.days_one": "{{count}} dag",
  "invoices.days_other": "{{count}} dagen",
  "invoices.creditsLabel": "Crediteert factuur",
  "invoices.creditedBy": "Gecrediteerd met",
  "invoices.billTo": "Factuuradres",
  "invoices.finalizedBy": "Definitief gemaakt door",
  "invoices.totalNet": "Totaal netto",
  "invoices.vatOver": "Btw {{percent}} % over {{base}}",
  "invoices.totalGross": "Totaal",
  "invoices.blockedIntro": "Gelost tot en met {{until}} en nog niet op een factuur te zetten. Los de reden op, dan neemt de volgende run de zending mee.",
  "invoices.noBlocked": "Niets: alles wat gelost is, kan op een factuur.",
  "invoices.reason.not_rated": "Nog geen tarief berekend",
  "invoices.reason.review": "Het tarief moet bekeken worden (tab Tarief op de order)",
  "invoices.reason.no_account": "Geen debiteur bij deze klant",
  "invoices.reason.no_agreement": "Geen prijsafspraak",
  "invoices.reason.nothing_applies": "Geen regel van de factuurmethode past",
  "invoices.reason.awaiting_approval": "De prijs is met de hand gezet en wacht op akkoord van de planning",
  "invoices.reason.rating_queued": "Het tarief wordt opnieuw berekend",
  "invoices.reason.no_ledger": "Een regel heeft geen grootboekrekening (toeslagcode, prijsafspraak of tarief)",
  "invoices.reason.diesel_provisional": "De dieseltoeslag is nog voorlopig: de maand is niet voorbij",
  "invoices.reason.reference_missing": "De klant wil een referentie en de order heeft er geen",
  "invoices.reason.order_incomplete": "Per order gefactureerd, en de order is nog niet compleet",
  "invoices.numbersIntro": "Waar de factuurnummers van een jaar verder gaan: twee cijfers van het jaar en zes van de reeks.",
  "invoices.year": "Jaar",
  "invoices.nextSequence": "Volgende volgnummer",
  "invoices.nextNumberIs": "De volgende factuur krijgt {{number}}",
  "invoices.noSeries": "Nog geen nummering ingesteld: definitief maken kan pas als die er is.",
  "invoices.nextNumber": "Volgende nummer",
  "invoices.lastNumber": "Laatst gegeven",
  "invoices.error.INVOICE_STALE": "Er is iets veranderd sinds het voorstel, een tarief of een zending. Maak het voorstel opnieuw.",
  "invoices.error.NO_NUMBER_SERIES": "Er is nog geen nummering voor {{year}}. Stel die in bij Nummering.",
  "invoices.error.INVOICE_HELD": "Deze factuur is tegengehouden. Geef hem eerst vrij.",
  "invoices.error.INVOICE_NOT_DRAFT": "Deze factuur is al definitief.",
  "invoices.error.INVOICE_NOT_HELD": "Deze factuur is niet tegengehouden.",
  "invoices.error.INVOICE_NOT_FINAL": "Alleen een definitieve factuur kan gecrediteerd worden.",
  "invoices.error.INVOICE_CREDITED": "Alles op deze factuur is al gecrediteerd.",
  "invoices.error.CONSIGNMENT_CREDITED": "Een van de zendingen is al gecrediteerd.",
  "invoices.error.NOT_ON_INVOICE": "Een van de zendingen staat niet op deze factuur.",
  "invoices.referenceEdit": "Aanpassen",
  "invoices.referencePrompt": "De factuurreferentie, bijvoorbeeld een PO-nummer. De volgende run houdt hem vast; leeg zet de week of de maand terug.",
  "invoices.pdfLabel": "PDF",
  "invoices.mailLabel": "Mail",
  "invoices.bookingLabel": "AFAS",
  "invoices.pdf.none": "Niet gevraagd",
  "invoices.pdf.requested": "Wordt gemaakt",
  "invoices.pdf.ready": "Klaar",
  "invoices.pdf.failed": "Mislukt",
  "invoices.pdfView": "Bekijken",
  "invoices.specificationDownload": "Specificatie (csv)",
  "invoices.invoiceFromLabel": "Factureren vanaf",
  "invoices.invoiceFromHelp": "De losdag vanaf wanneer WLX factureert. Wat eerder gelost is, komt niet in een voorstel. Leeg: alles wat in WLX staat.",
  // Commercie → Tarieven (docs/tms-facturatie.md §24).
  "tariffs.tab.customers": "Per klant",
  "tariffs.tab.tariffs": "Tarieven",
  "tariffs.tab.surcharges": "Toeslagen",
  "tariffs.agreement.edit.error.LAST_RATE": "Een toeslag houdt minstens één percentage.",
  "warehouse.tab.weeks": "Weken",
  "warehouse.tab.agreements": "Prijslijsten",
  "warehouse.status.none": "Nog niet gemaakt",
  "warehouse.status.open": "Open",
  "warehouse.status.ready": "Klaar",
  "warehouse.status.invoiced": "Gefactureerd",
  "warehouse.status.credited": "Gecrediteerd",
  "warehouse.state.running": "Loopt",
  "warehouse.state.future": "Begint nog",
  "warehouse.state.ended": "Afgelopen",
  "warehouse.rhythmLabel": "Ritme",
  "warehouse.rhythm.weekly": "Week",
  "warehouse.rhythm.monthly": "Maand",
  "warehouse.colChange": "Wijziging",
  "warehouse.change.none": "Geen",
  "warehouse.change.new": "Nieuw, wacht op goedkeuring",
  "warehouse.change.submitted": "Wacht op goedkeuring",
  "warehouse.change.rejected": "Teruggestuurd",
  "warehouse.change.waits": "{{name}} bood op {{date}} een wijziging aan; die geldt na goedkeuring door een tweede persoon.",
  "warehouse.change.waitsNew": "Nieuwe prijslijst van {{name}} ({{date}}): er worden weken van gemaakt na goedkeuring door een tweede persoon.",
  "warehouse.change.rejectedBy": "Teruggestuurd door {{name}}: {{reason}}",
  "warehouse.change.heading": "kop",
  "warehouse.change.added": "Nieuw: {{line}} ({{value}})",
  "warehouse.change.removed": "Weg: {{line}}",
  "warehouse.change.changed": "{{line}}: {{what}}",
  "warehouse.change.details": "grootboek, activiteit, vestiging, btw of toeslag",
  "warehouse.change.approve": "Goedkeuren",
  "warehouse.change.reject": "Terugsturen",
  "warehouse.change.sendBack": "Terugsturen met deze reden",
  "warehouse.change.reason": "Waarom",
  "warehouse.change.notYours": "Je werkte zelf aan deze wijziging: een ander keurt hem goed.",
  "warehouse.change.withdraw": "Wijziging intrekken",
  "warehouse.change.offer": "Wijziging aanbieden",
  "warehouse.change.saveAndOffer": "Opslaan en aanbieden",
  "warehouse.change.help": "Een wijziging geldt pas als een tweede persoon hem goedkeurt (met het recht om prijsafspraken goed te keuren, nooit wie eraan werkte).",
  "warehouse.error.NO_CHANGE": "Er wacht geen wijziging op goedkeuring.",
  "warehouse.error.CHANGE_OWN": "Je werkte zelf aan deze wijziging: een ander keurt hem goed.",
  "warehouse.colCustomer": "Klant",
  "warehouse.colDebtor": "Debiteur",
  "warehouse.colAgreement": "Prijslijst",
  "warehouse.colPeriod": "Periode",
  "warehouse.colFilled": "Ingevuld",
  "warehouse.colNet": "Bedrag",
  "warehouse.colInvoice": "Factuur",
  "warehouse.colRhythm": "Ritme",
  "warehouse.colFrom": "Vanaf",
  "warehouse.colTo": "T/m",
  "warehouse.colLines": "Regels",
  "warehouse.colWeeks": "Weken",
  "warehouse.invoiceDraft": "voorstel",
  "warehouse.previous": "Vorige periode",
  "warehouse.next": "Volgende periode",
  "warehouse.pending": "Alles wat nog openstaat",
  "warehouse.pendingTitle": "Open en klaar, van elke periode",
  "warehouse.makeWeeks_zero": "Weken maken",
  "warehouse.makeWeeks_one": "1 week maken",
  "warehouse.makeWeeks_other": "{{count}} weken maken",
  "warehouse.noAgreements": "Geen prijslijst voor deze periode.",
  "warehouse.nothingPending": "Er staat niets meer open.",
  "warehouse.per": "Per",
  "warehouse.ledger": "Grootboek",
  "warehouse.axis1": "Activiteit",
  "warehouse.axis2": "Vestiging",
  "warehouse.vat": "Btw",
  "warehouse.surcharges": "Toeslag erover",
  "warehouse.surchargesShort": "Toeslag",
  "warehouse.week.helpOpen": "Tik de aantallen van deze periode in; Enter of pijl omlaag gaat naar de volgende regel, en wat je tikt wordt meteen bewaard. Een vaste regel vult zich. Klaarzetten rekent de toeslag uit; de volgende factuurrun maakt er een factuur van.",
  "warehouse.week.helpReady": "Klaar: de volgende factuurrun maakt er een factuur van. Moet er nog iets anders, zet de week dan terug.",
  "warehouse.week.helpDone": "Deze week staat op een factuur.",
  "warehouse.week.colDescription": "Omschrijving",
  "warehouse.week.colQuantity": "Aantal",
  "warehouse.week.colUnit": "Eenheid",
  "warehouse.week.colPrice": "Prijs",
  "warehouse.week.colAmount": "Bedrag",
  "warehouse.week.colLedger": "Grootboek · activiteit · vestiging",
  "warehouse.week.quantityOf": "Aantal {{line}}",
  "warehouse.week.headingOf": "Kop {{line}}",
  "warehouse.week.amountOf": "Bedrag {{line}}",
  "warehouse.week.byHand": "bijgezet",
  "warehouse.week.withSurcharges": "met toeslag",
  "warehouse.week.total": "Totaal",
  "warehouse.week.saving": "bewaren…",
  "warehouse.week.notSaved": "Niet alles is bewaard; kijk de aantallen na.",
  "warehouse.week.noRate": "Toeslag {{surcharge}} heeft geen percentage op {{date}} en staat er niet op.",
  "warehouse.week.ready": "Klaarzetten",
  "warehouse.week.addLine": "Regel bijzetten",
  "warehouse.week.handLine": "Regel met de hand",
  "warehouse.week.edit": "Wijzigen",
  "warehouse.week.refresh": "Opnieuw uit de prijslijst",
  "warehouse.week.refreshHelp": "Neemt de prijzen en regels van de prijslijst zoals hij nu is; wat je tikte en wat je bijzette, blijft.",
  "warehouse.week.delete": "Week verwijderen",
  "warehouse.week.deleteSure": "Zeker weten? Verwijderen",
  "warehouse.week.reopen": "Terugzetten naar open",
  "warehouse.week.reason": "Waarom (voor het logboek)",
  "warehouse.agreements.intro": "Per klant een prijslijst per factuur die hij krijgt: een magazijn of een afdeling. Een week die al gemaakt is, houdt zijn prijzen.",
  "warehouse.agreements.none": "Nog geen prijslijst.",
  "warehouse.agreements.alsoEnded": "Ook afgelopen",
  "warehouse.agreements.new": "Nieuwe prijslijst",
  "warehouse.agreements.newTitle": "Nieuwe prijslijst",
  "warehouse.agreements.weeksMade_zero": "Nog geen week gemaakt",
  "warehouse.agreements.weeksMade_one": "1 week gemaakt",
  "warehouse.agreements.weeksMade_other": "{{count}} weken gemaakt",
  "warehouse.agreements.reference": "Op de factuur en in AFAS",
  "warehouse.agreements.referencePlaceholder": "Weekly invoice warehousing DC Haps",
  "warehouse.agreements.note": "Notitie",
  "warehouse.agreements.remarks": "Tekstregels op de factuur",
  "warehouse.agreements.remarksPlaceholder": "Reference: kostenplaats of inkoopnummer\nt.a.v. …",
  "warehouse.agreements.quantity": "Aantal",
  "warehouse.agreements.byHand": "Met de hand",
  "warehouse.agreements.fixed": "Vast",
  "warehouse.agreements.amount": "Bedrag per keer",
  "warehouse.agreements.fixedQuantity": "Vast aantal",
  "warehouse.agreements.headingPlaceholder": "Kop, bijvoorbeeld DC Rijkevoort",
  "warehouse.agreements.up": "Omhoog",
  "warehouse.agreements.down": "Omlaag",
  "warehouse.agreements.addLine": "Regel toevoegen",
  "warehouse.agreements.addHeading": "Kop toevoegen",
  "warehouse.agreements.delete": "Prijslijst verwijderen",
  "warehouse.agreements.deleteSure": "Zeker weten? Verwijderen",
  "warehouse.agreements.customerRequired": "Kies een klant.",
  "warehouse.agreements.nameRequired": "Geef de prijslijst een naam.",
  "warehouse.agreements.pricesHelp": "Een gewijzigde prijs geldt voor de weken die je hierna maakt. Een open week neemt hem over met *Opnieuw uit de prijslijst*.",
  "warehouse.error.NO_ACCOUNT": "Deze relatie heeft geen debiteur: kies een klant.",
  "warehouse.error.HAS_WEEKS": "Deze prijslijst heeft weken: hij kan niet weg en houdt zijn klant. Geef hem een einddatum.",
  "warehouse.error.WEEK_NOT_OPEN": "Deze week staat niet meer open.",
  "warehouse.error.WEEK_NOT_READY": "Alleen een week die klaarstaat, kan terug naar open.",
  "warehouse.error.WEEK_ON_INVOICE": "Deze week staat op een factuur die is tegengehouden of definitief is.",
  "warehouse.error.NOT_A_LINE": "Een kop krijgt geen aantal.",
  "warehouse.error.NOT_BY_HAND": "Alleen een bijgezette regel kan helemaal worden gewijzigd of weg.",
  "warehouse.error.EMPTY_WEEK": "Er staat nog niets met een bedrag op deze week.",
  "warehouse.error.NO_LEDGER": "De regel {{description}} heeft geen grootboek.",
  "surcharges.intro": "Het percentage van elke toeslag over de tijd. Een nieuw percentage vanaf een datum rekent de open orders vanaf die dag opnieuw.",
  "surcharges.alsoInactive": "Ook niet actieve",
  "surcharges.colGroup": "Toeslaggroep",
  "surcharges.colKind": "Soort",
  "surcharges.colSince": "Sinds",
  "surcharges.colNext": "Volgende",
  "surcharges.colCustomers": "Klanten",
  "surcharges.colFrom": "Vanaf",
  "surcharges.colTo": "T/m",
  "surcharges.colPercent": "Percentage",
  "surcharges.kind.levy": "Kilometerheffing",
  "surcharges.kind.levyIn": "Kilometerheffing {{country}}",
  "surcharges.kind.diesel": "Diesel",
  "surcharges.kind.discount": "Korting",
  "surcharges.kind.other": "Toeslag",
  "surcharges.nextFrom": "{{percent}} vanaf {{date}}",
  "surcharges.drawerTitle": "Toeslag {{code}}",
  "surcharges.ledger": "grootboek {{account}}",
  "surcharges.vat": "btw {{code}}",
  "surcharges.help.levy": "Komt over de vracht en de extra's van klanten wier prijsafspraak alle toeslagen draagt, bij lossen in {{country}}.",
  "surcharges.help.diesel": "Klanten met een dieselmethode krijgen het percentage van hun methode (Commercie → Diesel); dit percentage geldt voor wie er geen heeft.",
  "surcharges.help.other": "Komt over de vracht en de extra's van de klanten in deze toeslaggroep.",
  "surcharges.customers_zero": "Nu bij geen enkele klant.",
  "surcharges.customers_one": "Nu bij 1 klant.",
  "surcharges.customers_other": "Nu bij {{count}} klanten.",
  "surcharges.newRate": "Nieuw percentage",
  "surcharges.newRateHelp": "Het percentage dat op die dag gold, loopt tot de dag ervoor. Op dezelfde dag vervangt het een percentage dat er al stond.",
  "surcharges.addRate": "Percentage toevoegen",
  "surcharges.percentRequired": "Vul een percentage in.",
  "surcharges.noRates": "Nog geen percentage.",
  "surcharges.now": "nu",
  "surcharges.removeSure": "Zeker weten? Verwijderen",
  "tariffs.tab.texts": "Engelse teksten",
  "tariffs.colDutch": "Nederlands",
  "tariffs.colEnglish": "Engels",
  "tariffs.colUses": "Op regels",
  "tariffs.textsIntro_one": "Wat er op de factuur van een Engelse klant staat. Zonder Engelse tekst blijft de Nederlandse staan; {{count}} tekst heeft er nog geen.",
  "tariffs.textsIntro_other": "Wat er op de factuur van een Engelse klant staat. Zonder Engelse tekst blijft de Nederlandse staan; {{count}} teksten hebben er nog geen.",
  "tariffs.onlyMissing": "Alleen zonder Engels",
  "tariffs.noEnglish": "nog geen Engels: de Nederlandse blijft staan",
  "tariffs.sameInEnglish": "Zelfde",
  "tariffs.sameInEnglishHelp": "In het Engels staat er hetzelfde, zoals een route met alleen plaatsnamen",
  "tariffs.saveFailed": "Niet opgeslagen",
  "invoices.untranslated_one": "Deze klant krijgt een Engelse factuur, maar {{count}} regeltekst heeft nog geen Engels: {{texts}}.",
  "invoices.untranslated_other": "Deze klant krijgt een Engelse factuur, maar {{count}} regelteksten hebben nog geen Engels: {{texts}}.",
  "invoices.untranslatedLink": "Engelse teksten",
  "tariffs.colCustomer": "Klant",
  "tariffs.colDebtor": "Debiteur",
  "tariffs.colReview": "Nakijken",
  "tariffs.colRhythm": "Ritme",
  "tariffs.colDiesel": "Dieselmethode",
  "tariffs.colSurchargeGroup": "Toeslaggroep",
  "tariffs.colZoneScheme": "Rayonindeling",
  "tariffs.colAgreement": "Prijsafspraak",
  "tariffs.agreement.freight": "Vracht",
  "tariffs.agreement.colFrom": "Van",
  "tariffs.agreement.colTo": "Naar",
  "tariffs.agreement.colCounts": "Gerekend op",
  "tariffs.agreement.colWhat": "Wat",
  "tariffs.agreement.colWhen": "Wanneer",
  "tariffs.agreement.noFreight": "Geen vrachtregels.",
  "tariffs.agreement.bothWays": "ook andersom",
  "tariffs.agreement.onlyWith": "alleen met {{code}}",
  "tariffs.agreement.perConsignment": "per zending",
  "tariffs.agreement.extras": "Extra's",
  "tariffs.agreement.noExtras": "Geen extra's.",
  "tariffs.agreement.extra.window_loading": "Tijdzending laden",
  "tariffs.agreement.extra.window_unloading": "Tijdzending lossen",
  "tariffs.agreement.extra.waiting_hours": "Wachturen",
  "tariffs.agreement.extra.saturday": "Zaterdag",
  "tariffs.agreement.extra.requirement": "Vervoerseis",
  "tariffs.agreement.extra.pickup": "Afhaling",
  "tariffs.agreement.extra.other": "Op voorwaarde",
  "tariffs.agreement.when.window_loading": "het laadvenster is smaller dan de openingstijden",
  "tariffs.agreement.when.window_unloading": "het losvenster is smaller dan de openingstijden",
  "tariffs.agreement.when.waiting_hours": "er zijn wachturen geregistreerd",
  "tariffs.agreement.when.saturday": "gelost op een zaterdag",
  "tariffs.agreement.when.requirement": "de zending heeft {{code}}",
  "tariffs.agreement.when.pickup": "één keer per laadstop",
  "tariffs.agreement.when.other": "als alles hieronder klopt",
  "tariffs.agreement.surcharges.all": "Diesel en kilometerheffing",
  "tariffs.agreement.surcharges.diesel": "Alleen diesel",
  "tariffs.agreement.surcharges.none": "Geen",
  "tariffs.agreement.place.anywhere": "Overal",
  "tariffs.agreement.place.cityContains": "plaats met \"{{value}}\"",
  "tariffs.agreement.place.postal": "postcode {{value}}…",
  "tariffs.agreement.place.zone": "rayon {{value}}",
  "tariffs.tab.changes": "Wijzigingen",
  "tariffs.colValidFrom": "Geldt vanaf",
  "tariffs.colFreight": "Vrachtregels",
  "tariffs.colExtras": "Extra's",
  "tariffs.colEditors": "Gewijzigd door",
  "tariffs.colTrial": "Proefberekening",
  "tariffs.agreement.state.active": "Actief",
  "tariffs.agreement.state.concept": "Concept",
  "tariffs.agreement.state.submitted": "Ter goedkeuring",
  "tariffs.agreement.state.rejected": "Teruggestuurd",
  "tariffs.agreement.state.future": "Gaat in op {{date}}",
  "tariffs.agreement.state.past": "Vervangen",
  "tariffs.agreement.state.none": "Geen",
  "tariffs.agreement.conceptFrom": "Concept vanaf {{date}}",
  "tariffs.agreement.fromTheStart": "vanaf het begin",
  "tariffs.agreement.version": "Versie",
  "tariffs.agreement.versionFrom": "vanaf {{date}}",
  "tariffs.agreement.versionStart": "eerste versie",
  "tariffs.agreement.versionConcept": "concept vanaf {{date}}",
  "tariffs.agreement.newVersion": "Nieuwe versie",
  "tariffs.agreement.newVersionHelp": "Een nieuwe versie begint als kopie van de afspraak die op die dag geldt. Je wijzigt hem regel voor regel, probeert hem op een maand die geweest is, en een tweede persoon keurt hem goed. Tot die dag blijft de huidige versie rekenen.",
  "tariffs.agreement.validFrom": "Gaat in op",
  "tariffs.agreement.note": "Waarom",
  "tariffs.agreement.notePlaceholder": "Bijvoorbeeld: nieuwe prijzen met de klant afgesproken",
  "tariffs.agreement.none": "Deze klant heeft nog geen prijsafspraak.",
  "tariffs.agreement.withdrawToChange": "Dit concept wacht op goedkeuring. Neem het terug om het verder te wijzigen.",
  "tariffs.agreement.freightChip": "Per zending één regel: de meest specifieke die past",
  "tariffs.agreement.extrasChip": "Komen erbij als de zending erom vraagt",
  "tariffs.agreement.surchargesTitle": "Toeslagen",
  "tariffs.agreement.surchargesChip": "Over de vracht en de extra's",
  "tariffs.agreement.addRule": "Regel",
  "tariffs.agreement.addExtra": "Extra",
  "tariffs.agreement.colMinimum": "Minimum",
  "tariffs.agreement.colSurcharge": "Toeslag",
  "tariffs.agreement.colHow": "Hoe",
  "tariffs.agreement.onlyIf": "alleen als:",
  "tariffs.agreement.onInvoice": "Op de factuur: {{text}}",
  "tariffs.agreement.diesel": "Dieseltoeslag",
  "tariffs.agreement.dieselByMethod": "dieselmethode {{method}}",
  "tariffs.agreement.dieselByGroup": "toeslag {{code}} van de toeslaggroep",
  "tariffs.agreement.levy": "Kilometerheffing",
  "tariffs.agreement.levyHow": "vanzelf naar het land van het lossen",
  "tariffs.agreement.fromGroup": "van de toeslaggroep",
  "tariffs.agreement.noSurcharges": "Geen toeslagen.",
  "tariffs.agreement.tie": "Regels {{a}} en {{b}} zijn even specifiek en kunnen allebei passen. WLX kiest dan niet: de zending gaat op Nakijken. Maak een van beide specifieker.",
  "tariffs.agreement.placeKind.anywhere": "Overal",
  "tariffs.agreement.placeKind.country": "Land",
  "tariffs.agreement.placeKind.zone": "Rayon",
  "tariffs.agreement.placeKind.city": "Plaats",
  "tariffs.agreement.placeKind.postal": "Postcodegebied",
  "tariffs.agreement.placeKind.location": "Locatie",
  "tariffs.agreement.pricing.perUnit": "{{price}} per eenheid",
  "tariffs.agreement.pricing.none": "Geen prijs",
  "tariffs.agreement.pricing.staffel": "Staffel op {{what}}",
  "tariffs.agreement.pricing.matrix": "{{rows}} × {{columns}}",
  "tariffs.agreement.pricing.matrixSize": "matrix, {{rows}} × {{columns}}",
  "tariffs.agreement.pricing.sum": "{{first}} plus {{second}}",
  "tariffs.agreement.pricing.more": "+{{count}}",
  "tariffs.agreement.conceptTitle": "Concept",
  "tariffs.agreement.conceptSubmitted": "Ter goedkeuring",
  "tariffs.agreement.startsOn": "Gaat in op {{date}}",
  "tariffs.agreement.changedBy": "Gewijzigd door {{names}}",
  "tariffs.agreement.offeredBy": "Aangeboden door {{name}}, {{when}}",
  "tariffs.agreement.offeredOn": "aangeboden {{when}}",
  "tariffs.agreement.sentBack": "Teruggestuurd door {{name}}: {{reason}}",
  "tariffs.agreement.tryFirst": "Doe eerst een proefberekening: wie goedkeurt, ziet de uitkomst.",
  "tariffs.agreement.submit": "Ter goedkeuring aanbieden",
  "tariffs.agreement.withdraw": "Terugnemen",
  "tariffs.agreement.approve": "Goedkeuren",
  "tariffs.agreement.reject": "Terugsturen",
  "tariffs.agreement.rejectReason": "Waarom terug",
  "tariffs.agreement.discard": "Concept weggooien",
  "tariffs.agreement.discardSure": "Zeker weten? Weggooien",
  "tariffs.agreement.trial.title": "Proefberekening",
  "tariffs.agreement.trial.help": "De zendingen van de klant in een maand die geweest is: zoals ze nu gerekend zijn, en zoals dit concept ze zou rekenen. Er wordt niets bewaard.",
  "tariffs.agreement.trial.month": "Maand",
  "tariffs.agreement.trial.run": "Rekenen",
  "tariffs.agreement.trial.consignments_one": "1 zending in {{month}}",
  "tariffs.agreement.trial.consignments_other": "{{count}} zendingen in {{month}}",
  "tariffs.agreement.trial.same": "{{count}} gelijk",
  "tariffs.agreement.trial.differ": "{{count}} anders: {{delta}}",
  "tariffs.agreement.trial.totals": "Nu {{now}}, concept {{concept}}",
  "tariffs.agreement.trial.show": "Bekijk de verschillen",
  "tariffs.agreement.trial.hide": "Verschillen verbergen",
  "tariffs.agreement.trial.runToSee": "Reken opnieuw om de verschillen per zending te zien.",
  "tariffs.agreement.trial.colOrder": "Zending",
  "tariffs.agreement.trial.colNow": "Nu",
  "tariffs.agreement.trial.colConcept": "Concept",
  "tariffs.agreement.trial.status.review": "Nakijken",
  "tariffs.agreement.trial.status.nothing_applies": "Geen regel",
  "tariffs.agreement.trial.status.no_agreement": "Geen afspraak",
  "tariffs.agreement.trial.status.no_account": "Geen klant",
  "tariffs.agreement.trial.status.awaiting_approval": "Wacht op akkoord",
  "tariffs.agreement.trial.status.by_hand": "Met de hand",
  "tariffs.agreement.trial.status.counted": "Geteld",
  "tariffs.agreement.trial.listSame": "{{month}}: alles gelijk",
  "tariffs.agreement.trial.listDiffer": "{{month}}: {{count}} anders, {{delta}}",
  "tariffs.agreement.trial.notYet": "nog niet gerekend",
  "tariffs.agreement.forEveryoneTitle": "Voor iedereen, zonder regel",
  "tariffs.agreement.forEveryone1": "Niet facturabel: geen bedrag.",
  "tariffs.agreement.forEveryone2": "Geen rayon of hoeveelheid: geen prijs, en de zending gaat op Nakijken.",
  "tariffs.agreement.forEveryone3": "Zendingen op één rit tellen op zoals altijd.",
  "tariffs.agreement.history": "Historie",
  "tariffs.agreement.historyConcept": "Concept vanaf {{when}}",
  "tariffs.agreement.historyApproved": "Vanaf {{when}}, goedgekeurd door {{name}} op {{on}}",
  "tariffs.agreement.historyFirst": "Eerste versie, {{when}}, sinds {{on}}",
  "tariffs.agreement.customer": "Klant",
  "tariffs.agreement.pickAll": "Alle zichtbare",
  "tariffs.agreement.changesIntro": "De concepten die gewijzigd worden of op goedkeuring wachten. Wie een concept wijzigde, keurt het niet zelf goed.",
  "tariffs.agreement.noChanges": "Geen concepten.",
  "tariffs.agreement.approvePicked_zero": "Goedkeuren",
  "tariffs.agreement.approvePicked_one": "1 goedkeuren",
  "tariffs.agreement.approvePicked_other": "{{count}} goedkeuren",
  "tariffs.agreement.approved_one": "1 concept goedgekeurd: het rekent vanaf zijn datum.",
  "tariffs.agreement.approved_other": "{{count}} concepten goedgekeurd: ze rekenen vanaf hun datum.",
  "tariffs.agreement.approvedSome": "{{count}} goedgekeurd, {{failed}} niet: die heb je zelf gewijzigd of ze wachten niet meer.",
  "tariffs.agreement.increase.button": "Verhogen met %",
  "tariffs.agreement.increase.title": "Prijzen verhogen",
  "tariffs.agreement.increase.forPicked_zero": "Verhogen met %",
  "tariffs.agreement.increase.forPicked_one": "Verhogen met % (1)",
  "tariffs.agreement.increase.forPicked_other": "Verhogen met % ({{count}})",
  "tariffs.agreement.increase.help_one": "Voor 1 klant",
  "tariffs.agreement.increase.help_other": "Voor {{count}} klanten: per klant een concept met alle prijzen, minimums en tabellen verhoogd, vanaf de prijzen van de dag ervoor. Elk concept keurt een tweede persoon goed.",
  "tariffs.agreement.increase.helpOne": "Een concept voor {{name}} met alle prijzen, minimums en tabellen verhoogd, vanaf de prijzen van de dag ervoor. Een tweede persoon keurt het goed.",
  "tariffs.agreement.increase.percent": "Percentage",
  "tariffs.agreement.increase.notePlaceholder": "Bijvoorbeeld: indexering 2027",
  "tariffs.agreement.increase.make": "Concepten maken",
  "tariffs.agreement.increase.badPercent": "Een percentage tussen -50 en 100, niet 0.",
  "tariffs.agreement.increase.created_one": "1 concept gemaakt. Het staat onder Wijzigingen tot iemand het goedkeurt.",
  "tariffs.agreement.increase.created_other": "{{count}} concepten gemaakt. Ze staan onder Wijzigingen tot iemand ze goedkeurt.",
  "tariffs.agreement.increase.skip.NO_ACCOUNT": "geen klant",
  "tariffs.agreement.increase.skip.NO_AGREEMENT": "heeft geen actieve prijsafspraak",
  "tariffs.agreement.increase.skip.CONCEPT_EXISTS": "heeft al een concept",
  "tariffs.agreement.increase.skip.other": "niet gelukt ({{reason}})",
  "tariffs.agreement.edit.freightTitle": "Vrachtregel {{sequence}}",
  "tariffs.agreement.edit.newFreight": "Nieuwe vrachtregel",
  "tariffs.agreement.edit.extraTitle": "Extra wijzigen",
  "tariffs.agreement.edit.newExtra": "Nieuwe extra",
  "tariffs.agreement.edit.bothWays": "Geldt ook andersom",
  "tariffs.agreement.edit.onlyWith": "Alleen voor zendingen met",
  "tariffs.agreement.edit.allConsignments": "— alle zendingen —",
  "tariffs.agreement.edit.choose": "— kies —",
  "tariffs.agreement.edit.mode.perConsignment": "Per zending",
  "tariffs.agreement.edit.mode.perUnit": "Per eenheid",
  "tariffs.agreement.edit.mode.staffel": "Staffel",
  "tariffs.agreement.edit.mode.matrix": "Matrix",
  "tariffs.agreement.edit.mode.sum": "Twee tabellen",
  "tariffs.agreement.edit.sumHelp": "Deze regel telt twee tabellen op. Die wijzig je hier niet; de rest van de regel wel.",
  "tariffs.agreement.edit.price": "Prijs",
  "tariffs.agreement.edit.perWhat": "Per",
  "tariffs.agreement.edit.perHowMany": "Per hoeveel",
  "tariffs.agreement.edit.counts": "Grenzen in",
  "tariffs.agreement.edit.rows": "Rijen",
  "tariffs.agreement.edit.columns": "Kolommen",
  "tariffs.agreement.edit.staffelHelp": "Elke rij geldt tot en met zijn grens. Een lege laatste grens is alles daarboven. Plakken uit Excel kan: klik in de tabel en plak.",
  "tariffs.agreement.edit.matrixHelp": "Rijen en kolommen gelden tot en met hun grens; een lege laatste grens is alles daarboven, een lege prijs is geen prijs. Plakken uit Excel kan, met de kolomgrenzen op de eerste regel.",
  "tariffs.agreement.edit.upTo": "t/m",
  "tariffs.agreement.edit.above": "daarboven",
  "tariffs.agreement.edit.columnBound": "Kolomgrens",
  "tariffs.agreement.edit.perUnitShort": "per eenheid",
  "tariffs.agreement.edit.row": "Rij",
  "tariffs.agreement.edit.column": "Kolom",
  "tariffs.agreement.edit.lastColumn": "Laatste kolom",
  "tariffs.agreement.edit.minimum": "Minimum per zending",
  "tariffs.agreement.edit.invoiceText": "Tekst op de factuur",
  "tariffs.agreement.edit.dropConditions": "Deze voorwaarden weghalen",
  "tariffs.agreement.edit.reviewed": "Nagekeken: zendingen met deze regel gaan niet meer op Nakijken",
  "tariffs.agreement.edit.findLocation": "Zoek een locatie",
  "tariffs.agreement.edit.cityContains": "Ook als de plaatsnaam dit bevat",
  "tariffs.agreement.edit.placeholder.country": "NL, BE",
  "tariffs.agreement.edit.placeholder.zone": "1, 2, 3",
  "tariffs.agreement.edit.placeholder.city": "Waalwijk",
  "tariffs.agreement.edit.placeholder.postal": "51, 5251",
  "tariffs.agreement.edit.deleteSure": "Zeker weten? Verwijderen",
  "tariffs.agreement.edit.save": "Opslaan in concept",
  "tariffs.agreement.edit.error.place": "Zeg waar: een land, rayon, plaats, postcodegebied of locatie.",
  "tariffs.agreement.edit.error.price": "Een prijs is een bedrag van 0 of meer.",
  "tariffs.agreement.edit.error.quantity": "Kies waarop de regel rekent.",
  "tariffs.agreement.edit.error.per": "Per hoeveel is een getal.",
  "tariffs.agreement.edit.error.table": "Een tabel heeft minstens één rij.",
  "tariffs.agreement.edit.error.bound": "Elke grens is een getal; alleen de laatste mag leeg.",
  "tariffs.agreement.edit.error.order": "De grenzen lopen op.",
  "tariffs.agreement.edit.error.minimum": "Het minimum is een bedrag.",
  "tariffs.agreement.edit.error.requirement": "Kies de vervoerseis.",
  "tariffs.agreement.edit.error.UNKNOWN_LOCATION": "Een locatie staat niet in het adresboek.",
  "tariffs.agreement.edit.error.BAD_COUNTRY": "Een land is twee hoofdletters: NL, BE.",
  "tariffs.agreement.edit.error.BAD_ZONE": "Een rayon is een getal.",
  "tariffs.agreement.edit.error.UNKNOWN_REQUIREMENT": "Geen vervoerseis met die code.",
  "tariffs.agreement.edit.error.BAD_TABLE": "Een matrix heeft kolommen en rekent op twee dingen; een staffel op één.",
  "tariffs.agreement.edit.error.AGREEMENT_NOT_DRAFT": "Alleen een concept wijzigt; maak een nieuwe versie.",
  "tariffs.agreement.edit.error.CONCEPT_EXISTS": "Deze klant heeft al een concept: wijzig dat, of gooi het weg.",
  "tariffs.agreement.edit.error.AGREEMENT_OWN": "Je hebt dit concept zelf gewijzigd: iemand anders keurt het goed.",
  "tariffs.agreement.edit.error.AGREEMENT_NOT_SUBMITTED": "Dit concept is nog niet aangeboden.",
  "tariffs.agreement.edit.error.NO_START_DATE": "Zeg eerst vanaf wanneer het geldt.",
  "tariffs.colKind": "Soort",
  "tariffs.colQuantity": "Telt",
  "tariffs.colNow": "Vandaag",
  "tariffs.colPeriods": "Perioden",
  "tariffs.colUsedBy": "Klanten",
  "tariffs.colLedger": "Grootboek",
  "tariffs.colVat": "Btw-code",
  "tariffs.colSurcharges": "Toeslagen",
  "tariffs.colPrice": "Prijs",
  "tariffs.customersCount_one": "{{count}} klant",
  "tariffs.customersCount_other": "{{count}} klanten",
  "tariffs.tariffsCount_one": "{{count}} tarief",
  "tariffs.tariffsCount_other": "{{count}} tarieven",
  "tariffs.allCustomers": "Ook klanten zonder prijsafspraak",
  "tariffs.noCustomers": "Geen klanten met een prijsafspraak.",
  "tariffs.noTariffs": "Geen tarieven.",
  "tariffs.noPeriodNow": "Geen prijs vandaag",
  "tariffs.table": "Tabel",
  "tariffs.kind.fixed": "Vaste prijs",
  "tariffs.kind.staffel": "Staffel",
  "tariffs.kind.matrix": "Matrix",
  "tariffs.kind.sum": "Twee staffels",
  "tariffs.talisField": "Veld zonder naam ({{field}})",
  "tariffs.upTo": "t/m {{value}}",
  "tariffs.moreThan": "meer dan {{value}}",
  "tariffs.anyAmount": "elk aantal",
  "tariffs.aboveReview": "Meer dan {{value}}: nakijken, WLX rekent hier geen prijs.",
  "tariffs.abovePerUnit": "Daarboven: dezelfde prijs per eenheid.",
  "tariffs.columnsAboveReview": "Een hogere kolom dan {{value}}: nakijken.",
  "tariffs.noPrice": "geen prijs",
  "tariffs.pricePer": "{{price}} per {{per}}",
  "tariffs.periodBetween": "{{from}} t/m {{to}}",
  "tariffs.periodFrom": "vanaf {{from}}",
  "tariffs.periodUntil": "t/m {{to}}",
  "tariffs.periodAlways": "altijd",
  "tariffs.op.equals": "is {{value}}",
  "tariffs.op.notEquals": "is niet {{value}}",
  "tariffs.op.startsWith": "begint met {{value}}",
  "tariffs.op.contains": "bevat {{value}}",
  "tariffs.op.between": "ligt tussen {{value}} en {{value2}}",
  "tariffs.op.empty": "is leeg",
  "tariffs.op.notEmpty": "is niet leeg",
  "tariffs.op.notContains": "bevat niet {{value}}",
  "tariffs.op.notStartsWith": "begint niet met {{value}}",
  "tariffs.op.notOneOf": "is geen van {{values}}",
  "tariffs.op.notPlaces": "is niet {{value}}: {{places}}",
  "tariffs.op.lessThan": "is kleiner dan {{value}}",
  "tariffs.op.atLeast": "is minstens {{value}}",
  "tariffs.op.oneOf": "is een van {{values}}",
  "tariffs.op.places": "is {{value}}: {{places}}",
  "tariffs.op.placesNone": "is {{value}} (niet in WLX)",
  "tariffs.op.unsupported": "(niet te lezen: {{value}})",
  "tariffs.not": "niet: {{condition}}",
  "tariffs.field.billableLoadingMeters": "Te factureren laadmeters",
  "tariffs.field.loadingMeters": "Laadmeters",
  "tariffs.field.billablePallets": "Te factureren pallets",
  "tariffs.field.pallets": "Pallets",
  "tariffs.field.billableWeightKg": "Te factureren gewicht (kg)",
  "tariffs.field.zoneUnloading": "Rayon van de losplaats",
  "tariffs.field.zoneLoading": "Rayon van de laadplaats",
  "tariffs.field.zoneHighest": "Hoogste rayon",
  "tariffs.field.unloadingWindowMinutes": "Minuten losvenster (tijdzending)",
  "tariffs.field.loadingWindowMinutes": "Minuten laadvenster",
  "tariffs.field.extraWaitingHours": "Extra wachturen",
  "tariffs.field.tariffPostcode": "Tariefpostcode (eerste twee cijfers van de losplaats)",
  "tariffs.field.count": "Aantal",
  "tariffs.field.cubicMeters": "Kubieke meters",
  "tariffs.field.hours": "Uren",
  "tariffs.field.kilometres": "Kilometers",
  "tariffs.field.unloadingWeekday": "Losdag (1 = maandag)",
  "tariffs.field.notLoaded": "Niet geladen",
  "tariffs.field.notBillable": "Niet facturabel",
  "tariffs.field.loading.location": "Laadplaats",
  "tariffs.field.unloading.location": "Losplaats",
  "tariffs.field.loading.city": "Plaats van het laden",
  "tariffs.field.unloading.city": "Plaats van het lossen",
  "tariffs.field.loading.name": "Naam van de laadplaats",
  "tariffs.field.unloading.name": "Naam van de losplaats",
  "tariffs.field.loading.postalCode": "Postcode van het laden",
  "tariffs.field.unloading.postalCode": "Postcode van het lossen",
  "tariffs.field.loading.country": "Land van het laden",
  "tariffs.field.unloading.country": "Land van het lossen",
  "tariffs.field.loading.customerPlaceCode": "Plaatscode van de klant bij het laden",
  "tariffs.field.unloading.customerPlaceCode": "Plaatscode van de klant bij het lossen",
  "tariffs.field.loading.windowRequested": "Tijdzending bij het laden",
  "tariffs.field.unloading.windowRequested": "Tijdzending bij het lossen",
  "tariffs.field.loading.windowStart": "Begin van het laadvenster",
  "tariffs.field.unloading.windowStart": "Begin van het losvenster",
  "tariffs.field.unloading.windowEnd": "Eind van het losvenster",
  "tariffs.field.loading.planned": "Planbaar (laden)",
  "tariffs.field.unloading.planned": "Planbaar (lossen)",
  "tariffs.field.loading.preNotify": "Voormelden bij het laden",
  "tariffs.field.unloading.preNotify": "Voormelden bij het lossen",
  "tariffs.field.requirement": "Vervoerseis",
  "tariffs.field.invoiceReference": "Factuurreferentie",
  "tariffs.field.returnLoad": "Retourlading",
  "tariffs.field.route": "Route",
  "tariffs.field.consignmentLine": "Regelnummer in de order",
  "tariffs.field.loading.firstAtStop": "Eerste zending op de laadstop",
  "tariffs.field.unloading.firstAtStop": "Eerste zending op de losstop",
  "tariffs.field.unloading.vehicle": "Wagen die lost",
  "tariffs.field.unloading.carrier": "Charter die lost",
  "tariffs.field.unloading.charter": "Charter die lost",
  "tariffs.field.loadingWeekday": "Laaddag (1 = maandag)",
  "tariffs.backToList": "Terug naar Tarieven",
  "tariffs.openRelation": "Relatiekaart",
  "tariffs.vatCode": "Btw-code",
  "tariffs.zoneSchemeDefault": "de standaardindeling",
  "tariffs.kgPerLoadingMeter": "Kilo per laadmeter",
  "tariffs.conversion.weight_to_lm": "gewicht naar laadmeters",
  "tariffs.conversion.lm_to_weight": "laadmeters naar gewicht",
  "tariffs.noRateToday": "geen percentage vandaag",
  "tariffs.discount": "Korting",
  "tariffs.seeTable": "zie de tabel",
  "tariffs.review": "Nakijken",
  "tariffs.reviewHelp": "Een zending die deze regel rekent, gaat op Nakijken tot iemand de regel heeft nagekeken.",
  "tariffs.noSurcharges": "Zonder toeslagen",
  "tariffs.withSurcharges": "Met toeslagen",
  "tariffs.countsNothing": "een vast bedrag",
  "tariffs.units": "Eenheid",
  "tariffs.surchargesLabel": "Toeslagen",
  "tariffs.invoiceText": "Tekst op de factuur",
  "tariffs.noPeriods": "Dit tarief heeft geen perioden.",
  "tariffs.currentPeriod": "Geldt vandaag",
  "tariffs.usedByTitle_one": "Gebruikt door {{count}} regel",
  "tariffs.usedByTitle_other": "Gebruikt door {{count}} regels",
  "tariffs.usedByNone": "Geen prijsafspraak gebruikt dit tarief.",
  "tariffs.colRule": "Regel",
  "tariffs.usedByFreight": "Vrachtregel {{sequence}}",
  "tariffs.usedByExtra": "Extra {{sequence}}",
  "tariffs.quantity": "Hoeveelheid",
  "tariffs.columnsAre": "De kolommen: {{quantity}}",
  "invoices.pdfAgain": "Opnieuw maken",
  "invoices.mail.sent": "Verstuurd {{at}} aan {{to}}",
  "invoices.mail.notSent": "Niet verstuurd",
  "invoices.mail.selfBilling": "Niet verstuurd: de klant factureert zelf",
  "invoices.mail.noAddress": "De klant heeft geen factuuradres (relatiekaart, Communicatie).",
  "invoices.mailSend": "Versturen",
  "invoices.mailAgain": "Opnieuw versturen",
  "invoices.booking.none": "Niet geboekt",
  "invoices.booking.queued": "In de wachtrij",
  "invoices.booking.booked": "Geboekt",
  "invoices.booking.failed": "Mislukt",
  "invoices.booking.dry_run": "Proefboeking, niet in AFAS",
  "invoices.bookAgain": "Opnieuw boeken",
  "invoices.afasPdfLabel": "Pdf in AFAS",
  "invoices.afasPdf.none": "Nog niet",
  "invoices.afasPdf.queued": "In de wachtrij",
  "invoices.afasPdf.attached": "Bij de factuur",
  "invoices.afasPdf.failed": "Mislukt",
  "invoices.afasPdf.dry_run": "Proef, niet in AFAS",
  "invoices.afasPdfSend": "Naar AFAS",
  "invoices.afasPdfAgain": "Opnieuw naar AFAS",
  "invoices.afasPdfAgainHint": "AFAS krijgt de pdf dan nog een keer, als tweede dossieritem bij de factuur.",
  "invoices.error.INVOICE_DOCUMENTS_OFF": "De factuur-pdf staat nog niet aan.",
  "invoices.error.INVOICE_BOOKING_OFF": "Boeken in AFAS staat nog niet aan.",
  "invoices.error.INVOICE_MAIL_OFF": "Facturen mailen staat nog niet aan.",
  "invoices.error.INVOICE_BOOKED": "Deze factuur is al geboekt in AFAS.",
  "invoices.error.INVOICE_NO_PDF": "De pdf van deze factuur is er nog niet.",
  "invoices.error.INVOICE_NOT_BOOKED": "Deze factuur staat nog niet in AFAS.",
  "invoices.error.NUMBER_USED": "Dat nummer is al gegeven; het laatste is {{last}}.",

  // Werklijsten — lijsten die DataBridge voor je uitvoert
  "worklists.group.warehouse": "Magazijn",
  "worklists.group.transport": "Transport",
  "worklists.request": "Aanvragen",
  "worklists.requesting": "Bezig…",
  "worklists.requested": "Aangevraagd",
  "worklists.requestedHint.print": "De lijst wordt op locatie afgedrukt. Duurt het lang, kijk dan bij de printer.",
  "worklists.requestedHint.mail": "De lijst komt er per mail aan. Duurt het lang, kijk dan bij de ongewenste mail.",
  "worklists.failed": "Aanvragen mislukt",
  "worklists.unavailable": "De koppeling met DataBridge is niet ingesteld, dus er kan hier nog niets aangevraagd worden.",
  "worklists.field.warehouse": "Magazijn",
  "worklists.field.owner": "Eigenaar",
  "worklists.field.collectionDate": "Afhaaldatum",
  "worklists.field.unloadingDate": "Losdatum",
  "worklists.field.fromRow": "Van rij",
  "worklists.field.toRow": "T/m rij",
  "worklists.field.printer": "Printer",
  "worklists.option.allOwners": "Alle eigenaren",
  "worklists.option.sameAsFrom": "Zelfde als van",
  "worklists.tellijstPicklocaties.label": "Tellijst picklocaties",
  "worklists.tellijstPicklocaties.desc":
    "Picklocaties met voorraad die sinds het vorige peilmoment gewijzigd is, met ruimte om het getelde aantal in te vullen.",
  "worklists.tellijstSecties.label": "Tellijst secties",
  "worklists.tellijstSecties.desc":
    "Per sectie de locaties en het aantal pallets volgens het systeem, met ruimte om het getelde aantal in te vullen. Elke rij komt op een eigen pagina.",
  "worklists.overzichtPicking.label": "Overzicht picking",
  "worklists.overzichtPicking.desc":
    "Te verzamelen orders voor de gekozen afhaaldag, per order de volle pallets, wat er met de hand bij moet en de VAS.",
  "worklists.aanvullijst.label": "Aanvullijst",
  "worklists.aanvullijst.desc":
    "Welke pallets er vanuit bulk naar een aanvullocatie moeten om de orders van de gekozen afhaaldag te kunnen picken, met de bestemming per pallet. Komt als Excel per mail.",
  "worklists.vrijeLocaties.label": "Vrije locaties",
  "worklists.vrijeLocaties.desc":
    "Alle locaties in het gekozen magazijn waar niets op staat. Komt als csv per mail naar het postvak van het magazijn.",
  "worklists.laadmetersHager.label": "Laadmeters Hager",
  "worklists.laadmetersHager.desc":
    "De Hager-zendingen op de gekozen losdag, met hun laadmeters en ruimte om een correctie in te vullen.",
  "worklists.requestedHint.screen": "De plaat opent zodra de pallets uit het systeem binnen zijn.",
  "worklists.field.rows": "Rijen",
  "worklists.ticked_one": "1 rij gekozen",
  "worklists.ticked_other": "{{count}} rijen gekozen",
  "worklists.tickAll": "Alles",
  "worklists.tickNone": "Geen",
  "worklists.tickRangeHint": "Shift + klik kiest alles vanaf de vorige.",
  "worklists.tellijstPlaat.label": "Tellijst als plaat",
  "worklists.tellijstPlaat.desc":
    "Elke gekozen rij als tekening, zoals je hem vanaf het pad ziet: per sectie de liggers met de pallets volgens het systeem en een vak voor het getelde aantal. Op de plaat vink je daarna de eigenaren aan, een of meer, uit wie er in die rijen staat: dan tellen alleen hun pallets. Verschijnt hier op het scherm, om af te drukken op A4 liggend, een blad per rij.",

  // Count sheet as a picture (route /count-sheet)
  "countSheet.back": "Werklijsten",
  "countSheet.print": "Afdrukken",
  "countSheet.paper": "Papier in",
  "countSheet.paperNl": "Nederlands",
  "countSheet.paperEn": "English",
  "countSheet.waiting": "Pallets ophalen uit het systeem…",
  "countSheet.slow": "Nog geen antwoord. Het scherm blijft wachten; komt er niets, vraag de plaat dan over een paar minuten opnieuw aan.",
  "countSheet.failed": "De pallets konden niet worden opgehaald.",
  "countSheet.notFound": "Deze tellijst bestaat niet (meer).",
  "countSheet.noAccess": "Je hebt geen toegang tot de werklijsten.",
  "countSheet.noPlaces_one": "WLX kent de plekken van rij {{rows}} in {{warehouse}} niet, dus daar is niets om te tekenen.",
  "countSheet.noPlaces_other": "WLX kent de plekken van de rijen {{rows}} in {{warehouse}} niet, dus daar is niets om te tekenen.",
  "countSheet.noOwnerPallets_one": "Geen pallets van {{owner}} in rij {{rows}}, dus daar is geen plaat van.",
  "countSheet.noOwnerPallets_other": "Geen pallets van {{owner}} in de rijen {{rows}}, dus daar zijn geen platen van.",
  "countSheet.sheets_one": "1 plaat",
  "countSheet.sheets_other": "{{count}} platen, een blad per rij",
  "countSheet.owner": "Alleen pallets van {{owner}}",
  "countSheet.ownersOnPaper": "Tel alleen de pallets van de eigenaren met een kruisje:",
  "countSheet.owners": "Eigenaren in deze rijen",
  "countSheet.ownersAll": "Niets aangevinkt: de pallets van iedereen tellen.",
  "countSheet.ownersTicked": "Alleen de pallets van de aangevinkte eigenaren tellen: op de plaat staan ze met een kruisje, en de pallets van een ander grijs.",
  "countSheet.ownersReset": "Alle eigenaren",
  "countSheet.ownerNumber": "Eigenaar {{number}}",
  "countSheet.ownerMeta_one": "Eigenaar {{number}} · 1 pallet",
  "countSheet.ownerMeta_other": "Eigenaar {{number}} · {{count}} pallets",
  "countSheet.ownersUnknown": "Het systeem stuurde niet mee van wie de pallets zijn, dus bij deze plaat kun je geen eigenaren kiezen.",
  "countSheet.legend.other": "Pallet van een andere eigenaar: niet tellen",
  "countSheet.notInWlx": "Staan in het systeem maar niet in WLX ({{count}}): {{names}}",
  "countSheet.notInWms": "Plekken van WLX die het systeem niet noemt: {{count}}. Ze staan op de plaat met een vraagteken.",
  "countSheet.requested": "Aangevraagd door {{name}} op {{when}}",
  "countSheet.title": "Tellijst rij",
  "countSheet.subtitle": "{{warehouse}} · {{sections}} secties · {{levels}} niveaus · {{places}} plekken",
  "countSheet.walk": "Looprichting: begin bij",
  "countSheet.legend.pallet": "Pallet volgens het systeem",
  "countSheet.legend.palletCounted": "Pallet van een eigenaar met een kruisje: tellen",
  "countSheet.legend.multiple": "Meer dan één pallet op de plek",
  "countSheet.legend.empty": "Leeg volgens het systeem",
  "countSheet.legend.noPlace": "Geen plek",
  "countSheet.legend.blocked": "Geblokkeerd",
  "countSheet.legend.pick": "Pickplek",
  "countSheet.legend.bulk": "Bulkplek in de stelling",
  "countSheet.legend.set": "Pallet set: 2 op elkaar",
  "countSheet.legend.unknown": "Niet bekend in het systeem",
  "countSheet.systemTotal": "Volgens het systeem",
  "countSheet.pallets": "{{count}} pallets",
  "countSheet.asOf": "stand {{when}}",
  "countSheet.instruction":
    "Vergelijk elke sectie met de tekening. Pallet weg: streep hem door. Pallet op een lege plek: kruis de plek aan. Schrijf per sectie het getelde aantal in het vak.",
  "countSheet.attention": "Let op",
  "countSheet.multiple": "Volgens het systeem staat er meer dan één pallet op {{places}}. Kijk daar extra goed.",
  "countSheet.notDrawn": "In deze rij staat ook bulk die niet getekend is: {{places}} plekken met {{pallets}} pallets. Tel die apart.",
  "countSheet.section": "Sectie {{number}}",
  "countSheet.level": "Niv.",
  "countSheet.noPlace": "geen plek",
  "countSheet.system": "Systeem",
  "countSheet.counted": "Geteld",
  "countSheet.totalSystem": "Totaal volgens het systeem",
  "countSheet.totalCounted": "Totaal geteld",
  "countSheet.totalDeviating": "Totaal afwijkend",
  "countSheet.name": "Naam",
  "countSheet.date": "Datum",
  "countSheet.initials": "Paraaf",

  // Requirements module
  "req.tab.dashboard": "Dashboard",
  "req.tab.requirements": "Requirements",
  "req.tab.functionAreas": "Functiegebieden",
  "req.tab.relations": "Relaties",
  "req.tab.explore": "Verkennen",
  "req.explore.root": "Hoofd",
  "req.explore.back": "Terug",
  "req.explore.noArea": "Zonder functiegebied",
  "req.explore.empty": "Niets te tonen voor dit gebied.",
  "req.explore.hint": "Klik een gebied om in te zoomen; klik een requirement voor zijn relaties.",
  "req.project.select": "Kies een project",
  "req.project.new": "+ Nieuw project",
  "req.project.manage": "Project beheren",
  "req.project.none": "Nog geen projecten. Maak er een aan om te beginnen.",
  "req.project.nameLabel": "Naam",
  "req.project.descLabel": "Omschrijving",
  "req.project.vendorLabel": "Leverancier / pakket",
  "req.project.statusLabel": "Status",
  "req.projStatus.active": "Actief",
  "req.projStatus.completed": "Afgerond",
  "req.prio.must": "Must",
  "req.prio.should": "Should",
  "req.prio.could": "Could",
  "req.prio.wont": "Won't",
  "req.status.new": "Nieuw",
  "req.status.accepted": "Geaccepteerd",
  "req.status.rejected": "Afgewezen",
  "req.type.functional": "Functioneel",
  "req.type.non_functional": "Niet-functioneel",
  "req.fa.add": "Functiegebied toevoegen",
  "req.fa.addChild": "Subgebied toevoegen",
  "req.fa.rename": "Hernoemen",
  "req.fa.delete": "Verwijderen",
  "req.fa.namePrompt": "Naam van het functiegebied",
  "req.fa.empty": "Nog geen functiegebieden. Voeg er een toe.",
  "req.fa.adminOnly": "Alleen beheerders kunnen functiegebieden wijzigen.",
  "req.fa.deleteBlocked": "Kan niet verwijderen: er hangen subgebieden of requirements aan.",
  "req.fa.new": "Nieuw functiegebied",
  "req.fa.editTitle": "Functiegebied wijzigen",
  "req.fa.under": "Onder: {{parent}}",
  "req.fa.nameLabel": "Naam",
  "req.fa.deleteTitle": "Functiegebied verwijderen",
  "req.fa.deleteMsg": "Weet je zeker dat je «{{name}}» wilt verwijderen? Dit kan niet ongedaan worden gemaakt.",
  "req.col.number": "Nr.",
  "req.col.title": "Titel",
  "req.col.areas": "Functiegebieden",
  "req.col.priority": "Prioriteit",
  "req.col.status": "Status",
  "req.col.type": "Type",
  "req.col.requester": "Aanvrager",
  "req.col.actions": "Acties",
  "req.filter.all": "Alle",
  "req.filter.search": "Zoeken…",
  "req.new": "Nieuwe requirement",
  "req.edit": "Requirement bewerken",
  "req.empty": "Geen requirements gevonden.",
  "req.field.title": "Titel",
  "req.field.description": "Omschrijving",
  "req.field.priority": "Prioriteit",
  "req.field.status": "Status",
  "req.field.type": "Type",
  "req.field.areas": "Functiegebieden",
  "req.field.related": "Gerelateerde requirements",
  "req.delete.confirm": "Deze requirement verwijderen?",
  "req.export": "Exporteren",
  "req.import": "Importeren",
  "req.dash.total": "Totaal",
  "req.dash.byStatus": "Per status",
  "req.dash.byPriority": "MoSCoW-verdeling",
  "req.dash.byArea": "Per functiegebied",
  "req.dash.empty": "Nog geen requirements om te tonen.",
  "req.import.title": "Requirements importeren",
  "req.import.help":
    "Plak of upload een CSV met kolommen: title, description, priority, status, type, functionAreas. Functiegebieden gescheiden door ';' en hiërarchie met '>'. Gebieden die nog niet bestaan worden automatisch aangemaakt.",
  "req.import.run": "Importeren",
  "req.import.result": "{{created}} aangemaakt, {{failed}} mislukt van {{total}}.",
  "req.import.areasCreated": "Nieuwe functiegebieden aangemaakt: {{count}}.",
  "req.import.errorsHeading": "Fouten",
  "req.rel.loading": "Grafiek laden…",
  "req.rel.pickHint": "Klik op een requirement in de grafiek voor details.",
  "req.rel.anchor.label": "Anker-requirement",
  "req.rel.anchor.placeholder": "Zoek op nummer of titel…",
  "req.rel.anchor.none": "Kies een anker-requirement om relaties te leggen.",
  "req.rel.dropzone": "Sleep hierheen om te koppelen",
  "req.rel.linked": "Gekoppeld",
  "req.rel.link": "+ Koppel",
  "req.rel.unlink": "Ontkoppel",
  "req.rel.empty": "Geen requirements gevonden.",
  "req.rel.error": "Koppeling mislukt. Probeer het opnieuw.",

  // Env labels
  "env.prod": "PROD",
  "env.acc": "ACC",
  "env.local": "LOCAL",

  // Non-production notice banner
  "banner.acc": "Acceptatieomgeving",
  "banner.local": "Ontwikkelomgeving",
  "banner.note": "gegevens hier staan los van productie",

  // User menu
  "user.unknownUser": "Onbekende gebruiker",
  "user.menuLabel": "Gebruikersmenu van {{name}}",
  "user.profile": "Profiel",
  "user.language": "Taal",
  "user.theme": "Thema",
  "user.themeLight": "Licht",
  "user.themeDark": "Donker",
  "user.themeSystem": "Systeem",
  "user.keyboardShortcuts": "Sneltoetsen",
  "user.releaseNotes": "Release notes",
  "releaseNotes.title": "Release notes",
  "releaseNotes.summary": "{{count}} versies · de laatste is {{version}} van {{date}}",
  "releaseNotes.search": "Zoek op een woord, onderdeel of versie",
  "releaseNotes.showOther": "Ook documentatie en onderhoud",
  "releaseNotes.groupNew": "Nieuw",
  "releaseNotes.groupFixed": "Opgelost",
  "releaseNotes.groupOther": "Documentatie en onderhoud",
  "releaseNotes.onlyOther": "Alleen documentatie en onderhoud in deze versie.",
  "releaseNotes.noMatch": "Niets gevonden.",
  "user.signOut": "Uitloggen",

  // Keyboard shortcuts dialog
  "kb.title": "Sneltoetsen",
  "kb.close": "Sluiten",
  "kb.comingSoon": "— binnenkort",
  "kb.groups.global": "Globaal",
  "kb.shortcuts.openPanel": "Sneltoetsen (dit paneel)",
  "kb.shortcuts.commandPalette": "Opdrachtenpalette",
  "kb.groups.tables": "Tabellen",
  "kb.shortcuts.nextRow": "Volgende rij",
  "kb.shortcuts.prevRow": "Vorige rij",
  "kb.shortcuts.openRow": "Rij openen / selecteren",
  "kb.shortcuts.focusSearch": "Zoekbalk activeren",
  "kb.groups.general": "Algemeen",
  "kb.shortcuts.closePanel": "Paneel sluiten of annuleren",

  // Common / shared
  "common.loading": "Laden…",
  "columns.button": "Kolommen",
  "columns.buttonHint": "Kies welke kolommen je ziet en in welke volgorde",
  "columns.title": "Kolommen",
  "columns.alwaysShown": "Altijd zichtbaar",
  "columns.hint":
    "Sleep een rij (of Alt+↑/↓) om een kolom te verplaatsen. In de tabel sleep je een kolomkop naar een andere plek, of de rand ervan voor de breedte.",
  "columns.reset": "Standaardweergave herstellen",
  "columns.resize": "Breedte van {{column}}",
  "columns.resizeHint": "Sleep om de breedte te wijzigen, dubbelklik om de kolom zo breed te maken als de langste regel",
  "columns.filterBy": "Filteren op {{column}}",
  "columns.filteredBy": "Gefilterd op {{column}}: klik om het filter te wijzigen",
  "columns.filterContains": "Bevat…",
  "columns.filterRangeFrom": "Van",
  "columns.filterRangeTo": "Tot en met",
  "columns.filterFrom": "vanaf {{value}}",
  "columns.filterUntil": "tot en met {{value}}",
  "columns.filterClear": "Wissen",
  "columns.filterDone": "Klaar",
  "columns.filteredOn": "Gefilterd op",
  "columns.filterRemove": "Filter op {{column}} weghalen",
  "columns.filterClearAll": "Alle filters wissen",
  "columns.sortBy": "Sorteer op {{column}} · sleep om de kolom te verplaatsen",
  "columns.dragHint": "Sleep om de kolom te verplaatsen",
  "lightbox.label": "Afbeelding",
  "lightbox.toolbar": "Zoomen",
  "lightbox.zoomIn": "Inzoomen",
  "lightbox.zoomOut": "Uitzoomen",
  "lightbox.fit": "Hele afbeelding",
  "lightbox.openInTab": "Openen in nieuw tabblad",
  "lightbox.hint": "Scrol of klik om te zoomen, sleep om te verschuiven",
  "lightbox.failed": "De afbeelding kon niet worden geladen.",
  "common.cancel": "Annuleren",
  "common.save": "Wijzigingen opslaan",
  "common.saved": "Opgeslagen",
  "common.moreInfo": "Meer informatie",
  "common.close": "Sluiten",
  "common.back": "Terug",
  "common.saving": "Opslaan…",
  "common.remove": "Verwijderen",
  "common.create": "Aanmaken",
  "common.deactivate": "Deactiveren",
  "common.reactivate": "Reactiveren",
  "common.firstPage": "← Eerste pagina",
  "common.nextPage": "Volgende pagina →",
  "common.onThisPage_one": "{{count}} op deze pagina",
  "common.onThisPage_other": "{{count}} op deze pagina",
  "common.perPage": "Per pagina",
  "common.errorGeneric": "Er is een fout opgetreden",
  "common.status": "Status",
  "common.name": "Naam",
  "common.code": "Code",
  "common.type": "Type",
  "common.created": "Aangemaakt",
  "common.updated": "Bijgewerkt",
  "common.details": "Details",
  "common.record": "Record",
  "common.id": "ID",
  "common.active": "Actief",
  "common.inactive": "Inactief",
  "common.yes": "Ja",
  "common.no": "Nee",
  "common.all": "Alles",
  "common.changedAt": "Laatst gewijzigd",
  "common.changedBy": "Gewijzigd door",
  "common.changedViaWlx": "WLX",
  "common.changedViaTalis": "TALIS",
  "common.changedViaAfas": "AFAS",
  "common.changedViaDatabridge": "DataBridge",
  "common.changedViaScoretrace": "Scoretrace",
  "common.changedViaPortal": "Klantenportaal",
  "common.changedViaCustomer": "Klantkoppeling",
  "common.changedBySystem": "Een koppeling of WLX zelf, geen persoon",
  "common.lastUpdated": "Laatste update",

  // Login
  "login.logoAlt": "Willems Logistics",
  "login.platform": "Willems Logistics Platform",
  // Merkregel onder de payoff. Bewust leeg: zolang deze leeg is, staat er niets
  // onder "Your business on track." Vul hem om hem terug te zetten.
  "login.taglineSub": "",
  "login.copyright": "© 1930–2026 Willems Logistics · Rijkevoort, NL",
  "login.privacy": "Privacy",
  "login.support": "Ondersteuning",
  "login.signInEyebrow": "Aanmelden",
  "login.welcomeBack": "Welkom terug.",
  "login.signInDesc": "Gebruik je Willems Microsoft 365-account om aan te melden.",
  "login.signInFailed": "Aanmelden mislukt. Probeer opnieuw of neem contact op met IT-support.",
  "login.signInWith": "Aanmelden met Microsoft",
  "login.willemsInternal": "· Willems intern",
  "login.mfaEnforced": "MFA afgedwongen via Entra ID",
  "login.devMode": "Ontwikkelmodus — Entra ID omzeild",
  "login.signInAsMock": "Aanmelden als testgebruiker",

  // Dashboard screen
  "dashboard.summary": "Week {{week}} · {{events}} afspraken vandaag · {{overdue}} verlopen en {{today}} taken voor vandaag.",
  "dashboard.noModules": "Er zijn nog geen modules voor je vrijgegeven. Neem contact op met de beheerder.",
  "dashboard.workQueues": "Werkbakken",
  "dashboard.agendaTitle": "Vandaag in je agenda",
  "dashboard.agendaEmpty": "Geen afspraken vandaag.",
  "dashboard.agendaNotLinked": "Koppel je Outlook-agenda om je afspraken hier te zien.",
  "dashboard.openAgenda": "Naar agenda",
  "dashboard.tasksTitle": "Taken",
  "dashboard.tasksEmpty": "Niets verlopen of voor vandaag. Mooi.",
  "dashboard.tasksOverdue": "Verlopen ({{count}})",
  "dashboard.tasksToday": "Vandaag ({{count}})",
  "dashboard.tasksUnclaimed": "Onbeheerd in je postvak ({{count}})",
  "dashboard.teamTitle": "Je team",
  "dashboard.andMore": "+ {{count}} meer",
  // De "Wacht op jou"-strook — bovenaan de dagstart, boven elke deadline.
  "dashboard.forYouTitle": "Wacht op jou",
  "dashboard.forYouDesc": "Hier is jou persoonlijk iets gevraagd.",
  "dashboard.forYouOpen": "Openen",
  "dashboard.forYouMarkAll": "Alles gelezen",
  "dashboard.openTasks": "Naar taken",
  "dashboard.mailTitle": "Ongelezen mail",
  "dashboard.mailEmpty": "Alles gelezen.",
  "dashboard.openMail": "Naar mail",
  "dashboard.notImplemented": "Dashboard-inhoud is nog niet geïmplementeerd.",
  "dashboard.referenceNote": "Zie {{path}} voor het referentie-ontwerp.",

  // Documents screen
  "documents.type.SignedCMR": "Afgetekende CMR",
  "documents.type.CMR": "CMR",
  "documents.type.PackingSlip": "Pakbon",
  "documents.type.Checklist": "Checklist",
  "documents.type.PalletList": "Palletlijst",
  "documents.type.InboundChecklist": "Inbound checklist",
  "documents.type.WarehouseSet": "Magazijnset",
  "documents.type.Other": "Overig",
  "documents.visibility.CustomerVisible": "Ook de klant",
  "documents.visibility.InternalOnly": "Alleen Willems",
  "documents.col.type": "Soort",
  "documents.col.consignment": "Zending",
  "documents.col.file": "Bestand",
  "documents.col.version": "Versie",
  "documents.col.visibility": "Zichtbaar voor",
  "documents.col.received": "Binnen",
  "documents.noneForOrder": "Nog geen documenten bij deze order. De afgetekende CMR komt hier zodra hij gescand is.",
  "documents.replaced": "vervangen",
  "documents.inbox.title": "Scans zonder zending",
  "documents.inbox.intro": "Scans die geen zending vonden: geen barcode, een nummer dat WLX niet kent, of meer zendingen die het kunnen zijn. Open de scan, kies of typ het zendingnummer en koppel hem; zonder zending kan het ook het nummer van het dossier, de order of de levering zijn. Een pagina die geen CMR is, gooi je weg.",
  "documents.inbox.state.open": "Zonder zending",
  "documents.inbox.state.linked": "Gekoppeld",
  "documents.inbox.state.discarded": "Weggegooid",
  "documents.inbox.colReceived": "Binnen",
  "documents.inbox.colType": "Soort",
  "documents.inbox.colRead": "Gelezen nummer",
  "documents.inbox.colFile": "Scan",
  "documents.inbox.colSource": "Bron",
  "documents.inbox.colResult": "Zending en dossier",
  "documents.inbox.colActions": "Koppelen",
  "documents.inbox.noNumber": "geen barcode gelezen",
  "documents.inbox.discarded": "weggegooid",
  "documents.inbox.toTalis": "Naar TALIS, activiteit {{activity}}",
  "documents.inbox.talisRefused": "TALIS weigerde activiteit {{activity}}: {{error}}",
  "documents.inbox.empty.open": "Geen scans zonder zending.",
  "documents.inbox.empty.linked": "Nog niets gekoppeld.",
  "documents.inbox.empty.discarded": "Niets weggegooid.",
  "documents.inbox.numberPlaceholder": "ORD-2026-000123-1",
  "documents.inbox.numberLabel": "Zending-, order- of dossiernummer",
  "documents.inbox.link": "Koppelen",
  "documents.inbox.discard": "Weggooien",
  "documents.inbox.state.files": "Ingelezen",
  "documents.inbox.colReason": "Waarom",
  "documents.inbox.reason.no_barcode": "Geen barcode",
  "documents.inbox.reason.behind_cmr": "Geen CMR: hoort waarschijnlijk achter de vorige scan",
  "documents.inbox.reason.unknown_number": "Nummer niet gevonden",
  "documents.inbox.reason.several": "Meer orders of dossiers met deze levering",
  "documents.inbox.behindTrip": "achter rit {{trip}}",
  "documents.inbox.pages": "p. {{pages}}",
  "documents.inbox.numberPick": "Kies of typ de zending",
  "documents.scans.add": "Scans toevoegen",
  "documents.scans.title": "Scans toevoegen",
  "documents.scans.folder": "Map",
  "documents.scans.folders.MetVoorblad": "Met voorblad",
  "documents.scans.folders.ZonderVoorblad": "Zonder voorblad",
  "documents.scans.folders.Magazijn": "Magazijn",
  "documents.scans.folderHelp.MetVoorblad": "CMR's achter een ritlijst, en de laad- en loslijsten. Een pagina zonder barcode hoort bij de ritlijst ervoor.",
  "documents.scans.folderHelp.ZonderVoorblad": "CMR's zonder ritlijst ervoor.",
  "documents.scans.folderHelp.Magazijn": "Sets uit het magazijn: de checklist met de levering, de palletlijst en de CMR erachter.",
  "documents.scans.files": "Bestanden",
  "documents.scans.drop": "Sleep pdf's hierheen, of kies ze",
  "documents.scans.chosen_one": "1 bestand · {{size}}",
  "documents.scans.chosen_other": "{{count}} bestanden · {{size}}",
  "documents.scans.skipped_one": "1 overgeslagen: geen pdf",
  "documents.scans.skipped_other": "{{count}} overgeslagen: geen pdf",
  "documents.scans.order": "WLX leest ze op naam, één voor één, zoals de scanner ze nummert. Een bestand dat al is ingelezen, verandert niets.",
  "documents.scans.read": "Inlezen",
  "documents.scans.stop": "Stoppen",
  "documents.scans.more": "Meer inlezen",
  "documents.scans.progress": "{{done}} van {{total}}",
  "documents.scans.stopped": "gestopt",
  "documents.scans.pagesRead": "Met barcode",
  "documents.scans.outcome.linked": "Gekoppeld",
  "documents.scans.outcome.inbox": "In de werkbak",
  "documents.scans.outcome.talis": "Uit TALIS",
  "documents.scans.outcome.trip": "Bij een rit",
  "documents.scans.outcome.no_transport": "Zonder dossier",
  "documents.scans.outcome.blank": "Leeg",
  "documents.scans.errors": "Fout",
  "documents.scans.again": "al eerder ingelezen",
  "documents.scans.colFile": "Bestand",
  "documents.scans.colPages": "Pagina's",
  "documents.scans.colOutcome": "Wat ermee gebeurde",
  "documents.scans.error.NOT_A_PDF": "Geen pdf.",
  "documents.scans.error.SCAN_UNREADABLE": "De pdf gaat niet open.",
  "documents.scans.error.CONFLICT": "Er is al een ander bestand met deze naam uit deze map ingelezen.",
  "documents.scans.error.DOCUMENT_TOO_LARGE": "Groter dan 25 MB.",
  "documents.scans.error.DOCUMENT_STORAGE_OFF": "SharePoint is niet ingericht: er kan niets bewaard worden.",
  "documents.scans.list.intro": "Wat de lezer van elk bestand maakte. Klik op een bestand voor de pagina's en het bestand zelf. Een CMR uit TALIS waarvan de zending niet in WLX staat, gaat op zijn barcode naar TALIS.",
  "documents.scans.list.colReceived": "Ingelezen",
  "documents.scans.list.colRead": "Met barcode",
  "documents.scans.list.totals": "{{files}} bestanden · {{pages}} pagina's · {{read}} met barcode · {{linked}} gekoppeld · {{inbox}} werkbak · {{talis}} TALIS",
  "documents.scans.list.empty": "Nog niets ingelezen.",
  "documents.inbox.reason.candidates": "Mogelijk gevonden: kies de zending",
  "documents.scans.outcome.pending": "Wordt gelezen",
  "documents.scans.pendingHint_one": "1 pagina zonder tekst wordt op de achtergrond gelezen (OCR). Kijk straks bij Ingelezen.",
  "documents.scans.pendingHint_other": "{{count}} pagina's zonder tekst worden op de achtergrond gelezen (OCR). Kijk straks bij Ingelezen.",
  "documents.scans.list.colStatus": "Status",
  "documents.scans.status.reading": "Wordt gelezen",
  "documents.scans.status.done": "Klaar",
  "documents.scans.status.failed": "Niet gelukt",
  "documents.scans.kind.cmr": "CMR",
  "documents.scans.kind.trip_sheet": "Ritlijst",
  "documents.scans.kind.loading_list": "Laadlijst",
  "documents.scans.kind.unloading_list": "Loslijst",
  "documents.scans.kind.warehouse_set": "Magazijnset",
  "documents.scans.kind.none": "Geen barcode van ons",
  "documents.scans.kind.blank": "Leeg",
  "documents.scans.paper.checklist": "Checklist",
  "documents.scans.paper.pallet_list": "Palletlijst",
  "documents.scans.paper.packing_slip": "Pakbon",
  "documents.scans.paper.inbound_checklist": "Inbound checklist",
  "documents.scans.paper.cmr": "CMR",
  "documents.scans.system.wlx": "van WLX",
  "documents.scans.system.talis": "van TALIS",
  "documents.scans.pageCount_one": "1 pagina",
  "documents.scans.pageCount_other": "{{count}} pagina's",
  "documents.scans.openOriginal": "Bestand openen",
  "documents.scans.page.title": "Pagina {{page}}",
  "documents.scans.page.open": "Openen",
  "documents.scans.page.linked": "Gekoppeld aan {{what}}, dossier {{dossier}}",
  "documents.scans.page.inbox": "In de werkbak: {{why}}",
  "documents.scans.page.talis": "Uit TALIS: niet in WLX gevonden, blijft liggen",
  "documents.scans.page.toTalis": "Niet in WLX, op de barcode naar TALIS (activiteit {{activity}})",
  "documents.scans.page.trip": "Bij rit {{trip}}",
  "documents.scans.page.noTransport": "Set van levering {{delivery}}: geen transport van Willems en geen dossier met dit nummer, bewaard",
  "documents.scans.page.pending": "Wordt gelezen met OCR",
  "documents.scans.page.blank": "Leeg, overgeslagen",
  "documents.scans.page.toQueue": "naar de werkbak",
  "documents.scans.page.matchedOn": "Gevonden op de {{field}} {{reference}} en postcode {{postcode}}",
  "documents.scans.page.barcodes": "Barcodes:",
  "documents.scans.page.textFrom.pdf": "Tekst uit de pdf",
  "documents.scans.page.textFrom.ocr": "Tekst gelezen met OCR",
  "documents.scans.page.noReferences": "(geen nummers om op te zoeken)",
  "documents.scans.field.order": "referentie van de order",
  "documents.scans.field.consignment": "referentie van de zending",
  "documents.scans.field.loading": "laadreferentie",
  "documents.scans.field.unloading": "losreferentie",
  "documents.addToOrder.title": "Bij order zetten",
  "documents.addToOrder.open": "Toevoegen",
  "documents.addToOrder.drop": "Sleep hier een mail of bestand naartoe, uit WLX Mail, Outlook of de Verkenner.",
  "documents.addToOrder.dropHere": "Loslaten om bij deze order te zetten",
  "documents.addToOrder.order": "Order",
  "documents.addToOrder.searchOrder": "Ordernummer, zendingnummer of referentie",
  "documents.addToOrder.searchHint": "Typ minstens drie tekens.",
  "documents.addToOrder.noOrders": "Geen order gevonden.",
  "documents.addToOrder.otherOrder": "Andere order",
  "documents.addToOrder.wholeOrder": "De hele order",
  "documents.addToOrder.consignmentHelp": "Een pakbon hoort bij één zending: WLX print hem achter de CMR daarvan.",
  "documents.addToOrder.slipNeedsConsignment": "Kies de zending voor de pakbon.",
  "documents.addToOrder.theMail": "De mail zelf",
  "documents.addToOrder.loadingMail": "Bijlagen ophalen…",
  "documents.addToOrder.attachmentsHelp": "De bijlagen zitten al in de mail. Vink er een aan om hem ook los bij de order te zetten, bijvoorbeeld als pakbon.",
  "documents.addToOrder.internal": "Alleen voor Willems zichtbaar. Een pakbon gaat tot de livegang ook naar TALIS als de order daar ook staat.",
  "documents.addToOrder.submit": "Toevoegen",
  "documents.addToOrder.added_one": "Eén document bij de order gezet.",
  "documents.addToOrder.added_other": "{{count}} documenten bij de order gezet.",
  "documents.addToOrder.personalMailbox": "Een mail uit je eigen postvak gaat niet in een dossier. Sleep hem uit een gedeeld postvak, of stuur hem daar eerst naartoe.",
  "mail.addToOrder": "Bij order zetten",
  "mail.addedToOrder": "Bij order {{number}} gezet.",
  "documents.upload.open": "Bestand toevoegen",
  "documents.upload.title": "Bestand toevoegen aan het dossier",
  "documents.upload.submit": "Toevoegen",
  "documents.upload.file": "Bestand",
  "documents.upload.tooLarge": "Groter dan 25 MB: dat past niet.",
  "documents.upload.visibleHint": "De klant ziet hem bij de zending in het portaal.",
  "documents.upload.internalHint": "Alleen voor Willems zichtbaar.",
  "documents.upload.chooseConsignment": "Kies de zending",
  "documents.upload.noConsignment": "Geen zending in het bijzonder",

  // Users
  "users.searchPlaceholder": "Naam of e-mail zoeken…",
  "users.searchLabel": "Gebruikers zoeken",
  "users.allRoles": "Alle rollen",
  "users.allStatus": "Alles",
  "users.activeStatus": "Actief",
  "users.inactiveStatus": "Inactief",
  "users.colNameEmail": "Naam / E-mail",
  "users.colEmail": "E-mail",
  "users.colRoles": "Rollen",
  "users.colStatus": "Status",
  "users.colLastLogin": "Laatste login",
  "users.colCreated": "Aangemaakt",
  "users.noUsers": "Geen gebruikers gevonden.",
  "users.noRoles": "Geen rollen toegewezen.",
  "users.remove": "Verwijderen",
  "users.removeRoleLabel": "Rol {{role}} verwijderen",
  "users.assignRole": "+ Rol toewijzen",
  "users.userId": "Gebruiker-ID",
  "users.lastLogin": "Laatste login",
  "users.details": "Details",
  "users.filterByRole": "Filteren op rol",
  "users.roles": "Rollen",
  "users.failedAssignRole": "Rol toewijzen mislukt",
  "users.failedRemoveRole": "Rol verwijderen mislukt",
  "users.failedUpdateUser": "Gebruiker bijwerken mislukt",

  // Parties
  "parties.searchPlaceholder": "Naam, code of referentie zoeken…",
  "parties.searchLabel": "Relaties zoeken",
  "parties.sourceNote": "Relaties maak en wijzig je in AFAS; WLX neemt ze vanzelf over.",
  "parties.readOnlyNote": "Deze relatie wijzig je in AFAS. WLX neemt elke wijziging vanzelf over.",
  "parties.allTypes": "Alle typen",
  "parties.colName": "Naam",
  "parties.colCode": "Code",
  "parties.colType": "Type",
  "parties.colIdentifiers": "Systeem-ID's",
  "parties.colStatus": "Status",
  "parties.colCreated": "Aangemaakt",
  "parties.noParties": "Geen relaties gevonden.",
  "parties.nameLabel": "Naam",
  "parties.relationLabel": "Soort relatie",
  "parties.relationSales": "Verkooprelatie",
  "parties.relationPurchase": "Inkooprelatie",
  "parties.relationNone": "Geen debiteur- of crediteurnummer",
  "parties.relationHelp": "Afgeleid uit het debiteur- en het crediteurnummer, zoals in AFAS.",
  "parties.wlxSettingsTitle": "In WLX",
  "parties.wlxSettingsHelp": "AFAS kent dit niet, dus stel je het hier in.",
  "parties.wlxManagedHelp":
    "Dit beheer je in WLX: AFAS kent het niet. Wat hier staat, blijft staan.",
  "parties.ownOrganizationLabel": "Eigen organisatie",
  "parties.ownOrganizationHelp":
    "Willems zelf. Er is er één: vink je een andere relatie aan, dan verhuist het vinkje. Deze kaart krijgt dan de tab Organisatie, met de leidinggevende-boom.",
  "parties.identifiersTitle": "Systeemkenmerken",
  "parties.identifiersHelp":
    "Hoe andere systemen deze relatie noemen. Vastgelegd door de koppelingen — terugmeldingen en de TALIS-koppeling herkennen de relatie hierop. TMS is het systeem waar orders heen gaan (vandaag Qargo); TALIS is het nummer uit TALIS.",
  "parties.identifiersEmpty": "Nog geen enkel systeem heeft deze relatie benoemd.",
  "parties.systemTms": "TMS",
  "parties.systemWms": "WMS",
  "parties.systemErp": "ERP",
  "parties.systemTalis": "TALIS",
  "parties.systemAfas": "AFAS",
  "parties.parentHelp": "Het concern waar deze relatie bij hoort.",
  "parties.parentNone": "Geen concern",
  "parties.wmsOwnerLabel": "Eigenaar in Scoretrace",
  "parties.wmsOwnerHelp": "Het nummer van deze relatie als eigenaar van voorraad in Scoretrace. Magazijnorders en artikelen vinden de relatie hierop.",
  "parties.lastUpdated": "Laatste update",

  // Party roles and the party card (docs/tms-stamdata.md §5)
  "parties.roleFilterLabel": "Rol",
  "parties.roleAll": "Alle",
  "parties.roleCustomers": "Verkooprelaties",
  "parties.roleCharters": "Inkooprelaties",
  "parties.colRoles": "Rollen",
  "parties.roleCustomer": "Verkooprelatie",
  "parties.roleCharter": "Inkooprelatie",
  "parties.roleEnded": "beëindigd",
  "parties.chipBlocked": "geblokkeerd",
  "parties.tabGeneral": "Algemeen",
  "parties.tabCustomer": "Verkooprelatie",
  "parties.tabCharter": "Inkooprelatie",
  "parties.tabCommunication": "Communicatie",
  "parties.tabPortal": "Portaal",
  "parties.tabDossiers": "Dossiers",
  "parties.tabOrganization": "Organisatie",
  "parties.notFound": "Relatie niet gevonden",
  "parties.notFoundDesc": "Deze relatie bestaat niet (meer), of je hebt er geen toegang toe.",
  "parties.shortNameLabel": "Korte naam",
  "parties.cocLabel": "KvK-nummer",
  "parties.vatLabel": "Btw-nummer",
  "parties.phoneLabel": "Telefoon",
  "parties.websiteLabel": "Website",
  "parties.contactHelp": "De algemene gegevens van het bedrijf, nooit die van een persoon.",
  "parties.parentLabel": "Hoort bij",
  "parties.saved": "Opgeslagen",
  "parties.customerEmpty": "Deze relatie is geen verkooprelatie.",
  "parties.charterEmpty": "Deze relatie is geen inkooprelatie.",
  "parties.roleActiveLabel": "Rol actief",
  "parties.debtorNumberLabel": "Debiteurnummer (VR)",
  "parties.paymentTermLabel": "Betaaltermijn in dagen",
  "parties.vatCodeLabel": "Btw-code",
  "parties.vat1": "1 · Btw hoog (21%)",
  "parties.vat2": "2 · Btw laag (9%)",
  "parties.vat3": "3 · Geen btw",
  "parties.vat35": "35 · Btw 0%, diensten binnen de EU (verlegd)",
  "parties.vatShort1": "1 · 21%",
  "parties.vatShort2": "2 · 9%",
  "parties.vatShort3": "3 · 0%",
  "parties.vatShort35": "35 · verlegd",
  "parties.invoiceAddressTitle": "Factuuradres",
  "parties.invoiceStreetLabel": "Adres of postbus",
  "parties.postalCodeLabel": "Postcode",
  "parties.cityLabel": "Plaats",
  "parties.countryLabel": "Land",
  "parties.invoicingTitle": "Factureren",
  "parties.referenceRequiredLabel": "Factuurreferentie verplicht",
  "parties.referenceRequiredHelp": "Zonder factuurreferentie is een order niet in te voeren.",
  "parties.criticalWindowLabel": "Kritiek bij een vaste lostijd (uren)",
  "parties.criticalWindowHelp": "Heeft een losactiviteit een venster van hoogstens zoveel uur, dan wordt de order kritiek. Leeg: niet voor deze klant.",
  "parties.criticalWindowPlaceholder": "Niet",
  "parties.defaultReferenceLabel": "Vaste referentie op de factuur",
  "parties.defaultReferenceHelp": "Bijvoorbeeld een vast inkoopordernummer van de klant.",
  "parties.selfBillingLabel": "Self-billing",
  "parties.selfBillingHelp": "De klant stelt de factuur zelf op.",
  "parties.transportTitle": "Transport",
  "parties.conversionLabel": "Omrekenen bij facturatie",
  "parties.conversionWeightToLm": "Gewicht naar laadmeters",
  "parties.conversionLmToWeight": "Laadmeters naar gewicht",
  "parties.conversionHelp":
    "Bij facturatie rekent WLX gewicht om naar laadmeters of andersom, met de kilo per laadmeter hiernaast. Bij orderinvoer niet.",
  "parties.orderCutoffLabel": "Aanmeldtijd voor orders",
  "parties.orderCutoffHelp":
    "Tot hoe laat deze klant op de dag vóór het laden een order mag sturen. Leeg = geen afspraak, dan houdt WLX niets tegen. Geldt alleen voor orders die via een koppeling binnenkomen.",
  "parties.kgPerLmLabel": "Kilo per laadmeter",
  "parties.kgPerLmHelp": "Voor het omrekenen bij facturatie; standaard 1.750.",
  "parties.fuelGroupLabel": "Dieseltoeslaggroep",
  "parties.goodsProfileLabel": "Standaard goederenprofiel",
  "parties.creditorNumberLabel": "Crediteurnummer (IR)",
  "parties.approvalLabel": "Beoordeling",
  "parties.approvalNone": "Niet beoordeeld",
  "parties.approvalApproved": "Goedgekeurd",
  "parties.approvalDoubt": "Twijfel",
  "parties.approvalBlocked": "Geblokkeerd",
  "parties.approvalHelp": "Een geblokkeerde inkooprelatie is op het planbord niet te kiezen.",
  "parties.certificatesTitle": "Certificaten",
  "parties.certGmpFeed": "GMP+ Feed",
  "parties.certNvwaLabel": "NVWA-registratienummer",
  "parties.certNvwaHelp": "Een koppeling om het nummer op te zoeken heeft de NVWA niet; je vindt het in haar openbare overzicht.",
  "parties.nvwaLookup": "Overzicht bij de NVWA",
  "parties.onPlanningBoardLabel": "Op het planbord",
  "parties.onPlanningBoardHelp":
    "Aangevinkt: de inkooprelatie staat op het planbord, bijvoorbeeld omdat hij dagelijks voor ons rijdt. Uit: hij krijgt alleen transportopdrachten.",
  "parties.communicationHelp": "Per soort bericht de functionele adressen. Geen namen van contactpersonen.",
  "parties.communicationNote": "Deze adressen staan niet in AFAS en beheer je in WLX. Tot 27 november vult de koppeling ze; wat je hier wijzigt, blijft staan.",
  "parties.addressesPlaceholder": "naam@bedrijf.nl, …",
  "parties.addressesInvalid": "Dit is geen geldig e-mailadres. Scheid meer adressen met een komma.",
  "parties.contactActiveLabel": "{{purpose}} actief",
  "parties.frequencyLabel": "{{purpose}}: hoe vaak",
  "parties.frequencyPerEvent": "Per laden en lossen, elke 5 minuten",
  "parties.frequencyDaily": "Eén overzicht per dag, om 07:45",
  "parties.frequencyNone": "Nog niet gekozen: er gaat geen mail",
  "parties.colPurpose": "Bericht",
  "parties.colAddresses": "Adressen",
  "parties.colActive": "Actief",
  "parties.colSource": "Bron",
  "parties.sourceTalis": "TALIS",
  "parties.sourceWlx": "WLX",
  "parties.purposeInvoice": "Facturatie",
  "parties.purposePlanning": "Planning",
  "parties.purposeFreightDocuments": "Vrachtdocumenten",
  "parties.purposeOrderConfirmation": "Orderbevestiging",
  "parties.purposePlanned": "Planningsbevestiging",
  "parties.purposeDelivered": "Afleverbevestiging",
  "parties.purposeTransportOrder": "Transportopdracht",
  "parties.purposeWarehouseIn": "Inslagbevestiging",
  "parties.purposeWarehouseOut": "Uitslagbevestiging",
  "parties.purposeEmballageIncomplete": "Emballage niet volledig retour",
  "parties.purposePreAdvice": "Vooraanmelding pallets aan losplaats",
  "parties.toThePlace": "Naar het mailadres van de losplaats, eenmaal per zending na het picken",
  "parties.dossiersEmpty": "Nog geen dossiers voor deze relatie.",
  "parties.colDossier": "Dossier",
  "parties.colReference": "Referentie",
  "parties.colUpdated": "Bijgewerkt",
  "parties.colApproval": "Goedkeuring",
  "parties.approvalPending": "Wacht op goedkeuring",
  "parties.approvalDone": "Goedgekeurd",
  "parties.awaitingApproval_one": "{{count}} nieuwe relatie wacht op goedkeuring",
  "parties.awaitingApproval_other": "{{count}} nieuwe relaties wachten op goedkeuring",
  "parties.pendingTitle": "Nieuw uit AFAS, wacht op goedkeuring.",
  "parties.pendingText":
    "WLX gebruikt deze relatie pas als iemand hem goedkeurt: tot dan kies je hem nergens, voor geen order, rit of dossier. Een order van deze klant die toch binnenkomt, wacht in de werkbak tot hij is goedgekeurd.",
  "parties.approveButton": "Goedkeuren",
  "parties.pendingNoRight": "Goedkeuren doet iemand die relaties mag wijzigen.",
  "parties.approvedLabel": "Goedgekeurd",
  "parties.approvedHelp":
    "Een nieuwe relatie uit AFAS gebruikt WLX pas als dit aan staat. Zet je het uit, dan wacht de volgende order van deze klant weer; wat al geaccepteerd is, blijft staan.",
  "parties.approvedBy": "Goedgekeurd: {{date}} door {{name}}",
  "parties.approvedOn": "Goedgekeurd: {{date}}",

  // Organisation hierarchy (Beheer → Organisatie)
  "org.count": "{{count}} knopen",
  "org.newNode": "Nieuwe knoop",
  "org.newTitle": "Nieuwe knoop",
  "org.colName": "Naam",
  "org.colUser": "Gekoppelde gebruiker",
  "org.colChildren": "Onder deze knoop",
  "org.noNodes": "Nog geen organisatiestructuur. Voeg de eerste knoop toe.",
  "org.nameLabel": "Naam",
  "org.namePlaceholder": "Bijv. Team Planning of Jan Jansen",
  "org.parentLabel": "Leidinggevende",
  "org.parentNone": "— Geen (bovenaan) —",
  "org.parentHelp": "De knoop hier direct boven in de hiërarchie.",
  "org.userLabel": "Gekoppelde WLX-gebruiker",
  "org.userNone": "— Geen —",
  "org.userHelp":
    "Koppel deze knoop aan een persoon. Alleen dan tellen diens taken mee in het leidinggevende-overzicht. Laat leeg voor een tussenlaag (bv. een afdeling).",
  "org.userInactive": "inactief",
  "org.externalRefsTitle": "Externe referenties (urenregistratie)",
  "org.externalRefsHelp": "Vrije velden als brug naar het urenregistratiesysteem. Optioneel; WLX doet er nu niets mee.",
  "org.externalRefLabel": "Externe referentie {{n}}",
  "org.deleteNode": "Knoop verwijderen",
  "org.deleteConfirm": "Deze knoop verwijderen? Eventuele onderliggende knopen komen daardoor bovenaan te staan.",

  // Branches (Beheer → Vestigingen)
  "branches.paperTitle": "Op papier",
  "branches.paperHelp": "Zo staat de vestiging op de CMR (vak 16, 17 en 23) en op de ritlijst van een wagen van deze vestiging. Het adres is dat van de locatie.",
  "branches.documentName": "Naam",
  "branches.documentLegalName": "Rechtspersoon",
  "branches.documentCarrierCode": "Code transporteur",
  "branches.documentApprovalNumber": "Erkenningsnummer",
  "branches.documentPhone": "Telefoon",
  "branches.printLocations": "Printplekken",
  "branches.printLocationsNone": "Geen printplek bij deze vestiging.",
  "branches.printLocationDefault": "{{name}} (standaard)",
  "branches.printLocationsHelp": "Waar de ritlijsten en CMR's uitkomen. Een printplek erbij hoort bij een printer in DataBridge: vraag het de ontwikkeling.",
  "branches.count": "{{count}} vestigingen",
  "branches.newBranch": "Nieuwe vestiging",
  "branches.newTitle": "Nieuwe vestiging",
  "branches.city": "Plaats",
  "branches.location": "Locatie",
  "branches.locationHelp": "Waar de vestiging staat, uit Locaties: de plek op de kaart van het planbord, en het adres van het depot als de vestiging een depot is.",
  "branches.depot": "Depot",
  "branches.depotHelp": "Depot en magazijn op deze locatie. Een wagen met deze standplaats lost en laadt hier bij een ophaling en levering, en een order die hier laadt of lost is een levering of ophaling. Uit bij een standplaats waar de depotregels niet gelden.",
  "branches.depotNeedsLocation": "Kies eerst een locatie: een depot is een plek.",
  "branches.locationNoPosition": "Van deze locatie is de positie nog niet bekend, dus hij staat niet op de kaart. Controleer het adres op de locatiekaart.",
  "branches.locationClear": "Weghalen",
  "branches.headOffice": "Hoofdvestiging",
  "branches.noBranches": "Nog geen vestigingen.",
  "branches.namePlaceholder": "Bijv. Rijkevoort",
  "branches.codeHelp": "Twee tot vier hoofdletters, zoals RK. De code ligt vast zodra de vestiging bestaat.",
  "branches.codeFixed": "Ligt vast: de TALIS-koppeling en de planning verwijzen ernaar.",
  "branches.sortOrderLabel": "Volgorde",
  "branches.sortOrderHelp": "Lagere nummers staan eerder in lijsten en keuzelijsten.",
  "branches.headOfficeHelp": "Er is één hoofdvestiging. Vink je dit aan, dan gaat die rol over naar deze vestiging.",
  "branches.headOfficeFixed": "Dit is de hoofdvestiging. Wil je een andere, open dan die vestiging en vink het daar aan.",
  "branches.deactivateConfirm": "{{name}} deactiveren? De vestiging blijft bestaan, maar is niet meer te kiezen als standplaats.",

  // Integrations (Beheer → Koppelingen)
  "integrations.kindParties": "Relaties",
  "integrations.kindLocations": "Locaties",
  "integrations.kindFleet": "Transportmiddelen",
  "integrations.kindEmployees": "Chauffeurs",
  "integrations.kindAfasEmployees": "Medewerkers (AFAS)",
  "integrations.kindAfasShifts": "Diensten (AFAS)",
  "integrations.kindAfasLeaves": "Verlof (AFAS)",
  "integrations.kindAfasIllness": "Ziekte (AFAS)",
  "integrations.kindAfasDebtors": "Verkooprelaties (AFAS)",
  "integrations.kindAfasCreditors": "Inkooprelaties (AFAS)",
  "integrations.kindArticles": "Artikelen (Scoretrace)",
  "integrations.skipped": "{{count}} overgeslagen",
  "integrations.removed": "{{count}} weg",
  "integrations.report": "Uitkomst",
  "integrations.reportDriversLinked": "Chauffeurs gekoppeld",
  "integrations.reportMatchedOnNumber": "Op personeelsnummer",
  "integrations.reportMatchedWithoutLeadingZeros": "Waarvan zonder voorloopnullen",
  "integrations.reportMatchedOnBoardComputer": "Op boordcomputernummer",
  "integrations.reportDriversNotInAfas": "Chauffeurs niet in AFAS",
  "integrations.reportDriversNotInAfasCodes": "Welke",
  "integrations.reportFrom": "Eerste dag",
  "integrations.reportTo": "Laatste dag",
  "integrations.reportShifts": "Diensten",
  "integrations.reportDrivers": "Chauffeurs",
  "integrations.reportUnknownLocations": "Onbekende standplaatsen",
  "integrations.reportAbsences": "Afwezigheden",
  "integrations.reportDriversAwayNow": "Nu afwezig",
  "integrations.processingLive": "Verwerkt bij ontvangst",
  "integrations.processingStored": "Bewaard voor later",
  "integrations.processingRefused": "Nog niet aangenomen",
  "integrations.statusReceived": "Wacht",
  "integrations.statusProcessing": "Bezig",
  "integrations.statusProcessed": "Verwerkt",
  "integrations.statusFailed": "Mislukt",
  "integrations.lastReceived": "Laatst ontvangen",
  "integrations.lastProcessed": "Laatst verwerkt",
  "integrations.countWaiting": "Wacht op verwerking",
  "integrations.countProcessed": "Verwerkt",
  "integrations.countFailed": "Mislukt",
  "integrations.purge": "Bewaarde batches weggooien",
  "integrations.purgeConfirm_one":
    "{{count}} batch {{kind}} die nog rijen bewaart (wachtend of mislukt) weggooien? DataBridge stuurt hem bij de volgende ronde opnieuw.",
  "integrations.purgeConfirm_other":
    "{{count}} batches {{kind}} die nog rijen bewaren (wachtend of mislukt) weggooien? DataBridge stuurt ze bij de volgende ronde opnieuw.",
  "integrations.purged_one": "{{count}} batch weggegooid.",
  "integrations.purged_other": "{{count}} batches weggegooid.",
  "integrations.reprocess": "Opnieuw verwerken",
  "integrations.processNow": "Nu verwerken",
  "integrations.reprocessed": "De batch is verwerkt.",
  "integrations.reprocessKept": "De batch is niet verwerkt. De fout staat bij de batch.",
  "integrations.filterKind": "Soort",
  "integrations.filterStatus": "Status",
  "integrations.allKinds": "Alle soorten",
  "integrations.allStatuses": "Alle statussen",
  "integrations.autoRefresh": "Ververst elke 30 seconden",
  "integrations.refresh": "Vernieuwen",
  "integrations.colReceived": "Ontvangen",
  "integrations.colKind": "Soort",
  "integrations.colStatus": "Status",
  "integrations.colRows": "Rijen",
  "integrations.colResult": "Resultaat",
  "integrations.colActions": "Acties",
  "integrations.resultLine": "{{created}} nieuw · {{updated}} gewijzigd · {{unchanged}} ongewijzigd · {{rejected}} afgewezen",
  "integrations.notProcessed": "Nog niet verwerkt",
  "integrations.resultRejections": "Met afgewezen rijen",
  "integrations.resultWarnings": "Met waarschuwingen",
  "integrations.resultClean": "Zonder bevindingen",
  "integrations.hasError": "Fout bij verwerken",
  "integrations.issues_one": "{{count}} melding",
  "integrations.issues_other": "{{count}} meldingen",
  "integrations.empty": "Nog niets ontvangen. Zodra DataBridge stamdata stuurt, staat elke batch hier.",
  "integrations.colPk": "TALIS-PK",
  "integrations.colCode": "Code",
  "integrations.colMessage": "Toelichting",
  "integrations.rejections": "Afgewezen",
  "integrations.warnings": "Waarschuwingen",
  "integrations.processedAt": "Verwerkt op",
  "integrations.correlationId": "Correlatie-ID",
  "integrations.batchId": "Batch-ID",
  "integrations.detailHint": "Klik op een batch voor de afwijzingen en waarschuwingen.",

  // Address lookup (HERE)
  "addresses.searchLabel": "Adres zoeken",
  "addresses.searchPlaceholder": "Straat en huisnummer, plaats…",
  "addresses.searchHelp": "Kies een adres om de velden eronder te vullen.",
  "addresses.placeLabel": "Bedrijf zoeken",
  "addresses.placePlaceholder": "Naam en plaats, bijvoorbeeld hema venray…",
  "addresses.placeHelp": "Kies een bedrijf om naam, adres en openingstijden in te vullen. Geen bedrijf? Vul het adres eronder in.",
  "addresses.placeSearching": "Bedrijven zoeken…",
  "addresses.placeNone": "Geen bedrijf gevonden. Vul het adres eronder in.",
  "addresses.placeHasHours": "met openingstijden",
  "addresses.mapAlt": "Kaart rond {{label}}",
  "addresses.mapHelp": "Staat de speld op de goede plek? Zo niet, pas het adres aan.",
  "addresses.mapUnavailable": "Hier is geen kaart te tonen; de coördinaten staan eronder.",
  "addresses.mapShow": "Toon op de kaart",
  "addresses.mapNotFound": "De adreszoeker vond dit adres niet op de kaart.",
  "addresses.lookupFailed": "Adres zoeken lukt nu niet. Vul het adres zelf in.",
  "addresses.lookupOff": "Adres zoeken is in deze omgeving niet beschikbaar; vul het adres zelf in.",

  // Locations (Relaties → Locaties)
  "locations.searchPlaceholder": "Naam, code, plaats, postcode…",
  "locations.searchLabel": "Locaties doorzoeken",
  "locations.hoursFilterLabel": "Openingstijden",
  "locations.hoursAll": "Alle",
  "locations.hoursStatusKnown": "Bekend",
  "locations.hoursStatusUnknown": "Onbekend",
  "locations.hoursStatusAlways": "Altijd open",
  "locations.requirementFilterLabel": "Eis",
  "locations.requirementAll": "Alle eisen",
  "locations.countryFilterLabel": "Land",
  "locations.countryFilterPlaceholder": "Land",
  "locations.statusFilterLabel": "Status",
  "locations.newLocation": "Nieuwe locatie",
  "locations.colName": "Naam",
  "locations.colAddress": "Adres",
  "locations.colCountry": "Land",
  "locations.colHours": "Openingstijden",
  "locations.colRequirements": "Eisen",
  "locations.colAliases": "Aliassen",
  "locations.colStatus": "Status",
  "locations.noLocations": "Geen locaties gevonden.",
  "locations.moreRequirements": "+{{count}}",
  "locations.newTitle": "Nieuwe locatie",
  "locations.nameLabel": "Naam",
  "locations.namePlaceholder": "Bijv. Voorbeeld DC Veghel",
  "locations.codeAuto": "De code maakt WLX zelf (WLX-000123). Zoeken doe je op naam, plaats of postcode.",
  "locations.codeLabel": "Code",
  "locations.streetLabel": "Straat",
  "locations.houseNumberLabel": "Huisnummer",
  "locations.additionLabel": "Toevoeging",
  "locations.postalCodeLabel": "Postcode",
  "locations.cityLabel": "Plaats",
  "locations.countryLabel": "Land",
  "locations.countryHelp": "Twee letters, zoals NL of DE.",
  "locations.detailLabel": "Aanvullende informatie",
  "locations.detailHelp": "Bijvoorbeeld hal, unit, poort, dock of kade.",
  "locations.phoneLabel": "Telefoon",
  "locations.emailLabel": "E-mail",
  "locations.contactHelp": "Van de receptie of expeditie, niet van een persoon.",
  "locations.glnLabel": "GLN",
  "locations.glnHelp": "GS1-locatienummer, 13 cijfers.",
  "locations.addressAttachmentLabel": "Bijlage adres",
  "locations.addressAttachmentHelp": "De instructie voor dit adres: kies of sleep een pdf of filmpje, of plak een link.",
  "locations.routeAttachmentLabel": "Bijlage route",
  "locations.routeAttachmentHelp": "De route-instructie: kies of sleep een pdf of filmpje, of plak een link.",
  "locations.addressAttachmentInfo": "De boordcomputer opent deze bijlage zodra de chauffeur op Aankomst drukt.",
  "locations.routeAttachmentInfo": "De boordcomputer opent deze bijlage zodra de chauffeur op Navigeren drukt.",
  "locations.attachmentPlaceholder": "Plak of sleep een link: https://…",
  "locations.attachmentOpen": "Openen",
  "locations.attachmentInvalid": "Een link begint met http:// of https://.",
  "locations.attachmentChoose": "Bestand kiezen",
  "locations.attachmentReplace": "Vervangen",
  "locations.attachmentRemove": "Weghalen",
  "locations.attachmentRemoveConfirm": "{{name}} weghalen? De link op de boordcomputer werkt daarna niet meer.",
  "locations.attachmentUploading": "Bezig met opslaan…",
  "locations.attachmentRemoving": "Bezig met weghalen…",
  "locations.attachmentStored": "Bewaard in WLX. Vervang je het bestand, dan blijft de link op de boordcomputer dezelfde.",
  "locations.attachmentTooLarge": "Een bijlage is hoogstens 100 MB.",
  "locations.notFound": "Locatie niet gevonden",
  "locations.notFoundDesc": "Deze locatie bestaat niet, of je hebt er geen toegang toe.",
  "locations.tabGeneral": "Algemeen",
  "locations.tabHours": "Openingstijden",
  "locations.tabRequirements": "Eisen",
  "locations.tabAliases": "Aliassen",
  "locations.talisNote":
    "Deze locatie komt uit TALIS. Tot de overgang op 16 november overschrijft TALIS wat het stuurt: een wijziging hier geldt tot de volgende wijziging daar.",
  "locations.mergedInto": "Hoort nu bij",
  "locations.sameAddressTitle": "Op hetzelfde adres",
  "locations.sameAddressHelp": "TALIS maakte soms een locatie voor elke manier waarop een klant het adres schreef. Is het dezelfde plek, voeg hem dan samen in deze: zijn orders, stops, ritten en vestigingen komen hier, zijn code en adres worden een alias, en hij wordt inactief. Een ander bedrijf op hetzelfde adres laat je staan.",
  "locations.sameAddressNote": "Nog {{count}} locatie op dit adres",
  "locations.sameAddressNote_other": "Nog {{count}} locaties op dit adres",
  "locations.activityCount": "{{count}} activiteit",
  "locations.activityCount_other": "{{count}} activiteiten",
  "locations.mergeInto": "Samenvoegen in deze",
  "locations.mergeConfirm": "{{name}} gaat op in {{into}}. Dat is niet terug te draaien.",
  "locations.mergeConfirmYes": "Samenvoegen",
  "locations.duplicatesTitle": "Dubbelen",
  "locations.duplicatesIntro": "Adressen met meer dan één locatie. TALIS maakte een locatie voor elke manier waarop een klant een adres schreef. Onder Zelfde naam staan locaties met dezelfde woorden in de naam op één adres: dat is één plek, en die kun je in één keer samenvoegen. Onder Andere namen beslis je per adres: soms dezelfde plek anders geschreven, even vaak verschillende bedrijven op één terrein. Voorgesteld blijft de locatie met de meeste orders; de andere worden een alias ervan.",
  "locations.duplicatesSame": "Zelfde naam",
  "locations.duplicatesDifferent": "Andere namen",
  "locations.duplicatesSearch": "Zoek op adres, plaats of naam…",
  "locations.duplicatesJoinAll": "Alle {{count}} dubbele samenvoegen",
  "locations.duplicatesJoinAllConfirm": "{{count}} locaties gaan op in de locatie met dezelfde naam op hun adres die blijft. Dat is niet terug te draaien.",
  "locations.duplicatesJoiningAll": "Bezig… {{count}} samengevoegd",
  "locations.duplicatesJoinedAll": "{{count}} locatie samengevoegd.",
  "locations.duplicatesJoinedAll_other": "{{count}} locaties samengevoegd.",
  "locations.duplicatesJoined": "{{count}} locatie opgegaan in {{name}}.",
  "locations.ordersLinked": "{{count}} wachtende order heeft daarmee zijn plek gevonden.",
  "locations.ordersLinked_other": "{{count}} wachtende orders hebben daarmee hun plek gevonden.",
  "locations.duplicatesJoined_other": "{{count}} locaties opgegaan in {{name}}.",
  "locations.duplicatesKeep": "Blijft",
  "locations.duplicatesJoin": "Samenvoegen",
  "locations.duplicatesKeepPlace": "{{name}} blijft",
  "locations.duplicatesJoinPlace": "{{name}} samenvoegen",
  "locations.duplicatesJoinGroup": "Samenvoegen ({{count}})",
  "locations.duplicatesActivities": "Activiteiten",
  "locations.duplicatesPlaces": "{{count}} locatie",
  "locations.duplicatesPlaces_other": "{{count}} locaties",
  "locations.duplicatesNone": "Geen adressen met meer dan één locatie.",
  "locations.duplicatesRange": "{{from}}–{{to}} van {{total}} adressen",
  "locations.duplicatesPrevious": "← Vorige",
  "locations.duplicatesNext": "Volgende →",
  "locations.addressTitle": "Adres",
  "locations.contactTitle": "Contact",
  "locations.boardComputerTitle": "Boordcomputer",
  "locations.positionTitle": "Ligging",
  "locations.positionHelp": "Uit TALIS.",
  "locations.positionFromLookup": "Uit de adreszoeker (HERE): bewaard bij Adres controleren toen het adres klopte, of bij Overnemen en opslaan.",
  "locations.positionNone": "Nog geen ligging. Adres controleren zet hem erbij als het adres klopt; anders het voorstel overnemen en opslaan.",
  "locations.talisPkLabel": "TALIS-nummer",
  "locations.addressCheckTitle": "Adrescontrole",
  "locations.verdictValid": "Klopt",
  "locations.verdictCorrected": "Anders geschreven",
  "locations.verdictPartial": "Deels gevonden",
  "locations.verdictNotFound": "Niet gevonden",
  "locations.verdictNone": "Nog niet gecontroleerd",
  "locations.checkedOn": "gecontroleerd op {{date}}",
  "locations.sourceImport": "Uit TALIS",
  "locations.sourceHere": "Uit de adreszoeker",
  "locations.sourcePlanner": "Door een planner",
  "locations.addressCheck": "Adres controleren",
  "locations.checkDiffers": "Anders: {{fields}}",
  "locations.checkCompletes": "Vult aan: {{fields}}",
  "locations.checkTakeOver": "Overnemen",
  "locations.checkTakenOver": "Overgenomen in de velden. Sla op om het te bewaren.",
  "locations.checkNothing": "De adreszoeker vond dit adres niet.",
  "locations.hoursTitle": "Openingstijden",
  "locations.hoursChoiceUnknown": "Onbekend",
  "locations.hoursChoiceKnown": "Vaste tijden",
  "locations.hoursChoiceAlways": "Altijd open",
  "locations.ruleDays": "Dagen",
  "locations.ruleOpen": "Open",
  "locations.ruleClose": "Sluit",
  "locations.ruleBreak": "Pauze",
  "locations.ruleBreakFrom": "Pauze van",
  "locations.ruleBreakTo": "tot",
  "locations.ruleRemove": "Regel weghalen",
  "locations.ruleAdd": "Andere dagen toevoegen",
  "locations.dayInOtherRule": "Deze dag staat al in een andere regel",
  "locations.dayShort1": "ma",
  "locations.dayShort2": "di",
  "locations.dayShort3": "wo",
  "locations.dayShort4": "do",
  "locations.dayShort5": "vr",
  "locations.dayShort6": "za",
  "locations.dayShort7": "zo",
  "locations.hereHoursTitle": "Volgens HERE: {{place}}",
  "locations.hereHoursDistance": "op {{meters}} m",
  "locations.hereHoursHelp": "Dit zijn de openingstijden van het bedrijf zoals HERE ze kent, niet per se de laad- en lostijden. Neem ze over en pas aan wat anders is.",
  "locations.hereHoursTake": "Overnemen",
  "locations.hereHoursNone": "HERE kent geen openingstijden voor deze plek.",
  "locations.hereHoursLooking": "Openingstijden zoeken bij HERE…",
  "locations.hereLookup": "Opzoeken bij HERE",
  "locations.hereLookupName": "Zoeken op naam",
  "locations.hoursClosed": "gesloten",
  "locations.hoursPause": "pauze",
  "locations.hoursUnknown": "Openingstijden onbekend",
  "locations.hoursAlways": "Altijd open",
  "locations.hoursOvernight": "(tot de volgende ochtend)",
  "locations.problemNoRules": "Voeg minstens één regel toe, of kies Onbekend.",
  "locations.problemNoDays": "Kies bij elke regel de dagen.",
  "locations.problemDayTwice": "Een dag staat in twee regels.",
  "locations.problemSameTime": "Open en sluit zijn dezelfde tijd.",
  "locations.problemBreakOutside": "De pauze valt buiten de openingstijden.",
  "locations.problemInvalidTime": "Vul elke tijd in, bijvoorbeeld 8 of 16:30.",
  "locations.hoursCheckedOn": "Nagekeken op {{date}}",
  "locations.hoursFromTalis": "Uit TALIS, nog niet nagekeken.",
  "locations.hoursNeverChecked": "Nog niet nagekeken.",
  "locations.requirementsTitle": "Eisen aan wagen, trailer of chauffeur",
  "locations.requirementsHelp":
    "Alleen wat de plek zelf vraagt. Gewicht en milieuzone rekent de routeplanning straks uit; een kooiaap is een vervoerseis en zet je op de zending.",
  "locations.reqTailLift": "Laadklep",
  "locations.reqRigidWithTailLift": "Bakwagen met laadklep",
  "locations.reqNoRearTailLift": "Geen achterklep",
  "locations.reqCityTrailer": "Citytrailer",
  "locations.reqFcTraining": "Opgeleid FC",
  "locations.fcTrainingFixed": "Hoort bij dit adres: FrieslandCampina laat hier alleen opgeleide chauffeurs toe.",
  "locations.arrivalPopupLabel": "Popup aankomst",
  "locations.arrivalPopupHelp": "In de boordcomputer, zodra de chauffeur hier een laad- of losactie start.",
  "locations.departurePopupLabel": "Popup vertrek",
  "locations.departurePopupHelp": "In de boordcomputer, zodra de chauffeur hier een laad- of losactie afrondt.",
  "locations.popupsAdminOnly": "Alleen een beheerder wijzigt de popups en de bijlagen: de chauffeur krijgt ze in de boordcomputer te zien.",
  "locations.preNotificationTitle": "Aanmelden",
  "locations.preNotificationHelp": "Uit TALIS. Aanmelden wordt later een functie in WLX; tot dan meldt de planner aan met deze gegevens.",
  "locations.warehouseTitle": "Magazijn",
  "locations.noBatchPicking": "Niet batchpicken",
  "locations.noBatchPickingHelp": "Orders naar dit adres gaan niet in een ronde batchpicken; ze worden pickbaar gemaakt zoals elke verzending. Bijvoorbeeld een retour naar de klant zelf, of een stortorder.",
  "locations.orderEntryTitle": "Orderinvoer",
  "locations.tripMarkRequired": "Ritkenmerk nodig",
  "locations.tripMarkRequiredHelp": "Een order van een kanaal die hier lost, wacht in Aandacht nodig tot order entry hem een ritkenmerk geeft: de rit waar hij op gaat.",
  "locations.deliveryWeekdays": "Vaste leverdagen",
  "locations.deliveryWeekdaysHelp": "Op welke dagen hier geleverd wordt. Wat van Hager niet binnen is, gaat naar de eerstvolgende van deze dagen. Niets aangevinkt: elke werkdag.",
  "locations.weekday1": "Maandag",
  "locations.weekday2": "Dinsdag",
  "locations.weekday3": "Woensdag",
  "locations.weekday4": "Donderdag",
  "locations.weekday5": "Vrijdag",
  "locations.preBookSlot": "Tijdslot boeken",
  "locations.preAnnounceTrip": "Rit aanmelden",
  "locations.preAlways": "Bij elke order",
  "locations.preOnlyFor": "Alleen voor {{debtors}}",
  "locations.preLinks": "Portaal",
  "locations.preBookSlotEmails": "Mail tijdslot",
  "locations.preAnnounceTripEmails": "Mail rit",
  "locations.preMemo": "Memo",
  "locations.preDemands": "Verplicht",
  "locations.prePlateRequired": "kenteken",
  "locations.preEtaRequired": "ETA",
  "locations.aliasesHelp":
    "Hoe orders en klanten deze plek nog meer noemen. Een order met een van deze codes of aliassen komt op deze locatie terecht.",
  "locations.colAliasKind": "Soort",
  "locations.colAliasValue": "Alias",
  "locations.colSource": "Bron",
  "locations.aliasKindCode": "Code",
  "locations.aliasKindAddress": "Adres",
  "locations.aliasKindText": "Naam",
  "locations.aliasesEmpty": "Nog geen aliassen.",
  "locations.aliasRemove": "Weghalen",
  "locations.aliasKindLabel": "Soort",
  "locations.aliasValueLabel": "Alias",
  "locations.aliasAdd": "Toevoegen",
  "locations.aliasTooShort": "Een alias heeft minstens twee tekens.",

  // Orders (Transport → Orders)
  "planning.openTrip": "Rit openen",
  "planning.fit.no_tail_lift": "Geen laadklep, terwijl de plek erom vraagt",
  "planning.fit.not_a_rigid": "Geen bakwagen, terwijl de plek erom vraagt",
  "planning.fit.has_rear_tail_lift": "Heeft een achterklep, en die mag daar niet",
  "planning.fit.not_a_city_trailer": "Geen citytrailer (oplegger korter dan 12 m), terwijl de plek erom vraagt",
  "planning.fit.driver_not_fc_trained": "Chauffeur is niet opgeleid voor FrieslandCampina",
  "planning.fit.no_adr_equipment": "Geen ADR-uitrusting",
  "planning.fit.driver_no_adr": "Chauffeur heeft geen ADR",
  "planning.fit.no_forklift": "Geen meeneemheftruck op de combinatie",
  "planning.fit.driver_no_forklift": "Chauffeur is niet bevoegd voor de kooiaap",
  "planning.fit.no_cooling": "Niet gekoeld, terwijl de lading dat vraagt",
  "planning.fit.not_a_tautliner": "Geen schuifzeil",
  "planning.fit.missing_need": "De lading vraagt: {{need}}",
  "planning.fit.no_trailer": "Trekker zonder trailer: zo kan de rit niet vastgelegd worden",
  "planning.fit.over_pallets": "{{load}} pallets op {{capacity}} plekken",
  "planning.fit.over_weight": "{{load}} kg op {{capacity}} kg laadvermogen",
  "planning.fit.over_meters": "{{load}} laadmeters op {{capacity}}",
  "planning.fit.driver_ill": "Chauffeur is ziek",
  "planning.fit.driver_on_leave": "Chauffeur heeft verlof",
  "planning.fit.driver_no_shift": "Chauffeur heeft die dag geen dienst",
  "planning.fit.driver_no_shift_on": "Chauffeur heeft geen dienst op {{day}}",
  "planning.fit.driver_no_overnight": "Chauffeur overnacht niet",
  "planning.fit.driver_no_vca": "Chauffeur heeft geen VCA",
  "planning.fit.driver_home_by": "Thuis om {{time}}, de rit is later terug",
  "planning.fit.driver_start_after": "Begint niet vóór {{time}}, de rit vertrekt eerder",
  "planning.fit.driver_restricted_day": "Bijzonderheid: die dag niet",
  "planning.fit.after_previous_load": "Op {{trip}} had hij {{have}}: {{add}} mag daar niet na",
  "planning.overnight": "Overnachting",
  "planning.carriedFrom": "van {{day}}",
  "planning.sheet.uncouple": "Afkoppelen {{trailer}}",
  "planning.sheet.couple": "Aankoppelen {{trailer}}",
  "planning.conflictParked": "{{who}} staat dan afgekoppeld in {{depot}} ({{trip}}, {{range}})",
  "planning.conflictReload": "Omladen nodig: de lading staat in {{who}} ({{trip}})",
  "planning.carriedHelp": "Een rit van {{day}} die vandaag doorloopt: hij hoort bij die dag en telt in De dag van die dag. Wat erachter kan, is werk van vandaag.",
  "planning.overnightHelp": "De rit is pas na middernacht terug: de chauffeur overnacht onderweg of bij de klant",
  "planning.dayNote": "Bijzonderheid",
  "planning.dayNoteTitle": "Bijzonderheid: {{text}}",
  "planning.filterByBranch": "Filteren op vestiging",
  "planning.allBranches": "Alle vestigingen",
  "planning.vehiclesOnBoard": "{{count}} wagen",
  "planning.vehiclesOnBoard_other": "{{count}} wagens",
  "planning.chartersInUse_one": "{{count}} ingezet",
  "planning.chartersInUse_other": "{{count}} ingezet",
  "planning.stopsShort_one": "{{count}} stop",
  "planning.stopsShort_other": "{{count}} stops",
  "planning.kpiClashes_one": "{{count}} dubbel ingezet",
  "planning.kpiClashes_other": "{{count}} dubbel ingezet",
  "planning.kpiAway_one": "{{count}} chauffeur ziek of met verlof",
  "planning.kpiAway_other": "{{count}} chauffeurs ziek of met verlof",
  "planning.kpiWaits_one": "{{count}} rit wacht op de planner",
  "planning.kpiWaits_other": "{{count}} ritten wachten op de planner",
  "planning.waitsOnTrip_one": "Wacht op de planner: {{count}} order",
  "planning.waitsOnTrip_other": "Wacht op de planner: {{count}} orders",
  "planning.rowsCompose": "Samenstellen",
  "planning.sheetPlanHere_one": "Zet {{count}} traject hierop",
  "planning.sheetPlanHere_other": "Zet {{count}} trajecten hierop",
  "planning.sheetDrivesLeftOut_one": "(1 rit zonder positie niet meegeteld)",
  "planning.sheetDrivesLeftOut_other": "({{count}} ritten zonder positie niet meegeteld)",
  "planning.sheetByTime": "Volgorde voorstellen",
  "planning.sheetByTimeHelp": "De volgorde die WLX voorstelt: zo weinig mogelijk te laat, dan de minste kilometers",
  "planning.sheetPlanned_one": "{{count}} traject op {{trip}} gezet.",
  "planning.sheetPlanned_other": "{{count}} trajecten op {{trip}} gezet.",
  "planning.sheetMoved": "{{consignment}} staat nu op {{trip}}.",
  "planning.listNoTrip": "Kies een rit in de lijst.",
  "planning.listKvStops_one": "{{count}} stop",
  "planning.listKvStops_other": "{{count}} stops",
  "planning.listKvConsignments_one": "{{count}} zending",
  "planning.listKvConsignments_other": "{{count}} zendingen",
  "planning.listMoveStopHint": "Stop verplaatsen: slepen of",
  "planning.listReordered": "Volgorde van {{trip}} gewijzigd.",
  "planning.listByTimeDone": "{{trip}} staat weer in de volgorde die WLX voorstelt.",
  "planning.listTakenOff": "{{consignment}} terug naar Te plannen, van {{trip}}.",
  "planning.undo": "Ongedaan maken",
  "planning.undone": "Ongedaan gemaakt.",
  "planning.issueFitsNone_one": "past op geen wagen",
  "planning.issueFitsNone_other": "passen op geen wagen",
  "planning.dropPreview_one": "+{{count}} zending · piek {{from}} → ≈ {{to}}",
  "planning.dropPreview_other": "+{{count}} zendingen · piek {{from}} → ≈ {{to}}",
  "planning.lmUnknown": "? m",
  "planning.scaleRigid": "{{lm}} kleine bakwagen",
  "planning.scaleTrailer": "{{lm}} trailer",
  "planning.reqCooling": "KOEL",
  "planning.reqTailLift": "KLEP",
  "planning.reqRigid": "BAKWAGEN",
  "planning.reqNoRearLift": "GEEN ACHTERKLEP",
  "planning.reqCityTrailer": "CITYTRAILER",
  "planning.reqFc": "FC",
  "planning.lassoCaught_one": "1 traject",
  "planning.lassoCaught_other": "{{count}} trajecten",
  "planning.lassoWaitsForPickup_one": "1 wacht nog op zijn ophaling",
  "planning.lassoWaitsForPickup_other": "{{count}} wachten nog op hun ophaling",
  "planning.crewTitleDriver": "Chauffeur voor {{trip}}",
  "planning.crewTitleTrailer": "Trailer voor {{trip}}",
  "planning.crewOnLorry": "op {{code}}",
  "planning.crewSearchDriver": "Zoek op naam, nummer of plaats",
  "planning.crewSearchTrailer": "Zoek op nummer, kenteken of plaats",
  "planning.crewCooled": "koel",
  "planning.crewNoCapacity": "capaciteit onbekend",
  "planning.crewCurrent": "nu op de rit",
  "planning.crewNoQualifications": "geen bevoegdheden",
  "planning.crewHome": "zelfde standplaats",
  "planning.crewHintDriver": "chauffeur",
  "planning.crewHintTrailer": "trailer",
  "planning.crewPickDriver": "Kies een chauffeur in de lijst.",
  "planning.crewPickTrailer": "Kies een trailer in de lijst.",
  "planning.crewAssign": "Zet {{name}} erop",
  "planning.crewIsCurrent": "Staat nu al op deze rit.",
  "planning.crewQualifications": "Bevoegd",
  "planning.crewMissing": "Ontbreekt",
  "planning.crewSwappedDriver_zero": "{{name}} rijdt nu {{trip}}.",
  "planning.crewSwappedDriver_one": "{{name}} rijdt nu {{trip}}, met 1 melding.",
  "planning.crewSwappedDriver_other": "{{name}} rijdt nu {{trip}}, met {{count}} meldingen.",
  "planning.crewSwappedTrailer_zero": "Trailer {{name}} hangt nu achter {{trip}}.",
  "planning.crewSwappedTrailer_one": "Trailer {{name}} hangt nu achter {{trip}}, met 1 melding.",
  "planning.crewSwappedTrailer_other": "Trailer {{name}} hangt nu achter {{trip}}, met {{count}} meldingen.",
  "planning.holding_one": "1 traject",
  "planning.holding_other": "{{count}} trajecten",
  "planning.capAssigned_zero": "{{trip}} staat op {{what}}.",
  "planning.capAssigned_one": "{{trip}} staat op {{what}}, met 1 melding.",
  "planning.capAssigned_other": "{{trip}} staat op {{what}}, met {{count}} meldingen.",
  "planning.capBack": "Terug",
  "planning.capError": "De wagens konden niet gelezen worden.",
  "planning.capGroupFree": "Past en vrij",
  "planning.capGroupUnknown": "Onbekend",
  "planning.capGroupFitsNot": "Past niet",
  "planning.capGroupBusy": "Bezet in dit tijdvak",
  "planning.capMore_one": "nog {{count}} die past en vrij is",
  "planning.capMore_other": "nog {{count}} die passen en vrij zijn",
  "planning.capNone": "Geen wagens gevonden.",
  "planning.capCharterFree": "Nog geen ritten op deze dag",
  "planning.capCharterTrips": "Rijdt al {{trips}}",
  "planning.capNoCharters": "Geen charters op het planbord.",
  "planning.capEffectLabel": "Wat er verandert",
  "planning.capIf": "Als je {{code}} kiest",
  "planning.capAssignNone": "Inzetten",
  "planning.capFits": "Past",
  "planning.capFitsNot": "Past niet",
  "planning.capUnknown": "Onbekend",
  "planning.capBusy": "Bezet",
  "planning.capFree": "Vrij",
  "planning.capIll": "ziek",
  "planning.capLeave": "verlof",
  "planning.capNoShift": "geen dienst",
  "planning.capAvailable": "beschikbaar",
  "planning.restriction.home_by": "thuis om {{time}}",
  "planning.restriction.start_after": "begint niet vóór {{time}}",
  "planning.restriction.whole_day": "hele dag niet",
  "planning.effShift": "Dienst",
  "planning.effStill": "Je kunt toch inzetten.",
  "planning.effShiftFits": "Roosterdag: de hele dag beschikbaar.",
  "planning.effNoRoster": "Geen rooster uit AFAS voor deze dag.",
  "planning.effShuttle_one": "een depotpendel {{from}} → {{to}} voor 1 zending",
  "planning.effShuttle_other": "een depotpendel {{from}} → {{to}} voor {{count}} zendingen",
  "planning.effFits": "Past",
  "planning.effFitsUnknown": "Onbekend: geen capaciteit in de stamdata.",
  "planning.effBusy": "Bezet",
  "planning.effBusyTrip": "{{trip}} ({{range}})",
  "planning.errorUnloadBeforeLoad": "{{consignment}} zou dan gelost worden voordat het geladen is.",
  "planning.errorDepotStopFixed": "Laden in het depot blijft de eerste stop en lossen in het depot de laatste.",
  "planning.errorStopsChanged": "De rit is intussen gewijzigd. Probeer het nog eens.",
  "planning.errorTractorWithoutTrailer": "{{vehicle}} is een trekker zonder trailer. Geef de rit eerst een trailer; dan kun je hem vastleggen.",
  "planning.errorNothingToDecide": "Hier hoeft niets meer beslist te worden. De kaart wordt opnieuw gelezen.",
  "planning.v3.stepsLabel": "Stappen van de planning",
  "planning.v3.step1": "Volle leveringen",
  "planning.v3.step2": "Plannen",
  "planning.v3.step3": "Overzicht",
  "planning.v3.step4": "Capaciteit",
  "planning.v3.countLoading": "…",
  "planning.v3.count1Open_one": "{{count}} volle levering",
  "planning.v3.count1Open_other": "{{count}} volle leveringen",
  "planning.v3.count1Trips_one": "{{count}} rit · {{next}} met vervolg",
  "planning.v3.count1Trips_other": "{{count}} ritten · {{next}} met vervolg",
  "planning.v3.count2_one": "{{count}} traject open",
  "planning.v3.count2_other": "{{count}} trajecten open",
  "planning.v3.count3": "{{trips}} ritten · {{open}} open",
  "planning.v3.count4": "{{assigned}} van {{count}} op een wagen",
  "planning.v3.count4None": "wagen, chauffeur, trailer",
  "planning.v3.dayLabel": "De dag",
  "planning.v3.day": "De dag",
  "planning.v3.estimate": "schatting",
  "planning.v3.panelResize": "Sleep om het paneel breder of smaller te maken; dubbelklik zet het terug",
  "planning.v3.overRoad": "over de weg (HERE)",
  "planning.v3.trips": "Ritten",
  "planning.v3.tripsOpen_one": "{{count}} traject open",
  "planning.v3.tripsOpen_other": "{{count}} trajecten open",
  "planning.v3.km": "Kilometers",
  "planning.v3.kmEmpty": "waarvan leeg {{km}}",
  "planning.v3.hours": "Uren",
  "planning.v3.pendels": "Depotpendels",
  "planning.v3.pendelRuns_one": "{{count}} pendelrit · {{km}} km",
  "planning.v3.pendelRuns_other": "{{count}} pendelritten · {{km}} km",
  "planning.v3.pendelsMade_one": "{{count}} door de planning",
  "planning.v3.pendelsMade_other": "{{count}} door de planning",
  "planning.v3.deltaPendelPair": "+1 depotpendel {{from}} → {{to}}",
  "planning.v3.deltaPendels": "{{value}} depotpendels",
  "planning.v3.deltaRuns": "{{value}} pendelrit",
  "planning.v3.deltaKm": "{{value}} km",
  "planning.v3.deltaEmpty": "{{value}} km leeg",
  "planning.v3.deltaTime": "{{value}}",
  "planning.v3.tomorrow": "morgen",
  "planning.v3.today": "vandaag",
  "planning.v3.windowsFollow": "Hoofdscherm en kaart volgen elkaar",
  "planning.v3.stepOf": "Stap {{step}} van {{count}}",
  "planning.v3.next.adds": "vraagt dan {{adds}}",
  "planning.v3.next.clash": "na {{have}} geen {{add}} met dezelfde wagen",
  "planning.v3.next.code": "{{code}}",
  "planning.v3.next.fits": "past",
  "planning.v3.next.fitsWaits": "past · wacht",
  "planning.v3.next.full": "wagen weer vol",
  "planning.v3.next.inTheWay_one": "ligt bij {{count}} andere zending: misschien een eigen rit",
  "planning.v3.next.inTheWay_other": "ligt bij {{count}} andere zendingen: misschien een eigen rit",
  "planning.v3.next.late": "te laat",
  "planning.v3.next.pendel": "+1 depotpendel {{from}} → {{to}}",
  "planning.v3.next.tooBig": "past niet in de wagen",
  "planning.v3.s1.alreadyBehindLead": "Hierachter staat al:",
  "planning.v3.s1.endClosed": "Met de ophaling erachter rijdt de wagen geladen naar het depot: hier komt niets meer achter.",
  "planning.v3.s1.endFull": "Niets meer erachter",
  "planning.v3.s1.endClosedOvernight": "De rit is pas na middernacht terug: wat erachter komt, plan je de volgende dag.",
  "planning.v3.s1.endOvernight": "Na middernacht terug · niets meer erachter",
  "planning.v3.s1.behindAlready": "erachter: {{route}}",
  "planning.v3.s1.becomeText": "Elke volle levering wordt een rit zonder wagen. Fabriekspendels gaan volgens het pendelschema: per traject zoveel keer heen en weer op één rit als het schema zegt, met de volle pendel terug ertussen; wat overblijft blijft bij Te plannen. Daarna zie je per rit waar de wagen leeg raakt, en kies je wat erachter gaat.",
  "planning.v3.s1.becomeTitle_one": "{{count}} volle levering wordt {{trips}}",
  "planning.v3.s1.becomeTitle_other": "{{count}} volle leveringen worden {{trips}}",
  "planning.v3.s1.tripsWord_one": "{{count}} rit",
  "planning.v3.s1.tripsWord_other": "{{count}} ritten",
  "planning.v3.s1.toAndFroTitle": "Heen en weer op één rit, zonder pendelschema",
  "planning.v3.s1.toAndFroLine": "{{out}} heen, {{back}} terug",
  "planning.v3.s1.colKind": "Soort",
  "planning.v3.s1.colLoadAt": "Laden",
  "planning.v3.s1.rest": "rest",
  "planning.v3.s1.restHelp": "Past niet in een hele rit van het pendelschema: blijft bij Te plannen voor de gewone planning, tenzij je hem aanvinkt.",
  "planning.v3.s1.schemaTitle": "Pendelschema",
  "planning.v3.s1.schemaMixed": "Gemengd: {{routes}}",
  "planning.v3.s1.restTitle_one": "1 fabriekspendel blijft bij Te plannen",
  "planning.v3.s1.restTitle_other": "{{count}} fabriekspendels blijven bij Te plannen",
  "planning.v3.s1.restLine_one": "1 over",
  "planning.v3.s1.restLine_other": "{{count}} over",
  "planning.v3.s1.warnLate": "stop te laat",
  "planning.v3.s1.warnDriving": "meer dan 9 uur rijden op één dag, misschien overnachten",
  "planning.v3.s1.editSchema": "Pendelschema bekijken",
  "planning.v3.s1.clashCount_one": "{{count}} botst met de eis",
  "planning.v3.s1.clashCount_other": "{{count}} botsen met de eis",
  "planning.v3.s1.colBest": "Beste erachter",
  "planning.v3.s1.colConsignment": "Zending",
  "planning.v3.s1.colCustomer": "Klant",
  "planning.v3.s1.colDeltaKm": "Δ km",
  "planning.v3.s1.colEmptyFrom": "Leeg vanaf",
  "planning.v3.s1.colFrom": "Van",
  "planning.v3.s1.colFull": "Volle levering",
  "planning.v3.s1.colKm": "Km",
  "planning.v3.s1.colLoad": "Lading",
  "planning.v3.s1.colRequirements": "Eisen",
  "planning.v3.s1.colTo": "Naar",
  "planning.v3.s1.colTrip": "Rit",
  "planning.v3.s1.colUnload": "Lossen",
  "planning.v3.s1.depotLater": "lost in een depot; welk volgt uit de wagen (stap 4)",
  "planning.v3.s1.direct": "levert direct af, geen depot",
  "planning.v3.s1.effectCritical_one": "{{count}} kritieke levering",
  "planning.v3.s1.effectCritical_other": "{{count}} kritieke leveringen",
  "planning.v3.s1.effectDepot": "Depot",
  "planning.v3.s1.effectEmpty": "Leeg",
  "planning.v3.s1.effectEmptyNoHome": "{{km}} km leeg naar {{city}}",
  "planning.v3.s1.effectEmptyText": "{{km}} km naar {{city}} in plaats van {{back}} km leeg terug",
  "planning.v3.s1.effectKm": "{{km}} km, waarvan leeg {{empty}}",
  "planning.v3.s1.effectNotice": "Melding",
  "planning.v3.s1.effectRequirements": "Eisen",
  "planning.v3.s1.effectRequirementsText_one": "{{count}} met een eis: die vraagt de wagen",
  "planning.v3.s1.effectRequirementsText_other": "{{count}} met een eis: die vragen de wagen",
  "planning.v3.s1.effectTrips_one": "+{{count}} rit zonder wagen",
  "planning.v3.s1.effectTrips_other": "+{{count}} ritten zonder wagen",
  "planning.v3.s1.emptyFrom": "Leeg vanaf {{time}} in {{city}}",
  "planning.v3.s1.endsTitle": "Open einden · {{count}}",
  "planning.v3.s1.filterCritical": "Kritiek",
  "planning.v3.s1.filterRequirement": "Met eis",
  "planning.v3.s1.filter_fullDirect": "Directe FTL past erachter",
  "planning.v3.s1.filter_clash": "Eis botst",
  "planning.v3.s1.filter_nothing": "Niets dichtbij",
  "planning.v3.s1.fullTitle": "Volle leveringen en fabriekspendels · {{count}}",
  "planning.v3.s1.keyBehind": "erachter",
  "planning.v3.s1.keyCandidate": "kiezen",
  "planning.v3.s1.keyEnd": "open eind",
  "planning.v3.s1.keyMake": "ritten maken",
  "planning.v3.s1.keyOpen": "open laten",
  "planning.v3.s1.keyRow": "regel",
  "planning.v3.s1.keySpace": "Spatie",
  "planning.v3.s1.keyTick": "aanvinken",
  "planning.v3.s1.leaveOpen": "Open laten",
  "planning.v3.s1.leftOpen": "open gelaten",
  "planning.v3.s1.loadsThere": "Wat daar laadt",
  "planning.v3.s1.made_one": "{{count}} rit gemaakt.",
  "planning.v3.s1.made_other": "{{count}} ritten gemaakt.",
  "planning.v3.s1.madeSkipped": "{{count}} ritten gemaakt, {{skipped}} niet: {{reason}}",
  "planning.v3.s1.makeTrips_one": "{{count}} rit maken",
  "planning.v3.s1.makeTrips_other": "{{count}} ritten maken",
  "planning.v3.s1.modeEnds": "Open einden",
  "planning.v3.s1.modeFull": "Volle leveringen en fabriekspendels",
  "planning.v3.s1.modeLabel": "Volle leveringen of open einden",
  "planning.v3.s1.noEnds": "Nog geen ritten van volle leveringen op deze dag.",
  "planning.v3.s1.noFull": "Geen volle leveringen of fabriekspendels die op deze dag wachten.",
  "planning.v3.s1.noNewRequirement": "geen eis erbij",
  "planning.v3.s1.noneFits": "niets dat op tijd past",
  "planning.v3.s1.noneInFilter": "Niets in deze selectie.",
  "planning.v3.s1.nothingNear": "Niets dat binnen {{km}} km laadt.",
  "planning.v3.s1.stretchTo": "Zoek tot {{km}} km",
  "planning.v3.s1.oneByOne": "Eén voor één",
  "planning.v3.s1.openEnd": "Open eind",
  "planning.v3.s1.previewBehind": "Met {{city}} erachter",
  "planning.v3.s1.previewTrips_one": "Met {{count}} rit",
  "planning.v3.s1.previewTrips_other": "Met {{count}} ritten",
  "planning.v3.s1.putBehind": "{{city}} staat achter {{trip}}.",
  "planning.v3.s1.putBehindButton": "Zet {{city}} erachter",
  "planning.v3.s1.previewBehindMany": "{{count}} erachter",
  "planning.v3.s1.putBehindMany": "{{count}} zendingen achter {{trip}} gezet.",
  "planning.v3.s1.putBehindManyButton": "Zet {{count}} erachter",
  "planning.v3.s1.rankTitle": "Nummer {{rank}} van WLX; vink aan om er meer tegelijk achter te zetten",
  "planning.v3.s1.pickMore": "{{city}} erbij kiezen",
  "planning.v3.s1.effectTogether_one": "In de wagen",
  "planning.v3.s1.effectTogether_other": "Samen ({{count}})",
  "planning.v3.s1.togetherFits": "Hoogste belading {{lm}} m van {{capacity}} m · {{kg}} kg van {{capacityKg}} kg",
  "planning.v3.s1.togetherTooMuch": "Past niet: hoogste belading {{lm}} m van {{capacity}} m · {{kg}} kg van {{capacityKg}} kg",
  "planning.v3.s1.togetherTooMuchShort": "Past niet in de wagen, te veel laadmeters of gewicht",
  "planning.v3.s1.putBehindNone": "Zet erachter",
  "planning.v3.s2.addedWithStop": "Erbij op {{trip}}, met een laadstop in depot {{depot}}.",
  "planning.v3.s2.depotBlock.title": "Levering uit een ander depot",
  "planning.v3.s2.depotBlock.text": "{{city}} laadt in depot {{branch}}; de rit heeft depot {{home}} ({{why}}). Het kan, op twee manieren. Jij kiest.",
  "planning.v3.s2.depotBlock.textStop": "{{city}} laadt in {{branch}}, waar de order zelf laadt: de rit haalt het daar op.",
  "planning.v3.s2.depotBlock.stop": "Laadstop in {{city}}",
  "planning.v3.s2.depotBlock.stopText": "de wagen laadt ook in {{branch}}, vóór de eerste klant",
  "planning.v3.s2.depotBlock.pendel": "Depotpendel {{from}} → {{to}}",
  "planning.v3.s2.depotBlock.pendelRides": "rijdt al; de levering gaat mee",
  "planning.v3.s2.depotBlock.pendelNew": "een nieuwe depotpendelrit",
  "planning.v3.s2.depotBlock.runs_one": "+{{count}} pendelrit",
  "planning.v3.s2.depotBlock.runs_other": "+{{count}} pendelritten",
  "planning.v3.s2.depotBlock.stays": "Depot blijft {{home}}: de meeste meters laden daar. Overschrijven kan met Depot wijzigen.",
  "planning.v3.s2.depotBlock.becomes": "Let op: daarmee wordt {{branch}} het depot met de meeste meters.",
  "planning.v3.s2.captionAll": "Stap 2 · alle zendingen",
  "planning.v3.s2.captionSelection": "Stap 2 · gebied",
  "planning.v3.s2.captionBuilding": "Stap 2 · rit opbouwen",
  "planning.v3.s2.titleAll": "Plannen · alle zendingen",
  "planning.v3.s2.depotsLabel": "Ligt in",
  "planning.v3.s2.depotsCustomer": "bij de klant",
  "planning.v3.s2.depotsOpen": "depot nog open",
  "planning.v3.s2.depotsHelp": "Per depot het aantal zendingen en de laadmeters. Een levering ligt waar haar goederen liggen: het depot of warehouse waar ze laadt, of waar haar ophaling lost. Een ophaling of directe zending ligt bij de klant. Depot nog open: de ophaling heeft nog geen depot.",
  "planning.v3.s2.textAll": "Teken op de kaart met de lasso het gebied dat je wilt plannen; deze lijst toont dan alleen dat. Alle soorten: leveringen, ophalingen en directe zendingen. Verst van een depot eerst.",
  "planning.v3.s2.textSelection": "Vink aan wat samen een rit wordt. WLX zet de volgorde (eerst de vensters, dan de minste kilometers) en rekent met het depot waar de leveringen met de meeste meters laden.",
  "planning.v3.s2.textBuilding": "De rest van het gebied, per zending of hij op de rit past (meters, gewicht, eisen, tijd). Erbij zetten: aanvinken en Z, slepen naar de rit, of klikken op de kaart.",
  "planning.v3.s2.lensOpen": "Op de kaart: alles open",
  "planning.v3.s2.lensFits": "Op de kaart: past op de open rit",
  "planning.v3.s2.drawZone": "Gebied tekenen",
  "planning.v3.s2.zonesLabel": "Gebieden",
  "planning.v3.s2.zoneAll": "Alles",
  "planning.v3.s2.zone": "Gebied {{n}}",
  "planning.v3.s2.zoneRemove": "{{name}} weghalen",
  "planning.v3.s2.titleZone": "Plannen · Gebied {{n}}",
  "planning.v3.s2.titleZones": "Plannen · alle gebieden",
  "planning.v3.s2.lassoHelp": "De lasso op de kaart, in het kaartvenster: elke lasso wordt een eigen gebied, Gebied 1, Gebied 2, …, met een pil om de lijst erop te filteren; Alles toont de gebieden samen. Kom je van het bord, dan tekent slepen op de kaart meteen een gebied; een klik in een gebied kiest het, een klik erbuiten laat alles los.",
  "planning.v3.s2.search": "Zoek op klant, plaats of zending",
  "planning.v3.s2.checked_one": "{{count}} gekozen · {{lm}} m",
  "planning.v3.s2.checked_other": "{{count}} gekozen · {{lm}} m",
  "planning.v3.s2.newTrip": "Nieuwe rit",
  "planning.v3.s2.putOn": "Zet op {{trip}}",
  "planning.v3.s2.filter_fits": "Past",
  "planning.v3.s2.filter_depot": "Uit een ander depot",
  "planning.v3.s2.filter_not": "Past niet",
  "planning.v3.s2.colConsignment": "Zending",
  "planning.v3.s2.colKind": "Soort",
  "planning.v3.s2.colFrom": "Van",
  "planning.v3.s2.colTo": "Naar",
  "planning.v3.s2.colDistance": "Afstand",
  "planning.v3.s2.distanceHelp": "Kilometers tot het depot, over de weg geschat (hemelsbreed × 1,3). In een gebied: van het verste klanteind in het gebied tot het depot van het gebied (het depot erin, anders het depot dichtst bij het midden). Daarbuiten: van het verste klanteind van de zending (bij een levering ook waar hij vandaan kwam, bij een ophaling waar hij heen gaat) tot het dichtstbijzijnde depot",
  "planning.v3.s2.distanceFromArea": "{{city}} tot {{depot}}, het depot van het gebied: {{km}} km",
  "planning.v3.s2.distanceFromNearest": "{{city}} tot {{depot}}, het dichtstbijzijnde depot: {{km}} km",
  "planning.v3.s2.colWindows": "Laden · lossen",
  "planning.v3.s2.colLdm": "Ldm",
  "planning.v3.s2.colPal": "Pal",
  "planning.v3.s2.colKg": "Kg",
  "planning.v3.s2.colRequirements": "Eisen",
  "planning.v3.s2.colCustomer": "Klant",
  "planning.v3.s2.sortBy": "Sorteer op {{column}}; nog eens omgekeerd, een derde keer weer de volgorde van WLX",
  "planning.v3.s2.groupAll": "Verst van een depot eerst",
  "planning.v3.s2.groupSelection": "In het gebied",
  "planning.v3.s2.groupSorted": "Alles open",
  "planning.v3.s2.tickAll": "Alles in de lijst aanvinken",
  "planning.v3.s2.groupBuilding": "Past eerst",
  "planning.v3.s2.groupBuildingSelection": "In het gebied · past eerst",
  "planning.v3.s2.noneOpen": "Niets meer te plannen op deze dag.",
  "planning.v3.s2.noneFound": "Niets gevonden.",
  "planning.v3.s2.noneInArea": "Niets in dit gebied.",
  "planning.v3.s2.depot": "Depot",
  "planning.v3.s2.depotOpen": "volgt uit de rit",
  "planning.v3.s2.depotWindow": "depot",
  "planning.v3.s2.full": "vol",
  "planning.v3.fullOnWeight": "vol op gewicht",
  "planning.markGroupHelp_one": "Ritkenmerk: één zending met {{numbers}}, samen {{metres}} m. Wie er één plant, plant ze allebei",
  "planning.markGroupHelp_other": "Ritkenmerk: één zending met {{numbers}}, samen {{metres}} m. Wie er één plant, plant ze allemaal",
  "planning.markTogether_one": "samen, {{count}} zending",
  "planning.markTogether_other": "samen, {{count}} zendingen",
  "planning.onTrailer": "op oplegger {{code}}",
  "planning.uncoupledIn": "afgekoppeld in {{code}}",
  "planning.uncoupledHelp": "De lading staat in oplegger {{code}}, afgekoppeld door {{trip}}: aankoppelen, niet omladen.",
  "planning.menuUncoupleAt": "Afkoppelen in {{depot}} ({{city}})",
  "planning.menuViaCrossdock": "Toch via de crossdock (niet afkoppelen)",
  "planning.noticeUncoupleAt": "{{consignment}} wordt afgekoppeld in {{depot}}: de lading blijft in de oplegger, en de levering koppelt hem weer aan.",
  "planning.onTrailerHelp": "De lading zit in de oplegger van de afhaling ({{trip}}).",
  "planning.v3.s4.loadTrailer": "lading op oplegger {{code}}",
  "planning.v3.s2.keyTick": "aanvinken",
  "planning.v3.s2.keyNew": "nieuwe rit",
  "planning.v3.s2.keyDragKey": "Slepen",
  "planning.v3.s2.keyLasso": "gebied tekenen",
  "planning.v3.s2.keyCharter": "naar een charter",
  "planning.v3.s2.charter.menu_one": "Uitbesteden aan charter…",
  "planning.v3.s2.charter.menu_other": "{{count}} zendingen uitbesteden aan charter…",
  "planning.v3.s2.charter.title": "Uitbesteden aan charter",
  "planning.v3.s2.charter.summary_one": "{{count}} zending · {{lm}} m · {{kg}} kg",
  "planning.v3.s2.charter.summary_other": "{{count}} zendingen · {{lm}} m · {{kg}} kg",
  "planning.v3.s2.charter.more_one": "en nog {{count}}",
  "planning.v3.s2.charter.more_other": "en nog {{count}}",
  "planning.v3.s2.charter.search": "Zoek op naam of code",
  "planning.v3.s2.charter.none": "Geen charter gevonden. Een geblokkeerde charter of een relatie die nog niet is goedgekeurd, staat er niet tussen.",
  "planning.v3.s2.charter.onBoard": "Op het planbord",
  "planning.v3.s2.charter.others": "Overige charters",
  "planning.v3.s2.charter.after": "Het wordt één nieuwe rit voor deze charter, met de prijs voor de hele rit. Leeg laten geeft op de opdracht (All-in). De transportopdracht verstuur je daarna op de ritkaart.",
  "planning.v3.s2.charter.choose": "Kies een charter",
  "planning.v3.s2.charter.confirm": "Uitbesteden aan {{charter}}",
  "planning.v3.s2.charter.done_one": "{{trip}} gemaakt voor {{charter}} met {{count}} zending. De transportopdracht verstuur je op de ritkaart.",
  "planning.v3.s2.charter.done_other": "{{trip}} gemaakt voor {{charter}} met {{count}} zendingen. De transportopdracht verstuur je op de ritkaart.",
  "planning.v3.s2.charter.partly": "{{trip}} is gemaakt, maar {{charter}} staat er niet op: {{reason}} Kies de charter op de ritkaart.",
  "planning.v3.s2.charter.noTrip": "De rit is gemaakt, maar WLX vindt hem niet terug op deze dag. Kijk in stap 3.",
  "planning.v3.s2.charter.openTrip": "Ritkaart {{trip}} openen",
  "planning.v3.s2.keyEsc": "loslaten",
  "planning.v3.s2.trips.viewLabel": "Wat de lijst toont",
  "planning.v3.s2.trips.viewHelp": "De zendingen die wachten, of de ritten die er al zijn; R wisselt",
  "planning.v3.s2.trips.viewLegs": "Zendingen",
  "planning.v3.s2.trips.viewTrips": "Ritten",
  "planning.v3.s2.trips.caption": "Stap 2 · gemaakte ritten",
  "planning.v3.s2.trips.titleAll": "Gemaakte ritten",
  "planning.v3.s2.trips.text": "Alle ritten die er al zijn, los van het gebied. Klik een rit om hem onder de lijst te openen, met Ctrl of Shift meer ritten op de kaart: haal er een zending af met Delete, sleep een stop voor de volgorde of een zending op een andere rit hier, of zet er meer bij via Zendingen (R).",
  "planning.v3.s2.trips.lens": "Op de kaart: de ritten",
  "planning.v3.s2.trips.withFull": "ook volle leveringen ({{count}})",
  "planning.v3.s2.trips.noneAll": "Nog geen ritten gemaakt in stap 2.",
  "planning.v3.s2.trips.noneFiltered": "Geen rit bij dit filter of deze zoekterm.",
  "planning.v3.s2.trips.rowTitle": "{{trip}} openen, met Ctrl of Shift meer ritten op de kaart; rechtermuisknop voor de ritkaart of om hem te verwijderen",
  "planning.v3.s2.trips.rowOpen": "{{trip}} is open, rechts",
  "planning.v3.s2.trips.keyView": "zendingen · ritten",
  "planning.v3.s2.trips.keyTrips": "ritten",
  "planning.v3.s2.trips.keyMove": "rit openen",
  "planning.v3.s2.trips.keyMore": "rit erbij of eraf",
  "planning.v3.s2.waitsText_one": "{{count}} levering wacht op zijn ophaling",
  "planning.v3.s2.waitsText_other": "{{count}} leveringen wachten op hun ophaling",
  "planning.v3.s2.proposal": "Voorstel",
  "planning.v3.s2.building": "In opbouw",
  "planning.v3.s2.newNumber": "nieuw",
  "planning.v3.s2.depotChip": "Depot {{depot}}",
  "planning.v3.s2.stopsLine_one": "{{count}} stop · {{km}} km (leeg {{empty}}) · {{from}}–{{to}} · rijden {{driving}}",
  "planning.v3.s2.stopsLine_other": "{{count}} stops · {{km}} km (leeg {{empty}}) · {{from}}–{{to}} · rijden {{driving}}",
  "planning.v3.s2.departure": "Vertrek",
  "planning.v3.s2.departureAuto": "berekend: zo laat als de vensters toelaten",
  "planning.v3.s2.departureFixed": "vastgezet, de rit volgt deze tijd",
  "planning.v3.s2.departureReset": "Automatisch",
  "planning.v3.s2.departureSet": "Vertrek van {{trip}} op {{time}} gezet; de stops schuiven mee.",
  "planning.v3.s2.departureCleared": "Vertrek van {{trip}} weer berekend door WLX.",
  "planning.sheet.label": "De stops van de rit",
  "planning.sheet.colSeq": "#",
  "planning.sheet.colTime": "Tijd",
  "planning.sheet.colWindow": "Venster",
  "planning.sheet.colOpening": "Openingstijden",
  "planning.sheet.openOwn": "Eigen vestiging: de openingstijden gelden niet voor onze eigen wagens",
  "planning.sheet.openNone": "geen",
  "planning.sheet.openNoneHelp": "Geen openingstijden bekend: een vrij adres, of een locatie zonder openingstijden",
  "planning.sheet.openClosed": "gesloten",
  "planning.sheet.colPlace": "Plaats",
  "planning.sheet.colLocation": "Locatie",
  "planning.sheet.colWhat": "Wat",
  "planning.sheet.colConsignment": "Zending",
  "planning.sheet.colCustomer": "Klant",
  "planning.sheet.colLdm": "Ldm",
  "planning.sheet.colKg": "Kg",
  "planning.sheet.colPal": "Pal",
  "planning.sheet.colOnBoard": "Aan boord",
  "planning.sheet.colDrive": "Rit erheen",
  "planning.sheet.colNote": "Melding",
  "planning.sheet.colStatus": "Status",
  "planning.sheet.consignments_one": "{{count}} zending",
  "planning.sheet.consignments_other": "{{count}} zendingen",
  "planning.sheet.more": "+{{count}}",
  "planning.sheet.actCount": "{{act}} {{count}}",
  "planning.sheet.departs": "vertrek",
  "planning.sheet.wait": "wacht {{time}}",
  "planning.sheet.closed": "dicht",
  "planning.sheet.slotLate": "{{time}} na tijdslot",
  "planning.sheet.windowLate": "{{time}} na venster, wel open",
  "planning.sheet.breakOnRoad": "onderweg, ± {{km}} km na {{place}}",
  "planning.sheet.breakOnRoadAfter": "onderweg na {{place}}",
  "planning.sheet.breakAt": "bij {{place}}",
  "planning.sheet.home": "Thuis",
  "planning.sheet.kmHome": "naar huis {{km}} km",
  "planning.sheet.unloadsAt": "lost bij {{index}} {{place}}",
  "planning.sheet.loadedAt": "geladen bij {{index}} {{place}}",
  "planning.sheet.lateOne": "1 stop te laat: {{city}} {{time}}",
  "planning.sheet.lateMany": "{{count}} stops te laat",
  "planning.sheet.departureAuto": "berekend",
  "planning.sheet.departureFixed": "vast",
  "planning.sheet.small": "Rit klein",
  "planning.sheet.big": "Rit groot",
  "planning.sheet.sizeHelp": "De rit onder de lijst als strook of als het hele blad; WLX onthoudt het",
  "planning.sheet.resize": "Sleep voor meer lijst of meer rit; dubbelklik: zo hoog als de rit",
  "planning.sheet.moveTo": "Naar een andere rit",
  "planning.sheet.moveToLabel": "Naar welke rit gaat {{consignment}}?",
  "planning.sheet.moveToBack": "Terug",
  "planning.sheet.moveToNone": "Geen andere rit op deze dag",
  "planning.sheet.moveToKm": "{{km}} km",
  "planning.sheet.barLine": "{{from}} → {{to}} · {{count}} stops · {{lm}} / {{capacity}} m",
  "planning.sheet.inMapWindow": "Ritblad: in het kaartvenster",
  "planning.v3.s2.depotMetres": "Depot {{depot}} · meeste meters: {{metres}}",
  "planning.v3.s2.metresFrom": "{{lm}} m uit {{branch}}",
  "planning.v3.s2.depotNearest": "Depot {{depot}} · geen leveringen: dichtstbij waar hij laadt, tot de wagen het zegt",
  "planning.v3.s2.depotPlanner": "Depot {{depot}} · gekozen door de planner",
  "planning.v3.s2.depotVehicle": "Depot {{depot}} · standplaats van de wagen",
  "planning.v3.s2.depotNone": "Nog geen depot: dat volgt uit de wagen",
  "planning.v3.s2.depotChange": "Depot wijzigen",
  "planning.v3.s2.depotAuto": "Zoals WLX rekent (meeste meters, dan de wagen)",
  "planning.v3.s2.depotSet": "Depot van {{trip}}: {{depot}}.",
  "planning.timeline.activities": "Activiteiten",
  "planning.timeline.drive": "Rijden",
  "planning.timeline.wait": "Wachten",
  "planning.timeline.break": "Pauze",
  "planning.timeline.breakOrWait": "Pauze / Wachten",
  "planning.timeline.breakLine": "pauze {{time}}",
  "planning.timeline.restLine": "dagrust {{time}}",
  "planning.timeline.load": "Laden",
  "planning.timeline.unload": "Lossen",
  "planning.timeline.loadLegend": "Laadmeter (kleurindicatie)",
  "planning.timeline.was": "Dunne balk: de rit zonder wat is aangevinkt, {{from}}–{{to}}",
  "planning.timeline.band_full": "{{from}} – {{to}} lm",
  "planning.timeline.band_fair": "{{from}} – {{to}} lm",
  "planning.timeline.band_low": "{{from}} – {{to}} lm",
  "planning.timeline.band_poor": "{{from}} – {{to}} lm",
  "planning.timeline.bandEmpty": "0 lm",
  "planning.timeline.lm": "{{lm}} lm",
  "planning.timeline.blockTitle": "{{what}} {{from}}–{{to}} · {{duration}}",
  "planning.timeline.loadOnBoard": "{{lm}} lm aan boord, {{share}}% van {{capacity}} lm · {{from}}–{{to}}",
  "planning.timeline.leaves": "Vertrek {{place}} · {{time}}",
  "planning.timeline.back": "Terug {{place}} · {{time}}",
  "planning.timeline.stopTitle": "{{index}}. {{name}}, {{city}}",
  "planning.v3.s2.peak": "Hoogste belading",
  "planning.v3.s2.peakText": "{{lm}} van {{capacity}} m · {{kg}} kg van {{capacityKg}} kg",
  "planning.v3.s2.fits.button": "Past wel",
  "planning.v3.s2.fits.help": "De planner weet dat het samen in de wagen past: WLX laadt de zending met de rest in het depot in plaats van in een tweede ronde, en rekent haar laadmeters niet tegen de wagen (P103).",
  "planning.v3.s2.fits.then": "Samen in de wagen: {{reason}}",
  "planning.v3.s2.fits.added": "Past wel: {{consignment}} staat op {{trip}} en laadt met de rest",
  "planning.v3.s2.fits.set": "Past wel: {{consignment}} laadt met de rest op {{trip}}",
  "planning.v3.s2.fits.unset": "{{consignment}} telt weer met zijn laadmeters op {{trip}}",
  "planning.v3.s2.fits.menuSet": "Past wel (samen in de wagen)",
  "planning.v3.s2.fits.menuUnset": "Past wel terugzetten",
  "planning.v3.s2.fits.peak": "· past wel: telt {{lm}} m",
  "planning.v3.s2.fits.chip": "past wel",
  "planning.v3.s2.fits.chipBy": "Past wel volgens {{by}}, {{when}}: WLX rekent de laadmeters niet tegen de wagen",
  "planning.v3.s2.withAdded_one": "met {{count}} erbij: {{km}} km · {{time}}",
  "planning.v3.s2.withAdded_other": "met {{count}} erbij: {{km}} km · {{time}}",
  "planning.v3.s2.stopsLabel": "Stops in de volgorde van de rit",
  "planning.v3.s2.driveLine": "{{km}} km · {{time}}",
  "planning.v3.s2.driveUnknown": "positie onbekend: geen km",
  "planning.v3.s2.depotOf": "Depot {{depot}}",
  "planning.v3.s2.actLoad": "Laden",
  "planning.v3.s2.actUnload": "Lossen",
  "planning.v3.s2.actLoadDepot": "Laden depot",
  "planning.v3.s2.actUnloadDepot": "Lossen depot",
  "planning.v3.s2.actBoth": "Laden en lossen",
  "planning.v3.s2.makeTrip": "Nieuwe rit",
  "planning.v3.s2.cancel": "Loslaten",
  "planning.v3.s2.done": "Rit klaar",
  "planning.v3.s2.doneNotice": "{{trip}} is klaar voor nu; het gebied blijft staan voor de volgende.",
  "planning.v3.s2.closedNotice": "{{trip}} is dicht; wat erop staat, blijft erop.",
  "planning.v3.s2.made_one": "{{trip}} gemaakt met {{count}} zending.",
  "planning.v3.s2.made_other": "{{trip}} gemaakt met {{count}} zendingen.",
  "planning.v3.s2.added_one": "{{count}} zending erbij op {{trip}}.",
  "planning.v3.s2.added_other": "{{count}} zendingen erbij op {{trip}}.",
  "planning.v3.s2.removed_one": "{{count}} zending van {{trip}} af.",
  "planning.v3.s2.removed_other": "{{count}} zendingen van {{trip}} af.",
  "planning.v3.s2.previewNew_one": "Met deze rit ({{count}} zending)",
  "planning.v3.s2.previewNew_other": "Met deze rit ({{count}} zendingen)",
  "planning.v3.s2.previewAdd": "Met {{city}} erbij",
  "planning.v3.s2.previewAddCount_one": "Met {{count}} erbij",
  "planning.v3.s2.previewAddCount_other": "Met {{count}} erbij",
  "planning.v3.s2.fit.onTrip": "Op de rit",
  "planning.v3.s2.fit.fits": "Past · {{km}} km",
  "planning.v3.s2.fit.fitsLate": "Past · {{km}} km · {{city}} {{time}} na venster, wel open",
  "planning.v3.s2.fit.fitsLateMany": "Past · {{km}} km · {{count}} stops na hun venster, wel open",
  "planning.v3.s2.fit.fits_on_the_way": "Past · {{km}} km · onderweg",
  "planning.v3.s2.fit.fits_on_the_way_back": "Past · {{km}} km · op de terugweg",
  "planning.v3.s2.fit.fits_on_route": "Past · {{km}} km · op de route",
  "planning.v3.s2.fit.depotPendel": "Past · {{km}} km · uit depot {{branch}}: depotpendel naar het depot van de rit ({{rides}}, {{pendelKm}} km) of laadstop in {{branch}} ({{stopKm}} km)",
  "planning.v3.s2.fit.depotStop": "Past · {{km}} km · laadt in {{branch}}: een laadstop daar ({{stopKm}} km)",
  "planning.v3.s2.fit.rides": "rijdt al",
  "planning.v3.s2.fit.newRun": "nieuwe depotpendelrit",
  "planning.v3.s2.fit.adds": "vraagt dan {{adds}}",
  "planning.v3.s2.fit.waits": "Wacht op zijn ophaling",
  "planning.v3.s2.fit.waitsFrom": "Wacht op zijn ophaling in {{origin}}",
  "planning.v3.s2.fit.noPosition": "Positie onbekend: geen km en geen tijd",
  "planning.v3.s2.fit.clash": "Past niet: {{add}} en {{have}} niet op één rit",
  "planning.v3.s2.fit.overMeters": "Past niet: {{over}} m te veel ({{peak}} van {{capacity}} m)",
  "planning.v3.s2.fit.overWeight": "Past niet: {{peak}} kg van {{capacity}} kg",
  "planning.v3.s2.fit.late": "Dan komt {{city}} te laat: {{arrival}}, venster tot {{windowEnd}}",
  "planning.v3.s2.fit.lateDay": "Dan komt {{city}} pas {{at}}, venster {{window}}",
  "planning.v3.s2.fit.lateMany": "Dan komen {{count}} stops te laat: {{stops}}",
  "planning.v3.s2.fit.lateManyDay": "Dan komen {{count}} stops buiten hun venster, {{other}} op een andere dag: {{stops}}",
  "planning.v3.s2.fit.closed": "Dan staat {{city}} dicht: {{arrival}}, open {{open}}",
  "planning.v3.s2.fit.closedDay": "Dan staat {{city}} dicht: {{arrival}}",
  "planning.v3.s2.fit.slotMissed": "Dan mist {{city}} het tijdslot: {{arrival}}, tijdslot tot {{windowEnd}}",
  "planning.v3.s2.late.addDay": "Daarmee schuift de rit naar {{day}}",
  "planning.v3.s2.late.add_one": "Daarmee komt {{count}} stop te laat",
  "planning.v3.s2.late.add_other": "Daarmee komen {{count}} stops te laat",
  "planning.v3.s2.late.tripDay": "Deze rit schuift naar {{day}}",
  "planning.v3.s2.late.trip_one": "Op deze rit komt {{count}} stop te laat",
  "planning.v3.s2.late.trip_other": "Op deze rit komen {{count}} stops te laat",
  "planning.v3.s2.late.text": "Buiten het venster dat met de klant is afgesproken:",
  "planning.v3.s2.late.stop": "{{city}} · {{act}} {{at}} · venster {{window}}",
  "planning.v3.s2.late.stopClosed": "{{city}} · {{act}} {{at}} · dicht, open {{open}}",
  "planning.v3.s2.late.stopSlot": "{{city}} · {{act}} {{at}} · tijdslot {{window}}",
  "planning.v3.s2.late.load": "laden",
  "planning.v3.s2.late.unload": "lossen",
  "planning.v3.s2.fit.overDriving": "Te lang rijden: {{time}} op één dag, meer dan 9 u",
  "planning.v3.s3.title": "Overzicht van de dag",
  "planning.v3.s3.text": "Alle ritten van de dag. Depotpendels staan niet als rit in deze lijst; ze tellen wel mee in De dag. Rechts wat nog niet gepland is, met de reden. Klik op een rit om hem onder de lijst en op de kaart te zien; met Ctrl of Shift kies je meer ritten, die de kaart samen laat zien. De rechtermuisknop geeft het menu van de rit, met Verder plannen. In de rit onder de lijst staan de zendingen onder hun stops: sleep een stop om de volgorde te wijzigen, of een zending op een rit in de lijst om hem te verplaatsen.",
  "planning.v3.s3.lens": "Op de kaart: Ritten",
  "planning.v3.s3.filter_requirements": "Met eis",
  "planning.v3.s3.filter_otherDepot": "Laadstop ander depot",
  "planning.v3.s3.filter_late": "Te laat",
  "planning.v3.s3.filter_markSplit": "Ritkenmerk verdeeld",
  "planning.v3.s3.stageLabel": "Welke ritten",
  "planning.v3.s3.stage_all": "Alle",
  "planning.v3.s3.stage_1": "Stap 1",
  "planning.v3.s3.stage_2": "Stap 2",
  "planning.v3.s3.markSplit": "Ritkenmerk verdeeld: {{marks}}",
  "planning.v3.s3.markOnTrip": "{{mark}} op rit {{trip}}",
  "planning.v3.s3.markWaiting": "{{mark}} nog niet gepland",
  "planning.v3.s3.colTrip": "Rit",
  "planning.v3.s3.colRoute": "Van → naar",
  "planning.v3.s3.colDepot": "Depot",
  "planning.v3.s3.colStops": "Stops",
  "planning.v3.s3.colPeak": "Piek",
  "planning.v3.s3.colKm": "Km",
  "planning.v3.s3.colTime": "Tijd",
  "planning.v3.s3.colDuration": "Duur",
  "planning.v3.s3.timeTitle": "Van vertrek tot thuis: {{range}}",
  "planning.v3.s3.durationTitle": "Ritduur van vertrek tot thuis: {{time}}",
  "planning.v3.s3.daysLater_one": "de volgende dag",
  "planning.v3.s3.daysLater_other": "{{count}} dagen later",
  "planning.v3.s3.daysEarlier_one": "de dag ervoor",
  "planning.v3.s3.daysEarlier_other": "{{count}} dagen eerder",
  "planning.v3.s3.colRequirements": "Eisen",
  "planning.v3.s3.consignments_one": "{{count}} zending",
  "planning.v3.s3.consignments_other": "{{count}} zendingen",
  "planning.v3.s3.more": "+{{count}}",
  "planning.v3.s3.depotSource_planner": "Depot gekozen door de planner",
  "planning.v3.s3.depotSource_vehicle": "Depot: de standplaats van de wagen",
  "planning.v3.s3.depotSource_provisional": "Voorlopig, tot er een wagen op staat: de vertrekplaats in het pendelschema, waar de leveringen laden, of de eigen vestiging bij het werk",
  "planning.v3.s3.lateStops_one": "{{count}} stop te laat",
  "planning.v3.s3.lateStops_other": "{{count}} stops te laat",
  "planning.v3.s3.rowTitle": "{{trip}} rechts tonen; rechtermuisknop om hem verder te plannen",
  "planning.v3.s3.dragStop": "Sleep om de volgorde te wijzigen, of Alt ↑ ↓",
  "planning.v3.s3.dragLeg": "Sleep op een rit links om de zending te verplaatsen; rechtermuisknop voor meer",
  "planning.v3.s3.moveLegHint": "Zending naar een andere rit: sleep hem op de rit links",
  "planning.v3.s3.manualOrder": "Volgorde met de hand",
  "planning.v3.s3.menuTakeOff": "Van de rit halen",
  "planning.v3.s3.unloadFirst": "Daar lost een zending voordat ze geladen is.",
  "planning.v3.s3.showConsignments_one": "{{count}} zending tonen",
  "planning.v3.s3.showConsignments_other": "{{count}} zendingen tonen",
  "planning.v3.s3.planThis": "Verder plannen",
  "planning.v3.s3.closeTrip": "Rit sluiten",
  "planning.v3.s3.menuDelete": "Rit verwijderen…",
  "planning.v3.s3.deleteAsk": "Rit {{number}} verwijderen?",
  "planning.v3.s3.deleteDo": "Ja, verwijderen",
  "planning.v3.s3.giveBack_one": "De zending gaat terug naar Te plannen.",
  "planning.v3.s3.giveBack_other": "De {{count}} zendingen gaan terug naar Te plannen.",
  "planning.v3.s3.groupFull": "Volle leveringen met vervolg",
  "planning.v3.s3.groupPlanned": "Gepland in stap 2",
  "planning.v3.s3.groupKm": "{{km}} km",
  "planning.v3.s3.none": "Nog geen ritten op deze dag.",
  "planning.v3.s3.noneFiltered": "Geen rit met dit filter.",
  "planning.v3.s3.keyBack": "terug naar plannen",
  "planning.v3.s3.keyOpen": "rit openen",
  "planning.v3.s3.keyMove": "rit",
  "planning.v3.s3.keyCapacity": "capaciteit",
  "planning.v3.s3.openCaption": "Nog niet gepland",
  "planning.v3.s3.openTitle_one": "{{count}} zending",
  "planning.v3.s3.openTitle_other": "{{count}} zendingen",
  "planning.v3.s3.openSub": "{{lm}} m · nog op geen rit",
  "planning.v3.s3.allPlanned": "Alles van deze dag staat op een rit.",
  "planning.v3.s3.reasonsError": "Waarom het nog niet gepland is, kon niet worden gelezen.",
  "planning.v3.s3.reasonGroup.fits": "Past op een rit",
  "planning.v3.s3.reasonGroup.waits_for_pickup": "Na ophaling",
  "planning.v3.s3.reasonGroup.small": "Alleen en klein: past bij geen rit",
  "planning.v3.s3.reasonGroup.nowhere": "Past nergens",
  "planning.v3.s3.reasonText.fits": "Er is een rit in de buurt waar hij op past, hooguit 60 km om. Klik om die rit in stap 2 te openen, met de zending erbij gekozen.",
  "planning.v3.s3.reasonText.waits_for_pickup": "De levering kan pas als de ophaling op een rit staat.",
  "planning.v3.s3.reasonText.small": "Te klein voor een eigen rit, en geen rit in de buurt waar hij op past (tijd, wagen of eisen). Plan hem bij een rit, of via een depot.",
  "planning.v3.s3.reasonText.nowhere": "Geen rit in de buurt neemt hem op tijd, in de wagen of met de eisen. Maak er in stap 2 een rit van.",
  "planning.v3.s3.reason.fits": "past op {{trip}} · {{km}} km",
  "planning.v3.s3.reason.waits": "de ophaling staat nog op geen rit",
  "planning.v3.s3.reason.waitsFrom": "de ophaling in {{origin}} staat nog op geen rit",
  "planning.v3.s3.reason.noPosition": "adres zonder positie",
  "planning.v3.s3.reason.noTrip": "geen rit in de buurt",
  "planning.v3.s3.reason.longWay": "{{trip}} neemt hem, maar {{km}} km om",
  "planning.v3.s3.reason.near": "{{trip}} · {{why}}",
  "planning.v3.s3.far": "{{km}} km van {{depot}}",
  "planning.v3.s3.openTrip": "Openen in stap 2, op deze rit",
  "planning.v3.s3.openLeg": "Tonen in stap 2",
  "planning.v3.s3.back": "Terug naar plannen",
  "planning.v3.s3.toCapacity": "Naar capaciteit",
  "planning.v3.s4.tripsTitle": "Ritten zonder wagen",
  "planning.v3.s4.assigned": "{{count}} al ingezet",
  "planning.v3.s4.sortLabel": "Sorteren",
  "planning.v3.s4.sort_earliest": "Vroegst vertrek",
  "planning.v3.s4.sort_bottlenecks": "Knelpunten eerst",
  "planning.v3.s4.error": "De capaciteit kon niet worden geladen.",
  "planning.v3.s4.noneOpen": "Geen ritten zonder wagen.",
  "planning.v3.s4.unknownFree_one": "Daarnaast is 1 wagen vrij met onbekende ruimte (een trekker zonder vaste oplegger, of geen laadmeters in de stamdata).",
  "planning.v3.s4.unknownFree_other": "Daarnaast zijn {{count}} wagens vrij met onbekende ruimte (een trekker zonder vaste oplegger, of geen laadmeters in de stamdata).",
  "planning.v3.s4.fits_one": "1 past",
  "planning.v3.s4.fits_other": "{{count}} passen",
  "planning.v3.s4.keyTrip": "rit",
  "planning.v3.s4.keyPut": "inzetten",
  "planning.v3.s4.keySupply": "aanbod en vraag",
  "planning.v3.s4.keyFleet": "wagenpark",
  "planning.v3.s4.fleetLabel": "Wagenpark voor de rit",
  "planning.v3.s4.allAssigned": "Alle ritten van de dag hebben een wagen of charter.",
  "planning.v3.s4.toOverview": "Naar het overzicht",
  "planning.v3.s4.undo": "Ongedaan maken",
  "planning.v3.s4.peak": "piek {{lm}} · {{kg}} kg",
  "planning.v3.s4.onLorry": "op {{what}}",
  "planning.v3.s4.depotChip": "Depot {{depot}}",
  "planning.v3.s4.depotNone": "Nog geen depot",
  "planning.v3.s4.depotFollows": "Laadt in {{home}} · depot volgt de wagen",
  "planning.v3.s4.depotFollowsTitle": "{{home}} is geen depot: de rit krijgt het depot van de standplaats van de wagen.",
  "planning.v3.s4.stripLoads": "laadt hier",
  "planning.v3.s4.depotSource_planner": "Depot {{depot}}, gekozen door de planner",
  "planning.v3.s4.depotSource_vehicle": "Depot {{depot}}, de standplaats van de wagen",
  "planning.v3.s4.depotSource_provisional": "Depot {{depot}}, voorlopig: de vertrekplaats in het pendelschema of waar de meeste meters laden. Een wagen brengt zijn standplaats als depot mee.",
  "planning.v3.s4.stripFree_one": "1 past en vrij",
  "planning.v3.s4.stripFree_other": "{{count}} passen en vrij",
  "planning.v3.s4.stripDepot": "depot",
  "planning.v3.s4.stripSub": "{{all}} wagens · {{taken}} passen maar bezet",
  "planning.v3.s4.segmentLabel": "Groep",
  "planning.v3.s4.segment_all": "Alle",
  "planning.v3.s4.segment_free": "Passen",
  "planning.v3.s4.segment_taken": "Bezet",
  "planning.v3.s4.segment_fitsNot": "Past niet",
  "planning.v3.s4.chip_tractor": "Trekker",
  "planning.v3.s4.chip_rigid": "Bakwagen",
  "planning.v3.s4.chip_cooling": "Koel",
  "planning.v3.s4.chip_home": "Standplaats {{depot}}",
  "planning.v3.s4.colLorry": "Wagen",
  "planning.v3.s4.colKind": "Soort · ruimte",
  "planning.v3.s4.colBody": "Opbouw",
  "planning.v3.s4.colDriver": "Chauffeur · dienst",
  "planning.v3.s4.colStand": "Standpl.",
  "planning.v3.s4.colStatus": "Voor deze rit",
  "planning.v3.s4.noneFiltered": "Geen wagen met deze filters.",
  "planning.v3.s4.group_free": "Past en vrij",
  "planning.v3.s4.group_taken": "Past, maar bezet of niet in dienst",
  "planning.v3.s4.group_fitsNot": "Past niet",
  "planning.v3.s4.group_unknown": "Capaciteit onbekend",
  "planning.v3.s4.groupMeta_free": "met rooster eerst, dan de minste depotpendels en km voor de dag",
  "planning.v3.s4.groupMeta_taken": "terwijl de rit loopt",
  "planning.v3.s4.groupMeta_fitsNot": "met de reden",
  "planning.v3.s4.groupMeta_unknown": "trekker zonder vaste oplegger, of geen laadmeters in de stamdata",
  "planning.v3.s4.more": "+{{count}} meer",
  "planning.v3.s4.noDriver": "geen vaste chauffeur",
  "planning.v3.s4.noTrailer": "{{kind}}, geen oplegger",
  "planning.v3.s4.st.free": "past · vrij",
  "planning.v3.s4.st.freeAfter": "past · vrij na {{trip}} ({{time}})",
  "planning.v3.s4.st.freeUntil": "past · vrij tot {{trip}} ({{time}})",
  "planning.v3.s4.st.busy": "bezet {{trip}} {{start}}–{{end}}",
  "planning.v3.s4.st.fitsNot": "past niet: {{reason}}",
  "planning.v3.s4.st.fitsNotPlain": "past niet",
  "planning.v3.s4.st.noTrailer": "zonder vaste oplegger: kies er een bij",
  "planning.v3.s4.st.unknown": "capaciteit onbekend",
  "planning.v3.s4.dep.none": "geen standplaats",
  "planning.v3.s4.dep.chosen": "depot {{depot}} gekozen",
  "planning.v3.s4.dep.stays": "depot blijft {{depot}}",
  "planning.v3.s4.dep.open": "depot open: {{home}} is geen depot",
  "planning.v3.s4.dep.becomes": "depot wordt {{depot}}",
  "planning.v3.s4.dep.pendels_one": "+1 depotpendel {{pairs}}",
  "planning.v3.s4.dep.pendels_other": "+{{count}} depotpendels {{pairs}}",
  "planning.v3.s4.dep.becomesPendels_one": "depot wordt {{depot}} · +1 depotpendel {{pairs}}",
  "planning.v3.s4.dep.becomesPendels_other": "depot wordt {{depot}} · +{{count}} depotpendels {{pairs}}",
  "planning.v3.s4.dayKm": "{{km}} km voor de dag",
  "planning.v3.s4.standplaats": "standplaats {{code}}",
  "planning.v3.s4.noStandplaats": "geen standplaats",
  "planning.v3.s4.pickLorry": "Kies een wagen",
  "planning.v3.s4.pickCharter": "Kies een charter",
  "planning.v3.s4.charters": "Charters",
  "planning.v3.s4.chartersMeta": "die dag in dag uit voor ons rijden",
  "planning.v3.s4.ownFleet": "Eigen wagens",
  "planning.v3.s4.put": "Zet {{code}} in",
  "planning.v3.s4.board.title": "Bord",
  "planning.v3.s4.board.viewLabel": "Weergave",
  "planning.v3.s4.board.view_board": "Bord",
  "planning.v3.s4.board.view_fleet": "Per rit",
  "planning.v3.s4.board.view_supply": "Aanbod en vraag",
  "planning.v3.s4.board.complete": "Alle {{count}} ritten volledig ingepland",
  "planning.v3.s4.board.onLorry": "{{count}} van {{all}} ritten op een wagen",
  "planning.v3.s4.board.driverOpen": "{{count}} zonder chauffeur",
  "planning.v3.s4.board.trailerOpen": "{{count}} zonder oplegger",
  "planning.v3.s4.board.kindLabel": "Welke wagens",
  "planning.v3.s4.board.kind_all": "Alle",
  "planning.v3.s4.board.kind_tractor": "Trekkers",
  "planning.v3.s4.board.kind_rigid": "Bakwagens",
  "planning.v3.s4.board.search": "Zoek wagen, kenteken, chauffeur of oplegger",
  "planning.v3.s4.board.colTrailer": "Oplegger",
  "planning.v3.s4.board.driver": "Chauffeur",
  "planning.v3.s4.board.open": "open",
  "planning.v3.s4.board.open_driver": "chauffeur open",
  "planning.v3.s4.board.open_trailer": "oplegger open",
  "planning.v3.s4.board.pickTrip": "Kies links een rit en dan een wagen, of sleep de rit op de wagen. Een klik op een rit op het bord toont wat er nog open is.",
  "planning.v3.s4.board.pickRow": "Kies een wagen",
  "planning.v3.s4.board.chooseDriver": "Kies chauffeur",
  "planning.v3.s4.board.otherDriver": "Andere chauffeur",
  "planning.v3.s4.board.chooseTrailer": "Kies oplegger",
  "planning.v3.s4.board.otherTrailer": "Andere oplegger",
  "planning.v3.s4.board.driverChosen": "{{what}} rijdt {{trip}}.",
  "planning.v3.s4.board.trailerChosen": "{{what}} gaat mee op {{trip}}.",
  "planning.v3.s4.board.crewOpenTitle": "Chauffeur of oplegger open",
  "planning.cap.boardOff": "Geen bord",
  "planning.cap.boardWindow": "Bord los",
  "planning.cap.windowTitle": "Bord · {{date}}",
  "planning.cap.listTitle": "Ritten van de dag",
  "planning.cap.tabsLabel": "Welke ritten",
  "planning.cap.tab_all": "Alle",
  "planning.cap.tab_vehicle": "Zonder wagen",
  "planning.cap.tab_driver": "Zonder chauffeur",
  "planning.cap.tab_trailer": "Zonder oplegger",
  "planning.cap.tab_done": "Klaar",
  "planning.cap.chosenElsewhere": "Gekozen op het bord: een rit van een andere dag",
  "planning.cap.otherDay": "{{trip}} is een rit van {{day}}; de lijst blijft deze dag",
  "planning.cap.openBoard": "Het bord met de chauffeurs en opleggers staat in het tweede venster: kies rechtsboven Bord los.",
  "planning.cap.colPick": "Gekozen",
  "planning.cap.colTime": "Vertrek – terug",
  "planning.cap.colLorry": "Wagen",
  "planning.cap.colDriver": "Chauffeur",
  "planning.cap.colTrailer": "Oplegger",
  "planning.cap.colUsualDriver": "Vaste chauffeur",
  "planning.cap.colUsualTrailer": "Vaste opl.",
  "planning.cap.noneInTab": "Geen ritten onder deze tab.",
  "planning.cap.open": "open",
  "planning.cap.keyNextOpen": "volgende rit met iets open",
  "planning.cap.keyLists": "chauffeurs, opleggers",
  "planning.cap.keyUnassign": "van de wagen halen",
  "planning.cap.keyUndo": "terug",
  "planning.cap.keySheet": "ritblad klein of groot",
  "planning.cap.keyClose": "rit sluiten",
  "planning.cap.closeTrip": "Rit sluiten",
  "planning.cap.unassign": "Van de wagen halen",
  "planning.cap.unassigned": "{{trip}} is van de wagen gehaald en staat weer onder Zonder wagen",
  "planning.cap.driverRemoved": "Chauffeur van {{trip}} gehaald",
  "planning.cap.trailerRemoved": "Oplegger van {{trip}} gehaald",
  "planning.cap.noRoster": "geen rooster",
  "planning.cap.noUsualDriver": "geen vaste chauffeur",
  "planning.cap.box.toLorry": "Sleep naar een wagen",
  "planning.cap.box.lorryHint": "op het bord, of kies hem daar en klik een vrije rij",
  "planning.cap.box.standplaats": "standplaats {{city}}",
  "planning.cap.box.charter": "charter, met eigen chauffeur en oplegger",
  "planning.cap.box.charterCrew": "de charter rijdt zelf",
  "planning.cap.box.choose": "Kies",
  "planning.cap.box.driverHint": "rechts naast het bord, of sleep er een op de balk",
  "planning.cap.box.trailerHint": "rechts naast het bord, of sleep er een op de balk",
  "planning.cap.box.lorryFirst": "eerst een wagen",
  "planning.cap.box.rigid": "een bakwagen heeft geen oplegger",
  "planning.cap.box.toList": "Naar de lijst naast het bord",
  "planning.cap.box.removeDriver": "Chauffeur weghalen",
  "planning.cap.box.removeTrailer": "Oplegger weghalen",
  "planning.cap.putHere": "zet {{trip}} hier",
  "planning.cap.driverOpen": "Chauffeur open",
  "planning.cap.trailerOpen": "Oplegger open",
  "planning.cap.driverOpenLower": "chauffeur open",
  "planning.cap.trailerOpenLower": "oplegger open",
  "planning.cap.charter": "Charter",
  "planning.cap.charters": "Charters",
  "planning.cap.noCharters": "Geen vaste charters. Zet Op het planbord aan op de relatiekaart van een charter, dan staat hij hier elke dag.",
  "planning.cap.handed": "Uitbesteed",
  "planning.cap.onCharter": "Op {{name}}",
  "planning.cap.onLorry": "Op {{code}}",
  "planning.cap.onVehicle": "op {{code}}",
  "planning.cap.noLorryYet": "nog zonder wagen",
  "planning.cap.begins": "begint in {{city}}",
  "planning.cap.daysLabel": "Dagen op het bord",
  "planning.cap.dayLess": "Een dag minder (−)",
  "planning.cap.dayMore": "Een dag meer (+)",
  "planning.cap.days_one": "1 dag",
  "planning.cap.days_other": "{{count}} dagen",
  "planning.cap.along.comes": "{{name}} gaat mee",
  "planning.cap.along.none_driver": "geen vaste chauffeur: chauffeur blijft open",
  "planning.cap.along.none_trailer": "geen vaste oplegger: oplegger blijft open",
  "planning.cap.along.busy_driver": "{{name}} is bezet: chauffeur blijft open",
  "planning.cap.along.busy_trailer": "{{name}} is bezet: oplegger blijft open",
  "planning.cap.along.away_driver": "vaste chauffeur {{reason}}: chauffeur blijft open",
  "planning.cap.along.away_trailer": "{{name}} {{reason}}: oplegger blijft open",
  "planning.cap.along.reason_ill": "ziek",
  "planning.cap.along.reason_leave": "met verlof",
  "planning.cap.along.reason_noShift": "zonder dienst",
  "planning.cap.placed": "{{trip}} staat op {{what}}",
  "planning.cap.came_one": "{{names}} ging mee",
  "planning.cap.came_other": "{{names}} gingen mee",
  "planning.cap.and": " en ",
  "planning.cap.mind": "let op: {{text}}",
  "planning.cap.crewPlaced": "{{name}} staat op {{trip}}",
  "planning.cap.onTo": "verder met {{trip}}",
  "planning.cap.allDone": "alle ritten zijn volledig ingepland",
  "planning.cap.listsLabel": "Chauffeurs en opleggers",
  "planning.cap.forTrip": "Voor {{trip}} · {{time}}",
  "planning.cap.pickTrip": "Kies een rit",
  "planning.cap.pickTripText": "Zonder gekozen rit: wie die dag dienst heeft en op geen rit zit, en welke opleggers op geen rit staan",
  "planning.cap.drivers": "Chauffeurs",
  "planning.cap.trailers": "Opleggers",
  "planning.cap.group.current": "Op deze rit",
  "planning.cap.group.available_driver": "Beschikbaar",
  "planning.cap.group.available_trailer": "Beschikbaar · staat in {{city}}",
  "planning.cap.group.elsewhere": "Beschikbaar · staat elders",
  "planning.cap.group.warn": "Beschikbaar, let op",
  "planning.cap.group.busy": "Bezet",
  "planning.cap.group.away": "Niet beschikbaar",
  "planning.cap.group.cannot": "Kan niet",
  "planning.cap.group.free": "Beschikbaar, nog op geen rit",
  "planning.cap.group.onTrip": "Al op een rit",
  "planning.cap.group.show": "tonen",
  "planning.cap.group.fold": "inklappen",
  "planning.cap.lists.charter": "Een charter rijdt met zijn eigen chauffeur en oplegger",
  "planning.cap.lists.lorryFirst": "Zet de rit eerst op een wagen: dan kun je kiezen",
  "planning.cap.lists.rigid": "Een bakwagen heeft geen oplegger",
  "planning.cap.lists.open_driver": "Open op {{trip}}: kies een chauffeur",
  "planning.cap.lists.open_trailer": "Open op {{trip}}: kies een oplegger",
  "planning.cap.lists.alsoOpen_driver": "Ook open op {{trip}}: de chauffeur",
  "planning.cap.lists.alsoOpen_trailer": "Daarna: de oplegger is ook open",
  "planning.cap.lists.free": "beschikbaar",
  "planning.cap.lists.freeFrom": "beschikbaar vanaf {{time}}",
  "planning.cap.lists.freeAfter": "beschikbaar vanaf {{time}} na {{trip}}",
  "planning.cap.lists.standplaats": "standplaats",
  "planning.cap.lists.elsewhere": "staat in {{city}} → {{to}}",
  "planning.cap.lists.placeUnknown": "plaats onbekend",
  "planning.cap.lists.onTrips": "op {{trips}}",
  "planning.cap.lists.busyOn": "op {{trip}} tot {{time}}",
  "planning.cap.lists.awayUntil": "{{reason}} tot {{time}}",
  "planning.cap.lists.cooled": "koel",
  "planning.cap.lists.tailLift": "laadklep",
  "planning.cap.lists.freeCount": "{{count}} beschikbaar",
  "planning.cap.lists.searchDriver": "Zoek chauffeur",
  "planning.cap.lists.searchTrailer": "Zoek oplegger",
  "planning.cap.lists.none": "Niemand gevonden.",
  "planning.cap.lists.goesAlong": "gaat mee met {{code}}",
  "planning.cap.lists.fixedOn": "vast op {{code}}",
  "planning.cap.lists.fixedBehind": "vast achter {{code}}",
  "planning.cap.lists.choose": "Kies",
  "planning.cap.lists.off": "Eraf",
  "planning.cap.override.title": "Kan niet:",
  "planning.cap.override.text": "Volgens Beheer → Vervoerseisen kan dit niet. Toch inzetten? Zeg waarom: het komt in het logboek van de rit.",
  "planning.cap.override.reason": "Waarom toch",
  "planning.cap.override.go": "Toch inzetten",
  "planning.v3.s4.putCharter": "Zet {{name}} in",
  "planning.v3.s4.need.refrigerated": "koel",
  "planning.v3.s4.need.tautliner": "schuifzeil",
  "planning.v3.s4.need.adr_equipment": "ADR",
  "planning.v3.s4.need.truck_mounted_forklift": "kooiaap",
  "planning.v3.s4.need.tail_lift": "klep",
  "planning.v3.s4.need.box": "kast",
  "planning.v3.s4.need.curtain": "huif",
  "planning.v3.s4.supplyTitle": "Aanbod en vraag per depot",
  "planning.v3.s4.supplyText": "vrij = wagen met een chauffeur in dienst, nog op geen rit · nodig = ritten zonder wagen",
  "planning.v3.s4.colDepot": "Depot",
  "planning.v3.s4.colOpen": "Zonder wagen",
  "planning.v3.s4.colLong": "Lang · nodig / vrij",
  "planning.v3.s4.colShort": "Kort · nodig / vrij",
  "planning.v3.s4.total": "Totaal",
  "planning.v3.s4.tripsWord_one": "rit",
  "planning.v3.s4.tripsWord_other": "ritten",
  "planning.v3.s4.subLong": "trekker",
  "planning.v3.s4.subShort": "bakwagen",
  "planning.v3.s4.hoursTitle": "Over de dag",
  "planning.v3.s4.hoursText": "per uur: ritten onderweg tegen wagens met een chauffeur in dienst",
  "planning.v3.s4.withLorry": "met wagen",
  "planning.v3.s4.withoutLorry": "nog zonder wagen",
  "planning.v3.s4.available": "beschikbaar",
  "planning.v3.s4.hourTitle": "{{hour}}:00 · {{assigned}} met wagen · {{open}} zonder · {{available}} wagens beschikbaar",
  "planning.v3.s4.knelTitle": "Knelpunten",
  "planning.v3.s4.knelMeta": "ritten met 0 tot 2 wagens die passen en vrij zijn",
  "planning.v3.s4.knelNone": "Geen knelpunten: elke rit heeft drie of meer wagens die passen en vrij zijn.",
  "planning.v3.s4.tripsCount_one": "1 rit",
  "planning.v3.s4.tripsCount_other": "{{count}} ritten",
  "planning.v3.s4.knel.missing": "{{need}}: geen wagen in de stamdata",
  "planning.v3.s4.knel.missingText": "Geen wagen of oplegger heeft dit in de stamdata. Klopt de stamdata niet, of wordt het een charter?",
  "planning.v3.s4.knel.noneFits": "Geen wagen die past",
  "planning.v3.s4.knel.noneFitsText": "Te lang, te zwaar of de opbouw klopt niet, bij elke wagen met zijn vaste oplegger.",
  "planning.v3.s4.knel.noneFree": "Geen wagen die past en vrij is",
  "planning.v3.s4.knel.noneFreeText": "Er zijn wagens die passen, maar die rijden al of hun chauffeur is niet in dienst.",
  "planning.v3.s4.knel.few": "Eén of twee wagens die passen",
  "planning.v3.s4.knel.fewText": "Zet deze eerst in, anders is de passende wagen weg.",
  "planning.v3.s1.stepCaption": "Stap 1",
  "planning.v3.s1.tick": "{{number}} meenemen",
  "planning.v3.s1.anywayTitle": "Past niet in de wagen",
  "planning.v3.s1.anywayIntro": "Met {{what}} erachter is {{trip}} te vol:",
  "planning.v3.s1.anywayMany": "{{count}} zendingen",
  "planning.v3.s1.anywayMeters": "{{over}} m te veel: hoogste belading {{lm}} m van {{capacity}} m",
  "planning.v3.s1.anywayWeight": "{{over}} kg te zwaar: hoogste belading {{kg}} kg van {{capacityKg}} kg",
  "planning.v3.s1.anywayAsk": "Weet je het zeker?",
  "planning.v3.s1.anywayConfirm": "Toch erachter zetten",
  "planning.v3.s1.arrives": "aankomst ± {{time}}",
  "planning.v3.s1.closerHome": "dichter bij {{home}}",
  "planning.v3.s1.emptyKmHelp": "Leeg rijden van {{city}} naar {{to}}",
  "planning.v3.s1.emptyThere": "leeg erheen",
  "planning.v3.s1.extra": "extra",
  "planning.v3.s1.extraDirect": "{{empty}} km leeg naar {{city}}, lossen in {{to}} en dan naar {{home}}: {{km}} km tegenover {{back}} km leeg terug",
  "planning.v3.s1.extraNoHome": "{{km}} km op de dag",
  "planning.v3.s1.extraPickup": "{{empty}} km leeg naar {{city}} en dan {{after}} km naar {{home}}: {{km}} km tegenover {{back}} km leeg terug",
  "planning.v3.day.same": "De plandag, {{day}}",
  "planning.v3.day.later_one": "Een dag na de plandag ({{day}})",
  "planning.v3.day.later_other": "{{count}} dagen na de plandag ({{day}})",
  "planning.v3.day.earlier_one": "Een dag vóór de plandag ({{day}})",
  "planning.v3.day.earlier_other": "{{count}} dagen vóór de plandag ({{day}})",
  "planning.v3.s1.goesToDepot": "depot",
  "planning.v3.s1.markAlong_one": "{{mark}}: {{along}} gaat mee",
  "planning.v3.s1.markAlong_other": "{{mark}}: {{along}} gaan mee",
  "planning.v3.s1.markFull_one": "{{mark}}, {{count}} zending: {{lm}} m · {{kg}} kg",
  "planning.v3.s1.markFull_other": "{{mark}}, {{count}} zendingen samen: {{lm}} m · {{kg}} kg",
  "planning.v3.s1.goesViaDepot": "{{city}}, via het depot",
  "planning.v3.s1.legend": "Leeg erheen: km leeg van {{city}} naar waar het laadt. Extra: wat de dag erbij krijgt tegenover leeg terug naar {{home}} ({{back}} km); min is minder. Dichter bij {{code}}: daarna staat de wagen dichter bij huis dan in {{city}}.",
  "planning.v3.s1.legendNoHome": "Leeg erheen: km leeg van {{city}} naar waar het laadt. Zonder wagen heeft de rit nog geen depot; wat een keuze met het depot doet, zie je in stap 4.",
  "planning.v3.s1.pallets_one": "{{count}} pallet",
  "planning.v3.s1.pallets_other": "{{count}} pallets",
  "planning.v3.s1.headEmpty": "km leeg erheen",
  "planning.v3.s1.headExtra": "extra km tegenover {{km}} km leeg terug",
  "planning.v3.s1.headTime": "op tijd",
  "planning.v3.s1.headWhat": "wat laadt er, voor wie en waarheen",
  "planning.v3.s1.withoutBehindShort": "zonder iets erachter {{km}} km leeg terug naar {{home}}",
  "planning.v3.s1.cancelAskMany_one": "{{count}} rit annuleren?",
  "planning.v3.s1.cancelAskMany_other": "{{count}} ritten annuleren?",
  "planning.v3.s1.cancelFailed_one": "{{count}} rit niet geannuleerd ({{trip}}): {{reason}}",
  "planning.v3.s1.cancelFailed_other": "{{count}} ritten niet geannuleerd, de eerste {{trip}}: {{reason}}",
  "planning.v3.s1.cancelGivesBack_one": "De volle levering wacht weer bij Volle leveringen.",
  "planning.v3.s1.cancelGivesBack_other": "De volle leveringen wachten weer bij Volle leveringen.",
  "planning.v3.s1.cancelGivesBackBehind_one": "De volle levering wacht weer bij Volle leveringen, wat erachter stond bij stap 2.",
  "planning.v3.s1.cancelGivesBackBehind_other": "De volle leveringen wachten weer bij Volle leveringen, wat erachter stond bij stap 2.",
  "planning.v3.s1.cancelOne": "{{number}} annuleren",
  "planning.v3.s1.colVehicle": "Wagen",
  "planning.v3.s1.colWeight": "Gewicht",
  "planning.v3.s1.keepTrips": "Laten staan",
  "planning.v3.s1.keyOneMore": "één erbij",
  "planning.v3.s1.keyRun": "reeks",
  "planning.v3.s1.menuAll": "Alles aanvinken",
  "planning.v3.s1.menuCancelMany_one": "{{count}} rit annuleren…",
  "planning.v3.s1.menuCancelMany_other": "{{count}} ritten annuleren…",
  "planning.v3.s1.menuCopyNumber": "Zendingnummer kopiëren",
  "planning.v3.s1.menuCopyNumbers_one": "{{count}} zendingnummer kopiëren",
  "planning.v3.s1.menuCopyNumbers_other": "{{count}} zendingnummers kopiëren",
  "planning.v3.s1.menuCopyTrips_one": "{{count}} ritnummer kopiëren",
  "planning.v3.s1.menuCopyTrips_other": "{{count}} ritnummers kopiëren",
  "planning.v3.s1.menuLeaveOpen_one": "Open laten",
  "planning.v3.s1.menuLeaveOpen_other": "{{count}} open laten",
  "planning.v3.s1.menuMakeMany_one": "Rit maken van {{count}} levering",
  "planning.v3.s1.menuMakeMany_other": "Ritten maken van {{count}} leveringen",
  "planning.v3.s1.menuMakeOne": "Rit maken",
  "planning.v3.s1.menuNone": "Alles uitvinken",
  "planning.v3.s1.menuOnly": "Alleen deze aanvinken",
  "planning.v3.s1.menuReopen_one": "Niet meer open laten",
  "planning.v3.s1.menuReopen_other": "{{count}} niet meer open laten",
  "planning.v3.s1.menuRoute_one": "Alles van {{from}} naar {{to}} aanvinken ({{count}})",
  "planning.v3.s1.menuRoute_other": "Alles van {{from}} naar {{to}} aanvinken ({{count}})",
  "planning.v3.s1.menuTick": "Aanvinken",
  "planning.v3.s1.menuUntick": "Uitvinken",
  "planning.v3.s1.menuUntickMany_one": "{{count}} uitvinken",
  "planning.v3.s1.menuUntickMany_other": "{{count}} uitvinken",
  "planning.v3.s1.tickAll": "Alle volle leveringen aanvinken",
  "planning.v3.s1.tickAllTrips": "Alle ritten aanvinken",
  "planning.v3.s1.tickTrip": "{{number}} aanvinken",
  "planning.v3.s1.ticked_one": "{{count}} aangevinkt",
  "planning.v3.s1.ticked_other": "{{count}} aangevinkt",
  "planning.v3.s1.tickedOf_one": "{{count}} van {{total}} aangevinkt",
  "planning.v3.s1.tickedOf_other": "{{count}} van {{total}} aangevinkt",
  "planning.v3.s1.unloadsHome": "lost in {{home}}, waar de wagen thuis is",
  "planning.v3.s1.waits": "wacht {{time}}",
  "planning.v3.s1.within_one": "{{count}} binnen {{km}} km",
  "planning.v3.s1.within_other": "{{count}} binnen {{km}} km",
  "planning.v3.s1.radiusKm": "{{km}} km",
  "planning.v3.s1.radiusLabel": "Zoeken binnen",
  "planning.v3.s1.bestFirst": "beste eerst",
  "planning.v3.card.clash": "Past niet: na {{have}} geen {{add}} met dezelfde wagen (Beheer → Vervoerseisen)",
  "planning.v3.card.depot": "depot",
  "planning.v3.card.fits": "Past · {{km}} km voor de dag · {{empty}} km leeg",
  "planning.v3.card.goods": "Lading",
  "planning.v3.card.late": "Niet op tijd",
  "planning.v3.card.load": "Laden",
  "planning.v3.card.requirements": "Eisen",
  "planning.v3.card.unload": "Lossen",
  // The times of a place (P79): the opening hours always, the window when it says something of its own, a slot as a slot.
  "planning.times.load": "laden {{window}}",
  "planning.times.unload": "lossen {{window}}",
  "planning.times.window": "venster {{window}}",
  "planning.times.slot": "tijdslot {{window}}",
  "planning.times.slotAsked": "tijdslot {{window}} (klant vroeg {{asked}})",
  "planning.times.open": "open {{times}}",
  "planning.times.closed": "die dag gesloten",
  "planning.times.always": "altijd open",
  "planning.times.hoursUnknown": "openingstijden onbekend",
  "planning.times.help":
    "Open: de openingstijden van de plaats die dag. Een venster staat er alleen als de order een eigen tijd heeft; een tijdslot is geboekt bij de plaats (Zet op aangemeld): de planning plant erop, de prijs gaat uit van wat de klant vroeg.",
  "planning.v3.lens.barAdd": "{{city}} erbij: {{km}} km",
  "planning.v3.lens.barAddCount_one": "{{count}} zending erbij",
  "planning.v3.lens.barAddCount_other": "{{count}} zendingen erbij",
  "planning.v3.lens.barBuilding": "{{trip}} in opbouw: klik wat erbij moet, Z zet het op de rit",
  "planning.v3.lens.barFits": "{{count}} passen · {{not}} niet · Alt-klik haalt van de rit",
  "planning.v3.lens.barOrder": "WLX zet de volgorde: eerst de vensters, dan de minste kilometers",
  "planning.v3.tally.unload": "Lossen · leveringen",
  "planning.v3.tally.load": "Laden · ophalingen",
  "planning.v3.tally.direct": "Direct",
  "planning.v3.tally.unloadShort": "Lossen",
  "planning.v3.tally.loadShort": "Laden",
  "planning.v3.tally.stopsWord_one": "stop",
  "planning.v3.tally.stopsWord_other": "stops",
  "planning.v3.tally.consignmentsWord_one": "zending",
  "planning.v3.tally.consignmentsWord_other": "zendingen",
  "planning.v3.tally.elsewhereDeliveries_one": "en 1 levering die hier laadt en elders lost",
  "planning.v3.tally.elsewhereDeliveries_other": "en {{count}} leveringen die hier laden en elders lossen",
  "planning.v3.tally.elsewherePickups_one": "en 1 ophaling van elders naar een depot hier",
  "planning.v3.tally.elsewherePickups_other": "en {{count}} ophalingen van elders naar een depot hier",
  "planning.v3.tally.choose": "Klik kiest {{zone}}",
  "planning.v3.tally.selection": "Selectie",
  "planning.v3.tally.checked_one": "{{count}} aangevinkt",
  "planning.v3.tally.checked_other": "{{count}} aangevinkt",
  "planning.v3.tally.together": "samen {{lm}} m · depot {{depot}}",
  "planning.v3.tally.keys": "klik vinkt aan of uit · Alt-klik haalt van de rit · Esc naar Alles, dan de gebieden weg",
  "planning.v3.lens.barLasso": "Teken een gebied om wat je wilt plannen",
  "planning.v3.lens.barTickZone_one": "{{count}} in {{zone}}: klik vinkt aan of uit",
  "planning.v3.lens.barTickZone_other": "{{count}} in {{zone}}: klik vinkt aan of uit",
  "planning.v3.lens.barTickAll_one": "Alle gebieden, {{count}}: klik vinkt aan of uit",
  "planning.v3.lens.barTickAll_other": "Alle gebieden, {{count}}: klik vinkt aan of uit",
  "planning.v3.lens.barZones": "Een lasso is een nieuw gebied; klik in een gebied kiest het, erbuiten laat alles los",
  "planning.v3.lens.barZone": "Elke lasso wordt een eigen gebied · klik kiest één zending, Ctrl-klik erbij of eraf",
  "planning.v3.lens.lasso": "Gebied tekenen",
  "planning.v3.lens.openTrip": "Open rit",
  "planning.v3.lens.barBehind": "{{city}} achter {{trip}}: {{km}} km",
  "planning.v3.lens.barEnd": "Open eind van {{trip}} in {{city}}",
  "planning.v3.lens.barEnds_one": "{{count}} rit gekozen",
  "planning.v3.lens.barEnds_other": "{{count}} ritten gekozen, samen op de kaart",
  "planning.v3.lens.barEndsOne": "Kies één rit voor wat erachter kan, met de straal",
  "planning.v3.lens.barFull": "Elk een rit zonder wagen, fabriekspendels volgens het pendelschema; daarna wat erachter gaat",
  "planning.v3.lens.barLabel": "Wat nu kan",
  "planning.v3.lens.barWithin_one": "{{count}} laadt binnen {{km}} km van {{city}}",
  "planning.v3.lens.barWithin_other": "{{count}} laden binnen {{km}} km van {{city}}",
  "planning.v3.map.adds": "vraagt {{adds}}",
  "planning.v3.map.chosen": "gekozen · {{km}} km",
  "planning.v3.map.clash": "✕ {{add}} · na {{have}}",
  "planning.v3.map.fromDepot": "uit {{branch}} · {{km}} km",
  "planning.v3.map.fits": "past · {{km}} km",
  "planning.v3.map.late": "niet op tijd",
  "planning.v3.map.legendOpen": "Nog niet gepland",
  "planning.v3.map.roadNote": "Over de weg (HERE): {{road}} van {{count}} ritten · de rest een rechte lijn, schatting",
  "planning.v3.map.kindShown": "Wat de kaart toont",
  "planning.v3.map.kindAll": "Alles",
  "planning.v3.map.kindDeliveries": "Leveringen",
  "planning.v3.map.kindPickups": "Ophalingen",
  "planning.v3.map.kindDirects": "Direct",
  "planning.v3.map.kindHelp": "Klik: alleen deze soort · Ctrl+klik: meer soorten tegelijk",
  "planning.nextRange": "Latere dagen",
  "planning.previousRange": "Eerdere dagen",
  "planning.rangeDays_other": "{{count}} dagen",
  "planning.rangeDays_one": "{{count}} dag",
  "planning.rangeFrom": "Van",
  "planning.legsCount_one": "{{count}} te plannen",
  "planning.legsCount_other": "{{count}} te plannen",
  "planning.legsBehind_one": "{{count}} te laat",
  "planning.legsBehind_other": "{{count}} te laat",
  "planning.legColGoods": "Goederen",
  "planning.legColPallets": "Pal",
  "planning.legsDragged_one": "{{count}} zending · {{totals}}",
  "planning.legsDragged_other": "{{count}} zendingen · {{totals}}",
  "planning.legsPicked_one": "{{count}} gekozen",
  "planning.legsPicked_other": "{{count}} gekozen",
  "planning.kindDirect": "Direct",
  "planning.kindPickup": "Ophaling",
  "planning.kindShuttle": "Depotpendel",
  "planning.kindFactoryShuttle": "Fabriekspendel",
  "planning.kindDelivery": "Levering",
  "planning.depotOpen": "Depot",
  "planning.waitsForPickup": "Na ophaling",
  "planning.routeViaDepot": "Via depot",
  "trips.depotUnload": "Lossen depot",
  "trips.depotLoad": "Laden depot",
  "trips.uncouple": "Afkoppelen",
  "trips.couple": "Aankoppelen",
  "branches.depotThresholdLabel": "Laden en lossen op verschillende dagen: onder dit aantal laadmeter via een depot",
  "branches.depotThresholdHelp": "Geldt voor orders die vanaf nu binnenkomen. De planner kan per zending anders beslissen.",
  "branches.depotThresholdSaved": "Opgeslagen",
  "branches.sameDayDirectLabel": "Laden en lossen op één dag: direct",
  "branches.sameDayDirectHelp": "Een zending die op dezelfde dag laadt en lost, gaat direct, ook onder de grens. De planner kan hem met de hand via een depot laten gaan. Geldt voor orders die vanaf nu binnenkomen.",
  "planning.menuLoadAt": "Laden in depot {{depot}} ({{city}})",
  "planning.menuUnloadAt": "Lossen in depot {{depot}} ({{city}})",
  "planning.menuFollowTrip": "Depot volgt weer de rit",
  "planning.noticeLoadsAt": "{{consignment}} laadt in depot {{depot}}.",
  "planning.noticeUnloadsAt": "{{consignment}} lost in depot {{depot}}.",
  "planning.noticeFollowsTrip": "{{consignment}} volgt weer het depot van de rit.",
  "planning.errorNotThroughDepot": "{{consignment}} gaat op dit traject niet via een depot.",
  "planning.menuLabel": "Traject van {{consignment}}",
  "planning.menuDeliverDirect": "Direct afleveren, zonder depot",
  "planning.menuDirectNoDepot": "Direct, zonder depot",
  "planning.menuOpenOrder": "Order openen",
  "planning.menuOpenOrderNewTab": "Order openen in nieuw tabblad",
  "planning.noticeShuttleAdded": "Depotpendel {{consignment}} nodig: de ophaling lost in {{from}}, de levering laadt in {{to}} — staat bij Te plannen",
  "planning.noticeShuttleRemoved": "Depotpendel {{consignment}} vervallen",
  "planning.noticeShuttleOffNotNeeded": "Depotpendel {{consignment}} van {{trip}} gehaald: niet meer nodig",
  "planning.noticeShuttleOffMoved": "Depotpendel {{consignment}} van {{trip}} gehaald: tussen andere depots, opnieuw te plannen",
  "planning.menuViaDepot": "Via depot (het depot van de rit)",
  "planning.menu.giveBackAll": "Wat erop staat gaat terug naar Te plannen.",
  "planning.menu.tripsLabel_one": "{{count}} rit",
  "planning.menu.tripsLabel_other": "{{count}} ritten",
  "planning.menu.deleteMany_one": "{{count}} rit verwijderen…",
  "planning.menu.deleteMany_other": "{{count}} ritten verwijderen…",
  "planning.menu.letGoMany_one": "{{count}} rit verwijderen of annuleren…",
  "planning.menu.letGoMany_other": "{{count}} ritten verwijderen of annuleren…",
  "planning.menu.deleteAskMany_one": "{{count}} rit verwijderen?",
  "planning.menu.deleteAskMany_other": "{{count}} ritten verwijderen?",
  "planning.menu.letGoAskMany_one": "{{count}} rit verwijderen of annuleren?",
  "planning.menu.letGoAskMany_other": "{{count}} ritten verwijderen of annuleren?",
  "planning.menu.letGoDo": "Ja, weghalen",
  "planning.menu.deleteManyButton_one": "{{count}} rit verwijderen",
  "planning.menu.deleteManyButton_other": "{{count}} ritten verwijderen",
  "planning.menu.cancelManyButton_one": "{{count}} rit annuleren",
  "planning.menu.cancelManyButton_other": "{{count}} ritten annuleren",
  "planning.menu.letGoManyButton_one": "{{count}} rit verwijderen of annuleren",
  "planning.menu.letGoManyButton_other": "{{count}} ritten verwijderen of annuleren",
  "planning.menu.deleteOne": "{{number}} verwijderen",
  "planning.menu.gone_delete_one": "{{count}} rit verwijderd: de volle levering wacht weer bij Volle leveringen.",
  "planning.menu.gone_delete_other": "{{count}} ritten verwijderd: de volle leveringen wachten weer bij Volle leveringen.",
  "planning.menu.gone_cancel_one": "{{count}} rit geannuleerd: de volle levering wacht weer bij Volle leveringen.",
  "planning.menu.gone_cancel_other": "{{count}} ritten geannuleerd: de volle leveringen wachten weer bij Volle leveringen.",
  "planning.menu.gone_both_one": "{{count}} rit verwijderd of geannuleerd: de volle levering wacht weer bij Volle leveringen.",
  "planning.menu.gone_both_other": "{{count}} ritten verwijderd of geannuleerd: de volle leveringen wachten weer bij Volle leveringen.",
  "planning.menu.stopLabel_one": "Stop met {{count}} zending",
  "planning.menu.stopLabel_other": "Stop met {{count}} zendingen",
  "planning.menu.stopMoveTo_one": "Hele stop naar een andere rit",
  "planning.menu.stopMoveTo_other": "Hele stop naar een andere rit",
  "planning.menu.openOrderOf": "Order van {{consignment}} openen",
  "planning.menu.stopTakeOff_one": "Hele stop van de rit halen ({{count}})",
  "planning.menu.stopTakeOff_other": "Hele stop van de rit halen ({{count}})",
  "planning.menu.stopMoved_one": "{{count}} zending naar {{trip}} verplaatst.",
  "planning.menu.stopMoved_other": "{{count}} zendingen naar {{trip}} verplaatst.",
  "planning.menu.stopTakenOff_one": "{{count}} zending van {{trip}} gehaald.",
  "planning.menu.stopTakenOff_other": "{{count}} zendingen van {{trip}} gehaald.",
  "planning.menu.newTripOf_one": "Nieuwe rit van {{count}}",
  "planning.menu.newTripOf_other": "Nieuwe rit van {{count}}",
  "planning.menu.openInStepTwo": "Openen in stap 2",
  "planning.menu.lorryHere": "Zet {{trip}} op deze wagen",
  "planning.menu.openLorry": "Wagenkaart openen",
  "planning.menu.openDriver": "Chauffeurskaart openen",
  "planning.menu.openTrailer": "Opleggerkaart openen",
  "planning.menu.chooseFor": "Kiezen voor {{trip}}",
  "planning.menu.driverOff": "Chauffeur eraf",
  "planning.menu.trailerOff": "Oplegger eraf",
  "planning.menu.chooseDriver": "Chauffeur kiezen",
  "planning.menu.chooseTrailer": "Oplegger kiezen",
  "planning.menu.chooseLorry": "Wagen kiezen in het bord",
  "planning.menu.tick": "Aanvinken",
  "planning.menu.untick": "Uitvinken",
  "planning.menu.areaChoose": "{{name}} kiezen",
  "planning.v3.s2.putOnN_one": "Zet op {{trip}} ({{count}})",
  "planning.v3.s2.putOnN_other": "Zet op {{trip}} ({{count}})",
  "planning.v3.s2.trips.keyAll": "alle ritten",
  "planning.v3.s1.keyAll": "alles",
  "planning.v3.s1.keyDouble": "Dubbelklik",
  "planning.sheetKeys.put": "zet op de rit",
  "planning.sheetKeys.done": "rit klaar",
  "planning.sheetKeys.depot": "depot wijzigen",
  "planning.sheetKeys.size": "rit klein of groot",
  "planning.sheetKeys.move": "stop verplaatsen",
  "planning.sheetKeys.takeOff": "van de rit halen",
  "planning.sheetKeys.drag": "naar een rit in de lijst",
  "planning.sheetKeys.undo": "ongedaan maken",
  "planning.sheetKeys.new": "nieuwe rit",
  "planning.sheetKeys.release": "loslaten",
  "planning.sheetKeys.close": "rit sluiten",
  "planning.sheetKeys.menu": "Rechtermuisknop: het menu",
  "planning.cap.boardKeys.lorry": "wagen",
  "planning.cap.boardKeys.put": "rit op de wagen, of chauffeur of oplegger kiezen",
  "planning.cap.boardKeys.days": "dagen",
  "planning.cap.boardKeys.release": "loslaten",
  "planning.cap.boardKeys.double": "rit erop of kiezen",
  "planning.noticeViaDepotAt": "{{consignment}} gaat nu via depot {{depot}}: de ophaling lost daar.",
  "planning.errorViaDepotAt": "{{consignment}} gaat nu via het depot van de rit; lossen in depot {{depot}} lukte niet. {{reason}}",
  "planning.errorTripClosed": "{{consignment}} staat op {{trip}}, en die rit is al onderweg of afgerond: daar verandert niets meer aan.",
  "planning.errorLegDone": "Deze handeling van {{consignment}} op {{trip}} is al gedaan.",
  "planning.errorPickupNotPlanned": "Plan eerst de ophaling van {{consignment}}.",
  "planning.errorBeforeDepotArrival": "{{consignment}} zou in het depot laden voordat het daar gelost is: plan het later.",
  "planning.errorConsignmentPlanned": "{{consignment}} staat al op een rit: haal het er eerst af.",
  "planning.errorLegPlanned": "{{consignment}} staat al op een rit.",
  "planning.takeOffTitle": "{{consignment}} direct afleveren?",
  "planning.takeOffIntro": "{{consignment}} gaat nu via depot {{depot}}. Direct afleveren verandert twee ritten:",
  "planning.takeOffPickupTrip": "de ophaling lost niet meer in {{depot}} maar rijdt door naar {{place}} en levert daar af.",
  "planning.takeOffDeliveryTrip": "de levering gaat eraf: niet meer laden in {{depot}} en lossen bij {{place}}.",
  "planning.takeOffThisTrip": "(deze rit)",
  "planning.takeOffLogged": "Beide ritten krijgen het in hun logboek, en de order ook.",
  "planning.takeOffConfirm": "Direct afleveren",
  "planning.noticeDeliversDirect": "{{trip}} levert {{consignment}} nu direct af bij {{place}}, niet meer via {{depot}}",
  "planning.noticeUnloadsAtDepot": "{{trip}} lost {{consignment}} nu in {{depot}}; de levering naar {{place}} staat bij Te plannen",
  "planning.noticeDeliveryRemoved": "De levering is van {{trip}} gehaald",
  "planning.noticeNowViaDepot": "{{consignment}} gaat nu via een depot: de ophaling en de levering staan bij Te plannen",
  "planning.noticeNowDirect": "{{consignment}} gaat nu direct: één traject, bij Te plannen",
  "planning.menuLoadInWarehouse": "Laden in warehouse {{warehouse}}, zonder pendel",
  "planning.menuWarehouseViaDepot": "Via depot: met een pendel naar het depot van de rit",
  "planning.noticeLoadsAtWarehouse": "{{trip}} laadt {{consignment}} nu in warehouse {{depot}}; de depotpendel vervalt",
  "planning.noticeLoadsAtDepot": "{{trip}} laadt {{consignment}} nu in depot {{depot}}; een depotpendel uit het warehouse staat bij Te plannen",
  "planning.noticeWarehouseViaDepot": "{{consignment}} gaat nu via een depot: heeft de rit een ander depot, dan brengt een depotpendel het daarheen",
  "planning.noticeWarehouseDirect": "{{consignment}} laadt nu in het warehouse: de rit haalt het daar op",
  "planning.noticeShuttleAddedWarehouse": "Depotpendel {{consignment}} nodig: uit het warehouse in {{from}} naar {{to}}, waar de rit laadt — staat bij Te plannen",
  "planning.errorWarehouseOrder": "{{consignment}} laadt in ons warehouse: kies Direct (laden in het warehouse) of Via depot (met een pendel).",
  "planning.errorOpenEndOvernight": "{{trip}} is pas na middernacht terug: wat erachter komt, plan je de volgende dag.",
  "planning.errorDeliveryPlanned": "De levering van {{consignment}} staat op {{trip}}: haal die er eerst af.",
  "trips.logDeliversDirect": "Levert nu direct af bij {{place}}, niet meer via {{depot}}",
  "trips.logDeliveryOffOther": "De levering is van {{otherTrip}} gehaald",
  "trips.logUnloadsAtDepot": "Lost nu in {{depot}}; de levering naar {{place}} staat bij Te plannen",
  "trips.logDeliveredDirectBy": "Levering eraf: {{trip}} levert direct af bij {{place}}",
  "planning.legLoad": "Laden",
  "planning.legUnload": "Lossen",
  "planning.legPart": "{{nr}}/{{count}}",
  "planning.droppedLegs_one": "{{count}} zending op {{trips}} ({{on}}).",
  "planning.droppedLegs_other": "{{count}} zendingen op {{trips}} ({{on}}).",
  "planning.droppedSkipped_one": "{{count}} bleef staan, al gepland of niet meer te plannen: {{legs}}.",
  "planning.droppedSkipped_other": "{{count}} bleven staan, al gepland of niet meer te plannen: {{legs}}.",
  "planning.planPickedHere_one": "Klik om de gekozen zending hierop te plannen",
  "planning.planPickedHere_other": "Klik om de {{count}} gekozen zendingen hierop te plannen",
  "planning.legsNothingInScope_one": "Hier niets. Er wacht nog {{count}} op een rit: kijk bij Eerder, Later of Alles.",
  "planning.legsNothingInScope_other": "Hier niets. Er wachten nog {{count}} op een rit: kijk bij Eerder, Later of Alles.",
  "planning.tripsOnDay_other": "{{count}} ritten",
  "planning.viewLabel": "Weergave",
  "planning.mapLabel": "Kaart",
  "planning.mapOff": "Geen kaart",
  "planning.mapWindow": "Kaart los",
  "planning.mapWindowHelp": "De kaart in een eigen venster, voor een tweede scherm",
  "planning.mapWindowRefused": "De browser hield het venster tegen. Sta pop-ups toe voor WLX, of zet de kaart naast het bord.",
  "planning.boardElsewhere.title": "Het planbord is al open in een ander tabblad",
  "planning.boardElsewhere.text": "Twee planborden in één browser sturen elkaar en de losse kaart aan, daarom is er één. Werk in het andere tabblad verder, of open het planbord hier: het andere tabblad stopt dan.",
  "planning.boardTaken.title": "Het planbord is in een ander tabblad geopend",
  "planning.boardTaken.text": "Daar werk je nu verder, met de losse kaart. Wil je hier verder, open het planbord dan weer hier: het andere tabblad stopt dan.",
  "planning.boardHere": "Hier openen",
  "planning.mapWindowTitle": "Kaart · {{date}}",
  "planning.mapFollowsBoard": "Volgt het planbord",
  "planning.mapNoAccess": "Je hebt geen toegang tot het planbord.",
  "planning.mapTilesDown": "De kaart zelf is nu niet te laden; de ritten en wat te plannen is staan er wel op.",
  "planning.mapOpenOrder": "Order openen",
  "planning.mapStops_one": "{{count}} stop",
  "planning.mapStops_other": "{{count}} stops",
  "planning.mapLegend": "Legenda",
  "planning.mapPanelMove": "{{panel}} verplaatsen",
  "planning.mapPanelMoveHelp": "Slepen om te verplaatsen binnen de kaart; dubbelklik zet het terug",
  "planning.mapFleet": "Wagens tonen ({{count}})",
  "planning.tripsPicked_one": "{{count}} rit gekozen",
  "planning.tripsPicked_other": "{{count}} ritten gekozen",
  "planning.mapLorryNoTrip": "Geen rit vandaag",
  "planning.mapLorrySeen": "Laatst gezien {{time}}",
  "planning.mapLasso": "Lasso: sleep een vorm om trajecten te kiezen (of houd Shift ingedrukt en sleep). Met Ctrl of ⌘ erbij voeg je toe, met Alt of Option haal je weg; Ctrl- of ⌘-klik op een merkteken zet één traject erbij of eraf",
  "planning.mapLassoHolds": "{{count}} in de vorm · {{meters}} ldm",
  "planning.mapComesFrom": "Komt uit",
  "planning.mapPickupOpen": "Ophaling, depot nog open",
  "planning.mapDirect": "Direct",
  "planning.mapKeyLoad": "Laden",
  "planning.mapKeyUnload": "Lossen",
  "planning.mapKeyBranch": "Vestiging",
  "planning.mapTonesDay": "Ritten en werk per vestiging",
  "planning.mapFleetCount": "Wagens ({{count}})",
  "planning.mapKeyLorryTrip": "Rit vandaag",
  "planning.mapKeyLorryIdle": "Geen rit",
  "planning.mapKeyLorryStale": "Positie ouder dan {{minutes}} min",
  "planning.mapPlaceLegs_one": "{{count}} traject · {{meters}} ldm",
  "planning.mapPlaceLegs_other": "{{count}} trajecten · {{meters}} ldm — een klik kiest ze allemaal",
  "planning.mapPlaceMore_one": "en nog {{count}}",
  "planning.mapPlaceMore_other": "en nog {{count}}",
  "planning.mapUnplaced": "Zonder positie, niet op de kaart: {{what}}",
  "planning.mapUnplacedLegs_one": "{{count}} te plannen",
  "planning.mapUnplacedLegs_other": "{{count}} te plannen",
  "planning.mapUnplacedStops_one": "{{count}} stop",
  "planning.mapUnplacedStops_other": "{{count}} stops",
  "planning.mapUnplacedBranches_one": "{{count}} vestiging",
  "planning.mapUnplacedBranches_other": "{{count}} vestigingen",
  "planning.viewDay": "Dag",
  "planning.viewDrivers": "Chauffeurs",
  "planning.previousWeek": "Vorige week",
  "planning.nextWeek": "Volgende week",
  "planning.driversCount_other": "{{count}} chauffeurs",
  "planning.doubleBooked": "Dubbel ingezet",
  "planning.conflict": "{{who}} staat dan ook op {{trip}} ({{range}})",
  "trips.colNumber": "Ritnummer",
  "trips.colStatus": "Status",
  "trips.menuLabel": "Rit {{number}}",
  "trips.menuOpen": "Ritkaart openen",
  "trips.menuOpenNewTab": "Openen in nieuw tabblad",
  "trips.menuOnBoard": "Naar het planbord",
  "trips.menuConfirm": "Vastleggen",
  "trips.menuConfirmHint": "op de dag naar boordcomputer",
  "trips.menuSendToBoard": "Nu naar boordcomputer",
  "trips.boardSent": "{{trip}} is naar de boordcomputer van {{plate}} gestuurd.",
  "trips.boardAlreadyOn": "{{trip}} staat al zo op de boordcomputer van {{plate}}.",
  "trips.boardSendOff": "Naar de boordcomputer sturen staat hier niet aan.",
  "trips.boardSendNotConfirmed": "Leg {{trip}} eerst vast: alleen een vastgelegde rit gaat naar de boordcomputer.",
  "trips.boardSendNoVehicle": "{{trip}} heeft geen wagen met een kenteken.",
  "trips.menuBackToDraft": "Terug naar concept",
  "trips.menuCancel": "Rit annuleren…",
  "trips.menuCancelAsk": "Rit {{number}} annuleren?",
  "trips.menuCancelGivesBack": "{{count}} stops gaan terug naar Te plannen.",
  "trips.menuCancelEmpty": "Er staat niets op deze rit.",
  "trips.menuCancelDo": "Ja, annuleren",
  "trips.menuDelete": "Rit verwijderen",
  "trips.menuCopyNumber": "Ritnummer kopiëren",
  "trips.colWindow": "Vertrek – terug",
  "trips.colVehicle": "Wagen",
  "trips.colDriver": "Chauffeur",
  "trips.colEquipment": "Trailer",
  "trips.colStops": "Stops",
  "trips.colDriving": "Rijtijd",
  "trips.colKm": "Km",
  "trips.colName": "Naam",
  "trips.statusDraft": "In opbouw",
  "trips.statusConfirmed": "Vastgezet",
  "trips.statusInTransit": "Onderweg",
  "trips.statusCompleted": "Afgerond",
  "trips.statusCancelled": "Geannuleerd",
  "trips.stopOpen": "Nog te doen",
  "trips.stopArrived": "Aangekomen",
  "trips.stopDone": "Gedaan",
  "trips.newTrip": "Nieuwe rit",
  "trips.today": "Vandaag",
  "trips.day": "Dag",
  "trips.previousDay": "Vorige dag",
  "trips.nextDay": "Volgende dag",
  "trips.searchPlaceholder": "Ritnummer, wagen, chauffeur...",
  "trips.searchLabel": "Zoeken in ritten",
  "trips.filterByStatus": "Filteren op status",
  "trips.allStatuses": "Alle statussen",
  "trips.noneOnDay": "Geen ritten op {{day}}.",
  "trips.noneFiltered": "Geen ritten die aan het filter voldoen.",
  "trips.hoursUnit": "uur",
  "trips.noTrailer": "Geen trailer",
  "trips.noVehicle": "Geen wagen",
  "trips.noDriver": "Geen chauffeur",
  "trips.illMark": "ziek",
  "trips.leaveMark": "verlof",
  "trips.noShiftMark": "geen dienst",
  "trips.dayNote": "Bijzonderheid {{name}}: {{text}}",
  "trips.busyOn": "bezet: {{trip}}",
  "trips.charter": "Charter",
  "trips.depot": "Depot",
  "trips.charterNone": "Geen charter",
  "trips.charterPrice": "Inkoopprijs rit (€)",
  "trips.charterRemark": "Opmerking voor de charter",
  "trips.charterRemarkPlaceholder": "Leeg: (All-in)",
  "trips.allIn": "(All-in)",
  "trips.transportOrderSend": "Transportopdracht versturen",
  "trips.transportOrderSendAgain": "Opnieuw versturen",
  "trips.transportOrderSendNow": "Versturen",
  "trips.transportOrderTo": "Naar",
  "trips.transportOrderNoPrice": "Geen inkoopprijs",
  "trips.transportOrderNoAddress": "De charter heeft geen adres voor transportopdrachten onder Communicatie; vul er hier een in.",
  "trips.transportOrderNotConfigured": "Versturen is hier niet ingericht",
  "trips.transportOrderSaveFirst": "Sla de prijs en de opmerking eerst op",
  "trips.transportOrderMaking": "Transportopdracht wordt gemaakt…",
  "trips.transportOrderSent": "Transportopdracht verstuurd {{when}} door {{who}} aan {{to}}",
  "trips.transportOrderFailed": "Transportopdracht niet verstuurd",
  "trips.transportOrderChanged": "Gewijzigd na versturen",
  "trips.logTransportOrderRequested": "Transportopdracht verstuurd",
  "trips.logTransportOrderSent": "Transportopdracht gemaild",
  "trips.logTransportOrderFailed": "Transportopdracht mislukt",
  "trips.legOf": "traject {{nr}} van {{count}}",
  "trips.legMenu": "Meer voor {{consignment}}",
  "trips.depotOfVehicle": "Standplaats van de wagen",
  "trips.logTitle": "Logboek",
  "trips.logEmpty": "Nog niets vastgelegd.",
  "trips.logCreated": "Rit gemaakt",
  "trips.logUpdated": "Rit gewijzigd",
  "trips.logConfirmed": "Vastgelegd",
  "trips.logBackToDraft": "Terug naar concept",
  "trips.logCancelled": "Rit geannuleerd",
  "trips.logAssigned": "Op het bord gezet",
  "trips.logOverride": "Toch ingezet tegen: {{what}}. Waarom: {{reason}}",
  "trips.logWarnings": "Met de melding: {{what}}",
  "trips.logLegPlanned": "Traject erop gezet",
  "trips.logLegUnplanned": "Traject eraf gehaald",
  "trips.logRouteChanged": "Route gewijzigd",
  "trips.logDepotChanged": "Depot gekozen",
  "trips.logLegFits": "Past wel",
  "trips.logLegFitsUnset": "Past wel teruggezet",
  "trips.logDeleted": "Rit verwijderd",
  "trips.logPrinted": "Geprint",
  "trips.logCrossdockMarked": "Crossdock",
  "trips.logScoretraceSent": "Naar Scoretrace",
  "trips.logNote": "Notitie",
  "trips.logFollowUpTaken": "Afwijking in behandeling genomen",
  "trips.logFollowUpReleased": "Afwijking losgelaten",
  "trips.logOrderReplaced": "Voorlopige order vervangen",
  "trips.logOrderReplacedLine": "{{order}} in de plaats van {{provisional}}, op dezelfde stops",
  "trips.logOrderReplacedDayMoved": "Op een andere dag: wacht op de planner",
  "trips.logOrderReplacedByItself": "Vanzelf, toen de order van de klant binnenkwam: de stops bleven zoals ze waren",
  "trips.logScoretraceShipments_one": "{{count}} zending",
  "trips.logScoretraceShipments_other": "{{count}} zendingen",
  "trips.logCrossdockIncoming": "binnenkomend",
  "trips.logCrossdockOutgoing": "uitgaand",
  "trips.logCrossdockDock": "dock {{dock}}",
  "trips.logCrossdockNoDock": "geen dock",
  "trips.logCrossdockUnloaded": "gelost",
  "trips.logCrossdockLoaded": "geladen",
  "trips.logCrossdockUndone": "teruggezet",
  "trips.logLegKept": "Laten staan op een andere dag",
  "trips.logStopsReordered": "Volgorde gewijzigd",
  "trips.logStopsByHand": "Met de hand gezet; WLX stelt geen volgorde meer voor tot Volgorde voorstellen",
  "trips.logStopsProposed": "Terug naar de volgorde die WLX voorstelt",
  "trips.logBoardDispatched": "Naar de boordcomputer",
  "trips.logBoardDispatchedLine": "{{plate}}, {{count}} regel(s)",
  "trips.logBoardHowDay": "Op de dag van vertrek, vanzelf",
  "trips.logBoardHowChange": "Opnieuw, na een wijziging",
  "trips.logBoardHowManual": "Direct, met de hand",
  "trips.logBoardRemoved": "Van de boordcomputer gehaald",
  "trips.logBoardRemovedLine": "Eraf bij {{plate}}",
  "trips.logBoardReport": "Melding van de chauffeur",
  "trips.logBoardNotFullyUnloaded": "Niet volledig gelost",
  "trips.logBoardNotFullyLoaded": "Niet volledig geladen",
  "trips.logBoardReason": "Reden: {{reason}}",
  "trips.logBoardDeviations": "Afwijkingen: {{deviations}}",
  "trips.logBoardWaited": "Wachten: {{remark}}",
  "trips.logBoardEmballageScans_one": "1 barcode emballage gescand",
  "trips.logBoardEmballageScans_other": "{{count}} barcodes emballage gescand",
  "trips.logBoardStarted": "Rit begonnen (boordcomputer)",
  "trips.logBoardEnded": "Rit beëindigd (boordcomputer)",
  "trips.logStopSignedOff": "Stop afgemeld",
  "trips.logStopSignedOffLine": "Stop {{stop}}: aangekomen {{arrived}}, vertrokken {{departed}}",
  "trips.logStopSignedOffEvents": "{{count}} statusbericht(en) naar de klant",
  "trips.logReportSent": "Ritbericht naar klant verstuurd",
  "trips.logReportSentLine": "{{customer}}: {{count}} zending, bericht {{number}}",
  "trips.logReportSentLine_other": "{{customer}}: {{count}} zendingen, bericht {{number}}",
  "trips.logDriverMessageSent": "Bericht met ritlijst naar chauffeur verstuurd",
  "trips.logDriverMessageSentAgain": "{{driver}}, nog een keer",
  "trips.logDriverMessageFailed": "Bericht met ritlijst naar chauffeur mislukt",
  "trips.logLegKeptDays": "de order vraagt {{days}}",
  "trips.logShuttleNotNeeded": "Depotpendel niet meer nodig: door de planning eraf gehaald",
  "trips.logShuttleDepotsChanged": "Depotpendel tussen andere depots: door de planning eraf gehaald",
  "trips.logFieldVehicle": "wagen",
  "trips.logFieldDriver": "chauffeur",
  "trips.logFieldTrailer": "trailer",
  "trips.logFieldCharter": "charter",
  "trips.logFieldDepot": "depot",
  "trips.logFieldStatus": "status",
  "trips.logFieldName": "naam",
  "trips.logFieldDate": "datum",
  "trips.logDeliveredDirect": "De ophaling levert direct af: de levering was niet meer nodig",
  "trips.load": "Laden",
  "trips.unload": "Lossen",
  "trips.pallets": "{{count}} pallet",
  "trips.pallets_other": "{{count}} pallets",
  "trips.stopsCount": "{{count}} stop",
  "trips.stopsCount_other": "{{count}} stops",
  "trips.sharedStop": "één stop voor {{count}} zendingen — de chauffeur staat hier één keer",
  "trips.noStops": "Er staat nog niets op deze rit.",
  "trips.cancelledEmpty": "Deze rit is geannuleerd. Wat erop stond, staat weer bij Te plannen.",
  "trips.addConsignment": "Zending toevoegen",
  "trips.addTitle": "Wat wacht er op een rit",
  "trips.nothingWaiting": "Alles van deze dag staat al op een rit.",
  "trips.putOnTrip": "Op deze rit",
  "trips.addSearch": "Zoek op zending, order, referentie of klant",
  "trips.nothingFound": "Niets gevonden dat nog op een rit wacht.",
  "trips.signOff": "Afmelden",
  "trips.signOffChange": "Tijden wijzigen",
  "trips.arrivedAt": "Aangekomen",
  "trips.departedAt": "Vertrokken",
  "trips.arrivedAtValue": "Aangekomen {{time}}",
  "trips.departedAtValue": "Vertrokken {{time}}",
  "trips.signOffHelp": "Tot de boordcomputer het doet, meldt de planner de stop hier af. De eerste aankomst en het eerste vertrek gaan naar de klanten die statusberichten krijgen (P&O); een gewijzigde tijd niet opnieuw.",
  "trips.takeOff": "Van de rit halen",
  "trips.sheetMenuHint": "Rechtermuisknop op een stop of zending: het menu, ook naar een andere rit",
  "trips.notFound": "Deze rit bestaat niet",
  "trips.notFoundDesc": "Misschien is hij verwijderd, of klopt de link niet.",
  "trips.planned": "Gepland",
  "trips.window": "Venster",
  "trips.windowOwnPlace": "geen, eigen plek",
  "trips.windowOwnPlaceHelp": "De order vraagt {{asked}}. Op een eigen plek rekent de planning zonder venster: de wagen gaat naar het dock of de parkeerplaats (P35).",
  "trips.windowDepot": "geen, depot",
  "trips.planWait": "wacht {{time}} op het venster",
  "trips.lateBy": "{{time}} te laat",
  "trips.lateByHelp": "Zo ver na het einde van het venster komt de rit hier volgens de planning: met de rit van huis, de stops ervoor en de pauzes, zoals op het Planbord.",
  "trips.planSpan": "Vertrek {{from}} · terug {{to}}",
  "trips.planSpanFixed": "Vertrek {{from}} (vastgezet) · terug {{to}}",
  "trips.planKm": "{{km}} km (leeg {{empty}})",
  "trips.planDriving": "rijden {{time}}",
  "trips.lateStops": "{{count}} stop te laat",
  "trips.lateStops_other": "{{count}} stops te laat",
  "trips.otherDay": "Andere dag",
  "trips.otherDayHelp": "De order vraagt nu een andere dag dan deze rit. Hij blijft staan tot de planner beslist.",
  "trips.waitsTitle": "Wacht op de planner",
  "trips.waitsHelp": "Een wijziging aan een order haalt niets vanzelf van deze rit. Kies per order wat er gebeurt.",
  "trips.waitsReadOnly": "Een wijziging aan een order haalt niets vanzelf van deze rit: de planner beslist.",
  "trips.waitBy": "door {{who}}, {{when}}",
  "trips.waitByCustomer": "door de klant, {{when}}",
  "trips.waitMovedDay": "{{activity}} gaat naar {{window}}",
  "trips.waitTakeOff": "Van de rit halen",
  "trips.waitKeep": "Laten staan",
  "trips.waitCancelled": "Geannuleerd",
  "trips.waitChange": "Wijziging van de klant",
  "trips.waitChanged": "Gewijzigd",
  "trips.print": "Printen…",
  "trips.printTitleOne": "Rit {{number}} printen",
  "trips.printTitleMany": "{{count}} ritten printen",
  "trips.printTitleCmr": "CMR van {{number}} printen",
  "trips.printTripSheet": "Ritlijst",
  "trips.printCmrs": "CMR's (per losadres, in tweevoud)",
  "trips.printLocation": "Printplek",
  "trips.printLocationNone": "Er is nog geen printplek. Een beheerder zet ze klaar.",
  "trips.printLeftOutCancelled": "{{count}} geannuleerde rit wordt niet geprint.",
  "trips.printLeftOutCancelled_other": "{{count}} geannuleerde ritten worden niet geprint.",
  "trips.printSubmit": "Printen",
  "trips.printBusy": "Bezig…",
  "trips.printDone": "Naar {{place}}: {{sheets}} en {{cmrs}}.",
  "trips.printDoneCmr": "De CMR gaat naar {{place}}.",
  "trips.printSheets": "{{count}} ritlijst",
  "trips.printSheets_other": "{{count}} ritlijsten",
  "trips.printCmrCount": "{{count}} CMR",
  "trips.printCmrCount_other": "{{count}} CMR's",
  "trips.printSkippedAdr": "Geen CMR voor {{consignment}}: ADR, de klant levert het vervoersdocument.",
  "trips.printSkippedCustomer": "Geen CMR voor {{consignment}}: deze klant maakt zelf de CMR.",
  "trips.printErrorNotConfigured": "Printen staat hier nog niet aan: de koppeling met DataBridge ontbreekt.",
  "trips.printErrorCancelled": "Een van de ritten is geannuleerd; er is niets geprint.",
  "trips.printErrorNotPlanned": "Deze zending staat nog op geen rit die hem aflevert.",
  "trips.printErrorNoCmr": "Voor deze zending maakt WLX geen CMR: ADR, of de klant maakt hem zelf.",
  "trips.printed": "Geprint {{when}}",
  "trips.changedSincePrinted": "Gewijzigd na printen",
  "trips.printSelected": "{{count}} rit geselecteerd",
  "trips.printSelected_other": "{{count}} ritten geselecteerd",
  "trips.selectAll": "Alle ritten selecteren",
  "trips.selectTrip": "Rit {{number}} selecteren",
  "trips.clearSelection": "Selectie wissen",
  "trips.printMax": "Hoogstens {{count}} ritten tegelijk.",
  "trips.colPrinted": "Papier",
  "trips.colAttention": "Wacht op planner",
  "trips.attentionCount_one": "{{count}} order",
  "trips.attentionCount_other": "{{count}} orders",
  "trips.attentionHelp": "Voor zoveel orders wacht er iets op de planner: een andere dag, een annulering of wijziging, of iets dat veranderde. De ritkaart zegt wat.",
  "trips.printedState": "Geprint",
  "trips.notPrinted": "Niet geprint",
  "trips.colScoretrace": "Scoretrace",
  "trips.notToScoretrace": "Niet naar Scoretrace",
  "trips.scoretraceSentState": "Naar Scoretrace",
  "trips.scoretraceSentAt": "Naar Scoretrace {{when}}",
  "trips.changedSinceScoretrace": "Gewijzigd na versturen",
  "trips.toScoretrace": "Naar Scoretrace",
  "trips.toScoretraceHelp": "Stuurt wat deze ritten in Rijkevoort laden naar Scoretrace: de rit, de wagen en de oplegger bij elke order daar",
  "trips.scoretraceSent_one": "{{count}} rit naar Scoretrace gestuurd.",
  "trips.scoretraceSent_other": "{{count}} ritten naar Scoretrace gestuurd.",
  "trips.scoretraceSkipped": "Niet gestuurd, want ze laden niets in Rijkevoort of zijn geannuleerd: {{trips}}.",
  "trips.report": "Ritbericht naar klant…",
  "trips.reportsOfDay": "Ritberichten naar klanten…",
  "trips.menuReport": "Ritbericht naar klant",
  "trips.reportTitleOne": "Ritbericht naar de klant · {{number}}",
  "trips.reportTitleDay": "Ritberichten naar de klanten · {{day}}",
  "trips.reportIntro": "Het ritbericht (IFCSUM) zegt de klant welke van zijn zendingen een rit lost. WLX verstuurt het vanzelf zodra de rit voorbij is; daarna kan het hier opnieuw. Een klant die het vooraf krijgt, krijgt het vanuit Aandacht nodig.",
  "trips.reportNoneDay": "Geen rit op deze dag lost iets voor een klant met een ritbericht.",
  "trips.reportNoneTrip": "Deze rit lost niets voor een klant met een ritbericht.",
  "trips.reportColTrip": "Rit",
  "trips.reportColCustomer": "Klant",
  "trips.reportColMode": "Wanneer",
  "trips.reportColConsignments": "Zendingen",
  "trips.reportColLast": "Verstuurd",
  "trips.reportModeBefore": "Vooraf",
  "trips.reportModeAfter": "Achteraf",
  "trips.reportWithoutCodes": "{{count}} zonder plaatscode",
  "trips.reportWithoutCodes_other": "{{count}} zonder plaatscode",
  "trips.reportWithoutCodesHelp": "Zonder de plaatscode van de klant bij het laden of lossen gaat een zending niet mee in het ritbericht.",
  "trips.reportSentAt": "Verstuurd {{when}}",
  "trips.reportSentByItself": "Vanzelf verstuurd {{when}}",
  "trips.reportChangedSince": "Gewijzigd na versturen",
  "trips.reportWaitsForTrip": "Gaat vanzelf na de rit",
  "trips.reportNotSent": "Nog niet",
  "trips.reportNothingNow": "Er is nu niets te versturen.",
  "trips.reportSubmit": "{{count}} ritbericht versturen",
  "trips.reportSubmit_other": "{{count}} ritberichten versturen",
  "trips.reportBusy": "Bezig…",
  "trips.reportDone": "{{count}} ritbericht verstuurd.",
  "trips.reportDone_other": "{{count}} ritberichten verstuurd.",
  "trips.reportSkippedAfterTrip": "{{trip}} · {{customer}}: gaat vanzelf na de rit.",
  "trips.reportSkippedNoCodes": "{{trip}} · {{customer}}: geen zending met de plaatscodes van de klant.",
  "trips.reportSkippedCancelled": "{{trip}}: geannuleerd, er gaat niets.",
  "trips.reportSkippedNoCustomer": "{{trip}}: geen klant met een ritbericht.",
  "trips.reportErrorNotConfigured": "Ritberichten staan hier nog niet aan: de koppeling met DataBridge ontbreekt.",
  "trips.driverMessage": "Bericht met ritlijst naar chauffeur…",
  "trips.driverMessagesOfDay": "Berichten met ritlijst naar chauffeurs…",
  "trips.menuDriverMessage": "Bericht met ritlijst naar chauffeur",
  "trips.driverMessageSelected": "Bericht met ritlijst naar chauffeurs…",
  "trips.driverMessageTitleDay": "Bericht met ritlijst naar de chauffeurs · {{day}}",
  "trips.driverMessageTitleOne": "Bericht met ritlijst naar de chauffeur · {{number}}",
  "trips.driverMessageTitleMany": "Bericht met ritlijst naar de chauffeurs · {{count}} rit",
  "trips.driverMessageTitleMany_other": "Bericht met ritlijst naar de chauffeurs · {{count}} ritten",
  "trips.driverMessageIntro": "Elke chauffeur krijgt in de Welder-app een bericht over de eerste rit van de dag, met een link naar de ritlijst, zodra die rit is vastgezet. Klik op een rij voor de tekst.",
  "trips.driverMessageOff": "Berichten met ritlijst staan hier niet aan.",
  "trips.driverMessageTestOnly": "Op deze omgeving gaat het bericht alleen naar de testchauffeurs.",
  "trips.driverMessageNoneDay": "Op deze dag heeft geen chauffeur een rit.",
  "trips.driverMessageNoneTrips": "Geen ritten.",
  "trips.driverMessageWithoutAppId": "{{count}} chauffeur heeft geen Welder-id en krijgt geen bericht. Vul het in op de chauffeurskaart.",
  "trips.driverMessageWithoutAppId_other": "{{count}} chauffeurs hebben geen Welder-id en krijgen geen bericht. Vul het in op de chauffeurskaart.",
  "trips.driverMessageColDriver": "Chauffeur",
  "trips.driverMessageColTrip": "Rit",
  "trips.driverMessageColDeparture": "Vertrek",
  "trips.driverMessageColVehicle": "Wagen",
  "trips.driverMessageColState": "Stand",
  "trips.driverMessagePick": "Bericht voor {{number}}",
  "trips.driverMessagePickAll": "Alle chauffeurs",
  "trips.driverMessagePreview": "Het bericht aan {{name}}",
  "trips.driverMessageNotSent": "Nog niet verstuurd",
  "trips.driverMessageSentAt": "Verstuurd {{when}}",
  "trips.driverMessageDelivered": "Afgeleverd, verstuurd {{when}}",
  "trips.driverMessageFailed": "Mislukt, verstuurd {{when}}",
  "trips.driverMessageChangedSince": "Rit gewijzigd na versturen",
  "trips.driverMessageBlockCancelled": "Rit geannuleerd",
  "trips.driverMessageBlockNoDriver": "Geen chauffeur op de rit",
  "trips.driverMessageBlockNotFirst": "Niet de eerste rit van de chauffeur die dag",
  "trips.driverMessageBlockNotFirstOf": "Niet de eerste rit; dat is {{trip}}",
  "trips.driverMessageBlockNotConfirmed": "Nog niet vastgezet",
  "trips.driverMessageBlockNoAppId": "Geen Welder-id",
  "trips.driverMessageBlockAppIdInvalid": "Welder-id is geen nummer",
  "trips.driverMessageBlockBeforeStart": "Vóór {{day}} gaan er geen berichten",
  "trips.driverMessageBlockTestOnly": "Geen testchauffeur",
  "trips.driverMessageBlockAlreadySent": "Had het bericht al",
  "trips.driverMessageConfirmAgain": "{{names}} kreeg het bericht al. Nog een keer sturen?",
  "trips.driverMessageConfirmAgain_other": "{{names}} kregen het bericht al. Nog een keer sturen?",
  "trips.driverMessageSubmit": "Verstuur {{count}} bericht",
  "trips.driverMessageSubmit_other": "Verstuur {{count}} berichten",
  "trips.driverMessageSubmitAgain": "Ja, verstuur {{count}} bericht",
  "trips.driverMessageSubmitAgain_other": "Ja, verstuur {{count}} berichten",
  "trips.driverMessageBusy": "Versturen…",
  "trips.driverMessageDone": "{{count}} bericht verstuurd.",
  "trips.driverMessageDone_other": "{{count}} berichten verstuurd.",
  "orders.tabBlocked": "Aandacht nodig",
  "orders.tabAccepted": "Geaccepteerd",
  "orders.tabRejected": "Afgewezen",
  "orders.tabCancelled": "Geannuleerd",
  "orders.statusCancelled": "Geannuleerd",
  "orders.cancel": "Annuleren",
  "orders.cancelTitle": "Deze order annuleren",
  "orders.cancelHelp":
    "De order gaat van de planning af en blijft leesbaar staan. Annuleren is niet afwijzen: afwijzen doen wij, annuleren doet de klant.",
  "orders.cancelReasonLabel": "Reden (komt in het logboek)",
  "orders.cancelReasonPlaceholder": "Klant belde: gaat niet door",
  "orders.cancelSubmit": "Order annuleren",
  "orders.cancelledBecause": "Geannuleerd: {{reason}}",
  "orders.hold": "Hold",
  "orders.holdTitle": "Order op hold zetten",
  "orders.holdHelp": "De order blijft zoals hij is, maar is niet planbaar tot iemand hem vrijgeeft. Staat er iets van op een rit, dan haalt de planner het er eerst af.",
  "orders.holdReasonLabel": "Reden",
  "orders.holdReasonPlaceholder": "Bijvoorbeeld: klant betaalt eerst, wacht op papieren",
  "orders.holdSubmit": "Op hold zetten",
  "orders.release": "Vrijgeven",
  "orders.onHold": "Op hold",
  "orders.onHoldBecause": "Op hold, niet planbaar: {{reason}}",
  "orders.onHoldBy": "door {{name}} op {{date}}",
  "orders.holdOnTrip": "Deze order staat op {{trips}}: de planner haalt hem er eerst af.",
  "orders.priorityByRule": "Prioriteit volgens een regel: alleen een beheerder wijzigt hem.",
  "orders.logHeld": "Op hold gezet",
  "orders.logReleased": "Vrijgegeven",
  "orders.callOffRefused":
    "Deze order staat op een rit die al onderweg of afgerond is. Zo'n rit houdt zijn werk, dus de order kan er nu niet af.",
  "orders.cancelWaits_one": "Staat op rit {{trips}}. De annulering wacht op de planner: die haalt de order van de rit, of laat hem staan.",
  "orders.cancelWaits_other": "Staat op de ritten {{trips}}. De annulering wacht op de planner: die haalt de order van de ritten, of laat hem staan.",
  "orders.rejectOnTrips_one": "Staat op rit {{trips}}. Afwijzen kan pas als de planner hem van de rit heeft gehaald; anders: annuleren.",
  "orders.rejectOnTrips_other": "Staat op de ritten {{trips}}. Afwijzen kan pas als de planner hem van de ritten heeft gehaald; anders: annuleren.",
  "orders.rejectOnTrip": "Deze order staat op rit {{trips}}. Afwijzen kan pas als de planner hem eraf heeft gehaald; annuleren kan wel, dat wacht op de planner.",
  "orders.pickOrder": "Order {{number}} aanvinken",
  "orders.bulkPicked": "{{count}} order aangevinkt",
  "orders.bulkPicked_other": "{{count}} orders aangevinkt",
  "orders.bulkOnReason": "{{count}} orders wachten alleen op: {{reason}}",
  "orders.bulkAcceptPicked": "{{count}} accepteren zoals gevraagd",
  "orders.bulkAcceptAll": "Alle {{count}} accepteren zoals gevraagd",
  "orders.bulkClear": "Selectie leegmaken",
  "orders.bulkConfirm": "{{count}} orders accepteren zoals gevraagd?",
  "orders.bulkConfirmHelp":
    "Elke order komt met deze reden in zijn eigen logboek en blijft zichtbaar houden waarondanks hij is geaccepteerd.",
  "orders.bulkDone": "{{count}} orders geaccepteerd.",
  "orders.bulkHeldAddress": "{{count}} wacht op een locatie",
  "orders.bulkHeldAddress_other": "{{count}} wachten op een locatie",
  "orders.bulkHeldApproval": "{{count}} wacht op een goedgekeurde klant",
  "orders.bulkHeldApproval_other": "{{count}} wachten op een goedgekeurde klant",
  "orders.bulkHeldLoadingMeters": "{{count}} heeft geen laadmeters",
  "orders.bulkHeldLoadingMeters_other": "{{count}} hebben geen laadmeters",
  "orders.bulkHeldTripMark": "{{count}} wacht op een ritkenmerk",
  "orders.bulkHeldTripMark_other": "{{count}} wachten op een ritkenmerk",
  "orders.bulkHeldDates": "{{count}} lost vóór het laden en heeft een andere datum of tijd nodig",
  "orders.bulkHeldDates_other": "{{count}} lossen vóór het laden en hebben een andere datum of tijd nodig",
  "orders.bulkHeldDecision": "{{count}} wacht op de planner (een wijziging of annulering)",
  "orders.bulkHeldDecision_other": "{{count}} wachten op de planner (een wijziging of annulering)",
  "orders.bulkHeldPicked": "Gaan niet mee met accepteren: {{reasons}}. Los dat per order op.",
  "orders.bulkNotThrough": "Niet mee: {{reasons}}.",
  "orders.linkRemembersSpelling": "WLX onthoudt hoe de klant dit adres schreef, zodat een volgende order er vanzelf op landt. Andere orders die op deze plek wachten, gaan mee.",
  "orders.alsoLinked": "Ook {{count}} andere order die op deze plek wachtte, is gekoppeld.",
  "orders.alsoLinked_other": "Ook {{count}} andere orders die op deze plek wachtten, zijn gekoppeld.",
  "orders.logLinkedAlong": "Meegekoppeld met {{order}}: dezelfde plek",
  "orders.logLinkedByAddressBook": "Vanzelf gekoppeld: het adresboek kent deze plek nu",
  "orders.logRememberedSpelling": "Schrijfwijze onthouden: {{spelling}}",
  "orders.logContext": "Uit het bericht: {{values}}",
  "orders.freeAddressHeadsUp": "Dit adres staat nog niet in het adresboek.",
  "orders.makeLocationNeedsName": "Vul eerst een naam in.",
  "orders.makeLocationNeedsCity": "Vul eerst een plaats in.",
  "orders.addressVerdictValid": "Adres gevonden",
  "orders.addressVerdictCorrected": "Wordt elders anders geschreven",
  "orders.addressVerdictPartial": "Adres niet helemaal gevonden",
  "orders.addressVerdictNotFound": "Dit adres is nergens gevonden",
  "orders.addressVerdictHelp": "De order kan gewoon door; dit is een seintje, geen blokkade.",
  "orders.addressTakeOver": "Overnemen",
  "orders.tabAll": "Alles",
  "orders.filterByStatus": "Kies de status",
  "orders.statusBlocked": "Aandacht nodig",
  "orders.statusAccepted": "Geaccepteerd",
  "orders.statusRejected": "Afgewezen",
  "orders.statusHistory": "Historie",
  "orders.searchPlaceholder": "Nummer, referentie, klant…",
  "orders.searchLabel": "Orders zoeken",
  "orders.filterByPriority": "Filter op prioriteit",
  "orders.allPriorities": "Alle prioriteiten",
  "orders.newOrder": "Nieuwe order",
  "orders.newOrderHelp": "Klant, referentie en prioriteit; daaronder de zendingen.",
  "orders.colNumber": "Nummer",
  "orders.colPriority": "Prio",
  "orders.colCustomer": "Klant",
  "orders.colReference": "Factuurreferentie",
  "orders.colFrom": "Van",
  "orders.colTo": "Naar",
  "orders.colUnloadDate": "Losdatum",
  "orders.colLoadingMeters": "Laadmeters",
  "orders.colWeight": "Gewicht",
  "orders.colTransportRequirements": "Vervoerseisen",
  "orders.colConsignments": "Zendingen",
  "orders.colBlockers": "Blokkade",
  "orders.colWarnings": "Let op",
  "orders.colDriverReport": "Melding chauffeur",
  "orders.driverReportStateOpen": "Open",
  "orders.driverReportStateHandled": "Afgehandeld",
  "orders.driverReportsOpen_one": "1 open",
  "orders.driverReportsOpen_other": "{{count}} open",
  "orders.driverReportsTitle": "Melding chauffeur",
  "orders.driverReportsAllHandled": "afgehandeld",
  "orders.driverReportByPlanner": "door de planner",
  "orders.driverReportHandledBy": "Afgehandeld door {{who}}, {{when}}",
  "orders.driverReportReopen": "Opnieuw openen",
  "orders.driverReportEarlierNote": "Eerdere notitie: {{note}}",
  "orders.driverReportNoteLabel": "Notitie",
  "orders.driverReportNotePlaceholder": "Wat is er besloten, bijvoorbeeld: klant gebeld, morgen nageleverd",
  "orders.driverReportHandle": "Afgehandeld",
  "orders.driverNotFullyUnloaded": "Niet volledig gelost",
  "orders.driverNotFullyLoaded": "Niet volledig geladen",
  "orders.driverAmountUnloaded": "{{amount}} gelost",
  "orders.driverAmountLoaded": "{{amount}} geladen",
  "orders.driverColliHeadline_one": "1 collo {{what}}",
  "orders.driverColliHeadline_other": "{{count}} colli {{what}}",
  "orders.driverColliMixed_one": "1 collo niet afgeleverd",
  "orders.driverColliMixed_other": "{{count}} colli niet afgeleverd",
  "orders.driverReportedAllWell": "In orde gemeld",
  "orders.driverReason": "Reden: {{reason}}",
  "orders.driverColli": "Colli: {{colli}}",
  "orders.driverDeviations": "Afwijkingen: {{deviations}}",
  "orders.colloWhat.MANCO": "manco",
  "orders.colloWhat.NIEAAN": "klant niet aanwezig",
  "orders.colloWhat.TELAAT": "te laat",
  "orders.colloWhat.WEIGER": "geweigerd",
  "orders.colloWhat.SCHADE": "schade",
  "orders.colloWhat.delivered": "afgeleverd",
  "orders.logDriverReported": "Melding van de chauffeur",
  "orders.logDriverReportHandled": "Melding chauffeur afgehandeld",
  "orders.logDriverReportReopened": "Melding chauffeur weer open",
  "orders.logEmballageReturned": "Emballage retour (chauffeur)",
  "orders.logDriverNoLongerIssue": "Geen melding meer: de chauffeur meldde het later als in orde",
  "orders.logDriverReopenedByReport": "Was afgehandeld; weer open door een nieuwe melding",
  "orders.logDriverReportNote": "Notitie: {{note}}",
  "orders.logEmballageScans_one": "1 barcode gescand (CHEP {{chep}}, overig {{other}})",
  "orders.logEmballageScans_other": "{{count}} barcodes gescand (CHEP {{chep}}, overig {{other}})",
  "orders.logEmballageNotAllReturned": "Niet alle emballage retour: {{amount}} · {{reason}}",
  "orders.logEmballageAllReturned": "Alle emballage retour",
  "orders.scanStatus.scanned": "In orde",
  "orders.scanStatus.missing": "Manco",
  "orders.scanStatus.not_delivered": "Niet afgeleverd",
  "orders.scanStatus.refused": "Geweigerd",
  "orders.scanStatus.damaged": "Schade",
  "orders.scanStatus.other": "Anders",
  "orders.scanStatusTitle": "Wat de chauffeur van dit collo meldde",
  "orders.scanCode.MANCO": "Manco",
  "orders.scanCode.NIEAAN": "Klant niet aanwezig",
  "orders.scanCode.TELAAT": "Te laat",
  "orders.scanCode.WEIGER": "Geweigerd",
  "orders.scanCode.SCHADE": "Schade",
  "orders.colReceived": "Ontvangen",
  "orders.colStatus": "Status",
  "orders.andMore": "+{{count}} meer",
  "orders.queueEmpty": "Niets dat op je wacht. Orders zonder blokkade zijn meteen geaccepteerd.",
  "orders.noOrders": "Geen orders in deze lijst.",
  "orders.notFound": "Order niet gevonden",
  "orders.notFoundDesc": "Deze order bestaat niet, of je hebt er geen toegang toe.",
  "orders.blockedTitle_one": "Deze order wacht op jou: 1 reden",
  "orders.blockedTitle_other": "Deze order wacht op jou: {{count}} redenen",
  "orders.blockedHelp": "Los de reden op en de order gaat er meteen door; of accepteer hem zoals de klant hem vroeg.",
  "orders.whereConsignment": "Zending {{consignment}}",
  "orders.whereActivity": "Zending {{consignment}}, activiteit {{activity}}",
  "orders.openTwin": "Bekijk {{order}}",
  "orders.openLocation": "Naar de locatie",
  "orders.linkLocation": "Locatie koppelen",
  "orders.linkLocationTitle": "Welke locatie is dit?",
  "orders.linkLocationSearch": "Zoek in het adresboek",
  "orders.makeLocation": "Of maak er een locatie van",
  "orders.newLocationHours": "Openingstijden invullen",
  "orders.newLocationHoursDrop": "Niet invullen",
  "orders.makeLocationHelp":
    "Het adres van de order wordt overgenomen en WLX geeft de locatie zelf een code. Openingstijden en eisen vul je daarna op de locatiekaart in.",
  "orders.makeLocationSubmit": "Aanmaken en koppelen",
  "orders.acceptAsAsked": "Accepteren zoals gevraagd",
  "orders.acceptSubmit": "Accepteren",
  "orders.acceptNeedsLocation": "Koppel of maak eerst de locatie \u2014 dan is de order er vanzelf doorheen.",
  "orders.bulkNeedsLocation": "Deze wachten op een locatie, niet op een besluit: koppel of maak het adres per order.",
  "orders.acceptNeedsApproval": "Keur eerst de klant goed op zijn relatiekaart \u2014 dan is de order er vanzelf doorheen.",
  "orders.acceptNeedsLoadingMeters": "Zonder laadmeters plant WLX niet: vul ze eerst in op de zending.",
  "orders.acceptNeedsDates": "Lossen vóór laden kan geen wagen rijden: pas eerst de datum of tijd aan.",
  "orders.acceptNeedsLocationAnnounced": "Koppel of maak eerst de locatie — daarna wacht de order nog op de definitieve van de klant.",
  "orders.acceptNeedsApprovalAnnounced": "Keur eerst de klant goed op zijn relatiekaart — daarna wacht de order nog op de definitieve van de klant.",
  "orders.bulkNeedsApproval": "Deze wachten op een goedgekeurde klant, niet op een besluit: keur de klant goed op zijn relatiekaart.",
  "orders.bulkNeedsLoadingMeters": "Deze hebben geen laadmeters: vul ze per order in, accepteren zoals gevraagd kan niet.",
  "orders.bulkNeedsTripMark": "Deze wachten op hun rit: vink de orders van één rit aan en geef ze een ritkenmerk, of verstuur het ritbericht. Accepteren zoals gevraagd kan niet.",
  "orders.bulkNeedsDates": "Deze lossen vóór het laden: pas per order de datum of tijd aan, accepteren zoals gevraagd kan niet.",
  "orders.acceptReasonLabel": "Reden (komt in het logboek)",
  "orders.acceptReasonPlaceholder": "Bijv. klant weet het adres zeker",
  "orders.acceptedDespite_one": "Geaccepteerd ondanks 1 blokkade.",
  "orders.acceptedDespite_other": "Geaccepteerd ondanks {{count}} blokkades.",
  "orders.reject": "Afwijzen",
  "orders.rejectTitle": "Order {{number}} afwijzen",
  "orders.rejectReasonLabel": "Reden van afwijzen",
  "orders.rejectReasonPlaceholder": "Bijv. dubbel ingevoerd",
  "orders.rejectSubmit": "Afwijzen",
  "orders.rejectedBecause": "Afgewezen: {{reason}}",
  "orders.noticeQuestion": "Wat gaat er naar de klant? Dat is nog niet besloten.",
  "orders.noticeMail": "Mail naar de klant",
  "orders.noticeCall": "Wij bellen de klant",
  "orders.noticeNone": "Niets",
  "orders.noticeUndecided":
    "WLX verstuurt hier nog niets. Je keuze komt in het logboek, zodat we op echte gevallen kunnen besluiten wat automatisch gaat.",
  "orders.noticeWas": "Naar de klant: {{notice}}",
  "orders.receivedOn": "Ontvangen {{date}}",
  "orders.acceptedOn": "Geaccepteerd {{date}}",
  "orders.channelEdi": "Via EDI",
  "orders.channelMail": "Via mail",
  "orders.channelPortal": "Via portaal",
  "orders.enteredByPartner": "ingevoerd door {{name}}",
  "orders.talisCopy": "ook naar TALIS gestuurd",
  "orders.warningsCount_one": "{{count}} afwijking",
  "orders.warningsCount_other": "{{count}} afwijkingen",
  "orders.consignmentTitle": "Zending {{number}}",
  "orders.palletsValue_one": "{{count}} pallet",
  "orders.palletsValue_other": "{{count}} pallets",
  "orders.weightValue": "{{value}} kg",
  "orders.loadingMetersValue": "{{value}} ldm",
  "orders.temperatureValue": "{{min}} tot {{max}} °C",
  "orders.adrValue": "ADR",
  "orders.forkliftValue": "Kooiaap",
  "orders.colActivity": "Activiteit",
  "orders.colPlace": "Plaats",
  "orders.colWindow": "Venster",
  "orders.colRequirements": "Eisen",
  "orders.colInstruction": "Instructie",
  "orders.activityLoad": "Laden",
  "orders.activityUnload": "Lossen",
  "orders.activityWarning": "Activiteit {{number}}: {{text}}",
  "orders.noWarnings": "Geen afwijkingen.",
  "orders.givenAddress": "Opgegeven adres",
  "orders.customerLabel": "Klant",
  "orders.customerSearchPlaceholder": "Zoek een klant op naam of VR-nummer…",
  "orders.customerChange": "Andere klant",
  "orders.customerNothingFound": "Geen klant gevonden.",
  "orders.referenceLabel": "Factuurreferentie",
  "orders.referenceHelp": "Komt op de vrachtbrief en de factuur.",
  "orders.priorityLabel": "Prioriteit",
  "orders.priorityCritical": "Kritiek",
  "orders.priorityRegular": "Regulier",
  "orders.priorityFlexible": "Flexibel",
  "orders.priorityHelp": "Van een kritieke order wijzigt daarna alleen een beheerder de datum of tijd.",
  "orders.priorityByRuleCritical_one": "Kritiek volgens de regel van deze klant: een lossing met een venster van hoogstens 1 uur.",
  "orders.priorityByRuleCritical_other": "Kritiek volgens de regel van deze klant: een lossing met een venster van hoogstens {{count}} uur.",
  "orders.priorityByRuleFlexible": "Flexibel volgens de regel: een zending met de vervoerseis Emballage.",
  "orders.priorityByRuleShort": "volgens regel",
  "orders.pendelLabel": "Fabriekspendel",
  "orders.tripMarkLabel": "Ritkenmerk",
  "orders.tripMarkAdd": "+ Ritkenmerk",
  "orders.tripMarkChange": "Ritkenmerk wijzigen",
  "orders.tripMarkSave": "Opslaan",
  "orders.tripMarkPlaceholder": "1VR",
  "orders.tripMarkHelp": "Orders van deze klant met hetzelfde kenmerk die op dezelfde dag lossen, gaan samen op één rit. Het kenmerk is de naam van de rit: alles met 1VR is één rit, 2VR een andere.",
  "orders.pendelShort": "fabriekspendel",
  "orders.pendelHelp": "Fabriekspendel: volle ladingen die één wagen heen en weer rijdt tussen een fabriek en ons warehouse, zoals Nutrifeed Veghel en Haps. De zendingen krijgen de soort Fabriekspendel, en stap 1 deelt ze in volgens het pendelschema.",
  "orders.talisCopyLabel": "Ook naar TALIS",
  "orders.talisCopyHelp":
    "Tot de livegang gaat de order ook naar TALIS, en daarna elke wijziging, annulering of afwijzing die je hier doet. Zet het vinkje uit als de order al in TALIS staat.",
  "orders.criticalAdminOnly": "Kritieke order: alleen een beheerder wijzigt de datum, de tijd en de prioriteit.",
  "orders.printCmr": "CMR printen…",
  "orders.editConsignment": "Zending wijzigen",
  "orders.editSave": "Wijzigingen opslaan",
  "orders.editHelp": "De controles lopen opnieuw zodra je opslaat, en elke wijziging komt in het logboek.",
  "orders.editHelpNoWindows": "Datum en tijd van een kritieke order wijzigt alleen een beheerder; de rest kun je wel bijwerken.",
  "orders.colActivityReference": "Referentie",
  "orders.customerLocationCodeLabel": "Klantcode",
  "orders.loadReferenceLabel": "Laadreferentie",
  "orders.unloadReferenceLabel": "Losreferentie",
  "orders.logShow": "Logboek tonen",
  "orders.logHide": "Logboek verbergen",
  "orders.logEmpty": "Nog niets gebeurd met deze order.",
  "orders.logCreated": "Order binnengekomen",
  "orders.logUpdated": "Gewijzigd",
  "orders.logAccepted": "Geaccepteerd",
  "orders.logRejected": "Afgewezen",
  "orders.logCancelled": "Geannuleerd",
  "orders.logDepotPinned": "Depot gekozen",
  "orders.logDepotLoadsAt": "laadt in depot {{depot}}, niet via het depot van de rit",
  "orders.logDepotUnloadsAt": "lost in depot {{depot}}, niet in het depot van de rit",
  "orders.logDepotFollowsTrip": "volgt weer het depot van de rit",
  "orders.logRouteChanged": "Route gewijzigd",
  "orders.logRouteLine": "{{from}} → {{to}}",
  "orders.logRouteLegs": "Nu: {{legs}}",
  "orders.logRouteTrips_one": "Raakte rit {{trips}}",
  "orders.logRouteTrips_other": "Raakte de ritten {{trips}}",
  "orders.logRouteByRule": "Volgens de regel, na een wijziging van laadmeters of datum",
  "orders.logRouteMark_one": "Ritkenmerk {{mark}}: {{count}} zending, {{metres}} m",
  "orders.logRouteMark_other": "Ritkenmerk {{mark}}: {{count}} zendingen samen {{metres}} m, als één zending",
  "orders.logOffTrips_one": "Van rit {{trips}} gehaald",
  "orders.logOffTrips_other": "Van de ritten {{trips}} gehaald",
  "orders.logTripFollowed_one": "Rit {{trips}} schoof mee",
  "orders.logTripFollowed_other": "Ritten {{trips}} schoven mee",
  "orders.logTripOff_one": "Van rit {{trips}} gehaald; wacht weer op een rit",
  "orders.logTripOff_other": "Van de ritten {{trips}} gehaald; wacht weer op een rit",
  "orders.logTripWaiting_one": "Andere dag op rit {{trips}}; wacht op de planner",
  "orders.logTripWaiting_other": "Andere dag op de ritten {{trips}}; wacht op de planner",
  "orders.moveFollowsTrip": "Staat op rit {{trip}}: binnen de dag schuift de rit mee. Naar een andere dag blijft de zending op de rit staan en beslist de planner.",
  "orders.moveTripClosed": "Staat op rit {{trip}}, die al onderweg of afgerond is: dit tijdvenster verandert niet meer.",
  "orders.dayMovedOnTrip": "Andere dag gevraagd · staat nog op {{trip}}",
  "orders.dayMovedHelp": "De order vraagt nu een andere dag dan de rit. Er gaat niets vanzelf van de rit af: de planner haalt hem eraf of laat hem staan.",
  "orders.logConfirmed": "Bevestigd (oude intakepoort)",
  "orders.logCreatedAndConfirmed": "Aangemaakt en bevestigd (oude intakepoort)",
  "orders.logCreatedAccepted": "Zonder blokkade binnengekomen, meteen geaccepteerd",
  "orders.logCreatedBlocked": "Geblokkeerd bij binnenkomst: {{reasons}}",
  "orders.logCreatedBlockedBare": "Geblokkeerd bij binnenkomst",
  "nav.consignmentRequirements": "Vervoerseisen",
  "nav.pendelRoutes": "Pendelschema",
  "requirements.intro":
    "Wat een zending van het vervoer vraagt: kooiaap, diervoeder, temperatuur. Wat de plek zelf vraagt staat op de locatie en komt vanzelf op de stop te staan.",
  "requirements.new": "Nieuwe eis",
  "requirements.save": "Opslaan",
  "requirements.edit": "Wijzigen",
  "requirements.activate": "Weer in gebruik nemen",
  "requirements.deactivate": "Uit gebruik nemen",
  "requirements.active": "In gebruik",
  "requirements.inactive": "Niet in gebruik",
  "requirements.empty": "Nog geen vervoerseisen.",
  "requirements.colName": "Naam",
  "requirements.colCode": "Code",
  "requirements.colDescription": "Omschrijving",
  "requirements.colSortOrder": "Volgorde",
  "requirements.colStatus": "Status",
  "requirements.colActions": "",
  "requirements.viewLabel": "Weergave",
  "requirements.viewList": "Eisen",
  "requirements.viewPlanning": "Voertuig en combinaties",
  "requirements.planningIntro":
    "Wat een eis van het voertuig vraagt, en welke eisen samen of na elkaar kunnen. De planning gebruikt dit bij elke keuze: welke wagen past, wat er op een rit past en wat er achter een volle levering kan.",
  "requirements.allBranches": "Geldt voor alle vestigingen",
  "requirements.unsaved": "Niet opgeslagen",
  "requirements.saved": "Opgeslagen",
  "requirements.restoreDefaults": "Standaard herstellen",
  "requirements.needsTitle": "Per eis: wat het voertuig nodig heeft",
  "requirements.needsSubtitle": "Een wagen zonder wat de eis vraagt, past niet; de planning zegt waarom.",
  "requirements.needsNote":
    "Een zending zonder eis kan met elk voertuig. Komt er een zending met een eis op een rit zonder die eis, dan vraagt de rit hem vanaf dan (bijvoorbeeld een gekoelde ophaling achter een volle levering zonder eis).",
  "requirements.colRequirement": "Eis",
  "requirements.colKind": "Soort",
  "requirements.colVehicleNeeds": "Voertuig nodig",
  "requirements.colDriverNeeds": "Chauffeur moet hebben",
  "requirements.colWhenMissing": "Ontbreekt het",
  "requirements.whenMissing_warn": "Waarschuwing",
  "requirements.whenMissing_cannot": "Kan niet",
  "requirements.colTomorrow": "Morgen",
  "requirements.consignmentsCount_one": "{{count}} zend.",
  "requirements.consignmentsCount_other": "{{count}} zend.",
  "requirements.kind.body": "Opbouw",
  "requirements.kind.equipment": "Uitrusting",
  "requirements.kind.goods": "Lading",
  "requirements.needNone": "Niets",
  "requirements.need.refrigerated": "Koelopbouw",
  "requirements.need.box": "Kastopbouw",
  "requirements.need.curtain": "Huifopbouw",
  "requirements.need.tautliner": "Schuifzeilopbouw (tautliner)",
  "requirements.need.tail_lift": "Laadklep",
  "requirements.togetherTitle": "Samen op één rit",
  "requirements.togetherSubtitle": "Geldt in beide richtingen. De planning gebruikt het bij wat er op een rit past. Klik een vak om te wisselen.",
  "requirements.afterTitle": "Na elkaar met dezelfde wagen",
  "requirements.afterSubtitle":
    "Van rij (eerst) naar kolom (daarna). De planning gebruikt het bij wat er achter een volle levering kan, en bij twee ritten op één wagen.",
  "requirements.afterCorner": "eerst ↓ · daarna →",
  "requirements.can": "kan",
  "requirements.cannot": "kan niet",
  "requirements.togetherCell": "{{first}} en {{second}} samen op één rit: {{verdict}}",
  "requirements.afterCell": "Eerst {{first}}, daarna {{second}} met dezelfde wagen: {{verdict}}",
  "parties.defaultRequirementsLabel": "Standaard vervoerseisen",
  "parties.defaultRequirementsHelp": "Elke nieuwe zending van deze relatie begint hiermee; de planner kan er een afhalen.",
  "orders.requirementsLabel": "Vervoerseisen",
  "orders.executionLabel": "Uitvoering",
  "orders.executionOpen": "Nog te rijden",
  "orders.executionLoaded": "Geladen",
  "orders.executionInTransit": "Onderweg",
  "orders.executionUnloaded": "Gelost",
  "orders.executionCompleted": "Afgerond",
  "orders.executionCancelled": "Geannuleerd",
  "orders.issueLabel": "Bijzonderheid",
  "orders.issueNone": "Geen",
  "orders.issueShortage": "Manco",
  "orders.issueDamage": "Schade",
  "orders.issueRefused": "Geweigerd",
  "orders.issueRemarkLabel": "Toelichting",
  "orders.partiesTitle": "Partijen",
  "orders.partiesNone": "Geen afwijkende afzender, ontvanger of te berichten partij.",
  "orders.editParties": "Partijen wijzigen",
  "orders.entryPartiesAdd": "Afwijkende partijen: afzender, ontvanger, te berichten",
  "orders.entryUnitsAdd": "Goederenregels: te scannen barcodes",
  "orders.consignmentWord": "Zending",
  "orders.fromLocation": "Vraagt de locatie zelf",
  "orders.addRequirement": "Eis erbij…",
  "orders.stopRequirementsPlaceholder": "Eisen bij deze stop: typ of kies…",
  "orders.stopRequirements": "Eisen bij deze stop",
  "orders.removeRequirement": "{{name}} weghalen",
  "orders.partiesHelp": "Alleen invullen als ze afwijken van de klant. Kies een locatie, of geef een adres op dat geen bekende locatie is; leeg is de klant.",
  "orders.partyName": "Naam",
  "orders.partyReference": "Referentie",
  "orders.roleShipper": "Afzender",
  "orders.roleConsignee": "Ontvanger",
  "orders.roleNotify": "Te berichten",
  "orders.requirementsNone": "Nog geen vervoerseisen ingericht.",
  "orders.requirementsPlaceholder": "Typ of kies…",
  "orders.requirementsNothingFound": "Geen vervoerseis gevonden.",
  "orders.requirementRemove": "{{name}} weghalen",
  "orders.requirementsChosen_one": "1 gekozen",
  "orders.requirementsChosen_other": "{{count}} gekozen",
  "orders.requirementsNoneChosen": "niets gekozen",
  "orders.unitsTitle": "Te scannen",
  "orders.unitsCount_one": "{{count}} barcode",
  "orders.unitsCount_other": "{{count}} barcodes",
  "orders.unitsEmpty": "Nog niets ontvangen uit het WMS.",
  "orders.unitBarcode": "Barcode",
  "orders.unitKind": "Soort",
  "orders.unitDescription": "Omschrijving",
  "orders.unitQuantity": "Aantal",
  "orders.unitWeight": "Gewicht (kg)",
  "orders.unitBatch": "Batch",
  "orders.contentBestBeforeOn": "THT {{date}}",
  "orders.contentPalletNumber": "Pallet {{number}}",
  "orders.unitSource": "Bron",
  "orders.unitFromWms": "WMS",
  "orders.unitWarehouseIn": "Binnen {{at}}",
  "orders.unitWarehouseOut": "Geladen {{at}}",
  "orders.unitLoadDegree": "{{value}} laadmeter",
  "orders.unitByHand": "Met de hand",
  "orders.unitRemove": "Weghalen",
  "orders.unitPallet": "Pallet",
  "orders.unitIbc": "IBC",
  "orders.unitBox": "Doos",
  "orders.unitRollContainer": "Rolcontainer",
  "orders.unitTank": "Tank",
  "orders.unitOther": "Anders",
  // What stands on the pallet places of a consignment: "3 pallets · 2 IBC" (30-09-2026).
  "orders.carriersLabel": "Dragers",
  "orders.carrierPallet_one": "{{count}} pallet",
  "orders.carrierPallet_other": "{{count}} pallets",
  "orders.carrierIbc_one": "{{count}} IBC",
  "orders.carrierIbc_other": "{{count}} IBC",
  "orders.carrierBox_one": "{{count}} doos",
  "orders.carrierBox_other": "{{count}} dozen",
  "orders.carrierRollContainer_one": "{{count}} rolcontainer",
  "orders.carrierRollContainer_other": "{{count}} rolcontainers",
  "orders.carrierTank_one": "{{count}} tank",
  "orders.carrierTank_other": "{{count}} tanks",
  "orders.carrierOther_one": "{{count}} overig",
  "orders.carrierOther_other": "{{count}} overig",
  "orders.unitsAddLabel": "Barcodes toevoegen",
  "orders.unitsAddPlaceholder": "Eén barcode per regel",
  "orders.unitsAddHelp": "Plakken kan: één per regel, eventueel barcode;omschrijving;aantal.",
  "orders.unitsAdd": "Toevoegen aan de lijst",
  "orders.logUnits": "Barcodes: {{summary}}",
  "orders.logUnitsAdded_one": "1 erbij",
  "orders.logUnitsAdded_other": "{{count}} erbij",
  "orders.logUnitsRemoved_one": "1 eraf",
  "orders.logUnitsRemoved_other": "{{count}} eraf",
  "orders.logUnitsChanged_one": "1 gewijzigd",
  "orders.logUnitsChanged_other": "{{count}} gewijzigd",
  "orders.shortFreeAddress": "onbekend adres",
  "orders.shortLocationInactive": "non-actieve locatie",
  "orders.shortFirstNotLoad": "begint niet met laden",
  "orders.shortLastNotUnload": "eindigt niet met lossen",
  "orders.shortUnloadBeforeLoad": "lossen vóór laden",
  "orders.shortDuplicateOrder": "dubbele referentie",
  "orders.shortEnteredTooLate": "na de aanmeldtijd",
  "orders.shortCustomerNotApproved": "klant niet goedgekeurd",
  "orders.shortOutsideHours": "buiten de openingstijden",
  "orders.shortHoursUnknown": "openingstijden onbekend",
  "orders.shortClosedThatDay": "gesloten die dag",
  "orders.shortWindowInPast": "datum in het verleden",
  "orders.shortWindowBeforePrevious": "vóór de vorige stop",
  "orders.logAcceptedAsAsked": "Geaccepteerd zoals gevraagd",
  "orders.logAcceptedSolved": "De laatste blokkade was opgelost",
  "orders.logReason": "Reden: {{reason}}",
  "orders.logNotice": "Naar de klant: {{notice}}",
  "orders.logLocationLinked": "Locatie gekoppeld: {{location}}",
  "orders.logBySystem": "via een koppeling",
  "orders.logByNobody": "automatisch",
  "orders.errorOrderChanged":
    "Iemand anders heeft deze order zojuist gewijzigd. Sluit het bewerken en open het opnieuw — dan zie je wat er veranderd is en kun je jouw wijziging alsnog opslaan.",
  "orders.errorTripClosed":
    "Een handeling staat op een rit die al onderweg of afgerond is. Zo'n rit houdt zijn werk, dus het tijdvenster is niet gewijzigd.",
  "orders.errorIncompleteWindows": "Geef elke activiteit een datum. Een tijd mag leeg blijven, maar wat je typt moet een tijd zijn.",
  "orders.changePlace": "Ander adres",
  "orders.keepPlace": "Adres houden",
  "orders.rememberSpelling": "Hetzelfde adres: onthoud hoe de klant het schrijft",
  "orders.errorPlaceMissing": "Kies een adres voor elke stop die je verplaatst, met een naam, een plaats en een land, of houd het oude.",
  "orders.consignmentRemove": "Zending weghalen",
  "orders.consignmentAdd": "Zending toevoegen",
  "orders.serviceTypeLabel": "Soort vervoer",
  "orders.descriptionLabel": "Goederen",
  "orders.descriptionPlaceholder": "Bijv. 20 europallets fruit",
  "orders.palletsLabel": "Palletplaatsen",
  "orders.weightLabel": "Gewicht (kg)",
  "orders.loadingMetersLabel": "Laadmeters",
  "orders.volumeLabel": "Kuub (m³)",
  "orders.adrCodeLabel": "ADR-code",
  "orders.adrCodeHelp": "De code van de gevaarlijke stof, uit de lijst onder Beheer → ADR-codes.",
  "orders.adrCodePlaceholder": "Code of naam…",
  "orders.adrCodeNone": "Nog geen ADR-codes. Een beheerder zet ze onder Beheer → ADR-codes.",
  "orders.adrClass": "klasse {{value}}",
  "orders.adrPackingGroup": "VG {{value}}",
  "orders.adrLinesLabel": "ADR-regels",
  "orders.adrPackingGroupLabel": "Verpakkingsgroep",
  "orders.adrPackingGroupChoose": "Kies",
  "orders.adrGroupOption": "VG {{group}} · cat. {{category}}",
  "orders.adrQuantityLabel": "Hoeveelheid",
  "orders.adrUnitLabel": "Eenheid",
  "orders.adrRemoveLine": "Regel weghalen",
  "orders.adrAddLine": "ADR-regel erbij",
  "orders.adrPointsUnknown": "Punten onbekend: zonder categorie of hoeveelheid geldt ADR voor de rit.",
  "orders.adrPointsUnder": "{{points}} ADR-punten: vrijgesteld zolang de rit samen niet boven 1.000 komt.",
  "orders.adrPointsOver": "{{points}} ADR-punten: boven 1.000, ADR geldt voor de rit.",
  "orders.adrGroupShort": "VG {{group}}",
  "orders.adrCategoryShort": "cat. {{category}}",
  "planning.fit.adr_exempt": "ADR vrijgesteld: {{points}} punten (1.1.3.6)",
  "planning.v3.adrExempt": "ADR vrijgesteld · {{points}} p",
  "planning.v3.adrPoints": "ADR · {{points}} p",
  "planning.v3.adrUnknown": "ADR · punten onbekend",
  "adrCodes.colVariants": "Categorie per VG",
  "adrCodes.variantsHelp": "Per verpakkingsgroep de vervoerscategorie en eventueel de tunnelcode, bijvoorbeeld II:2:E III:3:E. Zonder verpakkingsgroep: -:2.",
  "adrCodes.variantsInvalid": "Schrijf de categorieën als II:2 III:3 (verpakkingsgroep I, II, III of -, categorie 0 tot 4).",
  "nav.adrCodes": "ADR-codes",
  "adrCodes.intro": "De ADR-codes waaruit order entry kiest bij een zending met ADR. Een code die niet meer gebruikt wordt, neem je uit gebruik: een zending houdt zijn code.",
  "adrCodes.new": "Nieuwe code",
  "adrCodes.save": "Opslaan",
  "adrCodes.edit": "Wijzigen",
  "adrCodes.activate": "Weer in gebruik nemen",
  "adrCodes.deactivate": "Uit gebruik nemen",
  "adrCodes.active": "In gebruik",
  "adrCodes.inactive": "Niet in gebruik",
  "adrCodes.empty": "Nog geen ADR-codes.",
  "adrCodes.colCode": "Code",
  "adrCodes.colDescription": "Omschrijving",
  "adrCodes.colClass": "Klasse",
  "adrCodes.colClassification": "Classificatie",
  "adrCodes.colPackingGroup": "Verpakkingsgroep",
  "adrCodes.colStatus": "Status",
  "adrCodes.colActions": "",
  "orders.meters.calculate": "Uitrekenen",
  "orders.meters.title": "Laadmeters uitrekenen",
  "orders.meters.count": "Aantal",
  "orders.meters.carrier": "Drager",
  "orders.meters.lengthCm": "Lengte cm",
  "orders.meters.widthCm": "Breedte cm",
  "orders.meters.europallet": "Europallet",
  "orders.meters.blockPallet": "Blokpallet",
  "orders.meters.ibc": "IBC",
  "orders.meters.bigBag": "Big Bag",
  "orders.meters.size": "Eigen maat",
  "orders.meters.perPiece": "{{carrier}} · {{meters}} m",
  "orders.meters.sizeHint": "Eigen maat: aantal × lengte × breedte, gedeeld door de 2,40 m laadvloer. Stapelen telt niet mee.",
  "orders.meters.addRow": "Regel toevoegen",
  "orders.meters.removeRow": "Regel weghalen",
  "orders.meters.total": "Totaal",
  "orders.meters.cancel": "Annuleren",
  "orders.meters.take": "Overnemen",
  "orders.loadingMetersFromScans": "Uit de scans van het magazijn",
  "orders.partsTitle": "WMS-orders in deze zending",
  "orders.partsHelp": "Een verzamelzending: Willems rijdt tot het losadres, daar gaat elke order verder naar zijn eigen adres. Bij het printen van de rit krijgt elke order een eigen CMR.",
  "orders.partWmsOrder": "WMS-order",
  "orders.partReceiverOrder": "Order ontvanger",
  "orders.partTo": "Naar",
  "orders.partPallets": "Pallets",
  "orders.partLoadingMeters": "Laadmeter",
  "orders.partWeight": "Gewicht (kg)",
  "orders.partState": "Stand",
  "orders.partEstimated": "Geschat uit de orderregels",
  "orders.partPicked": "Gepickt {{at}}",
  "orders.partNoAddress": "adres nog niet uit het WMS",
  "orders.loadingMetersFromParts": "Opgeteld uit de WMS-orders",
  "resources.searchLabel": "Zoeken",
  "resources.searchPlaceholderDrivers": "Naam of personeelsnummer…",
  "resources.searchPlaceholderUnits": "Vlootnummer, kenteken, merk, categorie…",
  "resources.typeFilter": "Soort",
  "resources.typeAll": "Alle",
  "resources.typeVehicles": "Wagens",
  "resources.typeEquipment": "Trailers",
  "resources.noUnits": "Geen transportmiddelen gevonden.",
  "resources.newUnit": "Nieuw transportmiddel",
  "resources.newUnitTitle": "Nieuw transportmiddel",
  "resources.newUnitType": "Wagen of trailer",
  "resources.newUnitVehicle": "Wagen",
  "resources.newUnitEquipment": "Trailer",
  "resources.newUnitCodeHelp": "Staat daarna vast. Geen andere wagen of trailer mag hetzelfde vlootnummer hebben.",
  "resources.newUnitRest": "Opbouw, maten, uitrusting en de vaste koppelingen vul je daarna op de kaart in.",
  "resources.newDriver": "Nieuwe chauffeur",
  "resources.newDriverTitle": "Nieuwe chauffeur",
  "resources.newDriverHelp":
    "Voor een zzp'er die niet in AFAS staat. Chauffeurs van Willems zelf komen uit AFAS. Een zzp'er heeft geen standplaats.",
  "resources.newDriverRest": "Bevoegdheden, overnachten en het Welder-id vul je daarna op de kaart in.",
  "resources.newDriverBcNumber": "Krijgt vanzelf het volgende nummer, van 90000 tot en met 99999.",
  "resources.colCoupled": "Vast gekoppeld",
  "resources.unitNote":
    "Dit transportmiddel komt uit TALIS. TALIS vulde het één keer en overschrijft het niet: wat je hier wijzigt, blijft staan.",
  "resources.driverNote":
    "Naam, personeelsnummer, dienstverband en standplaats komen uit AFAS, tot 16 november via TALIS; het dienstrooster rechtstreeks uit AFAS. Die wijzig je daar.",
  "resources.driverWlxHelp": "Dit beheer je in WLX. TALIS vult het één keer, bij een nieuwe chauffeur; daarna blijft staan wat hier staat.",
  "resources.driverWlxNote":
    "Deze chauffeur is in WLX aangemaakt en staat niet in AFAS. Alles behalve het nummer wijzig je hier.",
  "resources.driverActiveHelp": "Een inactieve chauffeur blijft bewaard, maar kies je niet meer voor een rit.",
  "resources.fieldLoadingMeters": "Laadmeters",
  "resources.fieldEmissionHelp": "Bijvoorbeeld EURO VI of BEV.",
  "resources.fieldTalisNumber": "TALIS-nummer",
  "resources.bodyNone": "Niet opgegeven",
  "resources.noneChosen": "Geen",
  "resources.branchFilter": "Standplaats",
  "resources.branchAll": "Alle standplaatsen",
  "resources.sourceNote":
    "Chauffeurs van Willems maak je aan en meld je uit dienst in AFAS, tot 16 november via TALIS. Een zzp'er die niet in AFAS staat, maak je hier aan.",
  "resources.colCode": "Vlootnummer",
  "resources.colKind": "Soort",
  "resources.colMakeModel": "Merk en type",
  "resources.colBranch": "Standplaats",
  "resources.colSpace": "Laadruimte",
  "resources.colTailLift": "Laadklep",
  "resources.colFeatures": "Uitrusting",
  "resources.colPersonnelNumber": "Personeelsnr.",
  "resources.colFirstName": "Voornaam",
  "resources.colLastName": "Achternaam",
  "resources.colLastNamePrefix": "Tussenvoegsel",
  "resources.colEmployment": "Dienstverband",
  "resources.colQualifications": "Bevoegdheden",
  "resources.colVehicles": "Vaste wagen",
  "resources.colOvernight": "Overnachten",
  "resources.noDrivers": "Geen chauffeurs gevonden.",
  "resources.notFound": "Niet gevonden",
  "resources.notFoundDesc": "Dit bestaat niet (meer), of je hebt er geen toegang toe.",
  "resources.fieldPlate": "Kenteken",
  "resources.fieldKind": "Soort",
  "resources.fieldSubType": "Soort",
  "resources.fieldCategory": "Categorie in TALIS",
  "resources.fieldMake": "Merk",
  "resources.fieldModel": "Type",
  "resources.fieldBody": "Opbouw",
  "resources.fieldTailLift": "Laadklep",
  "resources.fieldAxles": "Assen",
  "resources.fieldTare": "Leeggewicht",
  "resources.fieldPayload": "Laadvermogen",
  "resources.fieldEmission": "Emissieklasse",
  "resources.fieldZone": "Milieuzone",
  "resources.fieldFeatures": "Uitrusting",
  "resources.fieldDriver": "Vaste chauffeur",
  "resources.fieldTrailer": "Vaste trailer",
  "resources.fieldCoupledTo": "Vast achter",
  "resources.fieldPersonnelNumber": "Personeelsnummer",
  "resources.fieldFirstName": "Voornaam",
  "resources.fieldLastNamePrefix": "Tussenvoegsel",
  "resources.fieldLastName": "Achternaam",
  "resources.fieldBcNumber": "BC-nummer",
  "resources.fieldAfasNumber": "AFAS-nummer",
  "resources.fieldEmployment": "Dienstverband",
  "resources.fieldOvernight": "Blijft overnachten",
  "resources.fieldAppId": "Welder-app",
  "resources.fieldAppIdHelp": "Het id waarmee WLX de chauffeur in de Welder-app bereikt.",
  "resources.fieldVehicles": "Vaste wagen",
  "resources.fieldQualifications": "Bevoegdheden",
  "resources.blockGeneral": "Algemeen",
  "resources.blockInspection": "Keuring",
  "resources.blockLoading": "Laadruimte",
  "resources.blockMasses": "Gewicht",
  "resources.blockDimensions": "Afmetingen",
  "resources.blockDeployment": "Inzet",
  "resources.blockSystems": "Andere systemen",
  "resources.sectionBody": "Opbouw en maten",
  "resources.sectionEnvironment": "Milieu",
  "resources.sectionLinks": "Vast gekoppeld",
  "resources.sectionAvailability": "Dienstrooster",
  "resources.cooled": "Gekoeld",
  "resources.zoneAllowed": "Toegestaan",
  "resources.zoneNotAllowed": "Niet toegestaan",
  "resources.zoneUnknown": "Onbekend",
  "resources.spaceMeters": "{{meters}} m",
  "resources.sectionInspection": "Keuring, massa en maten",
  "resources.fieldApk": "APK tot",
  "resources.fieldTachograph": "Tachograaf tot",
  "resources.fieldMaxMass": "Toegestane maximummassa",
  "resources.fieldTechnicalMaxMass": "Technische maximummassa",
  "resources.fieldCombinationMass": "Treingewicht",
  "resources.fieldCombinationMassHelp": "Wat trekker, trailer en lading samen mogen wegen.",
  "resources.fieldLength": "Lengte",
  "resources.fieldWidth": "Breedte",
  "resources.fieldLengthM": "Lengte (m)",
  "resources.fieldWidthM": "Breedte (m)",
  "resources.kgValue": "{{value}} kg",
  "resources.metersValue": "{{value}} m",
  "resources.inspectionKind.apk": "APK",
  "resources.inspectionKind.tachograph": "Tachograaf",
  "resources.colPayload": "Laadvermogen",
  "resources.colMaxMass": "Max. massa",
  "resources.colDriver": "Vaste chauffeur",
  "resources.colEmission": "Milieu",
  "resources.colInspection": "Keuring",
  "resources.bodyCooled": "{{body}}, gekoeld",
  "resources.zoneNotAllowedShort": "Niet in milieuzone",
  "resources.inspectionDue": "{{kind}} {{date}}",
  "resources.inspectionExpired": "{{kind}} verlopen {{date}}",
  "resources.inspectionSoonHint": "Verloopt binnen een maand",
  "resources.inspectionExpiredHint": "Verlopen: niet inzetten voor een rit",
  "resources.rdwTitle": "RDW",
  "tracking.branch": "Vestiging",
  "tracking.allBranches": "Alle vestigingen",
  "tracking.activityLabel": "Activiteit",
  "tracking.allActivities": "Alle activiteiten",
  "tracking.search": "Zoeken",
  "tracking.searchPlaceholder": "Rit, plaats, chauffeur of wagen",
  "tracking.updated": "Bijgewerkt {{time}}",
  "tracking.limits": "Achter vanaf {{behind}} min · onzeker na {{stale}} min zonder positie",
  "tracking.tilesLabel": "Stand van de ritten",
  "tracking.tile.all": "Lopende ritten",
  "tracking.tile.onTime": "Op schema",
  "tracking.tile.behind": "Achter planning",
  "tracking.tile.late": "Verwacht te laat",
  "tracking.tile.uncertain": "Status onzeker",
  "tracking.tileText.all": "Actief op dit moment",
  "tracking.tileText.onTime": "Binnen de planning",
  "tracking.tileText.behind": "Nog binnen het tijdvenster",
  "tracking.tileText.late": "Buiten het tijdvenster",
  "tracking.tileText.uncertain": "Geen recente positie",
  "tracking.tile.reports": "Meldingen chauffeur",
  "tracking.tileText.reports": "Manco, schade, niet volledig",
  "tracking.listTitle": "Lopende ritten",
  "tracking.listText": "Op urgentie: wat de wagen doet en de afwijking apart",
  "tracking.sortLabel": "Volgorde",
  "tracking.sort.urgency": "Urgentie eerst",
  "tracking.sort.departure": "Eerstvolgende aankomst",
  "tracking.sort.number": "Ritnummer",
  "tracking.error": "De ritopvolging kon niet geladen worden.",
  "tracking.colTrip": "Rit / inzet",
  "tracking.colNow": "Nu",
  "tracking.colNext": "Volgende stop",
  "tracking.colArrival": "Aankomst",
  "tracking.colSchedule": "Schema",
  "tracking.none": "Er rijden nu geen ritten.",
  "tracking.noneFiltered": "Geen rit met deze filters.",
  "tracking.ftl": "FTL",
  "tracking.ltl": "LTL",
  "tracking.activity.driving": "Onderweg",
  "tracking.activity.loading": "Laden",
  "tracking.activity.unloading": "Lossen",
  "tracking.activity.waiting": "Wachten",
  "tracking.activity.still": "Stilstand",
  "tracking.activity.returning": "Terug naar huis",
  "tracking.activity.unknown": "Onbekend",
  "tracking.update": "Update {{time}}",
  "tracking.noPosition": "Geen positie",
  "tracking.noNext": "Alle stops gedaan",
  "tracking.progress": "{{done}}/{{total}} stops afgerond",
  "tracking.plan": "plan {{time}}",
  "tracking.until": "tot {{time}}",
  "tracking.onPlan": "Op tijd",
  "tracking.later": "+{{minutes}} min",
  "tracking.earlier": "−{{minutes}} min",
  "tracking.pastWindow": "{{minutes}} min buiten venster",
  "tracking.slack": "{{minutes}} min speling",
  "tracking.takenBy": "In behandeling: {{name}}",
  "tracking.openReport": "Open melding",
  "tracking.driverReports_one": "{{count}} melding chauffeur",
  "tracking.driverReports_other": "{{count}} meldingen chauffeur",
  "tracking.ended": "Rit afgerond",
  "tracking.mapLabel": "Kaart met de wagens",
  "tracking.stageLabel": "Welke ritten",
  "tracking.stage_all": "Alle",
  "tracking.stage_1": "FTL en fabriekspendels",
  "tracking.stage_2": "LTL",
  "tracking.mapPlaceLabel": "Kaart",
  "tracking.mapPlace_off": "Geen kaart",
  "tracking.mapPlace_beside": "Kaart ernaast",
  "tracking.mapPlace_window": "Kaart los",
  "tracking.mapWindowRefused": "De browser hield het kaartvenster tegen. Sta pop-upvensters voor WLX toe en probeer het opnieuw.",
  "tracking.mapWindowTitle": "Ritopvolging · kaart",
  "tracking.mapFollows": "De kaart volgt Ritopvolging; ga je naar het planbord, dan volgt hij dat weer.",
  "tracking.mapChosen": "{{lorry}} · {{trip}}",
  "tracking.mapNoTrip": "geen lopende rit",
  "tracking.mapRelease": "Loslaten",
  "tracking.mapHint": "Klik op een wagen of een stop voor de route van die wagen en wat hij nog moet doen.",
  "tracking.mapLegend": "Stops: donker = gedaan, teal = komt nog · driehoek en vierkant: orders die vandaag laden en nog niet gepland zijn · doorgetrokken: vandaag gereden · gestippeld: het geplande vervolg en naar huis",
  "tracking.mapStops": "Stops tonen",
  "tracking.noRunningTrip": "Deze wagen rijdt nu geen lopende rit. De kaart toont zijn route van vandaag.",
  "tracking.mapSeen": "gezien {{time}}",
  "tracking.detailLabel": "De gekozen rit",
  "tracking.pickTrip": "Kies een rit in de lijst of een wagen op de kaart.",
  "tracking.alertLate": "Verwacht te laat bij {{place}}: aankomst {{eta}}, {{later}} ten opzichte van het plan, {{past}}.",
  "tracking.alertBehind": "Achter op de planning: {{later}} bij de volgende stop, nog binnen het venster.",
  "tracking.alertUncertain": "Geen recente positie (laatste {{time}}): waar de wagen is en wat hij doet, is onzeker.",
  "tracking.nextStop": "Volgende: {{name}} · {{city}}",
  "tracking.planLabel": "Plan",
  "tracking.expectedLabel": "Verwacht",
  "tracking.differenceLabel": "Verschil",
  "tracking.window": "Klantvenster {{from}}–{{to}}",
  "tracking.expectedEnd": "Verwacht terug om {{time}}",
  "tracking.followUp": "Opvolging afwijking",
  "tracking.takenSince": "{{name}} sinds {{time}}",
  "tracking.take": "Neem in behandeling",
  "tracking.release": "Loslaten",
  "tracking.course": "Ritverloop",
  "tracking.now": "Nu {{time}}",
  "tracking.expectedAt": "{{time}} verwacht",
  "tracking.courseKind.load": "Laden",
  "tracking.courseKind.drive": "Rijden",
  "tracking.courseKind.unload": "Lossen",
  "tracking.courseKind.wait": "Wachten",
  "tracking.courseLight": "Licht = verwacht",
  "tracking.tabStops": "Stops · {{count}}",
  "tracking.tabLog": "Logboek",
  "tracking.notePlaceholder": "Interne notitie bij deze rit",
  "tracking.addNote": "Notitie toevoegen",
  "tracking.depot": "Depot",
  "tracking.load": "Laden",
  "tracking.unload": "Lossen",
  "tracking.nextWord": "Volgende",
  "tracking.arrived": "aankomst {{time}}",
  "tracking.expected": "verwacht {{time}}",
  "tracking.departed": "vertrek {{time}}",
  "tracking.windowFrom": "venster vanaf {{time}}",
  "tracking.stopLate": "Verwacht {{minutes}} min na het venster ({{time}})",
  "resources.unavailability.title": "Niet beschikbaar",
  "resources.unavailability.help": "Een periode dat deze wagen of oplegger niet gepland kan worden. Het bord van de planning toont hem, en een wagen neemt een oplegger die er niet is niet mee op een rit.",
  "resources.unavailability.from": "Van",
  "resources.unavailability.to": "Tot",
  "resources.unavailability.reason": "Reden",
  "resources.unavailability.remark": "Opmerking",
  "resources.unavailability.add": "Toevoegen",
  "resources.unavailability.remove": "Weghalen",
  "resources.unavailability.none": "Geen periode gepland.",
  "resources.unavailability.reason_workshop": "Werkplaats",
  "resources.unavailability.reason_damage": "Schade",
  "resources.unavailability.reason_inspection": "Keuring",
  "resources.unavailability.reason_other": "Anders",
  "resources.rdwHelp": "Vergelijk met wat de RDW bij dit kenteken registreert. Je kiest zelf wat je overneemt.",
  "resources.rdwNoPlate": "Zonder kenteken valt er bij de RDW niets op te halen.",
  "resources.rdwUnsaved": "Sla eerst je wijzigingen op; daarna kun je vergelijken met de RDW.",
  "resources.rdwCheckedAt": "Laatst overgenomen uit de RDW op {{date}}.",
  "resources.rdwCompare": "Vergelijken met RDW",
  "resources.rdwCompareAll": "Vergelijken met RDW",
  "resources.rdwAsking": "RDW vragen…",
  "resources.rdwLookup": "Ophalen bij RDW",
  "resources.rdwFound": "Gevonden bij de RDW",
  "resources.rdwNotFound": "De RDW kent kenteken {{plate}} niet: een buitenlands kenteken, of een typfout.",
  "resources.rdwFirstAdmission": "eerste toelating {{date}}",
  "resources.rdwExported": "Volgens de RDW is dit voertuig geëxporteerd.",
  "resources.rdwNothingDifferent": "Alles wat de RDW registreert, staat al zo in WLX.",
  "resources.rdwColTake": "Overnemen",
  "resources.rdwColField": "Veld",
  "resources.rdwColWlx": "In WLX",
  "resources.rdwColRdw": "RDW",
  "resources.rdwColUnit": "Transportmiddel",
  "resources.rdwSame": "Gelijk",
  "resources.rdwTakeField": "{{field}} overnemen",
  "resources.rdwTakeFieldOf": "{{field}} van {{unit}} overnemen",
  "resources.rdwTakeUnit": "Alle verschillen van {{unit}} overnemen",
  "resources.rdwApplyCount_one": "{{count}} veld overnemen",
  "resources.rdwApplyCount_other": "{{count}} velden overnemen",
  "resources.rdwApplied_one": "{{count}} veld overgenomen uit de RDW.",
  "resources.rdwApplied_other": "{{count}} velden overgenomen uit de RDW.",
  "resources.rdwFactPayload": "laadvermogen {{value}}",
  "resources.rdwFactCombination": "treingewicht {{value}}",
  "resources.rdwFactApk": "APK tot {{date}}",
  "resources.rdwFill": "Gegevens van de RDW overnemen",
  "resources.rdwFillHelp": "Merk, type, gewichten, assen, keuringen en maten komen dan uit de RDW.",
  "resources.rdwUnavailable": "De RDW is nu niet bereikbaar. Probeer het zo nog eens.",
  "resources.rdwOff": "Ophalen bij de RDW staat uit.",
  "resources.rdwRetry": "Opnieuw proberen",
  "resources.rdwOverviewIntro":
    "Alle actieve transportmiddelen naast wat de RDW bij hun kenteken registreert. Wat verschilt, staat aangevinkt; alleen wat aangevinkt blijft, neem je over.",
  "resources.rdwSummary":
    "{{found}} gevonden bij de RDW · {{withDifferences}} met verschillen · {{notFound}} niet gevonden · {{noPlate}} zonder kenteken",
  "resources.rdwSelectAll": "Alle verschillen aanvinken",
  "resources.rdwSelectNone": "Niets aanvinken",
  "resources.rdwApplySelection": "Overnemen: {{fields}} velden bij {{units}} transportmiddelen",
  "resources.rdwAppliedUnits_one": "Overgenomen bij {{count}} transportmiddel.",
  "resources.rdwAppliedUnits_other": "Overgenomen bij {{count}} transportmiddelen.",
  "resources.rdwNoDifferences": "Geen verschillen: wat de RDW registreert, staat al zo in WLX.",
  "resources.rdwDifferences_one": "{{count}} verschil",
  "resources.rdwDifferences_other": "{{count}} verschillen",
  "resources.rdwSameUnits_one": "{{count}} transportmiddel staat al gelijk aan de RDW.",
  "resources.rdwSameUnits_other": "{{count}} transportmiddelen staan al gelijk aan de RDW.",
  "resources.rdwNotFoundList": "Niet gevonden bij de RDW ({{count}}):",
  "resources.rdwNoPlateList": "Zonder kenteken ({{count}}):",
  "resources.featuresNone": "Geen bijzondere uitrusting.",
  "resources.rosterHelp": "Uit AFAS, alleen lezen. Met een dienst is de chauffeur die dag de hele dag beschikbaar voor de planning.",
  "resources.rosterUnknown": "AFAS kent deze chauffeur niet: er is geen dienstrooster.",
  "resources.rosterState_shift": "Dienst",
  "resources.rosterState_noShift": "Geen dienst",
  "resources.rosterState_ill": "Ziek",
  "resources.rosterState_leave": "Verlof",
  "resources.rosterState_away": "Afwezig",
  "resources.rosterState_unknown": "—",
  "resources.branchLabel": "Standplaats",
  "resources.branchNone": "Geen standplaats",
  "resources.branchSelfEmployedHelp": "Een zzp'er heeft geen standplaats: hij staat op het planbord van elke vestiging.",
  "resources.branchHelpVehicle": "De vestiging waar de wagen staat. Die kies je hier; WLX leidt hem niet meer af.",
  "resources.choiceOnVehicle": "nu op {{codes}}",
  "resources.weekdayNoteBy": "{{name}}, {{when}}",
  "resources.restriction.title": "Bijzonderheden",
  "resources.restriction.help":
    "Wat de chauffeur op een dag niet kan, naast zijn rooster uit AFAS: elke week, even of oneven weken, of eenmalig. De planning ziet het in Capaciteit en krijgt een waarschuwing als een rit ertegenin gaat. Geen gezondheidsredenen: ziek en verlof komen uit AFAS.",
  "resources.restriction.none": "Geen bijzonderheden.",
  "resources.restriction.new": "Nieuwe bijzonderheid",
  "resources.restriction.add": "+ Bijzonderheid",
  "resources.restriction.remove": "Weghalen",
  "resources.restriction.repeat": "Wanneer",
  "resources.restriction.repeat_weekly": "Elke week",
  "resources.restriction.repeat_even_weeks": "Even weken",
  "resources.restriction.repeat_odd_weeks": "Oneven weken",
  "resources.restriction.repeat_once": "Eenmalig",
  "resources.restriction.days": "Dagen",
  "resources.restriction.from": "Vanaf",
  "resources.restriction.onDay": "Op",
  "resources.restriction.untilOptional": "Tot (mag leeg)",
  "resources.restriction.untilDay": "Tot en met (mag leeg)",
  "resources.restriction.kind": "Wat",
  "resources.restriction.kind_home_by": "Thuis om",
  "resources.restriction.kind_start_after": "Begint niet vóór",
  "resources.restriction.kind_whole_day": "Hele dag niet",
  "resources.restriction.kind_note": "Opmerking",
  "resources.restriction.time": "Tijd",
  "resources.restriction.why": "Waarom (geen gezondheid)",
  "resources.restriction.when_weekly": "elke {{days}}",
  "resources.restriction.when_even_weeks": "even weken: {{days}}",
  "resources.restriction.when_odd_weeks": "oneven weken: {{days}}",
  "resources.restriction.onceSpan": "{{from}} t/m {{to}}",
  "resources.restriction.until": "tot {{date}}",
  "resources.driverOneVehicleHelp": "Een chauffeur is de vaste van één wagen. Kies je er een die al op een andere wagen staat, dan gaat hij daar af.",
  "resources.trailerOneVehicleHelp": "Een trailer is de vaste van één wagen. Kies je er een die al bij een andere wagen hoort, dan gaat hij daar af.",
  "resources.activeHelp": "Een inactief transportmiddel blijft bewaard, maar kies je niet meer voor een rit.",
  "resources.kind.tractor": "Trekker",
  "resources.kind.rigid": "Bakwagen",
  "resources.kind.van": "Bus",
  "resources.kind.shunter": "Rangeertrekker",
  "resources.kind.other": "Overig",
  "resources.subType.semi": "Oplegger",
  "resources.subType.drawbar": "Aanhangwagen",
  "resources.body.box": "Kast",
  "resources.body.curtain": "Huif",
  "resources.body.tautliner": "Taut",
  "resources.tailLift.none": "Geen",
  "resources.tailLift.rear": "Achterklep",
  "resources.tailLift.under": "Onderklep",
  "resources.employment.permanent": "Vast",
  "resources.employment.on_call": "Oproep",
  "resources.employment.agency": "Inlener",
  "resources.employment.self_employed": "Zzp'er",
  "resources.feature.steering_axle": "Gestuurde as",
  "resources.feature.sliding_roof": "Schuifdak",
  "resources.feature.roller_door": "Roldeur",
  "resources.feature.adr_equipment": "ADR-uitrusting",
  "resources.feature.truck_mounted_forklift": "Kooiaap",
  "resources.feature.extra_support_legs": "Extra steunpoten",
  "resources.feature.cargo_bars": "Stuwbalken",
  "resources.feature.shoring_planks": "Spanplanken",
  "resources.feature.shoring_props": "Stempels",
  "resources.qualification.adr": "ADR",
  "resources.qualification.vca": "VCA",
  "resources.qualification.truck_mounted_forklift": "Kooiaap",
  "resources.qualification.fc_training": "Opgeleid FC",
  "resources.day1": "ma",
  "resources.day2": "di",
  "resources.day3": "wo",
  "resources.day4": "do",
  "resources.day5": "vr",
  "resources.day6": "za",
  "resources.day7": "zo",
  "orders.temperatureMinLabel": "Temperatuur van (°C)",
  "orders.temperatureMaxLabel": "tot (°C)",
  "orders.adrLabel": "ADR (gevaarlijke stoffen)",
  "orders.forkliftLabel": "Kooiaap (meeneemheftruck)",
  "orders.consignmentReferenceLabel": "Referentie van de zending",
  "orders.remarkLabel": "Opmerking op de vrachtbrief",
  "orders.activitiesTitle": "Activiteiten",
  "orders.activitiesHelp": "Eerst laden, als laatste lossen, in volgorde. Tijden typ je zoals je praat: 8 wordt 08:00.",
  "orders.activityTypeLabel": "Activiteit",
  "orders.activityPlaceLabel": "Plaats",
  "orders.activityPlaceNameLabel": "Naam van de plek",
  "orders.activityDateLabel": "Datum",
  "orders.pickDate": "Kies een datum in de kalender",
  "orders.activityFromLabel": "Van",
  "orders.activityToLabel": "Tot",
  "orders.activityInstructionLabel": "Instructie",
  "orders.contactLabel": "Contact",
  "orders.contactNameLabel": "Contactpersoon",
  "orders.contactPhoneLabel": "Telefoon",
  "orders.arrivalPopupLabel": "Pop-up bij aankomst",
  "orders.activityRemove": "Weghalen",
  "orders.activityAdd": "Activiteit toevoegen",
  "orders.placeSearchPlaceholder": "Zoek een locatie: naam, code, plaats, postcode…",
  "orders.placeNothingFound": "Geen locatie gevonden.",
  "orders.placeGiveAddress": "Adres opgeven dat geen bekende locatie is",
  "orders.placeChange": "Andere plaats",
  "orders.placeFromBook": "Toch een bekende locatie",
  "orders.givenAddressTitle": "Adres zoals opgegeven",
  "orders.placeNameLabel": "Naam",
  "orders.dayOpen": "{{date}}: open {{hours}}",
  "orders.dayClosed": "{{date}}: gesloten",
  "common.and": "en",
  "orders.fromMessageCustomerNote": "De relatie kies je zelf in stap 1 — een naam in een mail is nog geen klant.",
  "orders.tabDrafts": "Concepten",
  // Transport → Orders → Aanmelden (docs/tms-aanmelden.md)
  "preNotify.tab": "Aanmelden",
  "preNotify.kindSlot": "Tijdslot",
  "preNotify.kindTrip": "Rit",
  "preNotify.load": "Laden",
  "preNotify.unload": "Lossen",
  "preNotify.colKind": "Soort",
  "preNotify.colDate": "Datum en venster",
  "preNotify.colPlace": "Plaats",
  "preNotify.colHow": "Aanmelden via",
  "preNotify.colTrip": "Rit",
  "preNotify.colPallets": "Pallets",
  "preNotify.colAction": "Aangemeld",
  "preNotify.openLink": "Portaal van de plaats",
  "preNotify.noPlate": "Wagen zonder kenteken; de plaats vraagt erom",
  "preNotify.plateRequired": "Kenteken verplicht",
  "preNotify.etaRequired": "ETA verplicht",
  "preNotify.mark": "Zet op aangemeld",
  "preNotify.waiting": "Nog aanmelden",
  "preNotify.count": "{{slots}} tijdslot(en) te boeken · {{trips}} rit(ten) aan te melden",
  "preNotify.none": "Er wacht niets op aanmelden.",
  "preNotify.markTitle": "Aangemeld bij {{place}}",
  "preNotify.markHelp": "{{order}}, gevraagd op {{date}} tussen {{from}} en {{to}}. Vul het tijdslot in als de plaats er een gaf: dan plant WLX op het tijdslot. De prijs blijft uitgaan van wat de klant vroeg.",
  "preNotify.slotDate": "Datum",
  "preNotify.slotFrom": "Tijdslot van",
  "preNotify.slotTo": "tot",
  "preNotify.slotHelp": "Geen tijdslot? Laat de tijden leeg.",
  "preNotify.note": "Referentie of afspraak",
  "preNotify.notePlaceholder": "Bijvoorbeeld het boekingsnummer",
  "preNotify.slotIncomplete": "Een tijdslot heeft een datum, een begin en een eind.",
  "preNotify.slotBackwards": "Het tijdslot eindigt na het begin.",
  "preNotify.markSubmit": "Aangemeld",
  "preNotify.stopDone": "Aangemeld",
  "preNotify.stopSlot": "Aangemeld, tijdslot {{from}}–{{to}}",
  "preNotify.stopRequested": "Gevraagd door de klant: {{date}} {{from}}–{{to}}",
  "preNotify.stopMailed": "Rit aangemeld per mail, {{when}}",
  "preNotify.stopMailLater": "Rit wordt per mail aangemeld als de rit vaststaat",
  "preNotify.stopTodoSlot": "Tijdslot nog boeken",
  "preNotify.stopTodoTrip": "Rit nog aanmelden",
  "preNotify.stopTodoHelp": "Boek het bij de plaats en zet het op Aangemeld onder Transport → Orders → Aanmelden.",
  "preNotify.undo": "Ongedaan maken",
  "preNotify.colReference": "Referentie",
  "preNotify.logMarked": "Aangemeld bij de plaats",
  "preNotify.logCleared": "Aanmelding ongedaan gemaakt",
  "preNotify.logTripMailed": "Rit aangemeld bij de plaats, per mail",
  "preNotify.logSlot": "Tijdslot {{date}} {{from}}–{{to}}",
  "preNotify.logTripChanged": "Gewijzigde aanmelding: andere dag, wagen of trailer",
  "orders.draftRoute": "Route",
  "orders.draftChanged": "Laatst gewijzigd",
  "orders.draftDiscard": "Weggooien",
  "orders.draftNoCustomer": "Nog geen klant gekozen",
  "orders.draftsEmpty": "Je hebt geen concepten liggen. Wat je halverwege opslaat, komt hier te staan — alleen voor jou.",
  "orders.makeLocationFromAddress": "Aanmaken uit dit adres",
  // ── The order entry in four steps, and taking an order over from a message
  "orders.stepsLabel": "Stappen",
  "orders.stepCustomer": "Klant & opdracht",
  "orders.stepShipment": "Lading & stops",
  "orders.stepStops": "Stops & tijden",
  "orders.stepCheck": "Controle & aanmaken",
  "orders.stepNext": "Volgende: {{step}}",
  "orders.stepPrevious": "Vorige",
  "orders.whoOrders": "Wie geeft de opdracht",
  "orders.howFixed": "Hoe hard zit het vast",
  "orders.windowLabel": "Venster",
  "orders.windowAllDay": "hele dag",
  "orders.windowFromOnly": "vanaf {{time}}",
  "orders.windowToOnly": "tot {{time}}",
  "orders.windowToNextDay": "{{from}}–{{to}} (+1 dag)",
  "orders.windowNextDay": "tot de volgende dag",
  "orders.windowEndsBeforeStart": "Eindigt vóór het begin",
  "orders.cityLabel": "Plaats",
  "orders.swapActivity": "Omwisselen",
  "orders.addStop": "Stop toevoegen",
  "orders.oneLoadOneUnload": "Eén keer laden, één keer lossen. Naar nog een adres? Voeg een zending toe; die laadt waar deze laadt.",
  "orders.solveDuringEntry": "Kies hierboven een bekende locatie, of maak er nu een van dit adres.",
  "orders.saveDraft": "Opslaan als concept",
  "orders.draftSavedAt": "Concept bewaard {{time}}",
  "orders.draftGone": "Dit concept bestaat niet meer. Je begint met een lege order.",
  "orders.orderInProgress": "Order in opbouw",
  "orders.checkTitle": "Controle",
  "orders.checkLive": "loopt mee tijdens het typen",
  "orders.checkNothingYet": "nog niets gecontroleerd",
  "orders.checkNothingFound": "geen blokkades",
  "orders.blockCount_one": "1 blokkade",
  "orders.blockCount_other": "{{count}} blokkades",
  "orders.noteCount_one": "1 opmerking",
  "orders.noteCount_other": "{{count}} opmerkingen",
  "orders.checkAllGood": "Geen blokkades. Deze order is meteen geaccepteerd en planbaar.",
  "orders.checkBlockedTitle_one": "1 blokkade — deze order komt in de werkbak",
  "orders.checkBlockedTitle_other": "{{count}} blokkades — deze order komt in de werkbak",
  "orders.checkBlockedHelp": "Los ze op in de stap waar ze horen, dan is de order meteen planbaar. Maak je hem toch aan, dan wacht hij in de werkbak.",
  "orders.checkNoteTitle_one": "1 opmerking — reist mee, blokkeert niet",
  "orders.checkNoteTitle_other": "{{count}} opmerkingen — reizen mee, blokkeren niet",
  "orders.checkPreviewTitle": "Zo komt de order eruit te zien",
  "orders.footClean": "Aanmaken kan; deze order is meteen planbaar.",
  "orders.footBlocked": "{{what}}. Oplossen kan hier meteen.",
  "orders.footNotes_one": "1 opmerking. Aanmaken kan gewoon; hij reist mee.",
  "orders.footNotes_other": "{{count}} opmerkingen. Aanmaken kan gewoon; ze reizen mee.",
  "orders.planFeasibility": "Planbaarheid",
  "orders.planFeasibilityHelp": "Welke wagens vrij zijn komt met het planbord.",
  "orders.fromMessageTitle": "Order uit een bericht",
  "orders.fromMessageIntro":
    "Plak de mail van de klant. WLX leest eruit wat het herkent en jij kijkt het na. Het kanaal wordt mail in plaats van handmatig.",
  "orders.fromMessagePrompt": "Heb je de mail van de klant?",
  "orders.fromMessageHint": "Plak hem hier en WLX vult de stappen alvast in.",
  "orders.fromMessageOpen": "Uit bericht overnemen",
  "orders.fromMessageSource": "Bron",
  "orders.fromMessageFrom": "Afzender",
  "orders.fromMessageFromPlaceholder": "Bijv. planning@klant.nl",
  "orders.fromMessagePlaceholder": "Plak hier de mail van de klant.",
  "orders.fromMessageReadAgain": "Opnieuw uitlezen",
  "orders.fromMessageResult": "Wat WLX eruit haalde",
  "orders.fromMessageCounts": "{{sure}} van {{total}} velden zeker · {{check}} om na te lopen",
  "orders.fromMessageNothingYet": "Plak een bericht; wat WLX herkent verschijnt hier.",
  "orders.fromMessageFooter": "Na overnemen open je de invoer met alles ingevuld. Elk veld blijft bewerkbaar.",
  "orders.fromMessageApply": "Overnemen in nieuwe order",
  "orders.confidenceSure": "Zeker",
  "orders.confidenceCheck": "Nalopen",
  "orders.confidenceGuess": "Aanname",
  "orders.confidenceMissing": "Niet gevonden",
  // ── The order card, rebuilt around the consignment (handoff 18-09-2026)
  "orders.tabConsignment": "Zending",
  "orders.tabConsignments": "Zendingen",
  "orders.tabGoods": "Lading",
  "orders.tabPallets": "Pallets",
  "orders.tabTariff": "Tarief",
  "orders.tariffPriced": "Geprijsd",
  "orders.tariffReview": "Nakijken",
  "orders.tariffNoPrice": "Geen tarief",
  "orders.tariffCancelled": "Vervallen",
  "orders.tariffCounted": "Opgeteld",
  "orders.tariffGroupCarries": "Opgeteld op rit {{trip}} met {{others}}: deze zending draagt de te factureren laadmeters, het gewicht en de pallets van allemaal.",
  "orders.tariffGroupCounted": "Opgeteld bij {{carrier}} op rit {{trip}}: die draagt de te factureren laadmeters, het gewicht en de pallets van de groep.",
  "orders.tariffNotYet": "Nog niet geprijsd.",
  "orders.tariffNoteNoAccount": "De klant is geen verkooprelatie: er is geen debiteur om het tarief van te nemen.",
  "orders.tariffNoteNoAgreement": "Deze klant heeft geen prijsafspraak voor deze dag.",
  "orders.tariffNoteNothingApplies": "Geen regel van de factuurmethode past bij deze zending.",
  "orders.tariffNoteLineUndecided": "Regel \"{{line}}\": niet te beslissen of hij geldt — een voorwaarde die WLX (nog) niet kan lezen, of openingstijden die onbekend zijn.",
  "orders.tariffNoteLineNeedsReview": "Regel \"{{line}}\" staat op nakijken: iemand kijkt hem na in de prijsafspraak.",
  "orders.tariffNoteLineNoPrice": "Regel \"{{line}}\": het tarief heeft hier geen prijs.",
  "orders.tariffNoteBeyondRows": "Regel \"{{line}}\": {{quantity}} valt boven de laatste grens van het tarief (t/m {{last}}). Pas het tarief aan of zet een prijs met de hand.",
  "orders.tariffNoteBeyondColumns": "Regel \"{{line}}\": rayon {{quantity}} valt buiten de matrix van het tarief (t/m {{last}}).",
  "orders.tabPrices": "Prijs akkoord",
  "orders.tariffAwaitingApproval": "Wacht op akkoord",
  "orders.tariffByHand": "Met de hand",
  "orders.tariffByAgreement": "Prijsafspraak",
  "orders.priceByHand": "Prijs met de hand",
  "orders.priceByHandHint": "Is er voor dit traject of deze klant geen afspraak? Zet een prijs met de hand; de planning keurt hem goed.",
  "orders.priceDescription": "Omschrijving",
  "orders.priceAmount": "Bedrag",
  "orders.priceSurcharges": "Toeslagen",
  "orders.priceWithSurcharges": "Plus toeslagen",
  "orders.priceAllIn": "Alles-in",
  "orders.priceSource": "Waar komt de prijs vandaan",
  "orders.priceSourceNoAgreement": "Geen afspraak voor dit traject of deze klant",
  "orders.priceSourceTransportOrder": "Uit de transportopdracht",
  "orders.priceSourcePlanner": "Op aanwijzing van de planner",
  "orders.priceNote": "Toelichting",
  "orders.priceNotePlaceholder": "Bijvoorbeeld: met de klant afgesproken per telefoon",
  "orders.priceSave": "Prijs opslaan",
  "orders.priceWaitsHint": "De prijs komt in plaats van wat de afspraak rekent, en wacht op akkoord van de planning.",
  "orders.priceNoneByHand": "Geen prijs met de hand",
  "orders.entryTariffWaiting": "Wat de afspraak rekent, staat hier zodra de klant en alle stops zijn ingevuld.",
  "orders.priceIncomplete": "Vul bij de prijs met de hand een omschrijving en een bedrag in, of haal hem weg.",
  "orders.priceDefaultDescription": "Transport {{route}}",
  "orders.priceByHandLine": "Prijs met de hand: {{amount}}, {{surcharges}}",
  "orders.priceSetBy": "gezet door {{name}} op {{when}}",
  "orders.priceApprovedBy": "Akkoord van {{name}} op {{when}}.",
  "orders.priceAwaits": "Wacht op akkoord van de planning. Tot dan gaat de zending niet op een factuur.",
  "orders.priceAwaitsOther": "Wacht op akkoord van de planning. Een prijs die je zelf zette, keurt een ander goed.",
  "orders.priceApprove": "Akkoord",
  "orders.priceChange": "Wijzigen",
  "orders.priceRemove": "Weghalen",
  "orders.priceErrorOwn": "Een prijs die je zelf zette, keurt een ander goed.",
  "orders.priceErrorChanged": "De prijs is intussen gewijzigd. Bekijk hem opnieuw en geef dan akkoord.",
  "orders.priceErrorInvoiced": "Deze zending staat op een definitieve factuur: een wijziging gaat met een creditfactuur.",
  "orders.priceErrorClosed": "De order is geannuleerd of afgewezen.",
  "orders.priceColUnloadDate": "Losdatum",
  "orders.priceColTotal": "Met toeslagen",
  "orders.priceColSetBy": "Gezet door",
  "orders.priceColSetAt": "Gezet op",
  "orders.priceColApproval": "Akkoord",
  "orders.priceStateWaiting": "Wacht op akkoord",
  "orders.priceStateWaitingOther": "Wacht op een ander",
  "orders.priceStateApproved": "Goedgekeurd",
  "orders.pricesCount_one": "1 prijs wacht op akkoord",
  "orders.pricesCount_other": "{{count}} prijzen wachten op akkoord",
  "orders.pricesCountAll_one": "1 prijs met de hand",
  "orders.pricesCountAll_other": "{{count}} prijzen met de hand",
  "orders.pricesAlsoApproved": "Ook goedgekeurde",
  "orders.pricesNone": "Er wacht geen prijs op akkoord.",
  "orders.pricesNoneAll": "Er is nog geen prijs met de hand gezet.",
  "orders.logPriceSet": "Prijs met de hand gezet",
  "orders.logPriceChanged": "Prijs met de hand gewijzigd",
  "orders.logPriceApproved": "Prijs met de hand goedgekeurd",
  "orders.logPriceRemoved": "Prijs met de hand weggehaald",
  "orders.logPalletsChanged": "Pallets gewijzigd",
  "orders.logPalletsChecked": "Pallets gecontroleerd",
  "orders.logPalletsReopened": "Palletcontrole opnieuw geopend",
  "orders.logCustomerMail": "Mail aan de klant",
  "orders.logPackingSlipAdded": "Pakbon toegevoegd in het portaal",
  "orders.logRepeated": "Herhaald",
  "orders.logRepeatedLine": "{{count}} order gemaakt: {{orders}}",
  "orders.logRepeatedLine_other": "{{count}} orders gemaakt: {{orders}}",
  "orders.logRepeatedProvisional": "{{count}} voorlopige order gemaakt: {{orders}}",
  "orders.logRepeatedProvisional_other": "{{count}} voorlopige orders gemaakt: {{orders}}",
  "orders.logReplacedProvisional": "Voorlopige order vervangen",
  "orders.logReplacedProvisionalLine": "In de plaats van {{order}}",
  "orders.logTookPlaceOnTrips": "Zijn plek ingenomen op rit {{trips}}",
  "orders.logTookPlaceOnTrips_other": "Zijn plek ingenomen op de ritten {{trips}}",
  "orders.logReplacedByLine": "Vervangen door {{order}}, die zijn plek op de rit innam",
  "orders.logReplacedByItself": "Vanzelf, toen de order van de klant binnenkwam",
  "orders.logProvisionalDismissed": "Vervangt geen voorlopige order",
  "orders.logFromList": "Bijgewerkt uit een lijst van de klant",
  "orders.logPackingSlipLine": "Zending {{consignment}}: {{name}}",
  "orders.logPackingSlipReprint": "Was de rit al geprint, dan zit hij er niet bij: opnieuw printen neemt hem mee",
  "orders.logCustomerMailConfirmation": "Orderbevestiging",
  "orders.logCustomerMailDelivered": "Gereedmelding",
  "orders.logCustomerMailPlanned": "Ingeplande zendingen van de dag",
  "orders.logCustomerMailEmballage": "Emballage onvolledig retour (avondmail)",
  "orders.logCustomerMailPreAdvice": "Vooraanmelding pallets aan de losplaats",
  "orders.logCustomerMailTo": "Aan {{to}}",
  "orders.logPriceAwaits": "Wacht op akkoord van de planning",
  "orders.logPriceStillApproved": "Zelfde prijs: blijft goedgekeurd",
  "orders.tariffNoteQuantityUnknown": "Regel \"{{line}}\": WLX weet de hoeveelheid ({{quantity}}) nog niet.",
  "orders.tariffNoteNoDate": "Regel \"{{line}}\": de zending heeft geen datum om de tariefperiode te kiezen.",
  "orders.tariffNoteSurchargeWithoutRate": "Toeslag \"{{surcharge}}\" heeft geen percentage op {{date}}.",
  "orders.tariffNotInvoiced": "Niet factureren",
  "orders.tariffNoteWaitingNotPriced": "{{quantity}} wachturen, maar de prijsafspraak heeft geen wachturen. Zet ze in de afspraak, geef een prijs met de hand of haal de wachturen weg.",
  "orders.tariffNoteViaWarehouse": "Niet factureren: het transport van deze klant staat op de factuur van de warehouseweek.",
  "orders.setByWhen": "Gezet door {{name}} op {{when}}.",
  "orders.waitingAdd": "Wachturen",
  "orders.waitingHours": "Wachturen",
  "orders.waitingNote": "Toelichting",
  "orders.waitingNotePlaceholder": "Bijv. 1,5 uur gewacht bij het lossen",
  "orders.waitingSave": "Opslaan",
  "orders.waitingHint": "Gerekend met de wachturen uit de prijsafspraak.",
  "orders.waitingLine": "Wachturen: {{hours}} uur",
  "orders.waitingChange": "Wijzigen",
  "orders.waitingRemove": "Weghalen",
  "orders.noInvoiceAdd": "Niet factureren",
  "orders.noInvoiceLine": "Niet factureren: {{reason}}",
  "orders.noInvoiceReason": "Reden",
  "orders.noInvoiceReasonPlaceholder": "Bijv. opnieuw geleverd na een weigering",
  "orders.noInvoiceSave": "Niet factureren",
  "orders.noInvoiceHint": "De zending komt op geen factuur en niet onder Niet te factureren.",
  "orders.noInvoiceUndo": "Toch factureren",
  "orders.logWaitingSet": "Wachturen gezet",
  "orders.logWaitingChanged": "Wachturen gewijzigd",
  "orders.logWaitingRemoved": "Wachturen weggehaald",
  "orders.logNoInvoiceSet": "Niet factureren",
  "orders.logNoInvoiceRemoved": "Toch factureren",
  "orders.logNoCmrReturnSet": "Geen CMR retour",
  "orders.logNoCmrReturnRemoved": "Toch een CMR retour",
  "orders.signedCmr": "Getekende CMR",
  "orders.signedCmrState.signed": "binnen",
  "orders.signedCmrState.waiting": "nog niet binnen",
  "orders.signedCmrState.none": "komt niet terug",
  "orders.logWaitingHours": "{{hours}} uur",
  "orders.tariffNoteOther": "Aantekening: {{code}}",
  "orders.tariffColDescription": "Omschrijving",
  "orders.tariffColQuantity": "Hoeveelheid",
  "orders.tariffColPrice": "Prijs",
  "orders.tariffColAmount": "Bedrag",
  "orders.tariffPricePer": "{{price}} per {{per}}",
  "orders.tariffTotal": "Totaal exclusief btw",
  "orders.tariffCalculatedAt": "Berekend op {{when}}; WLX rekent opnieuw zodra de order of de planning verandert.",
  "orders.tabParties": "Partijen",
  "orders.tabDocuments": "Documenten",
  "orders.tabLog": "Logboek",
  "orders.consignmentOfTotal": "Zending {{index}} van {{total}}",
  "orders.consignmentCount_one": "1 zending",
  "orders.consignmentCount_other": "{{count}} zendingen",
  "orders.stopCount_one": "1 stop",
  "orders.stopCount_other": "{{count}} stops",
  "orders.stopNumber": "Stop {{number}}",
  "orders.now": "Nu",
  "orders.nextHandling": "Eerstvolgende handeling",
  "orders.goodsTogether": "Lading samen",
  "orders.trip": "Rit",
  "orders.trips": "Ritten",
  "orders.tripNotPlanned": "Nog niet gepland",
  "orders.tripsWaiting_one": "nog {{count}} te plannen",
  "orders.tripsWaiting_other": "nog {{count}} te plannen",
  "orders.calledOffAt": "op {{when}}",
  "orders.addressLabel": "Adres",
  "orders.distanceLabel": "Afstand en rijtijd",
  "orders.viaDepotLabel": "Via een depot",
  "orders.openingHoursOn": "open {{day}} {{hours}}",
  "orders.openingHoursUnknown": "openingstijden onbekend",
  "orders.stateExpected": "Verwacht",
  "orders.stateBlockedStop": "Geblokkeerd",
  "orders.palletsShort_one": "1 pal",
  "orders.palletsShort_other": "{{count}} pal",
  "orders.referenceShort": "Factuurref.",
  "orders.referenceAdd": "+ Factuurreferentie",
  "orders.referenceChange": "Factuurreferentie wijzigen",
  "orders.referenceSave": "Opslaan",
  "orders.referenceLockedEdi": "Komt van de klant via EDI: wijzigingen van de klant vinden de order op deze referentie, dus die blijft staan.",
  "orders.referenceLockedInvoiced": "Staat op een definitieve factuur. Crediteer die eerst om de factuurreferentie te wijzigen.",
  "orders.customerPhone": "Telefoon",
  "orders.customerPhoneUnknown": "Geen telefoonnummer bij deze relatie",
  "orders.changePriority": "Prioriteit wijzigen",
  "orders.railFindings": "Wat er nu op staat",
  "orders.cardAllGood": "Geen blokkades. Deze order is planbaar.",
  "orders.cardNoBlockers": "Geen blokkades. De opmerkingen hieronder reizen mee.",
  "orders.cardCancelled": "Geannuleerd. Deze order wordt niet meer gepland.",
  "orders.cardRejected": "Afgewezen. Deze order wordt niet gepland.",
  "orders.checkBlocks": "Blokkeert",
  "orders.checkNote": "Opmerking",
  "orders.noteTravelsAlong": "Reist mee met de order, blokkeert niet.",
  "orders.solveNowHint": "Los je dit nu op, dan is de order meteen planbaar.",
  "orders.documents": "Documenten",
  "orders.documentsCount_one": "Eén document in het dossier",
  "orders.documentsCount_other": "{{count}} documenten in het dossier",
  "orders.documentsAdd": "Mail of document toevoegen",
  "orders.documentsOpen": "Naar de documenten",
  "orders.lastEvent": "Laatste gebeurtenis",
  "orders.wholeLog": "Heel het logboek",
  "orderNotes.commentsTitle": "Opmerkingen",
  "orderNotes.commentsEmpty": "Nog geen opmerkingen.",
  "orderNotes.commentsAll_one": "Alle opmerkingen",
  "orderNotes.commentsAll_other": "Alle {{count}} opmerkingen",
  "orderNotes.commentsFewer": "Minder tonen",
  "orderNotes.commentPlaceholder": "Schrijf een opmerking… @ vraagt een collega",
  "orderNotes.commentLabel": "Opmerking bij de order",
  "orderNotes.commentPlace": "Plaatsen",
  "orderNotes.commentHint": "of Ctrl+Enter",
  "orderNotes.error": "Dat lukte niet. Probeer het opnieuw.",
  "orderNotes.withdraw": "Intrekken",
  "orderNotes.withdrawAsk": "Opmerking intrekken? Het logboek houdt hem.",
  "orderNotes.withdrawYes": "Ja, intrekken",
  "orderNotes.askedOf": "Gevraagd aan {{names}}",
  "orderNotes.tasksTitle": "Taken",
  "orderNotes.taskNew": "Taak",
  "orderNotes.tasksNone": "Geen open taken.",
  "orderNotes.tasksClosedShow_one": "1 afgerond of geannuleerd",
  "orderNotes.tasksClosedShow_other": "{{count}} afgerond of geannuleerd",
  "orderNotes.tasksClosedHide_one": "Afgeronde verbergen",
  "orderNotes.tasksClosedHide_other": "Afgeronde verbergen",
  "orderNotes.taskClosedToYou": "Een taak van een postvak waar je geen lid van bent",
  "orderNotes.taskDue": "voor {{date}}",
  "orderNotes.logCommentAdded": "Opmerking",
  "orderNotes.logCommentWithdrawn": "Opmerking ingetrokken",
  "orderNotes.logWithImage": "Met een afbeelding",
  "orderNotes.logTaskCreated": "Taak aangemaakt",
  "orderNotes.logTaskAssigned": "Taak doorgezet",
  "orderNotes.logTaskDone": "Taak afgerond",
  "orderNotes.logTaskCancelled": "Taak geannuleerd",
  "orderNotes.logTaskReopened": "Taak heropend",
  "orderNotes.logTaskLinked": "Taak gekoppeld",
  "orderNotes.logTaskUnlinked": "Taak losgekoppeld",
  "orderNotes.logTaskFor": "Voor {{name}}",
  "orderNotes.logTaskMailbox": "Postvak {{name}}",
  "orderNotes.logTaskReview": "Terug bij de maker ter controle",
  "orderNotes.colTasks": "Taken",
  "orderNotes.taskStateOpen": "Open taak",
  "orderNotes.taskStateDone": "Afgerond",
  "orderNotes.tasksOpenCount_one": "1 open",
  "orderNotes.tasksOpenCount_other": "{{count}} open",
  "orders.toPlanboard": "Naar het planbord",
  // A place that is designed but has nothing behind it yet: the chip says so, and no
  // value is invented beside it (handoff §10).
  "orders.future": "Toekomst",
  "orders.futureValue": "nog niet beschikbaar",
  "orders.previewCount_one": "{{count}} afwijking gevonden",
  "orders.previewCount_other": "{{count}} afwijkingen gevonden",
  "orders.previewNone": "Geen afwijkingen",
  "orders.previewBlocked_one": "1 blokkade: deze order komt in de werkbak",
  "orders.previewBlocked_other": "{{count}} blokkades: deze order komt in de werkbak",
  "orders.previewWaiting": "De controle volgt zodra elke activiteit een plaats, een datum en tijden heeft.",
  "orders.create": "Order aanmaken",
  "orders.gapCustomer": "Kies een klant.",
  "orders.gapReference": "Vul de factuurreferentie in.",
  "orders.gapReferenceTaken": "Deze factuurreferentie staat al op {{order}} van deze klant. Een factuurreferentie komt per klant één keer voor.",
  "orders.gapReferenceTakenOpen": "Order bekijken",
  "orders.gapGoods": "Vul de laadmeters in. Pallets, gewicht en een omschrijving mogen erbij, maar zijn niet verplicht.",
  "orders.gapGoodsHere": "Nog nodig: de laadmeters.",
  "orders.stopMissing": "Nog nodig: {{what}}",
  "orders.stopMissingPlace": "plaats",
  "orders.stopMissingDate": "datum",
  "orders.stopMissingWindow": "een tijd die klopt",
  "orders.errorReferenceTaken": "Deze factuurreferentie staat al op een order van deze klant.",
  "orders.findingGoTo": "Naar {{step}}",
  "orders.leaveTitle": "Concept opslaan?",
  "orders.leaveBody": "Je bent een order aan het invoeren. Bewaar hem als concept, dan maak je hem later af vanuit Orders → Concepten.",
  "orders.leaveDiscard": "Niet opslaan",
  "orders.leaveStay": "Verder met invoeren",
  "orders.legDepot": "Depot",
  "orders.legDepotFollows": "volgt uit de wagen",
  "orders.legNotPlanned": "Nog niet gepland",
  "orders.errorNoCustomer": "Kies eerst een klant.",
  "orders.errorIncompleteActivities": "Geef elke activiteit een plaats, een datum en een begin- en eindtijd.",
  "orders.errorUnloadBeforeLoad": "De losdatum ligt vóór de laaddatum. Een zending wordt eerst geladen en dan gelost.",
  "orders.errorWindowReversed": "Een venster eindigt vóór het begint. Pas de tijd aan, of vink ‘tot de volgende dag’ aan als het een nachtvenster is.",
  "orders.warnFirstNotLoad": "De eerste activiteit is niet laden",
  "orders.warnLastNotUnload": "De laatste activiteit is niet lossen",
  "orders.warnWindowInPast": "{{date}} is al voorbij",
  "orders.warnWindowBeforePrevious": "Begint vóór de vorige activiteit",
  "orders.warnUnloadBeforeLoad": "Lossen op {{date}}, vóór het laden op {{loadDate}}",
  "orders.warnUnloadClosedBeforeLoad": "Lossen op {{date}} tot {{until}}, voordat het laden om {{loadFrom}} begint",
  "orders.warnFreeAddress": "Dit adres is geen bekende locatie",
  "orders.warnLocationInactive": "Deze locatie staat op non-actief",
  "orders.warnHoursUnknown": "Openingstijden onbekend",
  "orders.warnClosedThatDay": "Gesloten op {{date}}",
  "orders.warnOutsideHours": "Buiten de openingstijden op {{date}}: {{hours}}",
  "orders.warnDuplicateOrder": "Deze referentie staat al op {{order}}",
  "orders.warnEnteredTooLate": "Na de aanmeldtijd voor {{date}}",
  "orders.warnCustomerNotApproved": "De klant is nieuw uit AFAS en nog niet goedgekeurd",
  "orders.warnChangeWaiting": "De klant stuurde op {{date}} een wijziging terwijl de rit onderweg is; die wacht op jou",
  "orders.warnCancelWaiting": "De klant annuleerde op {{date}} terwijl de rit onderweg is; dat wacht op jou",
  "orders.warnChannelChanged": "Bijgewerkt door de klant via EDI op {{date}} {{time}}",
  "orders.shortChangeWaiting": "wijziging wacht",
  "orders.shortAnnounced": "aangekondigd",
  "orders.shortNoPreAnnouncement": "geen vooraanmelding",
  "orders.warnNoPreAnnouncement": "Geen vooraanmelding ({{reference}}): op dit traject meldt de klant de order vooraf aan, en die aanmelding is niet gekomen",
  "orders.helpNoPreAnnouncement": "Komt de vooraanmelding alsnog, dan gaat de order vanzelf door. Is hij afgesproken zonder, accepteer hem zoals gevraagd.",
  "orders.warnAnnounced": "Aangekondigd door de klant op {{date}} om {{time}}; nog niet te plannen tot de definitieve order komt",
  "orders.shortNoLoadingMeters": "geen laadmeters",
  "orders.warnNoLoadingMeters": "Geen laadmeters; WLX schat ze niet en plant pas als ze er zijn",
  "orders.helpNoLoadingMeters": "Vul de laadmeters in op de zending (Wijzigen). Daarna gaat de order vanzelf door.",
  "orders.shortNoTripMark": "wacht op rit",
  "orders.warnNoTripMark": "Wacht op ritindeling: geef de rit een ritkenmerk",
  "orders.warnNoTripMarkCustomer": "Wacht op ritindeling: verstuur het ritbericht, of geef het ritnummer van de klant",
  "orders.warnNoTripMarkSent": "Ritbericht {{report}} verstuurd op {{date}} om {{time}}; wacht op het ritnummer van de klant",
  "orders.helpNoTripMark": "Vink de orders van één rit aan en geef ze een ritkenmerk. Daarna gaan ze vanzelf door.",
  "orders.helpNoTripMarkCustomer": "Vink de orders van één rit aan en verstuur het ritbericht. Het ritnummer dat de klant terugstuurt wordt het ritkenmerk; weet je het al, geef het dan zelf.",
  "orders.shortProvisionalMatch": "voorlopige order",
  "orders.warnProvisionalMatch": "Er staat een voorlopige order voor deze lading: {{order}}",
  "orders.warnProvisionalMatch_other": "Er staan {{count}} voorlopige orders voor deze lading, het dichtst bij: {{order}}",
  "orders.helpProvisionalMatch": "Kies welke voorlopige order deze order vervangt. Deze order neemt dan zijn plek op de rit in, en de voorlopige vervalt.",
  "orders.acceptNeedsProvisionalChoice": "Kies eerst: vervangen of niet.",
  "orders.provisionalChip": "Voorlopig",
  "orders.repeatMade": "{{count}} order gemaakt.",
  "orders.repeatMade_other": "{{count}} orders gemaakt.",
  "orders.repeatFailed": "{{count}} regel niet gemaakt; hij staat hieronder met de reden.",
  "orders.repeatFailed_other": "{{count}} regels niet gemaakt; ze staan hieronder met de reden.",
  "orders.repeatWeek": "Week van",
  "orders.repeatPrefix": "Referentie begint met",
  "orders.repeatPerPallet": "Laadmeter per pallet",
  "orders.repeatColReference": "Referentie",
  "orders.repeatColLoad": "Laden",
  "orders.repeatColUnload": "Lossen",
  "orders.repeatColPallets": "Pallets",
  "orders.repeatColMetres": "Laadmeter",
  "orders.repeatProvisional": "Voorlopig",
  "orders.repeatProvisionalHelp": "Komt de order van de klant voor deze lading binnen, dan vraagt WLX of die de voorlopige vervangt. De voorlopige krijgt geen bevestiging, geen melding gepland en geen ritbericht.",
  "orders.repeatNoInvoice": "Niet factureren",
  "orders.repeatNoInvoiceReason": "Reden niet factureren",
  "orders.repeatNoInvoiceDefault": "Voorlopige order",
  "orders.repeatSubmit": "{{count}} order maken",
  "orders.repeatSubmit_other": "{{count}} orders maken",
  "orders.repeatFailedDuplicate": "Deze referentie staat al op een order van de klant.",
  "orders.repeatFailedInvalid": "Deze regel klopt niet: kijk de datums en tijden na.",
  "orders.repeatFailedOther": "Deze regel is niet gemaakt.",
  "orders.provisionalMatchTitle": "Deze order kan een voorlopige order vervangen",
  "orders.provisionalMatchTitle_other": "Deze order kan een van {{count}} voorlopige orders vervangen",
  "orders.provisionalMatchHelp": "Vervangen: deze order neemt de plek van de voorlopige op de rit in, met dezelfde stops, en de voorlopige vervalt. Vervangt hij geen van deze, dan gaat hij door zoals hij binnenkwam.",
  "orders.provisionalLoads": "laden {{date}} {{time}}",
  "orders.provisionalUnloads": "lossen {{date}} {{time}}",
  "orders.provisionalPallets": "{{count}} pallet",
  "orders.provisionalPallets_other": "{{count}} pallets",
  "orders.provisionalOnTrip": "op rit {{trip}}",
  "orders.provisionalNotPlanned": "nog niet gepland",
  "orders.provisionalReplace": "Vervangen",
  "orders.provisionalDismiss": "Vervangt geen van deze",
  "orders.provisionalReplacedReason": "Vervangen door {{order}}",
  "orders.provisionalReplacedBy": "Voorlopige order, vervangen door",
  "orders.provisionalNotice": "Voorlopige order, gemaakt {{when}}. Komt de order van de klant voor deze lading, dan vervangt die hem.",
  "orders.provisionalNoticeBy": "Voorlopige order, gemaakt door {{by}} {{when}}. Komt de order van de klant voor deze lading, dan vervangt die hem.",
  "orders.provisionalReplaces": "Deze order verving de voorlopige order",
  "orders.replaceBlocked": "Deze order wacht nog op iets anders. Los dat eerst op; tot dan houdt de voorlopige order zijn plek.",
  "orders.replaceDifferentRoute": "Deze order gaat anders dan de voorlopige op zijn rit. Plan hem zelf in en annuleer de voorlopige.",
  "orders.replacePlanned": "Deze order staat al op een rit. Haal hem er eerst af.",
  "orders.replaceGone": "Die voorlopige order is er niet meer: hij is al vervangen of geannuleerd.",
  "orders.mailTitle": "Orders inlezen · {{subject}}",
  "orders.mailFrom": "Van {{from}}",
  "orders.mailForwardedFrom": "doorgestuurd, oorspronkelijk van {{from}}",
  "orders.mailChannel": "Ordermail",
  "orders.mailChannelNone": "Kies een ordermail",
  "orders.mailChannelEdit": "Ordermail wijzigen",
  "orders.mailChannelNew": "Nieuwe ordermail",
  "orders.mailList": "Tabel",
  "orders.mailBodyTable": "Tabel in de mail",
  "orders.mailRowCount": "{{count}} regel",
  "orders.mailRowCount_other": "{{count}} regels",
  "orders.mailNoChannel": "Voor deze afzender is nog geen ordermail. Kies er een, of vraag een beheerder hem te maken op de relatiekaart (tab Ordermail).",
  "orders.mailNoList": "In deze mail staat geen tabel: geen Excel- of CSV-bijlage en geen tabel in de mail.",
  "orders.mailUnreadable": "Deze bijlage kan WLX niet lezen: {{files}}. Een oud Excel-bestand (.xls) opslaan als .xlsx helpt.",
  "orders.mailChannelNewTitle": "Nieuwe ordermail",
  "orders.mailChannelEditTitle": "Ordermail {{name}}",
  "orders.mailChannelNamePlaceholder": "bijvoorbeeld IDP leveringen",
  "orders.mailChannelSenders": "Afzenders",
  "orders.mailChannelCarriers": "Laadmeter per dragersoort",
  "orders.mailChannelLoadDay": "Laaddag als de tabel hem niet noemt",
  "orders.mailChannelLoadDayList": "De laaddatum uit de tabel",
  "orders.mailChannelLoadDayBefore": "De werkdag vóór de losdag",
  "orders.ordermailShipper": "Afzender op de CMR",
  "orders.ordermailShipperHelp": "Leeg: het laadadres, zoals op elke CMR. Kies een plaats uit Locaties om die als afzender in vak 1 te zetten.",
  "orders.mailChannelLoadDayMail": "Laaddag als de mail hem niet noemt",
  "orders.mailChannelLoadDayFromMail": "De datum uit de mail",
  "orders.mailChannelFilter": "Alleen regels waarin",
  "orders.mailChannelFilterNone": "Alle regels",
  "orders.mailChannelFilterText": "staat",
  "orders.mailChannelProvisionalHelp": "De order van de klant vervangt hem later.",
  "orders.mailChannelCreate": "Ordermail maken",
  "orders.mailChannelDeleteConfirm": "Ordermail {{name}} weghalen? De orders die ermee gemaakt zijn blijven.",
  "orders.mailChannelInvalid": "Iets in de ordermail klopt niet: een afzender is een adres of @domein, de laadmeters per dragersoort zijn een getal.",
  "nav.orderMails": "Ordermails",
  "parties.tabOrdermail": "Ordermail",
  "mail.toIntake": "Naar orderintake",
  "mail.toIntakeHelp": "Zet deze mail in de orderintake, waar order entry en planning er de orders van maken.",
  "mail.inIntake": "In de orderintake",
  "mail.toIntakeFailed": "Niet gelukt, opnieuw",
  "orders.mailChannelReadAs": "Hoe WLX de mail leest",
  "orders.mailChannelReadAsList": "Tabel: elke regel een order",
  "orders.mailChannelReadAsMail": "Tekst of pdf: het model leest de mail",
  "orders.mailChannelSubjectFilter": "Alleen als het onderwerp bevat",
  "orders.mailChannelSubjectFilterPlaceholder": "leeg: elke mail",
  "orders.mailChannelAutoIntake": "Vanzelf in de orderintake",
  "orders.mailChannelAutoIntakeHelp": "Een nieuwe mail van deze afzenders komt vanzelf in de bak.",
  "orders.mailChannelProposeWarehouse": "Magazijnorder voorstellen",
  "orders.mailChannelProposeWarehouseHelp": "Laadt of lost de order bij ons magazijn, dan komt de magazijnorder erbij.",
  "orders.mailChannelOrderOptional": "Begint met order (mag leeg)",
  "orders.mailChannelCustomer": "Klant",
  "orders.mailChannelSourceRequired": "Een lijst leest WLX op een order: noem bij Uit order een order van de klant.",
  "orders.mailChannelPartyRequired": "Kies de klant, of noem een order van de klant.",
  "intake.title": "Orderintake",
  "intake.tabTodo": "Te doen",
  "intake.tabAttention": "Aandacht nodig",
  "intake.empty": "De orderintake is leeg.",
  "intake.attentionEmpty": "Er wacht niets in Aandacht nodig.",
  "intake.keys": "Pijltjes door de bak, Enter opent de mail op het hoofdscherm.",
  "intake.why": "Waarom hier",
  "intake.whyManual": "door {{name}}",
  "intake.whyFolder": "uit de map Invoerbak",
  "intake.whySender": "vaste afzender {{name}}",
  "intake.urgent": "Spoed",
  "intake.waitingCustomer": "Wacht op klant",
  "intake.waitingPlanning": "Wacht op planning",
  "intake.proposalReady": "Voorstel klaar",
  "intake.noSubject": "(geen onderwerp)",
  "intake.due": "nodig {{day}}",
  "intake.attachments_one": "{{count}} bijlage",
  "intake.attachments_other": "{{count}} bijlagen",
  "intake.claimedMe": "jij hebt hem",
  "intake.claimedBy": "{{name}} heeft hem",
  "intake.takenBy": "{{name}} heeft deze regel. Je kunt meekijken; over een half uur zonder werk komt hij vrij.",
  "intake.back": "Naar de orderintake",
  "intake.outcome.made": "Gemaakt",
  "intake.outcome.changed": "Gewijzigd",
  "intake.outcome.no_order": "Geen order",
  "intake.markUrgent": "Spoed",
  "intake.packingSlipTitle": "Pakbon uit de mail",
  "intake.packingSlipHelp": "Aangevinkt gaat de pdf als pakbon bij de zending: hij wordt achter de CMR geprint.",
  "intake.packingSlipWith": "{{name}} als pakbon bij de transportorder (achter de CMR geprint)",
  "intake.shipperFromOrdermail": "Afzender op de CMR: {{name}} (uit de ordermail)",
  "intake.notUrgent": "Geen spoed",
  "intake.waitCustomer": "Wacht op klant",
  "intake.waitPlanning": "Wacht op planning",
  "intake.stopWaiting": "Wacht niet meer",
  "intake.waitNotePlaceholder": "bijvoorbeeld: klant bellen over het venster",
  "intake.waitUntil": "Terug op",
  "intake.waitSave": "Laten wachten",
  "intake.noOrderReason": "Waarom geen order",
  "intake.noOrderPick": "Geen order, want…",
  "intake.reason.question": "een vraag",
  "intake.reason.quote": "een offerte",
  "intake.reason.duplicate": "dubbel",
  "intake.reason.status": "een status",
  "intake.reason.other": "iets anders",
  "intake.noOrder": "Geen order",
  "intake.finish": "Klaar",
  "intake.release": "Laat los",
  "intake.mailFrom": "Van {{from}}",
  "intake.mailIn": "Binnen in {{mailboxes}}",
  "intake.madeTitle": "Gemaakt uit deze mail:",
  "intake.madeOrder": "transportorder",
  "intake.madeWarehouse": "magazijnorder",
  "intake.undo": "Terugdraaien",
  "intake.undoPlanned": "Deze order staat al op een rit: de planner beslist. Annuleer hem op de orderkaart.",
  "intake.undoWarehouse": "Een magazijnorder staat al in Scoretrace: annuleer hem daar.",
  "intake.customer": "Klant",
  "intake.ordermail": "Ordermail {{name}}",
  "intake.noOrdermail": "Voor deze afzender is nog geen ordermail.",
  "intake.mail": "De mail",
  "intake.ordermailOnCard": "Ordermail op de relatiekaart",
  "intake.partyTabAdminOnly": "Een beheerder maakt en wijzigt de ordermails.",
  "intake.readAs": "Lezen als",
  "intake.asList": "Tabel",
  "intake.asSingle": "Losse order",
  "intake.aiOff": "AI staat op deze omgeving niet aan. Voer de order zelf in.",
  "intake.propose": "Voorstel maken",
  "intake.proposeAgain": "Opnieuw voorstellen",
  "intake.typeYourself": "Zelf invoeren",
  "intake.reading": "WLX leest de mail…",
  "intake.proposeHelp": "AI leest de mail en de pdf-bijlagen en vult in wat erin staat. Wat er niet in staat, blijft leeg: dat vul je zelf in. Je kijkt alles na voordat er een order is.",
  "intake.proposalEmpty": "WLX vond in deze mail geen order.",
  "intake.state.found": "gevonden",
  "intake.state.not_found": "niet gevonden",
  "intake.state.missing": "ontbreekt",
  "intake.state.standard": "standaard",
  "intake.state.stock": "uit voorraad",
  "intake.load": "Laden",
  "intake.unload": "Lossen",
  "intake.place": "plek",
  "intake.date": "datum",
  "intake.window": "Orderintake",
  "intake.time": "tijd",
  "intake.reference": "referentie",
  "intake.instruction": "opmerking",
  "intake.orderN": "Order {{n}} van {{count}}",
  "intake.orderOne": "Order",
  "intake.duplicate.order": "Staat er al: {{number}}",
  "intake.duplicate.warehouse_order": "Magazijnorder staat er al: {{number}}",
  "intake.duplicate.wms": "Scoretrace heeft hem al: {{number}}",
  "intake.customerReference": "Referentie",
  "intake.pallets": "Pallets",
  "intake.loadingMeters": "Laadmeters",
  "intake.weight": "Gewicht",
  "intake.description": "Omschrijving",
  "intake.remark": "Op de vrachtbrief",
  "intake.temperature": "Temperatuur",
  "intake.warehouseTitle": "Magazijnorder · naar Scoretrace",
  "intake.warehouseOutbound": "Uitleveren uit {{warehouse}}",
  "intake.warehouseInbound": "Aanleveren in {{warehouse}}",
  "intake.warehouseOutboundUnknown": "Uitleveren uit voorraad: kies het magazijn op de magazijnorder",
  "intake.warehouseNoLines": "De mail noemt geen artikelen: kies ze op de magazijnorder.",
  "intake.warehouseHelp": "De pallets kiest het magazijn. Artikel en hoeveelheid kijk je na op de magazijnorder.",
  "intake.openWarehouse": "Openen als magazijnorder met transport",
  "intake.openOrderOnly": "Alleen transport",
  "intake.openOrder": "Openen als order",
  "intake.aboutTitle": "Gaat deze mail over een order die er al is?",
  "intake.aboutHelp": "Bij een wijziging of annulering: open de order, pas hem aan op de orderkaart en klik dan op Gewijzigd.",
  "intake.aboutSearch": "Zoek op ordernummer of referentie",
  "intake.aboutNone": "Geen order gevonden.",
  "intake.changedDone": "Gewijzigd, klaar",
  "intake.panelHelp": "Wat order entry en planning nog moeten invoeren. Met de knop Orderintake zet je hem in een eigen venster op je tweede scherm.",
  "intake.windowHelp": "De orderintake in een eigen venster, voor een tweede scherm",
  "intake.windowRefused": "De browser hield het venster tegen. Sta pop-ups toe voor WLX, of werk met de orderintake hier.",
  "intake.windowTitle": "Orderintake",
  "intake.noRight": "Voor de orderintake heb je het recht Orderintake nodig.",
  "intake.partyTabHelp": "Hoe deze klant zijn orders mailt: afzenders, of de mail vanzelf in de orderintake komt, en of WLX hem leest als tabel (elke regel een order) of als tekst of pdf (het model leest de mail).",
  "intake.partyTabEmpty": "Deze klant heeft nog geen ordermail.",
  "intake.subjectHas": "onderwerp bevat {{text}}",
  "intake.adminMailboxes": "Postvakken die de orderintake vullen",
  "intake.adminMailboxesHelp": "Van deze postvakken komt de mail uit de map Invoerbak en van vaste afzenders vanzelf in de orderintake.",
  "intake.adminOrdermails": "Ordermails",
  "intake.adminOrdermailsHelp": "Elke ordermail van elke klant. Een afzender die vaak Geen order krijgt, heeft een strakker filter nodig.",
  "intake.adminCustomer": "Klant",
  "intake.adminMails": "Mails",
  "intake.adminOpen": "Open",
  "intake.adminNoOrder": "Geen order",
  "orders.mailColumnsRemembered": "kolommen van de ordermail",
  "orders.mailColumnsGuessed": "de ordermail heeft nog geen kolommen: voorgesteld uit de kop",
  "orders.mailColumnsNone": "Geen kolommen herkend.",
  "orders.mailColumnsOnCard": "Klopt een kolom niet? Een beheerder past hem aan in de ordermail op de relatiekaart.",
  "orders.mailChannelColumns": "Welke kolom is wat",
  "orders.mailChannelColumnsHelp": "Kies een mail van deze klant: je ziet de koppen om uit te kiezen, en hoe WLX elke regel leest. Een wijziging hieronder zie je hier meteen.",
  "orders.mailChannelSampleNone": "Kies een mail",
  "orders.mailChannelSampleNoParty": "Noem eerst de klant of een order van de klant",
  "orders.mailChannelSampleEmpty": "Er staat nog geen mail van deze klant in de orderintake. Zet er een in met Naar orderintake in de mail, of kies een bestand.",
  "orders.mailChannelSampleFile": "Of een bestand (Excel, CSV)",
  "orders.mailChannelSamplePdf": "Een pdf is geen tabel met kolommen: zet Hoe WLX de mail leest op Tekst of pdf, dan doet het model een voorstel uit de tekst.",
  "orders.mailChannelSampleUnread": "In {{file}} vond WLX geen tabel met een kopregel.",
  "orders.ordermailUnsaved": "Niet bewaard",
  "orders.ordermailLeaveTitle": "Ordermail bewaren?",
  "orders.ordermailLeaveBody": "Je hebt de ordermail gewijzigd en nog niet bewaard. Bewaar je de wijzigingen?",
  "orders.ordermailLeaveBodyIncomplete": "Je hebt de ordermail gewijzigd en nog niet bewaard. Hij is nog niet compleet (een naam en de klant), dus bewaren kan nog niet: blijf om hem af te maken.",
  "orders.ordermailLeaveStay": "Verder met de ordermail",
  "orders.ordermailLeaveDiscard": "Niet bewaren",
  "orders.ordermailRoute": "Laden → lossen",
  "orders.ordermailPerRow": "per regel",
  "orders.ordermailOrderHelpList": "Zo wordt elke order van deze ordermail. Kies per veld waar de waarde vandaan komt: uit het bestand (welke kolom) of standaard (wat je hier invult). Wat het bestand zegt, gaat voor; de standaard vult aan.",
  "orders.ordermailOrderHelpMail": "Het model vult in wat er in de mail staat. Wat de mail niet zegt, vult de standaard aan; in het voorstel staat dat als standaard, niet als gevonden.",
  "orders.ordermailMailFields": "Referentie, datums, tijden, pallets en gewicht haalt het model altijd uit de mail.",
  "orders.ordermailSourceStandard": "Standaard",
  "orders.ordermailSourceNone": "Niet",
  "orders.ordermailSourceFile": "Uit bestand",
  "orders.ordermailSourceMail": "Uit de mail",
  "orders.ordermailSourceMailOrStandard": "Uit de mail, anders standaard",
  "orders.ordermailColumn": "Kolom: {{header}}",
  "orders.ordermailExample": "Voorbeeld: {{value}}",
  "orders.ordermailPlace": "Adres",
  "orders.ordermailPlaceStandard": "Vast adres",
  "orders.ordermailPlaceFile": "Per regel uit bestand",
  "orders.ordermailPlaceBook": "Kies een adres uit het adresboek: een los adres kan geen vast adres zijn.",
  "orders.ordermailPlaceNoneLoad": "Geen vast laadadres: elke regel moet er een hebben.",
  "orders.ordermailPlaceNoneUnload": "Geen vast losadres: elke regel moet er een hebben.",
  "orders.ordermailPlaceGone": "Een vast adres bestaat niet meer in het adresboek.",
  "orders.ordermailPlaceText": "Per tekst in een kolom",
  "orders.ordermailRuleColumn": "Kolom",
  "orders.ordermailRuleContains": "Bevat",
  "orders.ordermailRulePlace": "Adres bij deze tekst",
  "orders.ordermailRuleAdd": "Tekst toevoegen",
  "orders.ordermailRuleElse": "Past geen tekst, dan dit adres:",
  "orders.ordermailRowsTo_one": "{{count}} regel naar {{place}}",
  "orders.ordermailRowsTo_other": "{{count}} regels naar {{place}}",
  "orders.ordermailNoPlace": "geen adres",
  "orders.ordermailStepMail": "De mail",
  "orders.ordermailStepMailHelp": "Welke mail van deze klant bij deze ordermail hoort, en of WLX hem als tabel of als tekst leest.",
  "orders.ordermailStepOrder": "De order",
  "orders.ordermailStepEvery": "Elke order",
  "orders.ordermailSampleTitle": "Voorbeeld",
  "orders.ordermailPreviewOrders_one": "{{count}} order uit {{rows}} regels",
  "orders.ordermailPreviewOrders_other": "{{count}} orders uit {{rows}} regels",
  "orders.ordermailPreviewSkipped": "{{count}} niet voor ons",
  "orders.ordermailPreviewProblems_one": "{{count}} mist iets",
  "orders.ordermailPreviewProblems_other": "{{count}} missen iets",
  "orders.ordermailUnusedColumns": "Niet gebruikt: {{columns}}",
  "orders.ordermailMoreFields_one": "Meer velden ({{count}})",
  "orders.ordermailMoreFields_other": "Meer velden ({{count}})",
  "orders.ordermailFewerFields": "Alleen de gebruikte velden",
  "orders.ordermailColPalletsMetres": "Pallets · ldm",
  "orders.ordermailLoadWhen": "Datum en tijd laden",
  "orders.ordermailUnloadWhen": "Datum en tijd lossen",
  "orders.ordermailDateNone": "Datum: uit de mail",
  "orders.ordermailTimeNone": "Tijd: geen",
  "orders.ordermailPerPallet": "m per pallet",
  "orders.ordermailRequirements": "Vervoerseisen",
  "orders.ordermailStopRequirements": "Eisen aan de wagen",
  "orders.ordermailNoHistory": "Een wijziging aan de ordermail verandert geen orders die er al zijn.",
  "orders.ordermailWmsTitle": "Scoretrace (WMS)",
  "orders.ordermailWmsToggle": "Ook een magazijnorder voor Scoretrace klaarzetten",
  "orders.ordermailWmsOff": "Er gaat niets naar Scoretrace: WLX maakt alleen de transportorder.",
  "orders.ordermailWmsOutbound": "Laadt in {{warehouse}}, een magazijn van Willems. Naast de transportorder zet WLX een uitlevering voor Scoretrace klaar: magazijn {{warehouse}}, voor {{customer}}.",
  "orders.ordermailWmsInbound": "Lost in {{warehouse}}, een magazijn van Willems. Naast de transportorder zet WLX een aanlevering voor Scoretrace klaar: magazijn {{warehouse}}, voor {{customer}}.",
  "orders.ordermailWmsNoWarehouse": "Geen vast adres is een magazijn van Willems. Laadt of lost een order toch bij een magazijn, dan zet WLX daar de uitlevering of aanlevering voor klaar.",
  "orders.ordermailWmsLines": "De artikelen en aantallen haalt het model uit de mail. Order entry kijkt de magazijnorder na: er gaat pas iets naar Scoretrace als zij hem maken.",
  "orders.ordermailWmsList": "Nog niet: uit een tabel maakt WLX alleen transportorders, er gaat niets naar Scoretrace. Magazijnorders uit een tabel komen later.",
  "orders.mailLoadDate": "Laaddatum",
  "orders.mailUnloadDate": "Losdatum",
  "orders.mailDatesHelp": "Voor de regels die zelf geen datum hebben. Uit het onderwerp van de mail als het daar staat.",
  "orders.mailColumns": "Welke kolom is wat",
  "orders.mailGroupOrder": "Order en lading",
  "orders.mailGroupLoad": "Laden",
  "orders.mailGroupUnload": "Lossen",
  "orders.mailLoadPlacePerRow": "+ Laadadres per regel",
  "orders.mailTake": "Inlezen",
  "orders.mailColWeight": "Gewicht",
  "orders.mailColNote": "Let op",
  "orders.mailRowFiltered": "Niet voor ons (filter van de ordermail)",
  "orders.mailRowMade": "Gemaakt: {{number}}",
  "orders.mailRowWaiting": "Gemaakt: {{number}}, wacht in Aandacht nodig",
  "orders.mailWaiting": "{{count}} wacht in Aandacht nodig, meestal om een adres dat WLX nog niet kent.",
  "orders.mailWaiting_other": "{{count}} wachten in Aandacht nodig, meestal om een adres dat WLX nog niet kent.",
  "orders.mailSubmitHelp": "De mail komt bij elke order. Een adres dat WLX niet kent, wacht in Aandacht nodig.",
  "orders.mailCompareBusy": "WLX vergelijkt de regels met de orders van de klant…",
  "orders.mailCompareFailed": "WLX kon de regels niet vergelijken met de orders van de klant: {{message}}",
  "orders.mailRowNew": "Nieuw",
  "orders.mailRowExists": "Bestaat al: {{number}}",
  "orders.mailRowSame": "Bestaat al: {{number}}, niets anders",
  "orders.mailRowClosed": "Bestaat al: {{number}} ({{status}}). Deze regel wordt niet gemaakt.",
  "orders.mailRowInvalid": "Deze regel klopt niet: {{message}}",
  "orders.mailRowHeld": "Op rit {{trips}}, die al rijdt: de wijziging wacht op de planner.",
  "orders.mailRowOnTrip": "Op rit {{trips}}: de rit volgt, en de planner ziet wat er veranderde.",
  "orders.mailUpdateAgree": "Bijwerken",
  "orders.mailUpdateAll": "Alles akkoord",
  "orders.mailUpdateNone": "Niets akkoord",
  "orders.mailChangedCount": "{{count}} regel wijzigt een order die er al is. Kijk de verschillen na en vink Bijwerken aan bij wat klopt.",
  "orders.mailChangedCount_other": "{{count}} regels wijzigen een order die er al is. Kijk de verschillen na en vink Bijwerken aan bij wat klopt.",
  "orders.mailRowUpdated": "Bijgewerkt: {{number}}",
  "orders.mailRowUpdatedHeld": "Bijgewerkt: {{number}}, wacht op de planner",
  "orders.mailRowUpdatedSame": "{{number}} was al zo",
  "orders.mailUpdated": "{{count}} order bijgewerkt.",
  "orders.mailUpdated_other": "{{count}} orders bijgewerkt.",
  "orders.mailUpdatedHeld": "{{count}} wacht op de planner, omdat die rit al rijdt.",
  "orders.mailUpdatedHeld_other": "{{count}} wachten op de planner, omdat die ritten al rijden.",
  "orders.mailSubmitUpdate": "{{count}} order bijwerken",
  "orders.mailSubmitUpdate_other": "{{count}} orders bijwerken",
  "orders.mailSubmitBoth": "{{made}} maken, {{updated}} bijwerken",
  "orders.repeatFailedNothingToUpdate": "Geen open order heeft deze referentie meer.",
  "orders.mailField.reference": "Factuurreferentie",
  "orders.mailField.name": "Naam van de lading",
  "orders.mailField.loadDate": "Laaddatum",
  "orders.mailField.loadTime": "Laadtijd",
  "orders.mailField.loadReference": "Laadreferentie",
  "orders.mailField.loadInstruction": "Opmerking bij laden",
  "orders.mailField.loadName": "Laadnaam",
  "orders.mailField.loadStreet": "Laadstraat",
  "orders.mailField.loadPostalCode": "Laadpostcode",
  "orders.mailField.loadCity": "Laadplaats",
  "orders.mailField.loadCountry": "Laadland",
  "orders.mailField.unloadDate": "Losdatum",
  "orders.mailField.unloadTime": "Lostijd",
  "orders.mailField.unloadReference": "Losreferentie",
  "orders.mailField.unloadInstruction": "Opmerking bij lossen",
  "orders.mailField.unloadName": "Losnaam",
  "orders.mailField.unloadStreet": "Losstraat",
  "orders.mailField.unloadPostalCode": "Lospostcode",
  "orders.mailField.unloadCity": "Losplaats",
  "orders.mailField.unloadCountry": "Losland",
  "orders.mailField.pallets": "Pallets",
  "orders.mailField.carrier": "Dragersoort",
  "orders.mailField.loadingMeters": "Laadmeters",
  "orders.mailField.weightKg": "Gewicht (kg)",
  "orders.mailField.description": "Omschrijving",
  "orders.mailField.remark": "Opmerking op de vrachtbrief",
  "orders.mailProblem.reference": "geen referentie",
  "orders.mailProblem.loadDate": "geen laaddatum",
  "orders.mailProblem.unloadDate": "geen losdatum",
  "orders.mailProblem.loadingMeters": "geen laadmeters",
  "orders.mailProblem.unloadBeforeLoad": "lossen vóór laden",
  "orders.copyOrder": "Kopiëren",
  "orders.tripMarkSetLabel": "Ritkenmerk",
  "orders.tripMarkSet": "Ritkenmerk zetten",
  "orders.tripMarkSetDone": "{{count}} order kreeg ritkenmerk {{mark}}.",
  "orders.tripMarkSetDone_other": "{{count}} orders kregen ritkenmerk {{mark}}.",
  "orders.tripReportSend": "Ritbericht versturen",
  "orders.tripReportSendDone": "Ritbericht {{report}} verstuurd met {{count}} zending.",
  "orders.tripReportSendDone_other": "Ritbericht {{report}} verstuurd met {{count}} zendingen.",
  "orders.tripReportWithoutCodes": "{{count}} zonder plaatscode ging niet mee.",
  "orders.tripReportWithoutCodes_other": "{{count}} zonder plaatscode gingen niet mee.",
  "orders.tripReportNotOneCustomer": "Een ritbericht is voor de orders van één klant die het vooraf krijgt.",
  "orders.tripReportNoCodes": "Geen van deze orders heeft de plaatscodes van de klant bij het laden en lossen.",
  "orders.copyOneAtATime": "Kopieer één order tegelijk.",
  "orders.copyHelp": "De kopie opent als nieuwe order, met dezelfde klant, adressen en lading; de datums en de referentie vul je in.",
  "orders.listReadOnly": "Een lijst inlezen kan alleen wie orders invoert.",
  "orders.listTemplateFrom": "uit {{order}}",
  "orders.listTemplateOrderNotFound": "Order {{order}} bestaat niet.",
  "orders.listTemplateNotPlain": "Die order laadt niet één keer en lost niet één keer op een adres uit het adresboek. Kies een order met één zending.",
  "orders.listTemplateOtherCustomer": "Die order is van een andere klant dan het sjabloon.",
  "orders.listTemplateNameTaken": "Er is al een sjabloon met deze naam.",
  "orders.listTemplateName": "Naam",
  "orders.listTemplateOrder": "Uit order",
  "orders.listTemplateRefill": "Opnieuw uit order",
  "orders.listTemplatePrefixPlaceholder": "Lattiz wk{week}",
  "orders.listTemplatePerPalletPlaceholder": "uit de order",
  "orders.listTemplateSave": "Bewaren",
  "orders.listTemplateDelete": "Weghalen",
  "orders.helpAnnounced": "Niets te doen: komt de definitieve order van de klant, dan staat hij vanzelf bij Te plannen. Moet hij eerder mee, accepteer hem zoals gevraagd.",
  "orders.announcedLabel": "Aangekondigd",
  "orders.shortChannelChanged": "bijgewerkt via EDI",
  "orders.helpChangeWaiting": "Lees op de order wat de klant wijzigt, en voer het door of negeer het.",
  "orders.logFromChannel": "Bijgewerkt door de klant via EDI",
  "orders.logChannelHeld": "Wijziging of annulering van de klant via EDI; wacht op de planner, want de order staat op een rit",
  "orders.logCancelWaiting": "Annulering gevraagd; wacht op de planner",
  "orders.logCancelWaitingOn_one": "Staat op rit {{trips}}",
  "orders.logCancelWaitingOn_other": "Staat op de ritten {{trips}}",
  "orders.logChannelCarriedOut": "Wijziging van de klant doorgevoerd",
  "orders.logChannelLetGo": "Wijziging van de klant genegeerd",
  "orders.logConsignmentCount": "Aantal zendingen",
  "orders.unitFromChannel": "Klant",
  "orders.pendingChangeTitle": "De klant stuurde op {{when}} een wijziging, terwijl deze order op een rit staat",
  "orders.pendingCancelTitle": "{{who}} annuleerde deze order op {{when}}, terwijl hij op een rit staat",
  "orders.pendingHelp": "WLX haalt niets vanzelf van een rit: jij beslist. Bel eventueel de chauffeur en kies dan: doorvoeren of negeren.",
  "orders.pendingCarryOut": "Wijziging doorvoeren",
  "orders.pendingCarryOutCancel": "Annulering doorvoeren",
  "orders.pendingLetGo": "Negeren",
  "orders.pendingApplyRefused": "Een deel van de wijziging verschuift de rit, en die is onderweg of gereden. Zet de rit eerst terug op vastgelegd, of negeer de wijziging.",
  "orders.channelChangedNotice": "Bijgewerkt door de klant via EDI op {{when}}. Kijk of de planning nog klopt; wat er veranderde staat in het logboek.",
  "orders.channelChangedSeen": "Gezien",
  "orders.theCustomer": "De klant",
  "orders.pendingForPlanner": "Wacht op de planner: die voert het door of negeert het. Er gaat niets vanzelf van de rit af.",
  "orders.planChangeTitle": "Gewijzigd terwijl de order op een rit staat",
  "orders.planChangeBy": "{{who}}, {{when}}",
  "orders.planChangeHelp": "De rit is bijgewerkt waar het binnen de dag kon. Kijk of de planning nog klopt en zet het op gezien.",
  "orders.planChangeForPlanner": "De planner ziet dit ook op de ritkaart.",
  "orders.acceptNeedsDecision": "Wacht op de planner: die voert de wijziging of annulering door, of negeert hem",
  "orders.helpFreeAddress": "Koppel het adres aan een locatie, of maak er een: de planning heeft de locatie nodig, later ook voor de ETA.",
  "orders.helpLocationInactive": "Zet de locatie weer actief, of kies een andere plaats.",
  "orders.helpActivityOrder": "Een zending begint met laden en eindigt met lossen. Wijs de order af en voer hem opnieuw in.",
  "orders.helpUnloadBeforeLoad": "Zet het lossen na het laden: de losdatum op of na de laaddatum, en een losvenster dat nog open is als het laden begint.",
  "orders.helpDuplicateOrder": "Kijk of dit dezelfde order is. Zo ja, wijs deze af.",
  "orders.helpEnteredTooLate":
    "Deze order kwam binnen na de aanmeldtijd die met deze klant is afgesproken. De tijd staat op de relatiekaart, tab Verkooprelatie; leeg betekent geen afspraak.",
  "orders.helpCustomerNotApproved":
    "WLX gebruikt een nieuwe relatie uit AFAS pas na goedkeuring. Keur de klant goed op zijn relatiekaart: dan is de order er vanzelf doorheen.",

  // Dossiers
  "dossiers.searchPlaceholder": "Nummer, referentie, relatie…",
  "dossiers.searchLabel": "Dossiers zoeken",
  "dossiers.allParties": "Alle relaties",
  "dossiers.allStatuses": "Alle statussen",
  "dossiers.filterByParty": "Filter op relatie",
  "dossiers.filterByStatus": "Filter op status",
  "dossiers.newDossier": "Nieuw dossier",
  "dossiers.editDossier": "Dossier bewerken",
  "dossiers.colDossier": "Dossier",
  "dossiers.colPrimaryRef": "Primaire referentie",
  "dossiers.colParts": "Orders",
  "dossiers.part.transport": "Transport",
  "dossiers.part.outbound": "Uitlevering",
  "dossiers.part.inbound": "Ontvangst",
  "dossiers.part.warehouse": "Magazijnorder",
  "dossiers.part.wms": "WMS",
  "dossiers.part.tms": "TMS",
  "dossiers.part.other": "Extern",
  "dossiers.colParty": "Relatie",
  "dossiers.colStatus": "Status",
  "dossiers.colCreated": "Aangemaakt",
  "dossiers.noDossiers": "Geen dossiers gevonden.",
  "dossiers.statusOpen": "Open",
  "dossiers.statusInProgress": "In uitvoering",
  "dossiers.statusCompleted": "Voltooid",
  "dossiers.statusArchived": "Gearchiveerd",
  "dossiers.newTitle": "Nieuw dossier",
  "dossiers.partyLabel": "Relatie",
  "dossiers.primaryRefLabel": "Primaire referentie",
  "dossiers.primaryRefPlaceholder": "bv. PO-2026-00123",
  "dossiers.primaryRefHelp": "Klant- of orderreferentie voor dit dossier.",
  "dossiers.descriptionLabel": "Beschrijving",
  "dossiers.descriptionPlaceholder": "Optioneel — korte beschrijving van de zending of order",
  "dossiers.statusLabel": "Status",
  "dossiers.dossierNumber": "Dossiernummer",
  "dossiers.errorGeneric": "Er is een fout opgetreden",
  "dossiers.createButton": "Dossier aanmaken",
  "dossiers.createAriaLabel": "Dossier aanmaken",
  "dossiers.closeAriaLabel": "Sluiten",
  "dossiers.loading": "Dossier laden…",
  "dossiers.notFound": "Dossier niet gevonden",
  "dossiers.notFoundDesc": "Dit dossier bestaat niet of je hebt er geen toegang toe.",
  "dossiers.createdLabel": "Aangemaakt {{date}}",
  "dossiers.updatedLabel": "Bijgewerkt {{date}}",
  "dossiers.sharePointFolder": "SharePoint-map ↗",
  "dossiers.sharePointPending": "SharePoint-map aanmaken…",
  "dossiers.sharePointFailed": "SharePoint-map mislukt",
  "dossiers.primaryReference": "Primaire referentie",
  "dossiers.party": "Relatie",
  "dossiers.description": "Beschrijving",
  "dossiers.noAccess": "Geen toegang tot dossiers",
  "dossiers.noAccessDesc": "Je hebt het recht Dossiers niet, dus WLX kan dit dossier niet voor je openen. Vraag het aan bij wie de rechten beheert (Beheer → Rechten).",
  "dossiers.orderLink": "Dossier {{number}}",
  "dossiers.orderLinkTitle": "Het dossier van de klantorder: hier staan de documenten",

  // Dossier tabs
  "dossierTabs.documents": "Documenten",
  "dossierTabs.orders": "Orders",
  "dossierTabs.wlxColKind": "Soort",
  "dossierTabs.wlxColNumber": "Nummer",
  "dossierTabs.wlxColReference": "Klantreferentie",
  "dossierTabs.wlxColStatus": "Status",
  "dossierTabs.wlxColDetail": "Details",
  "dossierTabs.wlxKind.transport": "Transport",
  "dossierTabs.wlxKind.outbound": "Uitlevering",
  "dossierTabs.wlxKind.inbound": "Ontvangst",
  "dossierTabs.wlxKind.warehouse_outbound": "Magazijnorder uitleveren",
  "dossierTabs.wlxKind.warehouse_inbound": "Magazijnorder aanleveren",
  "dossierTabs.wlxConsignments_one": "{{count}} zending",
  "dossierTabs.wlxConsignments_other": "{{count}} zendingen",
  "dossierTabs.wlxOutbound.open": "Open",
  "dossierTabs.wlxOutbound.picking": "Wordt gepickt",
  "dossierTabs.wlxOutbound.picked": "Gepickt",
  "dossierTabs.wlxOutbound.shipped": "Verzonden",
  "dossierTabs.wlxOutbound.cancelled": "Geannuleerd",
  "dossierTabs.otherSystems": "In andere systemen",
  "dossierTabs.log": "Log",
  "dossierTabs.docColDocument": "Document",
  "dossierTabs.docColType": "Type",
  "dossierTabs.docColVisibility": "Zichtbaarheid",
  "dossierTabs.docColStatus": "Status",
  "dossierTabs.docColVersion": "Versie",
  "dossierTabs.docColCreated": "Aangemaakt",
  "dossierTabs.noDocuments": "Nog geen documenten.",
  "dossierTabs.ordColSource": "Bron",
  "dossierTabs.ordColSourceRef": "Bronreferentie",
  "dossierTabs.ordColTargetSystem": "Doelsysteem",
  "dossierTabs.ordColExternalNumber": "Extern nummer",
  "dossierTabs.ordColExternalId": "Extern ID",
  "dossierTabs.ordColExternalStatus": "Status extern",
  "dossierTabs.ordChanged": "gewijzigd",
  "dossierTabs.ordChangedTitle": "Gewijzigd in het doelsysteem sinds de laatste keer dat iemand keek",
  "dossierTabs.ordColStatus": "Status",
  "dossierTabs.ordColSnapshot": "Snapshot",
  "dossierTabs.orderTitle": "Order",
  "dossierTabs.ordSyncedAt": "Laatst opgehaald",
  "dossierTabs.snapshotTitle": "Antwoord van het doelsysteem",
  "dossierTabs.snapshotNone": "Nog geen snapshot. Die komt binnen bij de eerstvolgende terugmelding.",
  "dossierTabs.snapshotFailed": "Het snapshot kon niet worden opgehaald.",
  "dossierTabs.snapshotCaptured": "{{system}}, opgehaald op {{when}}",
  "dossierTabs.snapshotOpenHint": "Klik op de regel voor het volledige antwoord van het doelsysteem",
  "dossierTabs.ordColCreated": "Aangemaakt",
  "dossierTabs.noOrders": "Nog geen orders.",
  "dossierTabs.logColEvent": "Gebeurtenis",
  "dossierTabs.logColDetails": "Details",
  "dossierTabs.logColSource": "Bron",
  "dossierTabs.logColActor": "Door",
  "dossierTabs.logColWhen": "Wanneer",
  "dossierTabs.noLog": "Nog niets geregistreerd op dit dossier.",
  "dossierTabs.evtDossierCreated": "Dossier aangemaakt",
  "dossierTabs.evtDossierUpdated": "Dossier bijgewerkt",
  "dossierTabs.evtDossierStatusChanged": "Status gewijzigd",
  "dossierTabs.evtDossierArchived": "Dossier gearchiveerd",
  "dossierTabs.evtFolderCreated": "SharePoint-map aangemaakt",
  "dossierTabs.evtFolderFailed": "SharePoint-map mislukt",
  "dossierTabs.evtOrderReceived": "Order ontvangen",
  "dossierTabs.evtOrderExternalId": "Extern order-ID toegekend",
  "dossierTabs.evtExternalEvent": "Melding uit doelsysteem",
  "dossierTabs.evtExternalState": "Order bijgewerkt uit doelsysteem",
  "dossierTabs.evtDocumentDownloaded": "Document gedownload",
  "dossierTabs.evtOrderAdded": "Order toegevoegd",
  "dossierTabs.evtDossierMerged": "Dossier samengevoegd",
  "dossierTabs.detPrimaryReference": "Referentie",
  "dossierTabs.detParty": "Relatie",
  "dossierTabs.detSourceReference": "Orderreferentie",
  "dossierTabs.detTargetSystem": "Doelsysteem",
  "dossierTabs.detExternalOrderId": "Extern order-ID",
  "dossierTabs.detExternalOrderNumber": "Ordernummer extern",
  "dossierTabs.detExternalStatus": "Status extern",
  "dossierTabs.detEventType": "Soort melding",
  "dossierTabs.detConsignment": "Zending",
  "dossierTabs.detOrderNumber": "Order",
  "dossierTabs.detMergedFrom": "Samengevoegd uit",
  "dossierTabs.detOccurredAt": "Tijdstip",
  "dossierTabs.detStatus": "Status",
  "dossierTabs.detError": "Fout",
  "dossierTabs.detChange": "{{from}} → {{to}}",
  "dossierTabs.sourceDataBridge": "DataBridge",
  "dossierTabs.sourceWlx": "WLX",
  "dossierTabs.actorInternal": "medewerker",
  "dossierTabs.actorPartner": "partner",
  "dossierTabs.actorSystem": "systeem",
  "dossierTabs.ordStatusReceived": "Ontvangen",
  "dossierTabs.ordStatusProcessing": "In verwerking",
  "dossierTabs.ordStatusCompleted": "Voltooid",
  "dossierTabs.ordStatusCancelled": "Geannuleerd",
  "dossierTabs.docStatusDraft": "Concept",
  "dossierTabs.docStatusActive": "Actief",
  "dossierTabs.docStatusReplaced": "Vervangen",
  "dossierTabs.docStatusArchived": "Gearchiveerd",

  // Calendar (Agenda) — your own Outlook calendar (delegated)
  "calendar.view_month": "Maand",
  "calendar.view_week": "Week",
  "calendar.view_day": "Dag",
  "calendar.view_agenda": "Agenda",
  "calendar.prev": "Vorige",
  "calendar.next": "Volgende",
  "calendar.today": "Vandaag",
  "calendar.pickDate": "Datum kiezen",
  "calendar.newEvent": "Nieuwe afspraak",
  "calendar.empty": "Geen afspraken in deze periode.",
  "calendar.colTime": "Tijd",
  "calendar.colSubject": "Onderwerp",
  "calendar.colLocation": "Locatie",
  "calendar.colStatus": "Status",
  "calendar.allDay": "Hele dag",
  "calendar.teamsLink": "Teams",
  "calendar.statusInvited": "Uitgenodigd",
  "calendar.statusOrganizer": "Organisator",
  "calendar.statusDeclined": "Afgewezen",
  "calendar.statusTentative": "Onder voorbehoud",
  "calendar.statusAccepted": "Geaccepteerd",
  "calendar.notConfiguredTitle": "Agenda nog niet beschikbaar",
  "calendar.notConfiguredDesc": "De agenda-koppeling is op deze omgeving nog niet ingesteld. Neem contact op met de beheerder.",
  "calendar.connectTitle": "Koppel je Outlook-agenda",
  "calendar.connectDesc":
    "Geef WLX toestemming om je eigen Outlook-agenda te tonen en namens jou afspraken te beheren. Je logt in met je eigen Microsoft-account; WLX bewaart geen agenda-gegevens — alleen een versleutelde sleutel die je altijd weer kunt intrekken.",
  "calendar.reconnectTitle": "Agenda opnieuw koppelen",
  "calendar.reconnectDesc":
    "Je Outlook-koppeling mist nog de agenda-toegang (of is verlopen). Koppel eenmalig opnieuw om je agenda in WLX te gebruiken — je mail blijft gewoon werken.",
  "calendar.connectConsentAccept":
    "Ik ga ermee akkoord dat WLX mijn Outlook-agenda toont, namens mij afspraken beheert en de vrij/bezet-status van collega's opvraagt. WLX bewaart geen agenda-gegevens (alleen een versleutelde sleutel), het is vrijwillig en ik kan het op elk moment ontkoppelen.",
  "calendar.connectButton": "Agenda koppelen",
  "calendar.reconnectButton": "Opnieuw koppelen",
  "calendar.disconnectButton": "Agenda ontkoppelen",
  "calendar.connect_ok": "Je agenda is gekoppeld.",
  "calendar.connect_cancelled": "Koppelen geannuleerd — er is niets gewijzigd.",
  "calendar.connect_mismatch":
    "Het Microsoft-account waarmee je toestemming gaf is niet jouw WLX-account. Log bij Microsoft in met je eigen account en probeer het opnieuw.",
  "calendar.connect_consent_required": "Vink eerst het akkoord aan om je agenda te koppelen.",
  "calendar.connect_error": "Koppelen is niet gelukt. Probeer het opnieuw.",
  "calendar.drawerTitleCreate": "Nieuwe afspraak",
  "calendar.drawerTitleEvent": "Afspraak",
  "calendar.loadError": "De afspraak kon niet worden geladen.",
  "calendar.occurrenceHint": "Dit is één keer van een terugkerende reeks. Wijzigingen gelden alleen voor deze keer.",
  "calendar.seriesHint": "Dit hoort bij een terugkerende reeks. Waarop wil je dit toepassen?",
  "calendar.scopeOccurrence": "Deze afspraak",
  "calendar.scopeSeries": "Hele reeks",
  "calendar.seriesTimeHint":
    "Bij 'hele reeks' pas je onderwerp, locatie, Teams en notities aan. Een andere tijd geldt alleen voor deze afspraak.",
  "calendar.seriesTimeBlocked": "Kies 'deze afspraak' om de tijd te wijzigen — een hele reeks verzet je hier niet.",
  "calendar.deleteConfirmSeries": "De hele terugkerende reeks verwijderen? Alle genodigden krijgen een annulering.",
  "calendar.subjectLabel": "Onderwerp",
  "calendar.subjectPlaceholder": "Waar gaat de afspraak over?",
  "calendar.allDayLabel": "Hele dag",
  "calendar.startLabel": "Van",
  "calendar.endLabel": "Tot",
  "calendar.locationLabel": "Locatie",
  "calendar.locationPlaceholder": "Ruimte, adres of link",
  "calendar.teamsLabel": "Teams-vergadering toevoegen",
  "calendar.attendeesTitle": "Genodigden",
  "calendar.attendeePlaceholder": "Naam of e-mailadres…",
  "calendar.responsesTitle": "Reacties",
  "calendar.responseAccepted": "Geaccepteerd",
  "calendar.responseDeclined": "Afgewezen",
  "calendar.responseTentative": "Onder voorbehoud",
  "calendar.responsePending": "Nog geen reactie",
  "calendar.responseOrganizer": "Organisator",
  "calendar.responseSummaryAccepted": "{{n}} van {{total}} geaccepteerd",
  "calendar.responseSummaryDeclined": "{{n}} afgewezen",
  "calendar.responseSummaryTentative": "{{n}} onder voorbehoud",
  "calendar.responseSummaryPending": "{{n}} nog geen reactie",
  "calendar.responseRoomDeclined":
    "{{rooms}} heeft de uitnodiging afgewezen — de ruimte is niet geboekt. De afspraak zelf blijft gewoon staan.",
  "calendar.findSlot": "Vind een moment",
  "calendar.findSlotBusy": "Zoeken…",
  "calendar.findSlotNone": "Geen moment gevonden waarop iedereen vrij is. Pas de duur of de genodigden aan.",
  "calendar.availabilityTitle": "Beschikbaarheid",
  "calendar.attendeeBusy": "Bezet in het gekozen tijdvak",
  "calendar.attendeeFree": "Vrij in het gekozen tijdvak",
  "calendar.taskChipTitle": "WLX-taak",
  "calendar.taskPlanned": "tijd ingepland",
  "calendar.taskDue": "Opvolgdatum",
  "calendar.weekShort": "wk {{week}}",
  "calendar.weekNumberTitle": "Weeknummer",
  "calendar.weekHead": "wk",
  "calendar.roomsTitle": "Vergaderruimte",
  "calendar.roomAdd": "Ruimte toevoegen…",
  "calendar.roomFree": "vrij",
  "calendar.roomBusy": "bezet",
  "calendar.roomBusyWarning": "Een gekozen ruimte is bezet in dit tijdvak. De ruimte wijst de uitnodiging dan automatisch af.",
  "calendar.roomPastWarning": "Je kunt geen ruimte in het verleden boeken — de ruimte wijst dat automatisch af.",
  "calendar.roomsEmpty": "Geen ruimtes beschikbaar",
  "calendar.privateLabel": "Privé",
  "calendar.privateHint": "Anderen zien alleen 'bezet' — niet het onderwerp of de details.",
  "calendar.privateShort": "Privé",
  "calendar.statusPrivate": "Privé",
  "calendar.repeatWeekly": "Wekelijks herhalen",
  "calendar.repeatEvery": "Elke",
  "calendar.repeatInterval": "Herhaalinterval",
  "calendar.repeatWeeks": "weken",
  "calendar.repeatUntil": "Tot en met",
  "calendar.repeatPickDay": "Kies minstens één weekdag.",
  "calendar.day_monday": "Ma",
  "calendar.day_tuesday": "Di",
  "calendar.day_wednesday": "Wo",
  "calendar.day_thursday": "Do",
  "calendar.day_friday": "Vr",
  "calendar.day_saturday": "Za",
  "calendar.day_sunday": "Zo",
  "calendar.notesLabel": "Notities",
  "calendar.notesPlaceholder": "Optionele omschrijving…",
  "calendar.deleteButton": "Verwijderen",
  "calendar.deleteConfirm": "Deze afspraak verwijderen?",
  "calendar.deleteConfirmMeeting": "Verwijderen stuurt een annulering naar alle genodigden. Doorgaan?",
  "calendar.deleteConfirmYes": "Ja, verwijderen",
  "calendar.showDay": "Toon deze dag",
  "calendar.createButton": "Afspraak maken",
  "calendar.saveButton": "Opslaan",
  "calendar.errorSubject": "Vul een onderwerp in.",
  "calendar.errorTime": "Vul een geldige begin- en eindtijd in.",
  "calendar.errorEndTime": "De eindtijd moet na de begintijd liggen.",
  "calendar.errorRoomTooLong": "Een vergaderruimte of werkplek neemt hoogstens 24 uur achter elkaar aan; langer wijst hij automatisch af. Maak de afspraak korter of haal de ruimte eraf.",
  "calendar.errorGeneric": "Er ging iets mis. Probeer het opnieuw.",
  "calendar.organizedBy": "Georganiseerd door {{name}}",
  "calendar.joinTeams": "Deelnemen via Teams",
  "calendar.attachmentsTitle": "Bijlagen",
  "calendar.attachmentsNone": "Geen bijlagen bij deze afspraak.",
  "calendar.attachmentsFailed": "De bijlagen konden niet worden opgehaald.",
  "calendar.attachmentNotDownloadable": "Dit is een gekoppeld item (een mail of een OneDrive-link), geen bestand om te downloaden.",
  "calendar.rsvpTitle": "Jouw reactie",
  "calendar.rsvpAccept": "Accepteren",
  "calendar.rsvpTentative": "Onder voorbehoud",
  "calendar.rsvpDecline": "Afwijzen",
  "calendar.proposeToggle": "Ander tijdstip voorstellen",
  "calendar.proposeHint": "Stel een ander tijdvak voor. De organisator krijgt je voorstel en kan het overnemen of afwijzen.",
  "calendar.proposeTentative": "Onder voorbehoud + voorstel",
  "calendar.proposeDecline": "Afwijzen + voorstel",
  "calendar.roomInviteeHint":
    "Iemand anders organiseert deze afspraak, dus de ruimte wordt als aparte reservering in jouw agenda geboekt met dezelfde tijd — de uitnodiging van de organisator blijft ongewijzigd.",
  "calendar.forwardTitle": "Doorsturen",
  "calendar.forwardToggle": "Doorsturen…",
  "calendar.forwardHintOrganizer":
    "Stuur de uitnodiging naar iemand die nog niet is uitgenodigd. Alleen de ontvanger krijgt bericht; de andere genodigden niet.",
  "calendar.forwardHintInvitee":
    "Stuur de uitnodiging naar iemand die nog niet is uitgenodigd. {{name}} krijgt bericht dat je hem hebt doorgestuurd; de andere genodigden niet.",
  "calendar.forwardTheOrganizer": "De organisator",
  "calendar.forwardRecipients": "Aan",
  "calendar.forwardComment": "Bericht (niet verplicht)",
  "calendar.forwardCommentPlaceholder": "Bijvoorbeeld: kun jij hier ook bij zijn?",
  "calendar.forwardAlreadyInvited": "{{names}} staat al bij de genodigden en krijgt de uitnodiging dan nog een keer.",
  "calendar.forwardPickRecipient": "Kies ten minste één ontvanger.",
  "calendar.forwardSend": "Versturen",
  "calendar.forwardSending": "Versturen…",
  "calendar.forwardSent": "Doorgestuurd naar {{names}}.",
  "calendar.yourDayTitle": "Jouw agenda die dag",
  "calendar.yourDayConflict": "Je hebt al {{count}} afspraak in dit tijdvak.",
  "calendar.yourDayConflict_other": "Je hebt al {{count}} afspraken in dit tijdvak.",
  "calendar.yourDayEmpty": "Geen andere afspraken op deze dag.",
  "calendar.yourDayError": "Je agenda kon niet worden gelezen.",
  "calendar.yourDayFree": "Nog vrij — klik om daar te plannen:",
  "calendar.yourDayNoFree": "Geen vrije tijd meer tussen {{from}} en {{to}}.",
  "calendar.yourDayTakenAllDay": "Geen vrije tijd: een afspraak van de hele dag houdt deze dag bezet.",
  "calendar.yourDayFreePick": "Begin om {{time}}",

  // Reservations
  "reservations.pageEyebrow": "Reserveren",
  "reservations.viewWeek": "Week",
  "reservations.viewDay": "Dag",
  "reservations.viewAgenda": "Agenda",
  "reservations.prev": "Vorige",
  "reservations.today": "Vandaag",
  "reservations.next": "Volgende",
  "reservations.pickDate": "Datum kiezen",
  "reservations.filterType": "Filter op type",
  "reservations.allTypes": "Alle typen",
  "reservations.filterBranch": "Filter op vestiging",
  "reservations.allBranches": "Alle vestigingen",
  "reservations.typeRoomPlural": "Vergaderruimtes",
  "reservations.typeWorkplacePlural": "Werkplekken",
  "reservations.mineOnly": "Alleen mijn reserveringen",
  "reservations.visibilityAll": "Alles",
  "reservations.visibilityAllHint": "Alles aan, of alles uit als alles al aan staat",
  "reservations.noResourceSelected": "Geen ruimte of werkplek gekozen. Klik er hierboven een aan.",
  "reservations.showOutlook": "Mijn agenda tonen",
  "reservations.showOutlookTitle": "Leg je eigen agenda als overlay over de bezetting",
  "reservations.loading": "Laden…",
  "reservations.newReservation": "Nieuwe reservering",
  "reservations.legendOwn": "Eigen reservering",
  "reservations.legendBusy": "Bezet",
  "reservations.legendOption": "Optie",
  "reservations.legendOutlook": "Mijn agenda",
  "reservations.legendBlocked": "Niet beschikbaar (gedeelde ruimte)",
  "reservations.blockedTitle": "Bezet door {{name}}",
  "reservations.blockedHint": 'Deelt de ruimte met "{{name}}" en is daardoor niet te reserveren.',
  "reservations.confirmCancel": 'Reservering "{{subject}}" annuleren?',
  "reservations.periodAgenda": "Vanaf {{date}}",
  "reservations.periodWeek": "Week van {{date}}",
  "reservations.noRoomsSelected": "Geen ruimtes geselecteerd. Vink links iets aan.",
  "reservations.noReservations": "Geen reserveringen in deze periode. Maak er een aan met '+ Nieuwe reservering'.",
  "reservations.outlookMyAgenda": "Mijn agenda",
  "reservations.outlookYourAgenda": "Jouw agenda",
  "reservations.moreItems": "+{{count}} meer",
  "reservations.statusOwn": "Eigen",
  "reservations.statusBusy": "Bezet",
  "reservations.statusOption": "Optie",
  "reservations.statusOutlook": "Agenda",
  "reservations.statusBlocked": "Niet beschikbaar",
  "reservations.tableTime": "Tijd",
  "reservations.tableRoom": "Ruimte / plek",
  "reservations.tableSubject": "Onderwerp",
  "reservations.tableStatus": "Status",
  "reservations.editButton": "Wijzigen",
  "reservations.cancelButton": "Annuleren",
  "reservations.outlookLocation": "Eigen agenda",
  "reservations.teamsLink": "· Teams",
  "reservations.drawerTitleCreate": "Nieuwe reservering",
  "reservations.drawerTitleEdit": "Reservering wijzigen",
  "reservations.drawerTitleOutlook": "Ruimte reserveren voor afspraak",
  "reservations.outlookBookHint": "De gekozen ruimte wordt uitgenodigd voor deze afspraak. Onderwerp en tijd blijven gelijk.",
  "reservations.outlookBookHintAttendee":
    "Je bent geen organisator van deze afspraak, dus er wordt een aparte reservering voor de ruimte gemaakt op dezelfde tijd. Een eventuele Teams-link gaat mee.",
  "reservations.bookRoomButton": "Reserveer ruimte",
  "reservations.drawerClose": "Sluiten",
  "reservations.detailsSection": "Details",
  "reservations.subjectLabel": "Onderwerp",
  "reservations.subjectPlaceholder": "bv. Teamoverleg logistiek",
  "reservations.noSubject": "(geen onderwerp)",
  "reservations.whenLabel": "Wanneer",
  "reservations.roomLabel": "Ruimte / werkplek",
  "reservations.roomReadOnly": "De ruimte kan bij wijzigen niet worden aangepast.",
  "reservations.roomChangeHint": "Een andere ruimte kiezen boekt de nieuwe ruimte en annuleert deze reservering.",
  "reservations.roomsUnavailable":
    "De bezetting van deze ruimtes kon niet worden opgehaald: {{rooms}}. Ze staan hieronder niet in het overzicht — ga er niet van uit dat ze vrij zijn.",
  "reservations.confirmCancelSeries":
    "“{{subject}}” is een terugkerende reservering. Hiermee zeg je ALLE keren van deze reeks af, niet alleen deze. Doorgaan?",
  "reservations.deleteSeriesButton": "Hele reeks afzeggen",
  "reservations.deleteOccurrenceButton": "Deze keer afzeggen",
  "reservations.confirmCancelOccurrence": "Alleen deze keer van “{{subject}}” afzeggen? De rest van de reeks blijft gewoon staan.",
  "reservations.seriesOccurrenceOnly":
    "Dit is één keer uit een terugkerende reeks. Wat je hier wijzigt, geldt alleen voor deze keer — de rest van de reeks blijft ongemoeid.",
  "reservations.capacityShort": "{{count}} pers.",
  "reservations.roomChecking": "Beschikbaarheid controleren…",
  "reservations.roomFreeSlot": "Deze ruimte is vrij in dit tijdvak.",
  "reservations.roomBusySlot": "Deze ruimte is al bezet in dit tijdvak.",
  "reservations.slotBlockedShared": 'Niet beschikbaar: "{{name}}" is in dit tijdvak geboekt en deelt dezelfde ruimte.',
  "reservations.sharesSpaceWith": "Deelt de ruimte met {{names}} \u2014 is die bezet, dan kun je deze niet reserveren, en andersom.",
  "reservations.bookedBy": "Geboekt door {{name}}",
  "reservations.askMoveButton": "Vragen om te verplaatsen",
  "reservations.askMoveTooltip": "Klik om te vragen of dit kan verplaatsen",
  "reservations.otherTitle": "Reservering van {{name}}",
  "reservations.otherTitleNoName": "Reservering",
  "reservations.organizerUnknown": "Onbekend",
  "reservations.bookedByLabel": "Geboekt door",
  "reservations.askMoveSeries": "Eén keer uit een terugkerende reeks; je vraagt alleen naar deze keer.",
  "reservations.askMoveOver": "Deze reservering is al voorbij.",
  "reservations.askMoveSection": "Vragen om te verplaatsen",
  "reservations.askMoveHint": "WLX mailt {{name}} met een knop die deze reservering in WLX opent. Een antwoord komt bij jou.",
  "reservations.askMoveSuggestLabel": "Andere ruimte voorstellen",
  "reservations.askMoveNoSuggestion": "Geen voorstel",
  "reservations.askMoveSuggestHelp": "Alleen ruimtes die op dat moment vrij zijn, eerst die van dezelfde vestiging.",
  "reservations.askMoveNoneFree": "Er is op dat moment geen andere ruimte vrij.",
  "reservations.askMoveMessageLabel": "Bericht (niet verplicht)",
  "reservations.askMoveMessagePlaceholder": "Bijvoorbeeld: ik heb hier om 13:00 een klant.",
  "reservations.askMoveSend": "Vraag versturen",
  "reservations.askMoveSending": "Versturen…",
  "reservations.askMoveSentOwn": "Verstuurd aan {{name}}, vanuit je eigen postvak.",
  "reservations.askMoveSentSystem": "Verstuurd aan {{name}} via WLX. Je staat in de cc, en een antwoord komt bij jou.",
  "reservations.openNotFound": "De reservering uit de link staat er niet meer: hij is al verplaatst of afgezegd.",
  "reservations.suggestedRoom": "In de vraag voorgesteld: {{room}}. Die staat al gekozen.",
  "reservations.startLabel": "Begin",
  "reservations.endLabel": "Einde",
  "reservations.addTeams": "Teams-vergadering toevoegen",
  "reservations.repeatWeekly": "Wekelijks herhalen",
  "reservations.repeatEvery": "Elke",
  "reservations.repeatInterval": "Herhaalinterval",
  "reservations.repeatWeeks": "week(en)",
  "reservations.repeatUntil": "Tot en met",
  "reservations.repeatHorizon": "Uiterlijk {{date}} (boekingsvenster)",
  "reservations.repeatPickDay": "Kies minstens één weekdag.",
  "reservations.repeatCalculating": "Beschikbaarheid berekenen…",
  "reservations.repeatTooManyBusy": "Te veel keren bezet — de ruimte weigert de hele reeks. Pas de tijd, ruimte of einddatum aan.",
  "reservations.repeatAllFree": "Alle {{count}} keren vrij.",
  "reservations.repeatFreeCount": "Vrij {{free}}/{{total}} keren — de bezette keren worden overgeslagen.",
  "reservations.repeatCappedWarn": "Deze reeks loopt voorbij het boekingsvenster; alleen keren t/m {{date}} worden geboekt.",
  "reservations.repeatPastSkipped": "{{count}} keer al geweest (overgeslagen).",
  "reservations.repeatBusy": "bezet",
  "reservations.day_monday": "Ma",
  "reservations.day_tuesday": "Di",
  "reservations.day_wednesday": "Wo",
  "reservations.day_thursday": "Do",
  "reservations.day_friday": "Vr",
  "reservations.day_saturday": "Za",
  "reservations.day_sunday": "Zo",
  "reservations.deleteButton": "Annuleren (verwijderen)",
  "reservations.saveButton": "Opslaan",
  "reservations.createButton": "Reserveren",
  "reservations.errorSubject": "Geef een onderwerp op.",
  "reservations.errorEndTime": "Eindtijd moet na begintijd liggen.",
  "reservations.errorTooLong": "Een ruimte of werkplek neemt hoogstens 24 uur achter elkaar aan; langer wijst hij automatisch af. Kies een kortere tijd of maak er meer reserveringen van.",
  "reservations.errorPast": "Je kunt niet in het verleden reserveren.",
  "reservations.errorGeneric": "Er ging iets mis.",
  "reservations.personalConflict": 'Let op: je hebt dan zelf al "{{subject}}" ({{from}}–{{to}}) in Outlook.',

  // Resource administration (admin-only)
  "reservations.manageResources": "Ruimtes beheren",
  "reservations.resBackToOverview": "Terug naar bezettingsoverzicht",
  "reservations.resTypeRoom": "Vergaderruimte",
  "reservations.resTypeWorkplace": "Werkplek",
  "reservations.resNewTitle": "Nieuwe ruimte",
  "reservations.resNew": "Nieuwe ruimte",
  "reservations.resNameLabel": "Naam",
  "reservations.resNamePlaceholder": "bijv. Vergaderruimte Haps",
  "reservations.resMailboxLabel": "Postbus (e-mailadres)",
  "reservations.resMailboxPlaceholder": "ruimte@willemslogistics.com",
  "reservations.resMailboxHelp": "Het Exchange-postbusadres van de ruimte in Microsoft 365.",
  "reservations.resTypeLabel": "Type",
  "reservations.resBranchLabel": "Vestiging",
  "reservations.resBranchNone": "Geen vestiging",
  "reservations.resCapacityLabel": "Capaciteit",
  "reservations.resBuildingLabel": "Gebouw",
  "reservations.resFloorLabel": "Verdieping",
  "reservations.resAmenitiesLabel": "Voorzieningen",
  "reservations.resAmenitiesPlaceholder": "beamer, whiteboard",
  "reservations.resAmenitiesHelp": "Gescheiden door komma's.",
  "reservations.resTeamsLabel": "Teams-vergaderen mogelijk",
  "reservations.resParentLabel": "Staat in",
  "reservations.resParentNone": "Nergens in \u2014 staat op zichzelf",
  "reservations.resParentHelp":
    "Kies de ruimte waar deze plek fysiek in staat. Zolang die ruimte geboekt is, is deze plek niet te reserveren \u2014 en andersom. Twee plekken in dezelfde ruimte blokkeren elkaar niet.",
  "reservations.resParentHoldsOthers": "Er staan andere plekken in deze ruimte, dus deze kan zelf nergens in staan.",
  "reservations.resLastSynced": "Laatst gesynchroniseerd",
  "reservations.resSearchPlaceholder": "Zoek op naam, postbus of gebouw…",
  "reservations.resSync": "Synchroniseren met Microsoft 365",
  "reservations.resSyncing": "Synchroniseren…",
  "reservations.resSyncDone": "Synchronisatie klaar: {{created}} toegevoegd, {{updated}} bijgewerkt, {{deactivated}} gedeactiveerd.",
  "reservations.resSyncKeptInactive": "{{count}} ruimte blijft op inactief staan (hier handmatig uitgezet).",
  "reservations.resSyncKeptInactive_other": "{{count}} ruimtes blijven op inactief staan (hier handmatig uitgezet).",
  "reservations.resColName": "Naam",
  "reservations.resColType": "Type",
  "reservations.resColMailbox": "Postbus",
  "reservations.resColCapacity": "Capaciteit",
  "reservations.resColLocation": "Locatie",
  "reservations.resColSharedSpace": "Gedeelde ruimte",
  "reservations.resSharedIn": "Staat in {{name}}",
  "reservations.resSharedHolds": "Bevat {{names}}",
  "reservations.resColStatus": "Status",
  "reservations.resEmpty": "Nog geen ruimtes. Synchroniseer met Microsoft 365 of voeg er handmatig een toe.",

  // Tasks (personal + shared-mailbox tasks)
  "tasks.scopeAll": "Alles",
  "tasks.scopeMine": "Mijn taken",
  "tasks.searchPlaceholder": "Zoek op titel of omschrijving…",
  "tasks.searchLabel": "Taken zoeken",
  "tasks.filterByStatus": "Filter op status",
  "tasks.statusActive": "Actief (alles wat nog loopt)",
  "tasks.allStatuses": "Alle statussen",
  "tasks.statusOpen": "Open",
  "tasks.statusInProgress": "Mee bezig",
  "tasks.statusWaiting": "Wachten op reactie",
  "tasks.statusReplied": "Gereageerd",
  "tasks.statusRepliedHint": "Deze taak stond op wachten; er is inmiddels antwoord binnen.",
  "tasks.statusReview": "Afgerond, ter controle",
  "tasks.reviewBanner": "{{actor}} rondde deze taak af. Jij zette hem door, dus jij sluit hem.",
  "tasks.reviewClose": "Sluiten",
  "tasks.reviewReopen": "Toch niet klaar",
  "tasks.reviewWaiting": "Wacht op controle door {{name}}",
  "tasks.statusDone": "Afgerond",
  "tasks.statusCancelled": "Vervallen",
  "tasks.manageMailboxes": "Postvakken beheren",
  "tasks.newTask": "Nieuwe taak",
  "tasks.colTitle": "Titel",
  "tasks.colMailbox": "Postvak",
  "tasks.colStatus": "Status",
  "tasks.colAssignee": "Opvolger",
  "tasks.colDueDate": "Opvolgdatum",
  "tasks.colLastActivity": "Laatste activiteit",
  "tasks.sortBy": "Sorteer op {{column}} · sleep om de kolom te verplaatsen",
  "tasks.noTasks": "Geen taken gevonden.",
  "tasks.periodLabel": "Periode (opvolgdatum)",
  "tasks.periodAll": "Alles",
  "tasks.periodDay": "Dag",
  "tasks.periodWeek": "Week",
  "tasks.periodMonth": "Maand",
  "tasks.groupOverdue": "Verlopen",
  "tasks.groupToday": "Vandaag",
  "tasks.groupTomorrow": "Morgen",
  "tasks.groupThisWeek": "Deze week",
  "tasks.groupThisMonth": "Deze maand",
  "tasks.groupLater": "Later",
  "tasks.groupNoDate": "Geen opvolgdatum",
  "tasks.fromMail": "Vanuit e-mail",
  "tasks.hasReply": "reactie",
  "tasks.onlyUnread": "Met reactie",
  "tasks.onlyUnreadHint": "Toon alleen taken met een ongelezen reactie (binnen deze pagina).",
  "tasks.noUnread": "Geen taken met een ongelezen reactie op deze pagina.",
  "tasks.hasReplyTitle": "Nieuwe interne reactie op deze taak",
  "tasks.personal": "Persoonlijk",
  "tasks.newTitle": "Nieuwe taak",
  "tasks.createAriaLabel": "Nieuwe taak aanmaken",
  "tasks.createButton": "Taak aanmaken",
  "tasks.errorGeneric": "Er ging iets mis. Probeer het opnieuw.",
  "tasks.scopeLabel": "Voor",
  "tasks.scopePersonal": "Persoonlijk (alleen ik)",
  "tasks.scopeHelp": "Een postvak-taak is zichtbaar voor alle leden van dat postvak.",
  "tasks.titleLabel": "Titel",
  "tasks.titlePlaceholder": "bijv. Klant terugbellen over offerte",
  "tasks.completeButton": "Afronden",
  "tasks.editButton": "Bewerken",
  "tasks.editButtonHelp": "Titel en omschrijving bewerken",
  "tasks.editTitleTooShort": "Vul een titel in van minstens 2 tekens.",
  "tasks.unplanButton": "Blokkering verwijderen",
  "tasks.unplanHelp": "Verwijdert de tijdblokkering hier; de afspraak zelf blijft in je Outlook-agenda staan.",
  "tasks.descriptionLabel": "Omschrijving",
  "tasks.attachmentsLabel": "Bijlagen",
  "tasks.mailAttachmentsLabel": "Uit de mails",
  "tasks.mailAttachmentsLoading": "Bijlagen uit de mails ophalen…",
  "tasks.mailAttachmentsUnavailable_one":
    "Van {{count}} mail konden de bijlagen niet worden opgehaald: verplaatst, verwijderd of in een postvak dat jij niet kunt openen.",
  "tasks.mailAttachmentsUnavailable_other":
    "Van {{count}} mails konden de bijlagen niet worden opgehaald: verplaatst, verwijderd of in een postvak dat jij niet kunt openen.",
  "tasks.mailAttachmentHint": "{{name}} — uit de mail ‘{{subject}}’",
  "tasks.mailAttachmentUnnamed": "Bijlage",
  "tasks.attachmentDropHint": "Sleep bestanden hierheen of klik om te kiezen",
  "tasks.attachmentUploading": "Bezig met uploaden…",
  "tasks.attachmentTooLarge": "{{name}} is groter dan 100 MB",
  "tasks.attachmentUploadFailed": "Uploaden mislukt",
  "tasks.attachmentDeleteFailed": "Verwijderen mislukt",
  "tasks.attachmentDeleteConfirm": "{{name}} verwijderen?",
  "tasks.attachmentRemove": "Verwijderen",
  "tasks.descriptionPlaceholder": "Optionele toelichting…",
  "tasks.assigneeLabel": "Opvolger",
  "tasks.assigneeNone": "Nog geen opvolger",
  "tasks.participantsLabel": "Betrokkenen",
  "tasks.participantsHelp": "Collega's die meekijken: ze zien de taak en krijgen de reacties. De opvolger blijft verantwoordelijk.",
  "tasks.participantsSearchPlaceholder": "Voeg een collega toe…",
  "tasks.participantsNoMatch": "Geen collega gevonden",
  "tasks.participantsRemove": "{{name}} niet meer betrekken",
  "tasks.participantsTooltip": "Betrokken: {{names}}",
  "tasks.activityParticipantAdded": "{{actor}} betrok {{name}} bij de taak",
  "tasks.activityParticipantRemoved": "{{actor}} haalde {{name}} van de taak",
  "tasks.activityParticipantLeft": "{{actor}} is niet meer betrokken",
  "tasks.removeMail": "Uit deze taak halen",
  "tasks.removeMailConfirm": "De mail blijft gewoon in het postvak; hij verdwijnt alleen uit deze taak.",
  "tasks.removeMailConfirmYes": "Ja, uit de taak halen",
  "tasks.activityMailRemoved": "{{actor}} haalde een mail van de taak",
  "tasks.activityMailRemovedSubject": "{{actor}} haalde de mail ‘{{subject}}’ van de taak",
  "tasks.assigneeNoMembers": "Dit postvak heeft nog geen leden — voeg ze toe via Beheer → Postvakken om ze als opvolger te kunnen kiezen.",
  "tasks.dueDateConfirmHint": "Enter om te bevestigen, Esc om te annuleren",
  "tasks.dueDateEditHint": "Klik om de opvolgdatum te wijzigen",
  "tasks.dueDateLabel": "Opvolgdatum",
  "tasks.dueWeekLabel": "Je open taken in deze week",
  "tasks.dueDayCount": "{{date}}: {{count}} open taak",
  "tasks.dueDayCount_other": "{{date}}: {{count}} open taken",
  "tasks.dueDayNone": "Op {{date}} staan nog geen open taken van je.",
  "tasks.dueDaySome": "Op {{date}} heb je al {{count}} open taak:",
  "tasks.dueDaySome_other": "Op {{date}} heb je al {{count}} open taken:",
  "tasks.dueDayWith": "bij {{name}}",
  "tasks.dueDayMore": "en nog {{count}}",
  "tasks.dueDayError": "Je taken van die week konden niet worden geladen.",
  "tasks.statusLabel": "Status",
  "tasks.notFound": "Taak niet gevonden",
  "tasks.notFoundDesc": "Deze taak bestaat niet of je hebt er geen toegang toe.",
  "tasks.backToOverview": "Terug naar taken",
  "tasks.createdByLabel": "Aangemaakt door {{name}} op {{date}}",
  "tasks.tabActivity": "Activiteit & reacties",
  "tasks.tabMessages": "Berichten",
  "tasks.systemActor": "Systeem",
  "tasks.activityCreated": "{{actor}} heeft de taak aangemaakt",
  "tasks.activityStatusChanged": "{{actor}} wijzigde de status van {{from}} naar {{to}}",
  "tasks.activityAssigned": "{{actor}} maakte {{assignee}} opvolger",
  "tasks.activityUnassigned": "{{actor}} verwijderde de opvolger",
  "tasks.activityMailAdded": "E-mail toegevoegd aan de taak",
  "tasks.activityMailAddedSubject": "E-mail toegevoegd: {{subject}}",
  "tasks.activityMailHistoryAdded_one": "{{count}} mail uit hetzelfde gesprek toegevoegd",
  "tasks.activityMailHistoryAdded_other": "{{count}} mails uit hetzelfde gesprek toegevoegd",
  "tasks.activityMailReplied": "{{actor}} stuurde een antwoord",
  "tasks.activityMailRepliedSubject": "{{actor}} antwoordde: {{subject}}",
  "tasks.activityMergedFrom": "{{actor}} voegde {{number}} samen in deze taak",
  "tasks.activityMergedInto": "{{actor}} voegde deze taak samen in {{number}}",
  "tasks.messageOutgoing": "Verzonden",
  "tasks.noActivity": "Nog geen activiteit.",
  "tasks.mentionedLabel": "Gevraagd aan",
  // Onder je eigen reactie: is hij aangekomen bij wie je bedoelde?
  "tasks.seenBy": "Gezien door {{names}}",
  "tasks.notSeenBy": "nog niet door {{names}}",
  "tasks.seenByNobody": "Nog niet gezien",
  "tasks.mentionHint": "Typ @ om een collega te taggen",
  "tasks.commentLabel": "Reactie plaatsen",
  "tasks.commentPlaceholder": "Schrijf een interne reactie…",
  "tasks.commentSubmit": "Reageren",
  "tasks.commentAddImage": "Afbeelding",
  "tasks.commentImageHint": "Plakken of toevoegen",
  "tasks.commentImageTooLarge": "Afbeelding is te groot (max {{mb}} MB)",
  "tasks.commentImageType": "Alleen afbeeldingen (PNG, JPG, GIF, WEBP)",
  "tasks.noMessages": "Geen e-mails gekoppeld aan deze taak.",
  "tasks.noMessageBody": "Geen berichttekst beschikbaar.",
  "tasks.openInOutlook": "Openen in Outlook",
  "tasks.openInWlx": "Openen in WLX",
  "tasks.openInWlxFailed": "Deze mail is niet meer te vinden in het postvak — mogelijk verplaatst of verwijderd.",
  // Recurring tasks (schedules that spawn a task per occurrence)
  "tasks.manageRecurring": "Terugkerende taken",
  "tasks.planNowLabel": "Tijd plannen in mijn agenda",
  "tasks.planNowHelp": "Optioneel — blokkeert deze tijd in je eigen Outlook-agenda.",
  "tasks.planFromLabel": "Van",
  "tasks.planToLabel": "Tot",
  "tasks.planInvalid": "De eindtijd moet na de begintijd liggen.",
  "tasks.repeatLabel": "Herhalen",
  "tasks.repeatNone": "Niet herhalen",
  "tasks.repeatDaily": "Dagelijks",
  "tasks.repeatWeekly": "Wekelijks",
  "tasks.repeatMonthly": "Maandelijks",
  "tasks.repeatHelp": "Op elke geplande datum wordt automatisch een taak met eigen nummer aangemaakt.",
  "tasks.repeatIntervalLabel": "Elke",
  "tasks.repeatUnitDays": "dag(en)",
  "tasks.repeatUnitWeeks": "week/weken",
  "tasks.repeatUnitMonths": "maand(en)",
  "tasks.repeatOnDaysLabel": "Op dagen",
  "tasks.repeatPickDay": "Kies minimaal één dag.",
  "tasks.repeatDayOfMonthLabel": "Dag van de maand",
  "tasks.repeatDayOfMonthHelp": "Maanden zonder deze dag worden overgeslagen (bijv. dag 31 in februari).",
  "tasks.repeatStartLabel": "Eerste keer op",
  "tasks.repeatUntilLabel": "Herhalen t/m (optioneel)",
  // Calendar link ("Tijd plannen")
  "tasks.planTimeButton": "Tijd plannen",
  "tasks.planTimeAgainButton": "Opnieuw plannen",
  "tasks.planTimeHelp": "Blokkeer tijd voor deze taak in je eigen Outlook-agenda.",
  "tasks.planDueHint": "Opvolgdatum: {{date}}",
  "tasks.planStart": "Van",
  "tasks.planEnd": "Tot",
  "tasks.planConfirm": "Inplannen",
  "tasks.planErrorTime": "Vul een geldige begin- en eindtijd in.",
  "tasks.planErrorEnd": "De eindtijd moet na de begintijd liggen.",
  "tasks.plannedBadge": "Ingepland",
  "tasks.plannedBadgeHelp": "Er staat tijd voor deze taak in je agenda.",
  "tasks.recurringBadge": "Terugkerende taak",
  "tasks.recurringBadgeHelp": "Automatisch aangemaakt vanuit een herhaalschema.",
  "tasks.recPageTitle": "Terugkerende taken",
  "tasks.recColSchedule": "Schema",
  "tasks.recColPattern": "Patroon",
  "tasks.recColNext": "Volgende keer",
  "tasks.recColActions": "Acties",
  "tasks.recActive": "Actief",
  "tasks.recPaused": "Gepauzeerd",
  "tasks.recFinished": "Afgerond",
  "tasks.recPause": "Pauzeren",
  "tasks.recResume": "Hervatten",
  "tasks.recDelete": "Verwijderen",
  "tasks.recDeleteConfirm": "Dit herhaalschema verwijderen? Al aangemaakte taken blijven bestaan.",
  "tasks.recEmpty": "Nog geen terugkerende taken.",
  "tasks.recCreateHint": "Een terugkerende taak maak je via “Nieuwe taak” op het takenoverzicht — kies daar bij “Herhalen” een patroon.",
  "tasks.patDaily": "Dagelijks",
  "tasks.patEveryNDays": "Elke {{n}} dagen",
  "tasks.patWeekly": "Wekelijks op {{days}}",
  "tasks.patEveryNWeeks": "Elke {{n}} weken op {{days}}",
  "tasks.patMonthly": "Maandelijks op dag {{day}}",
  "tasks.patEveryNMonths": "Elke {{n}} maanden op dag {{day}}",
  "tasks.patUntil": "t/m {{date}}",
  "mail.mbNew": "Nieuw postvak",
  "mail.mbNewTitle": "Postvak registreren",
  "mail.mbColName": "Naam",
  "mail.mbColEmail": "E-mailadres",
  "mail.mbColMembers": "Leden",
  "mail.mbColTag": "Tag",
  "mail.mbColStatus": "Status",
  "mail.mbEmpty": "Nog geen gedeelde postvakken geregistreerd.",
  "mail.mbActive": "Actief",
  "mail.mbInactive": "Inactief",
  "mail.mbNameLabel": "Naam",
  "mail.mbNamePlaceholder": "bijv. Support",
  "mail.mbTagLabel": "Tag (kort label)",
  "mail.mbTagPlaceholder": "bijv. Support",
  "mail.mbTagHint": "Kort label op de mailregels in de “Alles”-lijst. Leeg = de naam wordt gebruikt.",
  "mail.mbTagColorLabel": "Tag-kleur",
  "mail.mbTagColorHint": "Kleur van de chip op de mailregels — handig om postvakken snel te herkennen.",
  "mail.mbAiLabel": "AI-huisstijl",
  "mail.mbAiPlaceholder":
    "bijv. Schrijf formeel en beknopt, in de u-vorm. Noem bij vertraging altijd onze 24-uurs terugkoppeling. Verwijs naar het ordernummer als dat bekend is.",
  "mail.mbAiHint":
    "Vaste schrijfinstructies voor de AI-assistent op dit postvak (toon, aanspreekvorm, standaardzinnen). Aanhef en handtekening worden automatisch toegevoegd — zet die hier níét in. Wordt als vertrouwde instructie meegegeven. Leeg = alleen de standaardstijl.",
  "mail.tagColorNone": "Geen kleur",
  "mail.tagColorSlate": "Grijs",
  "mail.tagColorNavy": "Blauw",
  "mail.tagColorTeal": "Turquoise",
  "mail.tagColorGreen": "Groen",
  "mail.tagColorAmber": "Oranje",
  "mail.tagColorRed": "Rood",
  "mail.tagsHeader": "Tags",
  "mail.tagsNone": "Nog geen tags",
  "mail.tagsManage": "Tags beheren…",
  "mail.tagsError_one": "De tag is niet gezet. Probeer het opnieuw.",
  "mail.tagsError_other": "Bij {{count}} mails is de tag niet gezet. Probeer het opnieuw.",
  "mail.tagFilter": "Tag",
  "mail.tagFilterHint": "Alleen de mails met een tag. Met Alle mappen in het hele postvak.",
  "mail.tagFilterHeader": "Filteren op tag",
  "mail.tagFilterAll": "Alle mails",
  "mail.tagButton": "Tag",
  "mail.tagButtonHint": "Een tag op deze mail zetten of eraf halen",
  "mail.tagsTitle": "Tags",
  "mail.tagsHelpShared": "De tags waaruit iedereen in dit postvak kiest. Een tag staat als categorie op de mail, dus je ziet hem ook in Outlook. Wijzig je een naam, dan gaan de mails met die tag vanzelf mee, voor iedereen in dit postvak.",
  "mail.tagsHelpOwn": "Je eigen tags voor je eigen postvak. Een tag staat als categorie op de mail, dus je ziet hem ook in Outlook. Wijzig je een naam, dan gaan de mails met die tag vanzelf mee.",
  "mail.tagsShortcut": "Sneltoets",
  "mail.tagsShortcutPress": "Druk op een toets…",
  "mail.tagsShortcutHint": "Eigen toets voor {{name}}: zet de tag op de open of geselecteerde mail, of haalt hem eraf. Klik en druk op een letter, een cijfer of Shift met een letter. Delete haalt de toets weg, Esc breekt af.",
  "mail.tagsShortcutInvalid": "Kies een letter, een cijfer of Shift met een letter.",
  "mail.tagsShortcutReserved": "{{key}} doet al iets in de mail. Kies een andere toets, of Shift erbij.",
  "mail.tagsShortcutTaken": "{{key}} staat al op {{name}}.",
  "mail.tagsRename": "Naam van {{name}} wijzigen",
  "mail.tagsRenaming": "De mails met {{name}} gaan over op deze naam. Dat kan even duren.",
  "mail.tagsColor": "Kleur",
  "mail.tagsUp": "{{name}} hoger",
  "mail.tagsDown": "{{name}} lager",
  "mail.tagsRemove": "Uit de lijst",
  "mail.tagsRemoveHint": "Uit de lijst halen. Mails met deze tag houden hem, zonder kleur.",
  "mail.tagsRemoveConfirm": "{{name}} uit de lijst halen? Mails met deze tag houden hem, zonder kleur.",
  "mail.tagsPlaceholder": "Bijv. Facturatie",
  "mail.tagsAddLabel": "Nieuwe tag",
  "mail.tagsAdd": "Toevoegen",
  "mail.tagsDuplicate": "{{name}} staat al in de lijst.",
  "mail.tagsNoComma": "Een tag kan geen komma bevatten.",
  "mail.mbEmailLabel": "E-mailadres",
  "mail.mbEmailPlaceholder": "support@willemslogistics.com",
  "mail.mbEmailHelp": "Het adres van het gedeelde postvak in Microsoft 365.",
  "mail.mbPhoneLabel": "Telefoonnummer",
  "mail.mbPhonePlaceholder": "bijv. +31 (0) 882081010",
  "mail.mbPhoneHint": "Komt als T-regel in de handtekening van dit postvak. Precies zoals je het hier typt. Leeg = geen telefoonregel.",
  "mail.mbAddressLabel": "Adres",
  "mail.mbAddressPlaceholder": "Hoogeindsestraat 32\n5447 PE Rijkevoort",
  "mail.mbAddressHint": "Komt onder het logo in de handtekening, één regel per regel die je hier typt. Leeg = geen adres.",
  "mail.focusLabel": "Aandachtsgebied:",
  "mail.focusAll": "Alle gebieden",
  "mail.focusAllHint": "Toon de mail van al je aandachtsgebieden",
  "mail.focusSwitchHint": "Schakel over naar dit aandachtsgebied — je beheerder bepaalt welke je hebt",
  "mail.mbActiveLabel": "Actief",
  "mail.mbCreateButton": "Postvak toevoegen",
  "mail.ownFoldersButton": "Mappen",
  "mail.ownFoldersHint": "Eigen mappen naast Verwerkt in je eigen postvak",
  "mail.ownFoldersTitle": "Mappen in je eigen postvak",
  "mail.ownFoldersHelp":
    "Extra mappen naast Postvak IN, Verwerkt, CC en Verzonden items. Ze staan hierboven na Verwerkt, en je kunt er mail naartoe verplaatsen: met de rechtermuisknop, door een mail op de map te slepen, of met Verplaatsen naar. E blijft naar Verwerkt gaan. WLX maakt de map in Outlook onder Postvak IN aan zodra er voor het eerst mail in gaat. Bestaat hij daar al, dan toont WLX meteen wat erin staat. Een map dieper schrijf je als pad, bijvoorbeeld Inkoopfacturen/WLX verwerkt.",
  "mail.moveTo": "Verplaatsen naar…",
  "mail.moveToHint": "Zet deze mail in een andere map",
  "mail.moveToHeader": "Verplaatsen naar",
  "mail.moveError": "Verplaatsen is niet gelukt.",
  "mail.movedUndoText": "Verplaatst naar {{folder}}.",
  "mail.folderDropHint": "Sleep een mail hierheen om hem naar {{folder}} te verplaatsen",
  "mail.foldersTitle": "Mappen",
  "mail.foldersEmpty": "Nog geen eigen mappen.",
  "mail.foldersMax": "Hoogstens {{count}} eigen mappen.",
  "mail.foldersPlaceholder": "Naam van de map, bijvoorbeeld Klachten",
  "mail.foldersAddLabel": "Nieuwe map",
  "mail.foldersAdd": "Toevoegen",
  "mail.foldersHide": "Verbergen",
  "mail.foldersHideHint": "Haalt de map uit WLX. In Outlook blijven de map en de mail erin gewoon staan.",
  "mail.foldersUp": "{{name}} een plek naar voren",
  "mail.foldersDown": "{{name}} een plek naar achteren",
  "mail.foldersFixed": "{{name}} is al een map in WLX of Outlook.",
  "mail.foldersDuplicate": "{{name}} staat al in de lijst.",
  "mail.mbFoldersHelp":
    "Extra mappen naast Postvak IN, Verwerkt en Verzonden items, voor iedereen in dit postvak. Ze staan in de mail na Verwerkt, en de leden kunnen er mail naartoe verplaatsen; E blijft naar Verwerkt gaan. WLX maakt de map in Outlook onder Postvak IN aan zodra er voor het eerst mail in gaat. Bestaat hij daar al, dan toont WLX meteen wat erin staat. Een map dieper schrijf je als pad, bijvoorbeeld Inkoopfacturen/WLX verwerkt.",
  "mail.mbMembersTitle": "Leden",
  "mail.mbNoMembers": "Nog geen leden — alleen beheerders zien de taken van dit postvak.",
  "mail.mbRemoveMember": "Verwijder {{name}}",
  "mail.mbAddMemberLabel": "Lid toevoegen",
  "mail.mbAddMemberPlaceholder": "Kies een medewerker…",
  "mail.mbAddMember": "Toevoegen",
  "mail.mbSyncLast": "Laatste mailsynchronisatie: {{date}}",
  "mail.mbSyncNever": "Nog geen mailsynchronisatie uitgevoerd.",
  "mail.mbSyncError": "Mailsynchronisatie faalt: {{error}}",
  // Visibility groups (admin)
  "mail.backToMail": "Terug naar mail",
  "mail.noMailboxes": "Je bent nog geen lid van een gedeeld postvak. Vraag een beheerder om je toe te voegen.",
  "mail.listEmpty": "Geen berichten in dit postvak.",
  "mail.searchPlaceholder": "Zoek in mail…",
  "mail.searchLabel": "Zoek in dit postvak",
  "mail.searchEmpty": "Geen resultaten voor “{{q}}”.",
  "mail.searchAllFolders": "Alle mappen",
  "mail.searchAllFoldersHint": "Zoek in alle mappen van dit postvak tegelijk; bij elke mail staat in welke map hij zit",
  "mail.selectMessage": "Selecteer een bericht om te lezen.",
  "mail.noSubject": "(geen onderwerp)",
  "mail.olderMessages": "Oudere berichten",
  "mail.moreMessages": "Meer berichten",
  "mail.colFrom": "Van",
  "mail.colTo": "Aan",
  "mail.colSubject": "Onderwerp",
  "mail.colTag": "Tag",
  "mail.colReceived": "Ontvangen",
  "mail.colSent": "Verzonden",
  "mail.sortBy": "Sorteer op {{column}} — nog een klik draait de volgorde om",
  "mail.sortHintCombined": "In Alles staat de nieuwste mail bovenaan. Sorteren kan in een postvak zelf",
  "mail.sortHintSearch": "Zoekresultaten staan op datum, de nieuwste bovenaan",
  "mail.sortHintTo": "Op ontvanger kan niet gesorteerd worden",
  "mail.newestMessages": "← Nieuwste berichten",
  "mail.tabAll": "Alles",
  "mail.tabReorderHint": "Sleep om de volgorde van je postvakken te wijzigen",
  "mail.tabAllHint": "Postvakken IN van meerdere postvakken in één lijst",
  "mail.allPickerLabel": "Postvakken:",
  "mail.allSoloHint": "Klik om aan of uit te zetten · dubbelklik voor alleen dit postvak",
  "mail.allSelectAll": "alle postvakken",
  "mail.allMinOne": "Er blijft altijd minstens één postvak aan staan",
  "mail.allMaxSources": "Maximaal {{count}} postvakken tegelijk in Alles",
  "mail.allEmpty": "Geen berichten in de geselecteerde postvakken.",
  "mail.allSourceError": "Kon niet laden: {{names}}. De lijst is daardoor niet volledig.",
  "mail.allIncomplete": "Verder terugbladeren lukt hier niet. Open het postvak zelf voor oudere berichten.",
  "mail.hasTask": "Taak",
  "mail.hasTaskTitle": "Dit gesprek heeft al een taak",
  "mail.makeTask": "Maak taak",
  "mail.addToTask": "Voeg toe aan taak",
  "mail.openTask": "Open taak",
  "mail.loadImages": "Afbeeldingen laden ({{count}})",
  "mail.showText": "Platte tekst",
  "mail.showHtml": "Opmaak tonen",
  "mail.toLabel": "Aan",
  "mail.ccLabel": "Cc",
  "mail.fromLabel": "Van",
  "mail.dateLabel": "Datum",
  "mail.attachmentsLabel": "Bijlagen",
  "mail.print": "Afdrukken",
  "mail.printHint": "Afdrukken, of opslaan als pdf",
  "mail.attachmentKindImage": "Afbeelding",
  "mail.attachmentKindPdf": "PDF-document",
  "mail.attachmentKindDoc": "Tekstdocument",
  "mail.attachmentKindSheet": "Rekenblad",
  "mail.attachmentKindSlides": "Presentatie",
  "mail.attachmentKindArchive": "Archief (zip)",
  "mail.attachmentKindAudio": "Geluidsbestand",
  "mail.attachmentKindVideo": "Videobestand",
  "mail.attachmentKindCode": "Gegevensbestand",
  "mail.attachmentKindMail": "Ingesloten bericht",
  "mail.attachmentKindEvent": "Afspraak",
  "mail.attachmentKindContact": "Contactpersoon",
  "mail.attachmentKindLink": "Koppeling",
  "mail.attachmentKindFile": "Bestand",
  "mail.attachmentFallback": "bijlage",
  "mail.spam": "Spam",
  "mail.spamHint": "Verplaats naar Rapporteer SPAM — daar pakt de beveiliging hem op",
  "mail.spamFolderMissing":
    "Dit postvak heeft geen map “Rapporteer SPAM”. Vraag IT om die aan te maken; WLX maakt hem bewust niet zelf aan.",
  "mail.spamUndoText": "Gemeld als spam.",
  "mail.attachmentEmbedded": "ingesloten bericht",
  "mail.folderCc": "CC",
  "mail.rulesButton": "Regels",
  "mail.rulesHint": "Mailregels voor je eigen postvak",
  "mail.rulesTitle": "Mailregels",
  "mail.rulesIntro": "WLX sorteert je eigen post volgens deze regels — ook als je niet in WLX zit.",
  "mail.rulesFirstMatchNote": "De bovenste regel die past wint; de rest wordt overgeslagen.",
  "mail.rulesEmpty": "Je hebt nog geen regels.",
  "mail.rulesCondLabel": "Wanneer",
  "mail.rulesCondCcOnly": "Ik sta alleen in CC",
  "mail.rulesCondSenderContains": "Afzender bevat",
  "mail.rulesCondSubjectContains": "Onderwerp bevat",
  "mail.rulesValueLabel": "Tekst",
  "mail.rulesValuePlaceholder": "bijv. berkhout",
  "mail.rulesNeedValue": "Vul in waarop deze regel moet letten.",
  "mail.rulesActionLabel": "Verplaats naar",
  "mail.rulesFolderCc": "Map CC",
  "mail.rulesFolderProcessed": "Verwerkt",
  "mail.rulesFolderNone": "Niet verplaatsen",
  "mail.rulesMarkRead": "Markeer als gelezen",
  "mail.rulesNeedEffect": "Een regel moet de mail verplaatsen, als gelezen markeren, of allebei.",
  "mail.rulesAdd": "Regel toevoegen",
  "mail.rulesPause": "Uitzetten",
  "mail.rulesResume": "Aanzetten",
  "mail.rulesDeleteConfirm": "Deze regel verwijderen?",
  "mail.rulesApplyNow": "Nu toepassen op Postvak IN",
  "mail.rulesApplyNowHint": "Nieuwe regels gelden vanaf nu. Wil je ook de mail opruimen die er al staat, dan doe je dat hier.",
  "mail.rulesApplyResult": "{{scanned}} bekeken, {{moved}} verplaatst, {{markedRead}} als gelezen gemarkeerd.",
  "mail.rulesApplyCapped": "Er stond meer klaar dan in één keer kan — draai het nog een keer.",
  "mail.rulesServerSideNote":
    "WLX kijkt hiervoor alleen naar afzender, geadresseerden en onderwerp — nooit naar de inhoud van je mail — en alleen zolang je zelf een regel hebt staan.",
  "mail.rulesAliasNote": "Alleen je eigen adres telt mee. Sta je in CC via een alias of een groepsadres, dan ziet de regel dat niet.",
  "mail.attachmentEmbeddedHint": "Ingesloten bericht — klik om te lezen",
  "mail.attachmentLink": "koppeling",
  "mail.embeddedTitle": "Ingesloten bericht",
  "mail.embeddedNoSender": "Afzender onbekend",
  "mail.embeddedNoBody": "Dit ingesloten bericht heeft geen inhoud.",
  "mail.embeddedHasAttachments":
    "Dit bericht heeft zelf ook bijlagen, maar WLX kon ze nu niet ophalen — open de mail in Outlook om erbij te komen.",
  "mail.embeddedUnreadable": "Dit ingesloten bericht kan niet geopend worden.",
  "mail.embeddedKindEvent": "Ingesloten afspraak",
  "mail.embeddedKindContact": "Ingesloten contactpersoon",
  "mail.embeddedKindOther": "Ingesloten item",
  "mail.openInOutlook": "Openen in Outlook",
  "mail.replied": "Beantwoord",
  "mail.waitingRowTitle": "Nog geen antwoord en geen taak — deze klant wacht nog op ons",
  "mail.waitingCount_one": "{{count}} wacht op ons",
  "mail.waitingCount_other": "{{count}} wachten op ons",
  "mail.waitingOldest": "oudste {{age}}",
  "mail.waitingCapped": "minimaal — er is verder teruggekeken dan hier past",
  "mail.waitingNone": "Alles beantwoord of opgepakt",
  "mail.repliedTitle": "Je hebt op deze mail geantwoord",
  "mail.forwarded": "Doorgestuurd",
  "mail.forwardedTitle": "Je hebt deze mail doorgestuurd",
  "mail.attachmentOpen": "Openen",
  "mail.attachmentDownload": "Downloaden",
  "mail.attachmentDragHint": "Sleep naar een map of het bureaublad. Naar een website kan slepen niet: download hem (⤓) en sleep hem uit de downloads van de browser",
  "mail.attachmentDragHintCopy": "Sleep naar een map of het bureaublad. Naar een website kan slepen niet: kopieer hem en plak met Ctrl+V",
  "mail.attachmentCopyImage": "Afbeelding kopiëren — plak met Ctrl+V in een website of app",
  "mail.attachmentCopyText": "Inhoud kopiëren als tekst — plak met Ctrl+V in een website of app",
  "mail.attachmentCopied": "Gekopieerd — plak met Ctrl+V",
  "mail.attachmentCopyFailed": "Kopiëren is niet gelukt",
  "mail.unreadCount": "{{count}} ongelezen",
  "mail.markRead": "Markeer gelezen",
  "mail.markUnread": "Markeer ongelezen",
  "mail.readError": "Markeren als (on)gelezen lukte niet — mogelijk ontbreekt nog het schrijfrecht (Mail.ReadWrite).",
  "mail.reply": "Beantwoorden",
  "mail.replyAll": "Allen beantwoorden",
  "mail.forward": "Doorsturen",
  "mail.forwardManyHint": "In één nieuwe mail, met de mails als bijlage",
  "mail.forwardManyMailboxes": "Samen doorsturen kan alleen met mails uit één postvak",
  "mail.forwardManyTooMany": "Samen doorsturen kan met hoogstens {{count}} mails",
  "mail.replyPlaceholder": "Typ je antwoord…",
  "mail.forwardPlaceholder": "Typ je bericht…",
  // Reply greetings are CONTENT for the customer, not interface text: the
  // language follows the INCOMING mail (detectGreeting), never the UI locale.
  // Hence identical values in nl.ts and en.ts — do not "translate" these.
  "mail.greetNl": "Hoi {{name}},",
  "mail.greetNlNoName": "Hoi,",
  "mail.greetNlAll": "Hoi allemaal,",
  "mail.greetNlFormal": "Beste {{name}},",
  "mail.greetNlFormalNoName": "Beste,",
  "mail.greetNlFormalAll": "Beste allen,",
  "mail.greetEn": "Hi {{name}},",
  "mail.greetEnNoName": "Hi,",
  "mail.greetEnAll": "Hi all,",
  "mail.greetEnFormal": "Dear {{name}},",
  "mail.greetEnFormalNoName": "Dear,",
  "mail.greetEnFormalAll": "Dear all,",
  "mail.greetingPrefSet": "Andere aanhef voor deze afzender?",
  "mail.greetingPrefEdit": "Aanhef voor deze afzender aanpassen",
  "mail.greetingPrefTitle": "Zo spreken we deze afzender voortaan aan",
  "mail.greetingPrefNamePlaceholder": "Voornaam",
  "mail.greetingPrefTone": "Aanhef",
  "mail.greetingPrefAuto": "Automatisch",
  "mail.greetingPrefHelp": "Alles leeg laten = weer automatisch bepalen. Geldt alleen voor dit postvak.",
  "mail.presenceReading": "{{name}} heeft deze mail ook open",
  "mail.presenceReplying": "{{name}} is deze mail aan het beantwoorden — stem even af voor je zelf verstuurt",
  "mail.templatesLabel": "Snelle antwoorden:",
  "mail.signatureAuto": "Je naam en de huisstijl-handtekening worden bij verzenden automatisch toegevoegd.",
  "mail.historyEdit": "Oorspronkelijke tekst bewerken",
  "mail.historyLabel": "Oorspronkelijk bericht",
  "mail.historyRevert": "Origineel ongewijzigd meesturen",
  "mail.historyRevertConfirm": "Je wijzigingen in het oorspronkelijke bericht gaan verloren. Doorgaan?",
  "mail.historyImagesHelp": "Afbeeldingen die hier als leeg kader staan, gaan gewoon mee.",
  "mail.historyError": "Het oorspronkelijke bericht kon niet worden geladen.",
  "mail.forwardOriginalAttachments": "Bijlagen van het origineel gaan mee: {{names}}",
  "mail.historyFrom": "Van:",
  "mail.historySent": "Verzonden:",
  "mail.historyTo": "Aan:",
  "mail.historyCc": "CC:",
  "mail.historySubject": "Onderwerp:",
  "mail.signatureOwn": "Je verstuurt onder je eigen naam; je eigen handtekening wordt automatisch toegevoegd.",
  "mail.makeAppointment": "Afspraak maken",
  "mail.makeAppointmentHelp": "Maakt een afspraak in je eigen agenda met de deelnemers van deze mail.",
  // Meeting invitation received as mail
  "mail.invite.label": "Vergaderuitnodiging",
  "mail.invite.series": "hele reeks",
  "mail.invite.sending": "Bezig…",
  "mail.invite.outOfDate": "Er is een nieuwere versie van deze uitnodiging. Reageer liever op de nieuwste.",
  "mail.invite.isResponse": "Dit is een antwoord op jouw uitnodiging.",
  "mail.invite.cancelled": "Deze afspraak is geannuleerd.",
  "mail.invite.youOrganised": "Je bent zelf de organisator.",
  "mail.invite.alreadyAccepted": "Je hebt deze uitnodiging al geaccepteerd.",
  "mail.invite.alreadyDeclined": "Je hebt deze uitnodiging al afgewezen.",
  "mail.invite.alreadyTentative": "Je hebt onder voorbehoud gereageerd.",
  "mail.invite.done_accept": "Geaccepteerd. De uitnodiging verdwijnt uit je Postvak IN.",
  "mail.invite.done_tentative": "Onder voorbehoud gereageerd. De uitnodiging verdwijnt uit je Postvak IN.",
  "mail.invite.done_decline": "Afgewezen. De uitnodiging verdwijnt uit je Postvak IN.",
  "mail.invite.response_accepted": "Antwoord op jouw uitnodiging: geaccepteerd.",
  "mail.invite.response_tentativelyAccepted": "Antwoord op jouw uitnodiging: onder voorbehoud.",
  "mail.invite.response_declined": "Antwoord op jouw uitnodiging: afgewezen.",
  "mail.invite.proposedTime": "Voorgesteld tijdstip:",
  "mail.invite.proposalApplied": "Dit tijdstip staat al in je agenda.",
  "mail.invite.acceptProposal": "Voorstel accepteren",
  "mail.invite.acceptProposalHelp": "De afspraak schuift naar dit tijdstip; de genodigden krijgen een bijgewerkte uitnodiging.",
  "mail.invite.done_proposal": "Voorstel geaccepteerd. De genodigden krijgen een bijgewerkte uitnodiging.",
  // Calendar sources
  "calendar.sourcesTitle": "Agenda's",
  "calendar.sourceOwn": "Eigen agenda",
  "calendar.sourceSharedBy": "gedeeld door {{name}}",
  "calendar.sourceReadOnly": "alleen lezen",
  "calendar.sourceFailed": "{{count}} agenda kon niet worden geladen — de lijst is mogelijk niet compleet.",
  "calendar.sourceFailed_plural": "{{count}} agenda's konden niet worden geladen — de lijst is mogelijk niet compleet.",
  "calendar.readOnlyEvent": "Deze afspraak staat in een agenda die je alleen mag lezen.",
  "mail.openInWindow": "Openen in een apart venster",
  "mail.windowNoAccess": "Je hebt geen toegang tot de mailmodule.",
  "mail.windowMissing": "Deze koppeling wijst niet naar een mail.",
  "mail.windowClose": "Venster sluiten ({{seconds}})",
  "mail.windowGone": "Deze mail is er niet meer — misschien is hij verplaatst of verwijderd.",
  "mail.windowBlocked": "Je browser blokkeerde het nieuwe venster. Sta pop-ups toe voor WLX en probeer het opnieuw.",
  "mail.composeWindowMissing": "Deze koppeling wijst niet naar een nieuwe mail.",
  "mail.composeWindowNoMailbox": "Vanuit dit postvak kun je hier niet mailen: je bent geen lid meer, of je eigen postvak is niet gekoppeld.",
  "mail.composeWindowNoStorage": "Deze browser bewaart geen concepten (een privévenster?), dus de mail kan niet naar een eigen venster.",
  "mail.composeWindowFilesLost_one": "1 bijlage kwam niet mee uit het hoofdvenster. Voeg hem hier opnieuw toe.",
  "mail.composeWindowFilesLost_other": "{{count}} bijlagen kwamen niet mee uit het hoofdvenster. Voeg ze hier opnieuw toe.",
  "mail.composeWindowSent": "Verzonden. Je kunt dit venster sluiten.",
  "mail.composeWindowClosed": "Je kunt dit venster sluiten.",
  "mail.myMailbox": "Mijn postvak",
  "mail.connectTitle": "Koppel je eigen postvak",
  "mail.connectDesc":
    "Geef WLX toestemming om jouw Outlook (mail én agenda) te tonen en namens jou te versturen en afspraken te beheren. Je logt in met je eigen Microsoft-account; WLX bewaart geen mail of agenda — alleen een versleutelde sleutel die je hier altijd weer kunt intrekken.",
  "mail.connectButton": "Postvak koppelen",
  "mail.connectConsentAccept":
    "Ik ga ermee akkoord dat WLX mijn zakelijke Outlook (mail én agenda) toont, namens mij mail verstuurt en afspraken beheert. WLX bewaart geen mail of agenda (alleen een versleutelde sleutel), het is vrijwillig en ik kan het op elk moment ontkoppelen.",
  "mail.connectConsentRequired": "Vink eerst het akkoord aan om je postvak te koppelen.",
  "mail.reconnectTitle": "Koppeling verlopen",
  "mail.reconnectDesc":
    "De koppeling met je postvak is verlopen (bijvoorbeeld na een wachtwoordwijziging). Koppel opnieuw om je mail weer te zien.",
  "mail.reconnectButton": "Opnieuw koppelen",
  "mail.autoReplyButton": "Afwezigheid",
  "mail.autoReplyHint": "Automatische afwezigheidsmelding voor je eigen postvak",
  "mail.autoReplyTitle": "Afwezigheidsmelding",
  "mail.autoReplyDesc": "Outlook verstuurt de melding en zet hem zelf aan en uit — je hoeft er verder niet aan te denken.",
  "mail.autoReplyStatus": "Melding",
  "mail.autoReplyOff": "Uit",
  "mail.autoReplyOn": "Aan, tot ik hem uitzet",
  "mail.autoReplyScheduled": "Aan in een periode",
  "mail.autoReplyFrom": "Van",
  "mail.autoReplyUntil": "Tot en met",
  "mail.autoReplyInternal": "Bericht aan collega's",
  "mail.autoReplyInternalPlaceholder": "Ik ben afwezig tot… Neem in dringende gevallen contact op met…",
  "mail.autoReplyExternalAudience": "Afzenders buiten Willems",
  "mail.autoReplyExternalNone": "Krijgen geen melding",
  "mail.autoReplyExternalContacts": "Alleen mijn contactpersonen",
  "mail.autoReplyExternalAll": "Iedereen die mij mailt",
  "mail.autoReplyExternal": "Bericht aan externen",
  "mail.autoReplyExternalPlaceholder": "I am currently out of office. For urgent matters please contact…",
  "mail.autoReplyExternalHint": "Dit bericht gaat naar klanten en leveranciers — houd het kort en zakelijk.",
  "mail.autoReplyInternalRequired":
    "Een melding die aanstaat heeft een bericht nodig — anders krijgt iedereen die je mailt een lege mail terug.",
  "mail.autoReplyExternalRequired":
    "Je hebt ingesteld dat afzenders buiten Willems een melding krijgen, dus dat bericht mag niet leeg zijn.",
  "mail.autoReplyNeedsReconnect":
    "WLX mag je afwezigheidsmelding nog niet beheren. Koppel je postvak opnieuw; daarbij vraagt WLX die toestemming erbij.",
  "mail.disconnectButton": "Postvak ontkoppelen",
  "mail.disconnectHint": "Verwijdert de toegang van WLX tot je eigen postvak",
  "mail.connectOk": "Je postvak is gekoppeld.",
  "mail.connectCancelled": "Koppelen geannuleerd — er is niets gewijzigd.",
  "mail.connectMismatch":
    "Het Microsoft-account waarmee je toestemming gaf is niet jouw WLX-account. Log bij Microsoft in met je eigen account en probeer het opnieuw.",
  "mail.connectError": "Koppelen is niet gelukt. Probeer het opnieuw.",
  "mail.bold": "Vet",
  "mail.italic": "Cursief",
  "mail.underline": "Onderstrepen",
  "mail.textColour": "Tekstkleur",
  "mail.textColourMore": "Andere tekstkleur kiezen",
  "mail.textColourAutomatic": "Automatisch",
  "mail.highlight": "Markeren",
  "mail.highlightMore": "Andere markeerkleur kiezen",
  "mail.highlightNone": "Geen kleur",
  "mail.colourDarkRed": "Donkerrood",
  "mail.colourRed": "Rood",
  "mail.colourOrange": "Oranje",
  "mail.colourYellow": "Geel",
  "mail.colourLightGreen": "Lichtgroen",
  "mail.colourGreen": "Groen",
  "mail.colourBrightGreen": "Felgroen",
  "mail.colourLightBlue": "Lichtblauw",
  "mail.colourBlue": "Blauw",
  "mail.colourDarkBlue": "Donkerblauw",
  "mail.colourPurple": "Paars",
  "mail.colourTurquoise": "Turquoise",
  "mail.colourPink": "Roze",
  "mail.colourTeal": "Groenblauw",
  "mail.colourViolet": "Violet",
  "mail.colourDarkYellow": "Donkergeel",
  "mail.colourGray50": "Grijs 50%",
  "mail.colourGray25": "Grijs 25%",
  "mail.colourBlack": "Zwart",
  "mail.bulletList": "Opsomming",
  "mail.numberList": "Genummerde lijst",
  "mail.link": "Link invoegen",
  "mail.formatPainter": "Opmaak kopiëren",
  "mail.formatPainterHint":
    "Opmaak kopiëren: neemt vet, cursief, onderstrepen, tekstkleur en markering over van de tekst waar je cursor of selectie in staat. Selecteer daarna de tekst die zo moet worden, of klik in een woord. Dubbelklik om het op meer tekst te doen; Esc stopt.",
  "mail.noSpacing": "Geen afstand",
  "mail.noSpacingHint":
    "Stijl Geen afstand, zoals in Outlook: enkele regelafstand en geen ruimte tussen de alinea's. Geldt voor de alinea's waar je cursor of selectie in staat; nog eens klikken zet ze terug.",
  "mail.imageBorder": "Omlijning",
  "mail.imageBorderHint": "Een dunne grijze lijn rond de afbeelding. Nog eens klikken haalt hem weg.",
  "mail.imageOriginalSize": "Oorspronkelijke grootte",
  "mail.imageOriginalSizeHint": "Zet de afbeelding terug op zijn eigen grootte, maar nooit breder dan de tekst.",
  "mail.imageResizeHint": "Sleep om de afbeelding groter of kleiner te maken",
  "mail.mentionSuggestions": "Suggesties voor ontvangers",
  "mail.linkPrompt": "Voer een URL in (https://…):",
  "mail.send": "Verzenden",
  "mail.sending": "Verzenden…",
  "mail.discardConfirm": "Deze mail is nog niet verzonden. Weggooien?",
  "mail.discardReplyConfirm": "Dit antwoord is nog niet verzonden. Weggooien?",
  "mail.replyParkHint": "Parkeren — het antwoord blijft in deze browser bij deze mail staan, en je kunt intussen andere mails beantwoorden",
  "mail.replyParked": "Je antwoord op deze mail staat als concept klaar.",
  "mail.replyParkedForward": "Je doorgestuurde mail staat als concept klaar.",
  "mail.replyResume": "Verder schrijven",
  "mail.replyDiscard": "Weggooien",
  "mail.replyParkedReplace": "Bij deze mail staat al een concept. Dat weggooien en opnieuw beginnen?",
  "mail.draftRow": "Concept",
  "mail.draftRowTitle": "Je bent een antwoord op deze mail begonnen en hebt het nog niet verzonden",
  "mail.processedUndoText": "Verplaatst naar Verwerkt.",
  "mail.processedUndo": "Ongedaan maken",
  "mail.replyError": "Versturen lukte niet — mogelijk ontbreekt nog het verstuurrecht (Mail.Send).",
  "mail.polish": "Netjes maken",
  "mail.polishing": "Bezig…",
  "mail.polishHint": "Verbeter spelling, hoofdletters en toon met AI; de begroeting past zich aan de klant aan.",
  "mail.polishError": "Netjes maken lukte niet. Probeer het opnieuw.",
  "mail.aiButton": "AI",
  "mail.toneNetjes": "Netjes maken",
  "mail.toneVriendelijk": "Vriendelijker",
  "mail.toneZakelijk": "Zakelijker",
  "mail.toneInformeel": "Informeler",
  "mail.toneDwingend": "Dwingender",
  "mail.aiHint": "AI: schrijf een concept of poets je tekst op",
  "mail.aiGroupReply": "Concept schrijven",
  "mail.aiGroupPolish": "Mijn tekst",
  "mail.aiPolishNeedsText": "Typ eerst je antwoord",
  "mail.styleZakelijk": "Zakelijk",
  "mail.styleVriendelijk": "Vriendelijk",
  "mail.styleInformeel": "Informeel",
  "mail.aiGroupTranslate": "Vertalen naar",
  "mail.langNl": "Nederlands",
  "mail.langEn": "Engels",
  "mail.langDe": "Duits",
  "mail.langFr": "Frans",
  "mail.assistant": "AI-assistent",
  "mail.assistantHint": "Open de AI-assistent — concept schrijven, verfijnen, vertalen, samenvatten",
  "mail.assistantTitle": "AI-assistent",
  "mail.assistantClose": "Sluiten",
  "mail.assistantConcept": "Concept",
  "mail.assistantSuggestionsLabel": "Snelle antwoorden",
  "mail.translateMailGroup": "Deze mail",
  "mail.translateDraftGroup": "Mijn concept",
  "mail.assistantVariants": "Meerdere concepten",
  "mail.assistantVariantsIntro": "Drie concepten met verschillende insteek — kies er één:",
  "mail.assistantSummarize": "Samenvatten",
  "mail.assistantTranslate": "Vertaal",
  "mail.assistantEmpty": "Kies een actie hierboven of stel een vraag. De assistent leest deze mail en je concept mee.",
  "mail.assistantThinking": "AI denkt na…",
  "mail.assistantInsert": "Invoegen",
  "mail.assistantReplace": "Vervang concept",
  "mail.assistantCopy": "Kopieer",
  "mail.assistantCopied": "Gekopieerd",
  "mail.assistantRefinePlaceholder": "Verfijn of vraag iets — bv. “korter”, “voeg toe dat we dinsdag kunnen leveren”",
  "mail.assistantStop": "Stop",
  "mail.assistantSend": "Stuur",
  "mail.assistantEnterHint": "Enter = sturen · Shift+Enter = nieuwe regel",
  "mail.checking": "Controleren…",
  "mail.checkTitle": "Controle vóór verzenden — even nakijken:",
  "mail.checkSendAnyway": "Toch verzenden",
  "mail.checkBack": "Terug",
  "mail.taskAiPropose": "AI-voorstel",
  "mail.taskAiBusy": "Bezig…",
  "mail.taskAiSummaryLabel": "AI-samenvatting",
  "mail.taskDescriptionLabel": "Omschrijving",
  "mail.taskDescriptionPlaceholder": "Korte omschrijving van de taak (AI-voorstel vult dit vanuit de mail).",
  "mail.manageMailboxes": "Postvakken beheren",
  "mail.summarize": "Samenvatten",
  "mail.summarizing": "Bezig…",
  "mail.summarizeHint": "Vat deze mail samen met AI",
  "mail.summarizeError": "Samenvatten lukte niet. Probeer het opnieuw.",
  "mail.summaryTitle": "Samenvatting",
  "mail.summaryClose": "Sluiten",
  "mail.delete": "Verwijderen",
  "mail.deleteHint": "Verplaats deze mail naar Verwijderde items — direct ongedaan te maken. Sneltoets: Delete.",
  "mail.deletedUndoText": "Verplaatst naar Verwijderde items.",
  "mail.bulkDelete": "Verwijderen",
  "mail.bulkDeleteConfirm_one": "{{count}} mail naar Verwijderde items verplaatsen?",
  "mail.bulkDeleteConfirm_other": "{{count}} mails naar Verwijderde items verplaatsen?",
  "mail.process": "Verwerken",
  "mail.processing": "Verwerken…",
  "mail.processHint": "Verplaats deze mail naar de map Verwerkt",
  "mail.processError": "Verwerken lukte niet — mogelijk ontbreekt nog het schrijfrecht (Mail.ReadWrite).",
  "mail.bulkHint": "Shift-klik voor een reeks · Ctrl-klik voor losse mails · Ctrl+A voor alle",
  "mail.bulkSelected_one": "{{count}} geselecteerd",
  "mail.bulkSelected_other": "{{count}} geselecteerd",
  "mail.bulkMarkRead": "Markeer gelezen",
  "mail.bulkMarkUnread": "Markeer ongelezen",
  "mail.bulkProcess": "Verwerken",
  "mail.bulkReadProcess": "Gelezen + verwerken",
  "mail.bulkToInbox": "Terug naar Postvak IN",
  "mail.bulkClear": "Selectie wissen",
  "mail.bulkDone_one": "{{count}} mail bijgewerkt.",
  "mail.bulkDone_other": "{{count}} mails bijgewerkt.",
  "mail.bulkPartial": "{{ok}} bijgewerkt, {{failed}} niet gelukt — die zijn mogelijk net verplaatst of verwijderd.",
  "mail.rowMenuLabel": "Acties voor deze mail",
  "mail.relatedHeader": "Verwante berichten zoeken",
  "mail.relatedFromSender": "Van deze afzender",
  "mail.relatedSubject": "Met dit onderwerp",
  "mail.downloadAllAttachments": "Alle {{count}} bijlagen downloaden (zip)",
  "mail.toInbox": "Terug naar Postvak IN",
  "mail.toInboxHint": "Verplaats deze mail terug naar Postvak IN",
  "mail.movingToInbox": "Terugzetten…",
  "mail.shortcutSend": "Ctrl + Enter",
  "mail.expectReply": "Verwacht reactie",
  "mail.expectReplyHint": "Bij versturen komt er een taak op Wacht op reactie; komt het antwoord binnen, dan staat hij op Gereageerd",
  "mail.expectReplyCreated": "Verzonden. Taak {{number}} wacht op reactie.",
  "mail.expectReplyExisting": "Verzonden. Taak {{number}} staat weer op Wacht op reactie.",
  "mail.expectReplyFailed": "Verzonden, maar de taak voor de reactie kon niet worden gemaakt. Maak hem met Maak taak op de verzonden mail.",
  "mail.expectReplyOpenTask": "Taak openen",
  "mail.composeNew": "Nieuwe mail",
  "mail.expand": "Uitklappen",
  "mail.collapse": "Inklappen",
  "mail.composeFullscreen": "Volledig scherm",
  "mail.composeExitFullscreen": "Volledig scherm verlaten",
  "mail.composeMinimize": "Parkeren",
  "mail.composeMinimizeHint": "Parkeren onderaan het scherm — de mail blijft zoals hij is, en je kunt intussen een andere schrijven",
  "mail.composePopOut": "Apart venster",
  "mail.composePopOutHint": "In een eigen venster zetten, om naar het andere scherm te slepen — de tekst, de ontvangers en de bijlagen gaan mee",
  "mail.composeTray": "Geparkeerde mails",
  "mail.composeTrayOpen": "Verder schrijven",
  "mail.composeTitle": "Nieuwe mail opstellen",
  "mail.composeFrom": "Van",
  "mail.composeTo": "Aan",
  "mail.composeToPlaceholder": "naam@bedrijf.nl (meerdere gescheiden door komma)",
  "mail.composeBcc": "Bcc",
  "mail.composeBccPlaceholder": "naam@bedrijf.nl — andere ontvangers zien dit niet",
  "mail.addBcc": "Bcc",
  "mail.addBccHint": "Voeg een blinde kopie toe — andere ontvangers zien deze adressen niet",
  "mail.composeCc": "Cc",
  "mail.composeCcPlaceholder": "optioneel",
  "mail.addCcHint": "Voeg een kopie toe",
  "mail.recipientRemove": "{{address}} weghalen",
  "mail.recipientEditHint": "Dubbelklik om te verbeteren; Backspace haalt het adres voor de cursor weg",
  "mail.recipientInvalid": "Dit is geen geldig e-mailadres — dubbelklik om te verbeteren",
  "mail.composeSubject": "Onderwerp",
  "mail.composeBody": "Bericht",
  "mail.attachAdd": "Bijlage toevoegen",
  "mail.attachDropHere": "Laat hier los om als bijlage toe te voegen",
  "mail.attachRemove": "Bijlage verwijderen",
  "mail.attachTooMany": "Maximaal {{count}} bijlagen.",
  "mail.attachFileTooLarge": "{{name}} is groter dan {{max}} MB en is overgeslagen.",
  "mail.attachTotalTooLarge": "Bijlagen mogen samen niet groter zijn dan {{max}} MB.",
  "mail.attachImageTooLarge": "Die afbeelding is groter dan {{max}} MB en past niet in de mail.",
  "mail.attachReadFailed": "{{name}} kon niet gelezen worden.",
  "mail.attachMail": "Mail bijvoegen",
  "mail.attachClipboardUnreadable":
    "Op het klembord staat een bestand dat de browser niet kan lezen — bijvoorbeeld gekopieerd in een andere sessie. Sla het eerst op en voeg het toe met de knop Bijlage toevoegen.",
  "mail.attachMailWrongMailbox": "Je kunt alleen een mail uit hetzelfde postvak bijvoegen.",
  "mail.attachMailTooMany": "Je kunt maximaal 10 mails bijvoegen.",
  "mail.attachMailRemove": "Bijgevoegde mail verwijderen",
  "mail.mailPickerTitle": "Mail als bijlage kiezen",
  "mail.mailPickerSearch": "Zoek op onderwerp of afzender…",
  "mail.mailPickerAdd": "Toevoegen",
  "mail.mailPickerEmpty": "Geen mails gevonden.",
  "mail.mailPickerAlreadyAdded": "Toegevoegd",
  "notif.bellLabel": "Meldingen",
  "notif.unreadPill_one": "{{count}} melding",
  "notif.unreadPill_other": "{{count}} meldingen",
  "notif.title": "Meldingen",
  "notif.markAllRead": "Alles gelezen",
  "notif.empty": "Geen meldingen",
  "notif.reactedOn": "{{actor}} reageerde op {{ref}}",
  "notif.askedYou": "{{actor}} vroeg jou iets op {{ref}}",
  "notif.forYou": "Voor jou",
  "notif.assignedToYou": "{{actor}} gaf {{ref}} aan jou",
  "notif.finishedForYou": "{{actor}} rondde {{ref}} af — jij kunt hem sluiten",
  "notif.involvedYou": "{{actor}} betrok je bij {{ref}}",
  "notif.someone": "Iemand",
  // Buiten de bel om — de teller in de navigatie, de tabtitel en de
  // bureaubladmelding (docs/notifications.md).
  "notif.waitingForYou_one": "{{count}} melding wacht op jou",
  "notif.waitingForYou_other": "{{count}} meldingen wachten op jou",
  "notif.desktopOn": "Je krijgt een melding op je bureaublad",
  "notif.desktopOff": "Melding op je bureaublad, ook als WLX op de achtergrond staat",
  "notif.desktopBlocked": "Je browser blokkeert meldingen van WLX",
  "notif.desktopEnable": "Aanzetten",
  "notif.desktopDisable": "Uitzetten",
  "notif.desktopBurstTitle_one": "{{count}} nieuwe melding in WLX",
  "notif.desktopBurstTitle_other": "{{count}} nieuwe meldingen in WLX",
  "notif.desktopBurstBody": "Open WLX om ze te bekijken",
  "mail.folderInbox": "Postvak IN",
  "mail.folderProcessed": "Verwerkt",
  "mail.folderSent": "Verzonden items",
  "mail.folderJunk": "Ongewenste e-mail",
  "mail.folderDeleted": "Verwijderde items",
  "mail.purge": "Definitief verwijderen",
  "mail.purgeHint": "Uit Verwijderde items halen. In WLX kan dat niet ongedaan worden; in Outlook haal je hem nog terug met Verwijderde items herstellen",
  "mail.purgeConfirm": "Deze mail definitief verwijderen? In WLX kun je dit niet ongedaan maken. In Outlook is hij nog een tijd terug te halen met Verwijderde items herstellen.",
  "mail.bulkPurge": "Definitief verwijderen",
  "mail.bulkPurgeConfirm_one": "Deze mail definitief verwijderen? In WLX kun je dit niet ongedaan maken. In Outlook is hij nog een tijd terug te halen met Verwijderde items herstellen.",
  "mail.bulkPurgeConfirm_other": "Deze {{count}} mails definitief verwijderen? In WLX kun je dit niet ongedaan maken. In Outlook zijn ze nog een tijd terug te halen met Verwijderde items herstellen.",
  "mail.junkNotice":
    "Deze mail staat in Ongewenste e-mail. Koppelingen werken hier niet en afbeeldingen blijven uit; achter elke koppeling staat waar hij heen gaat. Is het geen ongewenste mail, zet hem dan terug naar Postvak IN.",
  "mail.groupConversations": "Gesprekken groeperen",
  "mail.viewListPreview": "Voorbeeldtekst tonen",
  "mail.keepUnread": "Ongelezen laten",
  "mail.previousMessage": "Vorige mail",
  "mail.nextMessage": "Volgende mail",
  "mail.tasksPanelTitle": "Taken",
  "mail.tasksPanelResizeHint": "Versleep de rand om de taken breder of smaller te maken — dubbelklik voor de standaard",
  "mail.tasksPanelToggle": "Taken",
  "mail.tasksPanelToggleHint": "Toon je taken naast de mail",
  "mail.tasksPanelScope": "Van wie",
  "mail.tasksPanelMine": "Mijn taken",
  "mail.tasksPanelArrange": "Rangschikken op: opvolgdatum",
  "mail.tasksPanelOrderHint": "Andersom sorteren",
  "mail.tasksPanelEarliestFirst": "Vroegste eerst",
  "mail.tasksPanelLatestFirst": "Laatste eerst",
  "mail.tasksPanelNew": "Nieuwe taak typen",
  "mail.tasksPanelNewHintMine": "Typ een titel en druk op Enter: een eigen taak, zonder opvolgdatum",
  "mail.tasksPanelNewHintMailbox": "Typ een titel en druk op Enter: een taak in dit postvak, zonder opvolgdatum",
  "mail.tasksPanelComplete": "Markeren als voltooid",
  "mail.tasksPanelCompleted": "Afgerond: {{title}}",
  "mail.tasksPanelSentForReview": "Terug ter controle naar wie hem doorzette: {{title}}",
  "mail.tasksPanelUndo": "Ongedaan maken",
  "mail.tasksPanelEmpty": "Geen openstaande taken.",
  "mail.tasksPanelMore": "Er zijn meer taken — bekijk ze in Taken",
  "mail.tasksPanelError": "De taken konden niet worden geladen.",
  "mail.viewMenu": "Weergave",
  "mail.viewMenuHint": "Hoe het mailscherm eruitziet — leesvenster, lijst, opstellen",
  "mail.viewPaneLabel": "Leesvenster",
  "mail.viewPaneRight": "Rechts naast de lijst",
  "mail.viewPaneBottom": "Onder de lijst",
  "mail.viewPaneOff": "Uit — mail vult het scherm",
  "mail.viewListLabel": "Lijst",
  "mail.viewComposeLabel": "Opstellen",
  "mail.viewComposeWindow": "Nieuwe mail in een apart venster",
  "mail.viewComposeWindowHint": "Een nieuwe mail opent in een eigen venster, dat je naar het andere scherm sleept; daarna opent hij waar hij de vorige keer stond",
  "mail.viewReset": "Standaardweergave herstellen",
  "mail.viewResizeHint": "Versleep om de verdeling te wijzigen — dubbelklik voor de standaard",
  "mail.assistantResizeHint": "Versleep om het AI-venster breder of smaller te maken — dubbelklik voor de standaard",
  "mail.keepUnreadHint":
    "Markeer een mail niet automatisch als gelezen bij openen (handig tijdens triage). Sneltoetsen: J volgende, K vorige.",
  "mail.groupHint": "Berichten in dezelfde conversatie samenvoegen (per geladen pagina)",
  "mail.threadCount": "{{count}} berichten in dit gesprek",
  "mail.toggleThread": "Gesprek in-/uitklappen",
  "mail.messageGone": "Dit bericht is verplaatst of verwijderd.",
  "mail.createTaskTitle": "Taak maken van deze mail",
  "mail.taskAlreadyExisted":
    "Er was al een taak voor deze mail: {{number}}. Er is geen nieuwe taak gemaakt; wat je invulde is niet gebruikt.",
  "mail.addToTaskTitle": "Mail toevoegen aan een taak",
  "mail.addToTaskDesc": "Kies de taak waar deze mail aan toegevoegd moet worden — handig als het gesprek een nieuw onderwerp kreeg.",
  "mail.addToTaskMailboxGroup": "Taken van {{name}}",
  "mail.addToTaskPersonalGroup": "Mijn persoonlijke taken",
  "mail.noActiveTasks": "Geen open taken in dit postvak.",
  "tasks.colNumber": "Nummer",
  "tasks.colPriority": "Prio",
  "tasks.colCategory": "Kenmerk",
  "tasks.filterByPriority": "Filter op prioriteit",
  "tasks.allPriorities": "Alle prioriteiten",
  "tasks.priorityLabel": "Prioriteit",
  "tasks.priorityP1": "P1 — Kritiek",
  "tasks.priorityP2": "P2 — Hoog",
  "tasks.priorityP3": "P3 — Normaal",
  "tasks.priorityP4": "P4 — Laag",
  "tasks.priorityP5": "P5 — Zeer laag",
  "tasks.filterByCategory": "Filter op kenmerk",
  "tasks.allCategories": "Alle kenmerken",
  "tasks.categoryLabel": "Kenmerk",
  "tasks.categoryNone": "Geen kenmerk",
  "tasks.manageCategories": "Kenmerken beheren",
  "tasks.assignedToLabel": "Doorgezet naar {{name}}",
  "tasks.escalateButton": "Doorzetten",
  "tasks.escalateTitle": "Taak doorzetten",
  "tasks.escalateDesc":
    "Zet de taak door naar een collega die kan helpen. De collega wordt opvolger en ziet de taak, ook zonder lid te zijn van het postvak.",
  "tasks.escalateToLabel": "Doorzetten naar",
  "tasks.escalateToPlaceholder": "Kies een collega…",
  "tasks.escalateSuggestLabel": "Deze klant eerder behandeld door",
  "tasks.escalateSuggestHint": "Heeft {{count}} eerdere taak van deze klant afgehandeld",
  "tasks.escalateSearchPlaceholder": "Zoek een collega…",
  "tasks.escalateChange": "Wijzigen",
  "tasks.escalateNone": "Niet doorzetten",
  "tasks.escalateNoMatch": "Geen collega gevonden.",
  "tasks.escalateNoteLabel": "Toelichting",
  "tasks.escalateNotePlaceholder": "Waarom zet je deze taak door?",
  "tasks.escalateNoteHelp": "Verplicht — de toelichting komt in de tijdlijn van de taak.",
  "tasks.escalateSubmit": "Doorzetten",
  "tasks.activityEscalated": "Doorgezet naar {{to}}",
  "tasks.colOrder": "Order",
  "tasks.withOrder": "Bij een order",
  "tasks.orderLabel": "Order",
  "tasks.orderUnlink": "Loskoppelen",
  "tasks.orderPickPlaceholder": "Ordernummer, referentie of klant",
  "tasks.orderPickNone": "Geen order gevonden",
  "tasks.scopeHelpOrder": "Persoonlijk bij een order: iedereen die de order kan openen, ziet de taak.",
  "tasks.scopePersonalOrder": "Persoonlijk (bij de order)",
  "tasks.assigneeMyself": "Ikzelf",
  "tasks.assigneeOrderHelp": "Je collega krijgt hem meteen. Rondt die hem af, dan komt hij bij jou terug ter controle.",
  "tasks.activityMadeFor": "Aangemaakt voor {{to}}",
  "tasks.mergeButton": "Samenvoegen",
  "tasks.mergeHelp": "Voeg deze taak samen met een dubbele taak",
  "tasks.mergeTitle": "Taak samenvoegen",
  "tasks.mergeDesc":
    "Voeg deze taak ({{task}}) samen met een andere taak. De e-mails en interne reacties verhuizen naar die taak; deze taak blijft als verwijzing bestaan.",
  "tasks.mergeSearchLabel": "Doeltaak (deze blijft bestaan)",
  "tasks.mergeSearchPlaceholder": "Zoek op nummer of titel…",
  "tasks.mergeSearchHint": "Typ minimaal 2 tekens om een taak te zoeken.",
  "tasks.mergeNoResults": "Geen taken gevonden.",
  "tasks.mergeConfirm":
    "{{source}} wordt samengevoegd in {{target}}. De e-mails en reacties verhuizen naar {{target}}; {{source}} blijft als verwijzing bestaan.",
  "tasks.mergeSubmit": "Samenvoegen",
  "tasks.mergedBanner": "Deze taak is samengevoegd in {{number}}.",
  "tasks.mergedBannerLink": "Naar de samengevoegde taak",
  "tasks.mergedFromLabel": "Samengevoegd vanuit:",
  "tasks.openTaskFallback": "taak",
  "tasks.catNew": "Nieuw kenmerk",
  "tasks.catNewTitle": "Kenmerk toevoegen",
  "tasks.catColName": "Naam",
  "tasks.catColList": "Lijst",
  "tasks.catListLabel": "In welke lijst?",
  "tasks.catListPersonal": "Mijn kenmerken",
  "tasks.catListShared": "Gedeeld postvak",
  "tasks.catListHelp":
    "Je eigen kenmerken zie alleen jij. Kenmerken van een gedeeld postvak zijn voor alle leden. Achteraf verplaatsen kan niet — taken die het kenmerk al dragen zouden stranden.",
  "tasks.catColSortOrder": "Volgorde",
  "tasks.catColStatus": "Status",
  "tasks.catEmpty": "Nog geen kenmerken. Voeg het eerste kenmerk toe.",
  "tasks.catNameLabel": "Naam",
  "tasks.catNamePlaceholder": "bijv. Facturatie",
  "tasks.catSortOrderLabel": "Volgorde",
  "tasks.catSortOrderHelp": "Lagere nummers staan bovenaan in de keuzelijsten.",
  "tasks.catCreateButton": "Kenmerk toevoegen",

  // Weekday abbreviations (Monday-first)
  "weekdays.0": "Ma",
  "weekdays.1": "Di",
  "weekdays.2": "Wo",
  "weekdays.3": "Do",
  "weekdays.4": "Vr",
  "weekdays.5": "Za",
  "weekdays.6": "Zo",
  // Warehouse — Plekken, Artikelen, Instellingen (docs/design_handoff_wms/README.md §4)
  "nav.warehouseWork": "Werk",
  "nav.warehouseCrossdock": "Crossdock",
  "nav.warehouseStock": "Voorraad",
  "nav.warehouseInbound": "Ontvangsten",
  "nav.warehouseReplenishment": "Aanvullen",
  "nav.warehouseOutbound": "Orders",
  "nav.warehouseLocations": "Opslaglocaties",
  "nav.warehouseArticles": "Artikelen",
  "nav.warehouseVas": "VAS",
  "vasCodes.count": "{{count}} van {{total}} codes",
  "vasCodes.empty": "Geen VAS-codes die bij de filters passen",
  "vasCodes.col.code": "Code",
  "vasCodes.col.description": "Omschrijving",
  "vasCodes.col.moment": "Moment",
  "vasCodes.col.scanner": "Op scanner",
  "vasCodes.col.customerList": "Klantenlijst",
  "vasCodes.col.appliesTo": "Op een order",
  "vasCodes.col.atOrderEntry": "In het portaal",
  "vasCodes.appliesTo.header": "Hele order",
  "vasCodes.appliesTo.article": "Regel",
  "vasCodes.appliesTo.both": "Order of regel",
  "vasCodes.appliesTo.none": "Niet op een order",
  "vasCodes.atOrderEntryTick": "{{code}} kiesbaar in het portaal",
  "vasCodes.col.handling": "Handeling",
  "vasCodes.col.registration": "Vastleggen",
  "vasCodes.col.breaksPallet": "Pallet breken",
  "vasCodes.col.fullPalletsOnly": "Eén batch per pallet",
  "vasCodes.col.state": "Stand",
  "vasCodes.moment.startRide": "Voor de rit",
  "vasCodes.moment.startOrder": "Voor het laden",
  "vasCodes.moment.pickAmount": "Bij het picken",
  "vasCodes.moment.toStack": "Bij het stapelen",
  "vasCodes.moment.newBatch": "Bij een nieuwe batch",
  "vasCodes.moment.finishOrder": "Na het laden",
  "vasCodes.moment.orderReady": "Bij gereed melden",
  "vasCodes.handling.instruction": "Alleen instructie",
  "vasCodes.handling.restack": "Afstapelen",
  "vasCodes.handling.tilt": "Kantelen",
  "vasCodes.handling.step": "Eigen stap",
  "vasCodes.handlingHelp.instruction": "Tekst voor de picker of lader. De order gaat na het picken gewoon naar Verzameld.",
  "vasCodes.handlingHelp.restack": "Na het picken naar Klaar voor VAS; de goederen gaan op nieuwe pallets, tot de load quantity op de palletsoort van de klant.",
  "vasCodes.handlingHelp.tilt": "Na het picken naar Klaar voor VAS; de goederen gaan op nieuwe pallets, van blok naar blok.",
  "vasCodes.handlingHelp.step": "Na het picken naar Klaar voor VAS; op de scanner starten en klaar melden.",
  "vasCodes.registration.none": "Niets",
  "vasCodes.registration.seal": "Zegelnummer",
  "vasCodes.registration.container_number": "Containernummer",
  "vasCodes.registration.trailer_plate": "Kenteken oplegger",
  "vasCodes.registration.truck_plate": "Kenteken trekker",
  "vasCodes.registration.transport_reference": "Transportreferentie",
  "vasCodes.registration.amount": "Aantal",
  "vasCodes.level.pallet": "per pallet",
  "vasCodes.level.order": "per order",
  "vasCodes.levelLabel": "Per pallet of per order",
  "vasCodes.levelChoose": "Kies…",
  "vasCodes.registrationHelp": "Wat de vloer bij deze code vastlegt, zoals een zegel op iedere pallet of het kenteken van de oplegger.",
  "vasCodes.state.used": "In gebruik",
  "vasCodes.state.retired": "Niet gebruiken",
  "vasCodes.state.gone": "Niet meer in de lijst",
  "vasCodes.breaksPalletLabel": "Mag een pallet breken die anders heel blijft",
  "vasCodes.breaksPalletHelp": "Voor een sample: een regel met deze code pakt zakken of dozen uit een pallet die anders heel de deur uit gaat.",
  "vasCodes.fullPalletsOnlyLabel": "Eén batch per pallet: geen pallets met meer batches",
  "vasCodes.fullPalletsOnlyHelp": "Zoals I032: voor een order of regel met deze code komen de delen op de verzameldrager uit één batch, dus gaat er geen restpallet van een andere batch bij: volle pallets, en voor wat overblijft een deel uit één batch. Een pallet met meer batches gaat nooit heel mee. Wie minder dan een volle pallet bestelt, krijgt gewoon minder.",
  "vasCodes.retiredLabel": "Niet gebruiken",
  "vasCodes.retiredHelp": "Een oude of testcode: niet op de scanner, geen Groot VAS en niet in de download voor klanten.",
  "vasCodes.editTitle": "VAS-code {{code}}",
  "nav.warehouseConfirmations": "Bevestigingen",
  "confirmations.direction.inbound": "Inslag",
  "confirmations.direction.outbound": "Uitslag",
  "confirmations.state.waiting_document": "Wacht op vrachtbrief",
  "confirmations.state.deviation": "Afwijking",
  "confirmations.state.queued": "Onderweg",
  "confirmations.state.sent": "Verstuurd",
  "confirmations.state.failed": "Niet verstuurd",
  "confirmations.deviation.manco": "Manco",
  "confirmations.deviation.blocked": "Geblokkeerd",
  "confirmations.deviation.both": "Manco en geblokkeerd",
  "confirmations.deviation.none": "Geen",
  "confirmations.error.not_wanted": "De klant wil geen bevestiging meer (Communicatie op de relatiekaart)",
  "confirmations.error.too_large": "De scan en de foto zijn samen te groot voor één mail",
  "confirmations.col.direction": "Richting",
  "confirmations.col.party": "Klant",
  "confirmations.col.documentNumber": "Documentnummer",
  "confirmations.col.reference": "Referentie",
  "confirmations.col.readyAt": "Gereed",
  "confirmations.col.state": "Stand",
  "confirmations.col.deviation": "Afwijking",
  "confirmations.col.freightDocument": "Vrachtbrief",
  "confirmations.col.dossier": "Dossier",
  "confirmations.col.remark": "Opmerking",
  "confirmations.col.sent": "Verstuurd",
  "confirmations.owner": "Eigenaar {{owner}}",
  "confirmations.requested": "Document opgevraagd {{at}}",
  "confirmations.approve": "Afwijking akkoord",
  "confirmations.withoutDocument": "Versturen zonder vrachtbrief",
  "confirmations.withoutDocumentBy": "Zonder vrachtbrief ({{name}})",
  "confirmations.photo": "Foto afwijking",
  "confirmations.noDossier": "Geen dossier in WLX",
  "confirmations.approvedBy": "Akkoord: {{name}}, {{at}}",
  "confirmations.searchPlaceholder": "Zoek op documentnummer, klant of dossier",
  "confirmations.viewLabel": "Weergave",
  "confirmations.view.open": "Open",
  "confirmations.view.sent": "Verstuurd (14 dagen)",
  "confirmations.view.all": "Alles",
  "confirmations.count": "{{count}} van {{total}}",
  "confirmations.emptyOpen": "Niets wacht: alle bevestigingen zijn verstuurd.",
  "confirmations.empty": "Geen bevestigingen.",
  "confirmations.approveTitle": "Afwijking akkoord — {{number}}",
  "confirmations.approveSubmit": "Akkoord en versturen",
  "confirmations.approveIntro": "{{party}} krijgt de inbound confirmation met de afwijking ({{deviation}}). De opmerking staat vet in de mail.",
  "confirmations.remarkLabel": "Opmerking voor de klant",
  "confirmations.remarkHelp": "Bijvoorbeeld: 2 pallets minder ontvangen, in overleg met de klant.",
  "confirmations.photoLabel": "Foto (niet verplicht)",
  "confirmations.photoHelp": "Een jpg, png of pdf. Hij komt in het dossier en gaat mee met de mail.",
  "confirmations.photoNoDossier": "Deze order heeft geen dossier in WLX, dus een foto kan niet.",
  "confirmations.withoutDocumentTitle": "Versturen zonder vrachtbrief — {{number}}",
  "confirmations.withoutDocumentSubmit": "Versturen",
  "confirmations.withoutDocumentIntro": "{{party}} krijgt de bevestiging zonder de gescande vrachtbrief. Komt de scan later, dan gaat hij niet meer mee.",
  "parties.purposeWarehouseOutRequest": "Documentverzoek uitslag",
  "parties.waitForDocument": "Wacht op de vrachtbrief",
  "parties.waitForDocumentLabel": "{{purpose}}: wacht op de gescande vrachtbrief",
  "nav.warehouseSettings": "Instellingen",
  "nav.warehouseScannerUsers": "Scannergebruikers",
  "perm.modWmsScanner": "Scanner gebruiken",
  "perm.modWmsScannerLogins": "Scannergebruikers beheren",
  "perm.modPartnerUsers": "Portaalgebruikers beheren",
  "scannerLogins.intro": "Wie op de scanner inlogt zonder Entra: de vloer van het magazijn. Een nieuwe medewerker krijgt een tijdelijk wachtwoord en kiest bij de eerste keer inloggen een eigen wachtwoord. Wachtwoord vergeten? Geef een nieuw tijdelijk wachtwoord; elke scanner die nog met het oude is ingelogd, stopt dan.",
  "scannerLogins.new": "Nieuwe scannergebruiker",
  "scannerLogins.newTitle": "Nieuwe scannergebruiker",
  "scannerLogins.newExplain": "Voor een medewerker zonder Entra. WLX maakt een tijdelijk wachtwoord en laat het één keer zien.",
  "scannerLogins.kindLabel": "Voor wie",
  "scannerLogins.kind.new": "Nieuwe medewerker",
  "scannerLogins.kind.existing": "Bestaande gebruiker (met Entra)",
  "scannerLogins.existingExplain": "Voor iemand die al in WLX staat, zoals een teamleider of beheerder die ook scant: dezelfde persoon, met een gebruikersnaam en wachtwoord voor de scanner. WLX maakt een tijdelijk wachtwoord en laat het één keer zien.",
  "scannerLogins.searchPerson": "Wie",
  "scannerLogins.searchPersonHint": "Zoek op naam of e-mail",
  "scannerLogins.noPerson": "Niemand gevonden, of die heeft al een scannerinlog.",
  "scannerLogins.otherPerson": "Iemand anders",
  "scannerLogins.rolesAdd": "Rol erbij",
  "scannerLogins.rolesAddHint": "Alleen nodig als de eigen rol de scanner niet toestaat.",
  "scannerLogins.create": "Aanmaken",
  "scannerLogins.colName": "Naam",
  "scannerLogins.colUsername": "Gebruikersnaam",
  "scannerLogins.colRoles": "Rollen",
  "scannerLogins.colStatus": "Status",
  "scannerLogins.colLastLogin": "Laatst ingelogd",
  "scannerLogins.colActions": "Acties",
  "scannerLogins.usernameHint": "Kleine letters, cijfers en . _ - — kort, het wordt met handschoenen getypt (bijvoorbeeld het personeelsnummer).",
  "scannerLogins.noRoles": "Geen enkele rol mag de scanner gebruiken. Geef eerst een rol het recht Scanner gebruiken (Beheer → Rechten).",
  "scannerLogins.status.active": "Actief",
  "scannerLogins.status.waiting": "Wacht op eigen wachtwoord",
  "scannerLogins.status.locked": "Vergrendeld",
  "scannerLogins.status.off": "Uit",
  "scannerLogins.alsoEntra": "ook Entra",
  "scannerLogins.adminOnly": "Alleen een beheerder",
  "scannerLogins.unlock": "Ontgrendelen",
  "scannerLogins.reset": "Tijdelijk wachtwoord",
  "scannerLogins.turnOff": "Uitzetten",
  "scannerLogins.turnOn": "Aanzetten",
  "scannerLogins.empty": "Nog geen scannergebruikers.",
  "scannerLogins.temporaryPassword": "Tijdelijk wachtwoord",
  "scannerLogins.createdTitle": "{{name}} kan inloggen",
  "scannerLogins.resetTitle": "Nieuw tijdelijk wachtwoord voor {{name}}",
  "scannerLogins.createdExplain": "Geef dit door aan de medewerker. Bij de eerste keer inloggen op de scanner kiest de medewerker een eigen wachtwoord. WLX laat dit wachtwoord niet nog eens zien.",
  "scannerLogins.resetExplain": "Geef dit door aan de medewerker. Elke scanner die nog met het oude wachtwoord is ingelogd, is nu uitgelogd; bij het inloggen kiest de medewerker een eigen wachtwoord. WLX laat dit wachtwoord niet nog eens zien.",
  "scannerLogins.done": "Klaar",
  "portal.intro": "Deze mensen zien de zendingen van {{party}} en voeren orders in.",
  "portal.mailOff": "De portaalmail staat nog niet aan (PARTNER_MAIL_SENDER en PARTNER_PORTAL_BASE_URL). Uitnodigen kan pas als die er zijn.",
  "portal.mailOffLocal": "De portaalmail staat uit. Lokaal laat WLX de link hier zien in plaats van hem te mailen.",
  "portal.invite": "Uitnodigen",
  "portal.inviteTitle": "Iemand uitnodigen voor {{party}}",
  "portal.inviteExplain": "Hij of zij krijgt een mail met een link die één keer werkt, zeven dagen lang. Daarmee kiest hij een wachtwoord en koppelt een authenticator-app.",
  "portal.emailInvalid": "Dit is geen geldig e-mailadres",
  "portal.colName": "Naam",
  "portal.colEmail": "E-mailadres",
  "portal.colLanguage": "Taal",
  "portal.colStatus": "Status",
  "portal.colLastLogin": "Laatst ingelogd",
  "portal.colInvited": "Uitgenodigd",
  "portal.colOtherParties": "Ook voor",
  "portal.colActions": "Acties",
  "portal.language.nl": "Nederlands",
  "portal.language.en": "Engels",
  "portal.language.de": "Duits",
  "portal.status.active": "Actief",
  "portal.status.invited": "Uitgenodigd",
  "portal.status.expired": "Uitnodiging verlopen",
  "portal.status.locked": "Dicht",
  "portal.status.disabled": "Uitgezet",
  "portal.invitedBy": "door {{name}}",
  "portal.reinvite": "Opnieuw uitnodigen",
  "portal.reset": "Toegang opnieuw instellen",
  "portal.unlock": "Ontgrendelen",
  "portal.turnOff": "Uitzetten",
  "portal.turnOn": "Aanzetten",
  "portal.empty": "Nog niemand van deze relatie op het klantenportaal.",
  "portal.resetTitle": "Toegang van {{name}} opnieuw instellen?",
  "portal.resetExplain": "Het wachtwoord, de koppeling met de app en de herstelcodes werken daarna niet meer, en {{name}} is overal uitgelogd. Er gaat een nieuwe uitnodiging naar {{email}}. Doe dit bij een nieuwe telefoon, of als het wachtwoord vergeten is en de telefoon ook weg is.",
  "portal.resetConfirm": "Opnieuw instellen",
  "portal.unlinkTitle": "{{name}} loskoppelen van {{party}}?",
  "portal.unlinkExplain": "{{name}} ziet deze relatie dan niet meer op het klantenportaal.",
  "portal.unlinkLast": "Het is de enige relatie van {{name}}, dus het account gaat ook uit.",
  "portal.unlinkConfirm": "Loskoppelen",
  "portal.sentTitle": "Uitnodiging verstuurd",
  "portal.notSentTitle": "Uitnodiging niet verstuurd",
  "portal.localTitle": "Link klaar",
  "portal.localExplain": "Lokaal gaat er geen mail uit. Met de link hieronder stelt {{name}} het account in; hij werkt tot {{until}}.",
  "portal.sentExplain": "{{name}} krijgt een mail op {{email}}. De link werkt tot {{until}}.",
  "portal.notSent": "De mail is niet verstuurd. Het account staat er wel: probeer het later opnieuw met Opnieuw uitnodigen.",
  "portal.localLink": "Lokaal, zonder mail: de link om het account in te stellen",
  "portal.copy": "Kopiëren",
  "portal.copied": "Gekopieerd",
  "portal.linkedTitle": "Gekoppeld",
  "portal.linkedExplain": "{{name}} stond al op het klantenportaal en werkt nu ook voor deze relatie. Er gaat geen nieuwe uitnodiging uit.",
  "portal.done": "Klaar",
  "portal.introTitle": "Toegang tot het klantenportaal",
  "portal.inviteMore": "Meer tegelijk",
  "portal.inviteSend": "Uitnodiging versturen",
  "portal.languageLabel": "Taal van de mail en het portaal",
  "portal.emailHelp": "Staat dit adres al bij een andere relatie, dan is het dezelfde persoon: we koppelen hem, en hij kiest na het inloggen voor welk bedrijf hij werkt. Er gaat dan geen nieuwe uitnodiging uit.",
  "portal.status.lockedUntil": "Dicht tot {{time}}",
  "portal.status.invitedUntil": "Uitgenodigd · link tot {{date}}",
  "portal.never": "nog nooit",
  "portal.menu": "Acties voor {{name}}",
  "portal.resetHint": "Wachtwoord, app en herstelcodes vervallen, alle sessies stoppen. {{name}} krijgt een nieuwe uitnodiging.",
  "portal.notLocked": "niet dicht",
  "portal.stock": "Voorraad in het portaal",
  "portal.stockNoOwner": "Deze klant heeft nog geen WMS-kenmerk (Systeemkenmerken op de tab Algemeen): het portaal toont dan geen voorraad.",
  "portal.stockOwners_one": "Het portaal vraagt de voorraad van eigenaar {{owners}} in het magazijn op het moment dat de klant kijkt.",
  "portal.stockOwners_other": "Het portaal vraagt de voorraad van de eigenaren {{owners}} in het magazijn op het moment dat de klant kijkt.",
  "portal.unlinkFrom": "Loskoppelen van {{party}}",
  "portal.changedNote": "Wat een klant zelf doet (wachtwoord wijzigen, telefoon koppelen) telt niet mee in Laatst gewijzigd.",
  "portal.carriers": "Eigen dragers",
  "portal.carriersNone": "geen: de klant kiest uit de vaste lijst (Europallet, Blokpallet, IBC, Rolcontainer, …).",
  "portal.carriersAsShort": "{{name}} als {{carrier}}",
  "portal.carriersManage": "Beheren",
  "portal.carriersTitle": "Eigen dragers van {{party}}",
  "portal.carriersExplain": "De klant ziet deze dragers bovenaan bij Order invoeren, de vaste lijst eronder. Elke drager telt als de vaste drager ernaast: die bepaalt de laadmeters en de palletplaatsen. De naam komt in de omschrijving van de zending, zodat planning en de CMR zien welke drager het is. Een drager weghalen of hernoemen verandert niets aan orders die al verstuurd zijn.",
  "portal.carriersName": "Naam",
  "portal.carriersAs": "Telt als",
  "portal.carriersAdd": "Drager toevoegen",
  "portal.carriersRemove": "{{name}} weghalen",
  "portal.carriersSave": "Opslaan",
  "portal.carriersDuplicate": "Elke drager heeft een eigen naam.",
  "portal.carriersChanged": "Laatst gewijzigd {{date}}",
  "portal.carriersChangedBy": "Laatst gewijzigd {{date}} door {{name}}",
  "portal.carrierAs.europallet": "Europallet (0,4 lm)",
  "portal.carrierAs.block_pallet": "Blokpallet (0,5 lm)",
  "portal.carrierAs.block_pallet_06": "Blokpallet (0,6 lm)",
  "portal.carrierAs.block_pallet_09": "Blokpallet (0,9 lm)",
  "portal.carrierAs.ibc_02": "IBC (0,2 lm)",
  "portal.carrierAs.ibc_04": "IBC (0,4 lm)",
  "portal.carrierAs.ibc": "IBC (0,5 lm)",
  "portal.carrierAs.ibc_06": "IBC (0,6 lm)",
  "portal.carrierAs.big_bag": "Big Bag (0,5 lm)",
  "portal.carrierAs.roll_container": "Rolcontainer (laadmeters typen)",
  "portal.carrierAs.box": "Colli of dozen (laadmeters typen)",
  "portal.carrierAs.other": "Overig (laadmeters typen)",
  "portal.batch.title": "Uitnodigen voor {{party}}",
  "portal.batch.explain": "Plak de mensen die nu in het TALIX Portal voor deze klant werken, of voeg ze een voor een toe. Vink uit wie niet mee moet, en pas zo nodig de taal aan. WLX bewaart de lijst niet: alleen wie je verstuurt, krijgt een account.",
  "portal.batch.tickAll": "Alles aan- of uitvinken",
  "portal.batch.colLastTalix": "Laatst in TALIX",
  "portal.batch.remove": "Weghalen",
  "portal.batch.addPerson": "Iemand toevoegen",
  "portal.batch.pasteOpen": "Of plak een lijst",
  "portal.batch.pasteLabel": "Plak een lijst: naam; e-mail; taal; laatst ingelogd",
  "portal.batch.pastePlaceholder": "{{code}}; Marieke de Wit; m.dewit@klant.nl; NL; 17-11-2026",
  "portal.batch.pasteHelp": "Uit Excel of met puntkomma's, in elke volgorde. Een kolom met de code van de klant mag erbij: regels van een andere klant dan {{code}} blijven weg.",
  "portal.batch.take": "Overnemen",
  "portal.batch.taken_one": "{{count}} persoon overgenomen",
  "portal.batch.taken_other": "{{count}} mensen overgenomen",
  "portal.batch.otherCustomer_one": "{{count}} regel van een andere klant overgeslagen",
  "portal.batch.otherCustomer_other": "{{count}} regels van andere klanten overgeslagen",
  "portal.batch.unreadable_one": "{{count}} regel zonder e-mailadres",
  "portal.batch.unreadable_other": "{{count}} regels zonder e-mailadres",
  "portal.batch.invitations_one": "{{count}} nieuwe uitnodiging",
  "portal.batch.invitations_other": "{{count}} nieuwe uitnodigingen",
  "portal.batch.links_one": "{{count}} koppeling",
  "portal.batch.links_other": "{{count}} koppelingen",
  "portal.batch.send_one": "{{count}} versturen",
  "portal.batch.send_other": "{{count}} versturen",
  "portal.batch.why.invalidEmail": "geen geldig e-mailadres",
  "portal.batch.why.invalidName": "de naam ontbreekt",
  "portal.batch.why.duplicate": "staat er twee keer in",
  "portal.batch.why.onRelation": "staat al op het portaal voor deze klant",
  "portal.batch.why.willems": "een adres van Willems zelf",
  "portal.batch.why.stale": "al lang niet ingelogd in het TALIX Portal",
  "portal.batch.why.linked_one": "heeft al toegang tot {{count}} relatie: wordt gekoppeld",
  "portal.batch.why.linked_other": "heeft al toegang tot {{count}} relaties: wordt gekoppeld",
  "portal.batch.colOutcome": "Uitkomst",
  "portal.batch.outcome.invited": "Uitgenodigd",
  "portal.batch.outcome.linked": "Gekoppeld",
  "portal.batch.outcome.exists": "Stond er al",
  "portal.batch.outcome.failed": "Niet gelukt",
  "portal.batch.reasonError": "er ging iets mis",
  "portal.batch.notMailed": "De mail ging niet weg: probeer het later met Opnieuw uitnodigen.",
  "portal.batch.until": "link tot {{until}}",
  "portal.batch.done.invited_one": "{{count}} uitgenodigd",
  "portal.batch.done.invited_other": "{{count}} uitgenodigd",
  "portal.batch.done.linked_one": "{{count}} gekoppeld",
  "portal.batch.done.linked_other": "{{count}} gekoppeld",
  "portal.batch.done.exists_one": "{{count}} stond er al",
  "portal.batch.done.exists_other": "{{count}} stonden er al",
  "portal.batch.done.failed_one": "{{count}} niet gelukt",
  "portal.batch.done.failed_other": "{{count}} niet gelukt",
  "transition.stand.not_invited": "Nog niet uitgenodigd",
  "transition.stand.invited": "Uitgenodigd",
  "transition.stand.over": "Over",
  "transition.stand.done": "Klaar",
  "transition.segment.all": "Alle",
  "transition.segment.not_invited": "Nog niet",
  "transition.segment.invited": "Uitgenodigd",
  "transition.segment.over": "Over",
  "transition.segment.done": "Klaar",
  "transition.colCustomer": "Klant",
  "transition.colWeek": "Week",
  "transition.colPilot": "Proef",
  "transition.colStand": "Stand",
  "transition.colInvited": "Uitgenodigd",
  "transition.colLoggedIn": "Ingelogd",
  "transition.colLastLogin": "Laatst ingelogd",
  "transition.colOrdersTalix": "Orders via TALIX",
  "transition.colOrdersPortal": "Orders in portaal",
  "transition.colCutoff": "Aanmeldtijd",
  "transition.colStock": "Voorraad",
  "transition.colTalixClosed": "TALIX dicht",
  "transition.colNote": "Notitie",
  "transition.week": "wk {{week}}",
  "transition.pilot": "proef",
  "transition.expired_one": "{{count}} link verlopen",
  "transition.expired_other": "{{count}} links verlopen",
  "transition.search": "Zoek een klant",
  "transition.rowsOf": "{{shown}} van {{total}}",
  "transition.add": "Klanten toevoegen",
  "transition.empty": "Nog geen klanten op de lijst. Voeg ze toe met hun code.",
  "transition.noneFound": "Geen klanten met dit filter.",
  "transition.invite": "Uitnodigen",
  "transition.invitePeople": "Mensen uitnodigen",
  "transition.menu": "Acties voor {{name}}",
  "transition.edit": "Week, proef en notitie",
  "transition.markDone": "Klaar: TALIX dicht",
  "transition.reopen": "Weer open: TALIX nog niet dicht",
  "transition.remove": "Van de lijst halen",
  "transition.removeTitle": "{{name}} van de lijst halen?",
  "transition.removeExplain": "{{name}} staat dan niet meer op de overgangslijst. De mensen op het portaal houden hun account.",
  "transition.removeConfirm": "Van de lijst halen",
  "transition.ordersNote": "Orders: de laatste {{days}} dagen, via de brug uit het TALIX Portal of in het portaal ingevoerd. Over: iemand van de klant logde in. Klaar: de toegang tot het TALIX Portal is dicht.",
  "transition.addTitle": "Klanten toevoegen",
  "transition.addCodes": "Codes van de klanten",
  "transition.addCodesHelp": "Eén code per regel, het VR-nummer. Wat erachter staat telt niet, dus een kolom uit Excel kan zo.",
  "transition.addSubmit_one": "{{count}} toevoegen",
  "transition.addSubmit_other": "{{count}} toevoegen",
  "transition.pilotLabel": "Proef",
  "transition.addOutcome.added_one": "{{count}} klant toegevoegd",
  "transition.addOutcome.added_other": "{{count}} klanten toegevoegd",
  "transition.addOutcome.already_one": "{{count}} stond er al",
  "transition.addOutcome.already_other": "{{count}} stonden er al",
  "transition.addOutcome.unknown_one": "{{count}} code onbekend",
  "transition.addOutcome.unknown_other": "{{count}} codes onbekend",
  "transition.addOutcome.not_customer_one": "{{count}} is geen verkooprelatie",
  "transition.addOutcome.not_customer_other": "{{count}} zijn geen verkooprelatie",
  "transition.addOutcome.inactive_one": "{{count}} is niet actief",
  "transition.addOutcome.inactive_other": "{{count}} zijn niet actief",
  "transition.editTitle": "{{name}} wijzigen",
  "transition.doneTitle": "{{name}} klaar zetten",
  "transition.doneExplain": "Zet eerst in TALIX de toegang van {{name}} tot het TALIX Portal dicht. Vul dan de dag in: de klant staat daarna op Klaar.",
  "transition.doneConfirm": "Klaar zetten",
  "transition.closedHelp": "De dag dat de toegang tot het TALIX Portal dicht ging. Leeg: nog open.",
  "warehouse.kind.receiving": "Ontvangst",
  "warehouse.kind.bulk": "Bulk",
  "warehouse.kind.floor": "Vloer",
  "warehouse.kind.pick": "Pick",
  "warehouse.kind.pallet": "Palletlocatie",
  "warehouse.kind.staging": "Expeditie",
  "warehouse.kind.dock": "Dock",
  "warehouse.kind.lost_found": "Lost & found",
  "warehouse.kind.damaged": "Breuk",
  "warehouse.kind.inspection": "Controle",
  "warehouse.kind.replenishment": "Aanvullocatie",
  "warehouse.property.cooled": "Gekoeld",
  "warehouse.property.frozen": "Bevroren",
  "warehouse.property.hazardous": "Gevaarlijke stoffen",
  "warehouse.property.dry": "Droog",
  "warehouse.blockReason.damaged": "Beschadigd",
  "warehouse.blockReason.quality": "Kwaliteit",
  "warehouse.blockReason.customer": "Op verzoek van de klant",
  "warehouse.blockReason.count_difference": "Telverschil",
  "warehouse.blockReason.question": "Openstaande vraag",
  "warehouse.blockReason.other": "Anders",
  "warehouse.status.free": "Vrij",
  "warehouse.status.occupied": "Bezet",
  "warehouse.status.blocked": "Geblokkeerd",
  "warehouse.status.lostFound": "Lost & found",
  "warehouse.status.outOfUse": "Uit gebruik",
  "warehouse.uom.PCE_one": "stuk",
  "warehouse.uom.PCE_other": "stuks",
  "warehouse.uom.CT_one": "doos",
  "warehouse.uom.CT_other": "dozen",
  "warehouse.uom.BG_one": "zak",
  "warehouse.uom.BG_other": "zakken",
  "warehouse.uom.PF_one": "pallet",
  "warehouse.uom.PF_other": "pallets",
  "warehouse.uom.KGM_one": "kilo",
  "warehouse.uom.KGM_other": "kilo",
  "warehouse.uom.other_one": "eenheid",
  "warehouse.uom.other_other": "eenheden",
  "warehouse.level.cu": "CU · basiseenheid",
  "warehouse.level.tu": "TU · handelseenheid",
  "warehouse.level.du": "DU · pallet",
  "warehouse.unitField.name": "naam",
  "warehouse.unitField.unitOfMeasure": "soort eenheid",
  "warehouse.unitField.quantityOfChild": "bevat",
  "warehouse.unitField.gtin": "GTIN",
  "warehouse.unitField.netWeightKg": "nettogewicht",
  "warehouse.unitField.grossWeightKg": "brutogewicht",
  "warehouse.unitField.lengthCm": "lengte",
  "warehouse.unitField.widthCm": "breedte",
  "warehouse.unitField.heightCm": "hoogte",
  "warehouse.unitField.volumeM3": "volume",
  "warehouse.unitField.perLayer": "per laag",
  "warehouse.unitField.splittable": "splitsbaar",
  "warehouse.setting.pickMode": "Picken",
  "warehouse.setting.pickModeHint": "Wie kiest de pallets?",
  "warehouse.setting.batchPicking": "Batchpicken",
  "warehouse.setting.batchPickingHint": "Meerdere orders in één ronde",
  "warehouse.setting.stackPicking": "Stapelen",
  "warehouse.setting.stackPickingHint": "Pallets op een verzameldrager",
  "warehouse.setting.mergePartials": "Deelpallets samenvoegen",
  "warehouse.setting.mergePartialsHint": "Restanten op één pallet",
  "warehouse.setting.oneBatchPerPallet": "Eén batch per pallet",
  "warehouse.setting.oneBatchPerPalletHint": "Geen gemengde batches op een pallet",
  "warehouse.setting.pickByLocationScan": "Picken van de locatie",
  "warehouse.setting.pickByLocationScanHint": "Locatie scannen in plaats van pallet",
  "warehouse.setting.replenishMode": "Aanvullen",
  "warehouse.setting.replenishModeHint": "Hoe de picklocatie weer vol komt",
  "warehouse.setting.outboundDay": "Orders per week op",
  "warehouse.setting.outboundDayHint": "Welke datum de week van Orders bepaalt",
  "warehouse.setting.receiveOnStaging": "Ontvangen op expeditieplek",
  "warehouse.setting.receiveOnStagingHint": "Elke ontvangen pallet wordt op een expeditieplek gescand",
  "warehouse.setting.loadAfterActivation": "Laden na activeren",
  "warehouse.setting.loadAfterActivationHint": "Een order wordt pas geladen als hij geactiveerd is",
  "warehouse.setting.shadowMode": "Schaduw",
  "warehouse.setting.shadowModeHint": "Scoretrace is leidend en de vloer scant in beide systemen",
  "warehouse.setting.receiptQuestions": "Vragen bij ontvangst",
  "warehouse.setting.receiptQuestionsHint": "Controles per magazijn, per klant aan te vullen",
  "warehouse.settingOn": "Aan",
  "warehouse.settingOff": "Uit",
  "warehouse.settingValue.pickMode.reserve": "Reserveren",
  "warehouse.settingValue.pickMode.free": "Vrij",
  "warehouse.settingValue.mergePartials.none": "Niet",
  "warehouse.settingValue.mergePartials.same_batch": "Zelfde batch",
  "warehouse.settingValue.mergePartials.mixed_batches": "Ook gemengde batches",
  "warehouse.settingValue.replenishMode.replace": "Vervangen",
  "warehouse.settingValue.replenishMode.top_up": "Bijvullen",
  "warehouse.settingValue.outboundDay.load": "Laaddag",
  "warehouse.settingValue.outboundDay.delivery": "Losdag",
  "warehouse.settingEffect.pickMode.reserve": "Het systeem kiest bij het vrijgeven van de order; de picker scant wat er gevraagd wordt.",
  "warehouse.settingEffect.pickMode.free": "De picker kiest een pallet die aan de order voldoet; het systeem controleert de scan.",
  "warehouse.settingEffect.batchPicking.true": "Orders worden samen in één pickronde gepickt.",
  "warehouse.settingEffect.batchPicking.false": "Elke order wordt apart gepickt.",
  "warehouse.settingEffect.stackPicking.true": "De scanner vraagt na elke pallet om de verzameldrager.",
  "warehouse.settingEffect.stackPicking.false": "Elke pallet gaat los naar de expeditie.",
  "warehouse.settingEffect.mergePartials.none": "Deelpallets blijven zoals ze zijn.",
  "warehouse.settingEffect.mergePartials.same_batch": "Deelpallets van dezelfde batch worden samengevoegd tot een volle pallet.",
  "warehouse.settingEffect.mergePartials.mixed_batches": "Deelpallets worden samengevoegd, ook met verschillende batches.",
  "warehouse.settingEffect.oneBatchPerPallet.true": "Een tweede batch op dezelfde pallet wordt op de scanner geweigerd.",
  "warehouse.settingEffect.oneBatchPerPallet.false": "Batches mogen samen op een pickpallet.",
  "warehouse.setting.deliveredCheck": "THT-controle per afnemer",
  "warehouse.setting.deliveredCheckHint": "Een afnemer krijgt nooit een kortere THT dan hij al kreeg",
  "warehouse.setting.pickReport": "PIC-bericht",
  "warehouse.setting.pickReportHint": "Voor landen met een COKZ-keuring liggen de batches vooraf vast en hoort de klant ze",
  "warehouse.setting.palletTypeAtReceipt": "Palletsoort wijzigen bij ontvangst",
  "warehouse.setting.palletTypeAtReceiptHint": "Een pallet kan op een andere palletsoort binnenkomen dan bij het artikel staat",
  "warehouse.settingEffect.deliveredCheck.true": "WLX levert nooit een kortere THT van een artikel dan de afnemer al kreeg; anders valt de regel kort. Noemt de klant een batch, dan telt het niet.",
  "warehouse.settingEffect.deliveredCheck.false": "Alleen de minimale THT van de order telt.",
  "warehouse.settingEffect.pickReport.true": "Een order naar een land met COKZ-keuring krijgt 5 werkdagen voor de laaddag (Brazilië 15) vaste batches; de klant krijgt het PIC-bericht.",
  "warehouse.settingEffect.pickReport.false": "Geen PIC-bericht; de vloer pickt FEFO.",
  "warehouse.settingEffect.palletTypeAtReceipt.true": "De vloer kan bij het ontvangen een andere palletsoort kiezen.",
  "warehouse.settingEffect.palletTypeAtReceipt.false": "De vloer ziet de palletsoort van het artikel en kan hem niet wijzigen.",
  "warehouse.settingEffect.pickByLocationScan.true": "De picker scant de locatie in plaats van de pallet.",
  "warehouse.settingEffect.pickByLocationScan.false": "De picker scant de pallet.",
  "warehouse.settingEffect.replenishMode.replace": "Pas een nieuwe pallet op de picklocatie als de oude leeg is.",
  "warehouse.settingEffect.replenishMode.top_up": "De locatie wordt bijgevuld met dezelfde batch zodra hij onder de drempel komt.",
  "warehouse.settingEffect.outboundDay.load": "Orders toont per dag wat er die dag wordt afgehaald; de losdag staat ernaast.",
  "warehouse.settingEffect.outboundDay.delivery": "Orders toont per dag wat er die dag bij de ontvanger moet zijn; de laaddag staat ernaast.",
  "warehouse.settingEffect.receiveOnStaging.true": "De vloer scant elke ontvangen pallet op een expeditieplek (S01 …).",
  "warehouse.settingEffect.receiveOnStaging.false": "Een ontvangen pallet komt op de ontvangstplek van de ontvangst.",
  "warehouse.settingEffect.loadAfterActivation.true": "Laden kan pas als kantoor (of iTV of de portal) de order activeerde; de scanner bevestigt kenteken of containernummer.",
  "warehouse.settingEffect.loadAfterActivation.false": "Laden kan zonder activeren; de vloer tikt het kenteken in.",
  "warehouse.settingEffect.shadowMode.true": "Scoretrace is leidend: elke scanner toont de schaduwbalk en WLX stuurt de klant niets.",
  "warehouse.settingEffect.shadowMode.false": "WLX is het magazijnsysteem.",
  "warehouse.addArticle": "Artikel toevoegen",
  "warehouse.addModeLabel": "Wat toevoegen",
  "warehouse.addModeSeries": "Een reeks",
  "warehouse.addModeSingle": "Eén locatie",
  "warehouse.addPlaces": "Locaties toevoegen",
  "warehouse.addSeriesSubmit_one": "{{count}} locatie toevoegen",
  "warehouse.addSeriesSubmit_other": "{{count}} locaties toevoegen",
  "warehouse.addSingleSubmit": "Locatie toevoegen",
  "warehouse.addTitle": "Locaties toevoegen in {{warehouse}}",
  "warehouse.addedOne": "{{name}} is toegevoegd.",
  "warehouse.addedResult_one": "{{count}} locatie toegevoegd.",
  "warehouse.addedResult_other": "{{count}} locaties toegevoegd.",
  "warehouse.aisleLabel": "Gang",
  "warehouse.articleActiveLabel": "In gebruik",
  "warehouse.articleCodeHelp": "Zoals de klant het stuurt, met voorloopnullen.",
  "warehouse.articleCodeLabel": "Artikelnummer",
  "warehouse.articleCount_one": "{{count}} artikel",
  "warehouse.articleCount_other": "{{count}} artikelen",
  "warehouse.articleDescriptionLabel": "Omschrijving",
  "warehouse.articleGroupLabel": "Artikelgroep van de klant",
  "warehouse.articleListLabel": "Artikelen",
  "warehouse.articleSearch": "Artikel of code",
  "warehouse.articleShortLabel": "Korte omschrijving",
  "warehouse.articlesMore": "{{shown}} van {{total}} getoond: zoek om de rest te vinden.",
  "warehouse.articlesNoMatch": "Geen artikel gevonden.",
  "warehouse.articlesNone": "Deze klant heeft nog geen artikelen.",
  "warehouse.barcodeLabel": "Barcode",
  "warehouse.batchPureAll": "Alle niveaus",
  "warehouse.batchPureBottom": "Alleen onderin",
  "warehouse.blockAction": "Blokkeren…",
  "warehouse.blockExplain": "Een geblokkeerde locatie weigert wegzetten op de scanner. De reden komt in het logboek.",
  "warehouse.blockReasonLabel": "Reden",
  "warehouse.blockRemarkLabel": "Toelichting",
  "warehouse.blockSubmit": "Blokkeren",
  "warehouse.blockTitle_one": "{{count}} locatie blokkeren",
  "warehouse.blockTitle_other": "{{count}} locaties blokkeren",
  "warehouse.blockedBy": "Geblokkeerd op {{when}} door {{who}}",
  "warehouse.blockedResult": "Geblokkeerd: {{count}}.",
  "warehouse.blockedResultAlready": "Geblokkeerd: {{count}}. Stond al geblokkeerd: {{already}}.",
  "warehouse.blocksNone": "Deze locatie is nog nooit geblokkeerd.",
  "warehouse.blocksTitle": "Blokkades",
  "warehouse.cellHint": "Klik om voor deze klant af te wijken",
  "warehouse.check.batchAndBestBefore": "Batch en THT verplicht bij ontvangst",
  "warehouse.check.batchRequired": "Batch verplicht bij ontvangst",
  "warehouse.check.bestBeforeRequired": "THT verplicht bij ontvangst",
  "warehouse.check.minDespatch": "Minimale houdbaarheid bij uitlevering",
  "warehouse.check.minReceipt": "Minimale houdbaarheid bij ontvangst",
  "warehouse.check.palletNumberRequired": "Palletnummer verplicht bij ontvangst",
  "warehouse.check.temperature": "Temperatuur",
  "warehouse.checkSentence.batchAndBestBefore": "Uit het GS1-label; anders vraagt de scanner erom.",
  "warehouse.checkSentence.minDespatch": "Een pallet met een kortere THT wordt bij het picken geweigerd.",
  "warehouse.checkSentence.minReceipt": "Een pallet met een kortere THT wordt bij ontvangst geweigerd.",
  "warehouse.checkSentence.palletNumber": "De scanner vraagt het palletvolgnummer bij ontvangst.",
  "warehouse.checkSentence.temperature": "Wegzetten kan alleen op een locatie met deze eigenschap.",
  "warehouse.checksSubtitle": "Dwingt het systeem af, op de scanner",
  "warehouse.checksTitle": "Controles",
  "warehouse.chooseOwnerFirst": "Kies rechtsboven een klant om zijn artikelen te zien.",
  "warehouse.clearSelection": "Selectie wissen",
  "warehouse.colActions": "Acties",
  "warehouse.colBatchPure": "Batchrein",
  "warehouse.colContains": "Bevat",
  "warehouse.colDimensions": "Afmeting (l × b × h)",
  "warehouse.colGtin": "GTIN op label",
  "warehouse.colKind": "Soort",
  "warehouse.colMaxHeight": "Max hoogte",
  "warehouse.colMaxWeight": "Max gewicht",
  "warehouse.colOwner": "Klant",
  "warehouse.colPlace": "Locatie",
  "warehouse.colProperties": "Eigenschappen",
  "warehouse.colSinglePallet": "Eén pallet",
  "warehouse.colSource": "Bron",
  "warehouse.colStatus": "Status",
  "warehouse.colUnit": "Pallet",
  "warehouse.colUnitKind": "Soort",
  "warehouse.colUnitName": "Eenheid",
  "warehouse.colWeight": "Gewicht",
  "warehouse.days_one": "{{count}} dag",
  "warehouse.days_other": "{{count}} dagen",
  "warehouse.deviating": "{{count}} afwijkend",
  "warehouse.deviatingFrom": "{{count}} afwijkend van {{name}}",
  "warehouse.duContainsLabel": "Bevat (TU per DU)",
  "warehouse.editAction": "Bewerken",
  "warehouse.editArticleTitle": "Artikel {{code}} bewerken",
  "warehouse.filledByWlx_one": "{{count}} veld aangevuld of aangepast door WLX",
  "warehouse.filledByWlx_other": "{{count}} velden aangevuld of aangepast door WLX",
  "warehouse.followsStandard": "standaard",
  "warehouse.followsStandardOf": "Volgt de standaard van {{name}}",
  "warehouse.fromCustomerLocked": "Dit artikel komt van de klant: omschrijving en artikelgroep blijven zoals de klant ze stuurde. De controles en de opslag zijn van WLX.",
  "warehouse.fromSettings": "uit Instellingen",
  "warehouse.grossWeightLabel": "Brutogewicht (kg)",
  "warehouse.groupChip": "Groep {{group}}",
  "warehouse.gtinLabel": "GTIN",
  "warehouse.head.aisles_one": "{{count}} gang",
  "warehouse.head.aisles_other": "{{count}} gangen",
  "warehouse.head.batchPureAll": "batchrein",
  "warehouse.head.batchPureBottom": "batchrein onderin",
  "warehouse.head.batchPureSome": "{{count}} batchrein",
  "warehouse.head.blocked": "{{count}} geblokkeerd",
  "warehouse.head.levels_one": "{{count}} niveau",
  "warehouse.head.levels_other": "{{count}} niveaus",
  "warehouse.head.perLevel_one": "{{count}} locatie per niveau",
  "warehouse.head.perLevel_other": "{{count}} locaties per niveau",
  "warehouse.head.places_one": "{{count}} locatie",
  "warehouse.head.places_other": "{{count}} locaties",
  "warehouse.head.racks_one": "{{count}} stelling",
  "warehouse.head.racks_other": "{{count}} stellingen",
  "warehouse.head.zones_one": "{{count}} zone",
  "warehouse.head.zones_other": "{{count}} zones",
  "warehouse.heightCmLabel": "Max hoogte (cm)",
  "warehouse.heightLabel": "Hoogte (cm)",
  "warehouse.inUseLabel": "In gebruik",
  "warehouse.keep": "Niet wijzigen",
  "warehouse.colWalkOrder": "Looproute",
  "warehouse.walkOrderAction": "Looproute…",
  "warehouse.walkOrderTitle_one": "Looproute van {{count}} locatie",
  "warehouse.walkOrderTitle_other": "Looproute van {{count}} locaties",
  "warehouse.walkOrderMode.number": "Nummeren",
  "warehouse.walkOrderMode.clear": "Uit de route halen",
  "warehouse.walkOrderExplain": "De scanner loopt de picks af van laag naar hoog. De locaties krijgen op volgorde van hun naam een nummer, met een stap ertussen zodat er later een locatie tussen past.",
  "warehouse.walkOrderClearExplain": "Zonder nummer komen deze locaties achteraan in de route, op naam.",
  "warehouse.walkOrderStart": "Beginnen bij",
  "warehouse.walkOrderStep": "Stap",
  "warehouse.walkOrderDirection": "Volgorde",
  "warehouse.walkOrderAsc": "Op naam, oplopend",
  "warehouse.walkOrderDesc": "Op naam, aflopend",
  "warehouse.walkOrderPreview": "{{first}} krijgt {{from}}, {{last}} krijgt {{to}}.",
  "warehouse.walkOrderPreviewOne": "{{first}} krijgt {{from}}.",
  "warehouse.kindAction": "Soort wijzigen",
  "warehouse.kindTitle_one": "Soort van {{count}} locatie wijzigen",
  "warehouse.kindTitle_other": "Soort van {{count}} locaties wijzigen",
  "warehouse.lengthLabel": "Lengte (cm)",
  "warehouse.levelsLabel": "Niveaus",
  "warehouse.matrixCaption": "Grijs = volgt de standaard van {{name}}. Klik een cel om voor die klant af te wijken; de wijziging komt in het logboek.",
  "warehouse.maxWeightKgLabel": "Max gewicht (kg)",
  "warehouse.minDespatchLabel": "Min. houdbaarheid bij uitlevering (dagen)",
  "warehouse.minReceiptLabel": "Min. houdbaarheid bij ontvangst (dagen)",
  "warehouse.netWeightLabel": "Nettogewicht (kg)",
  "warehouse.newArticleExplain": "Een artikel dat WLX zelf aanmaakt. Stuurt de klant het later in een artikelbericht, dan komen zijn eenheden erbij.",
  "warehouse.newArticleSubmit": "Artikel toevoegen",
  "warehouse.newArticleTitle": "Nieuw artikel voor {{owner}}",
  "warehouse.noArticleChosen": "Kies links een artikel.",
  "warehouse.noCustomerUnits": "Nog geen eenheden van de klant. Vul ze aan of wacht op het artikelbericht.",
  "warehouse.noOwnersYet": "Nog geen klanten in {{name}}: een klant komt hier met zijn eerste artikel of een eigen instelling. Zoek er een op met Klant kiezen.",
  "warehouse.noRequirement": "Geen eis",
  "warehouse.noThresholds": "Geen drempels",
  "warehouse.noWarehouses": "Er zijn nog geen magazijnen.",
  "warehouse.occupancy": "Bezetting",
  "warehouse.optional": "optioneel",
  "warehouse.ownerChoose": "Klant kiezen",
  "warehouse.ownerIn": "{{owner}} in {{warehouse}}",
  "warehouse.ownerLabel": "Klant: {{name}}",
  "warehouse.ownerListLabel": "Klanten",
  "warehouse.ownerNone": "Geen klant gevonden.",
  "warehouse.ownerSearch": "Klant zoeken",
  "warehouse.ownerTypeToFind": "Typ een naam om een klant te vinden.",
  "warehouse.perLayerLabel": "Per laag",
  "warehouse.pickAdd": "Picklocatie toevoegen",
  "warehouse.pickAddTitle": "Picklocatie toevoegen",
  "warehouse.pickEditTitle": "Picklocatie in {{warehouse}}",
  "warehouse.pickMaxLabel": "Aanvullen tot",
  "warehouse.pickMinLabel": "Aanvullen onder",
  "warehouse.pickNone": "Nog geen vaste picklocatie.",
  "warehouse.pickPlaceLabel": "Locatie",
  "warehouse.pickSubtitle": "Vast, per magazijn",
  "warehouse.pickTitle": "Picklocatie",
  "warehouse.pickUnitLabel": "Drempels in",
  "warehouse.pickerAria": "Magazijn",
  "warehouse.pickerLabel": "Magazijn: {{name}}",
  // Warehouse → Crossdock (docs/tms-crossdock.md)
  "crossdock.depotLabel": "Depot: {{name}}",
  "crossdock.depotAria": "Kies het depot",
  "crossdock.noDepots": "Geen vestiging is een depot. Zet het vinkje Depot bij Beheer → Vestigingen.",
  "crossdock.tabIncoming": "Binnenkomend ({{count}})",
  "crossdock.tabOutgoing": "Uitgaand ({{count}})",
  "crossdock.emptyIncoming": "Op {{day}} komt er geen wagen lossen in {{depot}}.",
  "crossdock.emptyOutgoing": "Op {{day}} laadt er geen rit in {{depot}}.",
  "crossdock.phaseExpected": "Verwacht",
  "crossdock.phaseArrived": "Aangekomen",
  "crossdock.phaseUnloaded": "Gelost",
  "crossdock.phaseWaiting": "Wacht op lading",
  "crossdock.phaseLate": "Komt laat binnen",
  "crossdock.phaseWarehouse": "Uit het warehouse",
  "crossdock.phaseComplete": "Compleet",
  "crossdock.phaseLoaded": "Geladen",
  "crossdock.kindPickup": "Ophaling",
  "crossdock.kindShuttle": "Depotpendel",
  "crossdock.kindFactoryShuttle": "Fabriekspendel",
  "crossdock.kindDelivery": "Levering",
  "crossdock.kindDirect": "Direct",
  "crossdock.kindWarehouse": "Warehouse",
  "crossdock.colTrip": "Rit",
  "crossdock.colKind": "Soort",
  "crossdock.colExpected": "Verwacht",
  "crossdock.colDeparture": "Vertrek",
  "crossdock.colVehicle": "Wagen",
  "crossdock.colTrailer": "Oplegger",
  "crossdock.colDriver": "Chauffeur / charter",
  "crossdock.colShipments": "Zendingen",
  "crossdock.colInDepot": "Binnen",
  "crossdock.colOnward": "Gaat verder met",
  "crossdock.colWaitingFor": "Wacht op",
  "crossdock.colPallets": "Pallets",
  "crossdock.colLoadingMeters": "Ldm",
  "crossdock.colWeight": "Gewicht",
  "crossdock.colPhase": "Stand",
  "crossdock.colTripStatus": "Status rit",
  "crossdock.colConsignment": "Zending",
  "crossdock.colCustomer": "Klant",
  "crossdock.colFrom": "Van",
  "crossdock.colTo": "Naar",
  "crossdock.colReference": "Referentie",
  "crossdock.colTemperature": "Temperatuur",
  "crossdock.colOnwardOne": "Gaat verder met",
  "crossdock.colInboundOne": "Komt binnen met",
  "crossdock.colState": "In het depot",
  "crossdock.arrivedAt": "binnen {{time}}",
  "crossdock.departedAt": "weg {{time}}",
  "crossdock.notPlannedCount": "{{count}} nog niet gepland",
  "crossdock.staysCount": "{{count}} blijft in het warehouse",
  "crossdock.notPlanned": "Nog niet gepland",
  "crossdock.staysInWarehouse": "Blijft in het warehouse",
  "crossdock.fromWarehouse": "Uit het warehouse",
  "crossdock.staysInTrailer": "blijft in de oplegger",
  "crossdock.stateUnloaded": "Gelost",
  "crossdock.stateNotUnloaded": "Nog niet gelost",
  "crossdock.stateInDepot": "Binnen",
  "crossdock.stateNotInDepot": "Nog niet binnen",
  "crossdock.stateUnknown": "Niet gemeld",
  "crossdock.colDock": "Dock",
  "crossdock.colUnloadingList": "Loslijst",
  "crossdock.colLoadingList": "Laadlijst",
  "crossdock.colAction": "Gelost / geladen",
  "crossdock.paperNever": "Niet geprint",
  "crossdock.paperPrinted": "Geprint",
  "crossdock.paperPrintedAt": "Geprint {{at}}",
  "crossdock.paperChanged": "Gewijzigd na printen",
  "crossdock.dockAria": "Dock van rit {{trip}}",
  "crossdock.undo": "Terugzetten",
  "crossdock.markUnloaded": "Gelost",
  "crossdock.markLoaded": "Geladen",
  "crossdock.remarkUnloading": "Opmerking op de loslijst",
  "crossdock.remarkLoading": "Opmerking op de laadlijst",
  "crossdock.picked": "{{count}} geselecteerd",
  "crossdock.pickAll": "Alle ritten kiezen",
  "crossdock.pickTrip": "Rit {{trip}} kiezen",
  "crossdock.printUnloadingButton": "Loslijst printen…",
  "crossdock.printLoadingButton": "Laadlijst printen…",
  "crossdock.printCouplingButton": "Koppellijst…",
  "crossdock.printUnloadingOne": "Loslijst van {{number}}",
  "crossdock.printUnloadingMany": "Loslijsten van {{count}} ritten",
  "crossdock.printLoadingOne": "Laadlijst van {{number}}",
  "crossdock.printLoadingMany": "Laadlijsten van {{count}} ritten",
  "crossdock.printCouplingTitle": "Koppellijst {{depot}}",
  "crossdock.printCouplingHelp": "De wagens van dit depot die vandaag met een oplegger vertrekken, op volgorde van vertrek.",
  "crossdock.printUnloadingList": "Loslijst",
  "crossdock.printLoadingList": "Laadlijst",
  "crossdock.printLabels": "Palletlabels",
  "crossdock.printDone": "Naar {{place}}: {{what}}.",
  "crossdock.printDoneUnloading": "{{count}} loslijst(en)",
  "crossdock.printDoneLoading": "{{count}} laadlijst(en)",
  "crossdock.printDoneLabels": "{{count}} palletlabel(s)",
  "crossdock.printDoneScoretrace": "de belading naar Scoretrace",
  "crossdock.printCouplingDone": "de koppellijst met {{count}} wagen(s)",
  "warehouse.placeCodeLabel": "Code van de locatie",
  "warehouse.placeSearch": "Locatie zoeken",
  "warehouse.placeUnitsNone": "Er staat niets op deze locatie.",
  "warehouse.placesNone": "Geen locaties die hieraan voldoen.",
  "warehouse.placesNoneYet": "Dit magazijn heeft nog geen locaties. Voeg ze toe met Locaties toevoegen.",
  "warehouse.positionsLabel": "Locaties per niveau",
  "warehouse.previewCodes_one": "{{count}} locatie: {{first}}",
  "warehouse.previewCodes_other": "{{count}} locaties: {{first}} … {{last}}",
  "warehouse.previewExisting": "{{count}} van deze locaties bestaan al: {{names}}.",
  "warehouse.previewIncomplete": "Vul de gang en de aantallen in om de codes te zien.",
  "warehouse.propertiesAction": "Eigenschappen",
  "warehouse.propertiesExplain": "Alleen wat je invult of kiest, verandert; de rest blijft zoals het per locatie is.",
  "warehouse.propertiesTitle_one": "Eigenschappen van {{count}} locatie",
  "warehouse.propertiesTitle_other": "Eigenschappen van {{count}} locaties",
  "warehouse.rackFromLabel": "Stelling van",
  "warehouse.rackToLabel": "Stelling tot en met",
  "warehouse.receiptQuestionsLater": "Staat bij Vragen en controles (volgt).",
  "warehouse.releaseAction": "Vrijgeven…",
  "warehouse.releaseExplain": "De locatie kan weer gebruikt worden. Zeg waarom; het komt in het logboek.",
  "warehouse.releaseRemarkLabel": "Waarom vrijgeven",
  "warehouse.releaseSubmit": "Vrijgeven",
  "warehouse.releaseTitle_one": "{{count}} locatie vrijgeven",
  "warehouse.releaseTitle_other": "{{count}} locaties vrijgeven",
  "warehouse.releasedBy": "Vrijgegeven op {{when}} door {{who}}: {{remark}}",
  "warehouse.releasedResult": "Vrijgegeven: {{count}}.",
  "warehouse.replenishFollowWarehouse": "Zoals het magazijn",
  "warehouse.replenishLabel": "Aanvulwijze",
  "warehouse.replenishThresholds": "Aanvullen",
  "warehouse.saveSettings": "Opslaan",
  "warehouse.selectPage": "Alles op deze pagina selecteren",
  "warehouse.selectPlace": "{{name}} selecteren",
  "warehouse.selectedCount": "{{count}} geselecteerd",
  "warehouse.setPropertiesLabel": "Opslageigenschappen vervangen door:",
  "warehouse.settingsAdminOnly": "Alleen een beheerder wijzigt instellingen, tot besloten is welke rol dat mag.",
  "warehouse.settingsSaved_one": "{{count}} wijziging opgeslagen.",
  "warehouse.settingsSaved_other": "{{count}} wijzigingen opgeslagen.",
  "warehouse.shelfLifeLabel": "Houdbaarheid (dagen)",
  "warehouse.sourceCustomer": "klant",
  "warehouse.sourceWlx": "WLX",
  "warehouse.ssccPerPallet": "SSCC per pallet",
  "warehouse.standard": "Standaard",
  "warehouse.standardHint": "geldt tenzij de klant afwijkt",
  "warehouse.standardOf": "Standaard {{name}}",
  "warehouse.storageLabel": "Opslag",
  "warehouse.thresholds": "onder {{min}}, tot {{max}}",
  "warehouse.tree.aisle": "Gang {{aisle}}",
  "warehouse.tree.floor": "Vloer · ontvangst en expeditie",
  "warehouse.tree.noAisle": "Zonder gang",
  "warehouse.tree.noRack": "Zonder stelling",
  "warehouse.tree.noZone": "Zonder zone",
  "warehouse.tree.rack": "Stelling {{rack}}",
  "warehouse.tree.special": "Lost & found, breuk, controle",
  "warehouse.tree.zone": "Zone {{zone}}",
  "warehouse.treeEmpty": "Nog geen locaties.",
  "warehouse.treeLabel": "Indeling van het magazijn",
  "warehouse.tuContainsLabel": "Bevat (CU per TU)",
  "warehouse.unitAdd": "Eenheid toevoegen",
  "warehouse.unitAddTitle": "Eenheid toevoegen",
  "warehouse.unitEditTitle": "Eenheid {{level}}",
  "warehouse.unitFill": "Aanvullen",
  "warehouse.unitFromCustomer": "Deze eenheid komt van de klant. Wat de klant stuurde blijft; wat leeg is, kan WLX aanvullen.",
  "warehouse.unitLevelLabel": "Niveau",
  "warehouse.unitNameLabel": "Naam",
  "warehouse.unitOfMeasureLabel": "Soort eenheid",
  "warehouse.unitsNone": "Nog geen eenheden.",
  "warehouse.unitsOnPlace": "Op deze locatie",
  "warehouse.unitsSubtitle": "Werkeenheid op de scanner: {{unit}}.",
  "warehouse.unitsSubtitleClosed": "Werkeenheid op de scanner: {{unit}} — een {{unit}} gaat niet open.",
  "warehouse.unitsSubtitleWhole": "Werkeenheid op de scanner: {{unit}} — die gaat heel de deur uit, behalve met een VAS-code die hem mag breken (een sample).",
  "warehouse.unitsSubtitleNone": "Zonder eenheden kan de scanner niet tellen.",
  "warehouse.unitsTitle": "Eenheden",
  "warehouse.unsavedChanges_one": "{{count}} wijziging nog niet opgeslagen",
  "warehouse.unsavedChanges_other": "{{count}} wijzigingen nog niet opgeslagen",
  "warehouse.updatedResult": "Gewijzigd: {{count}}.",
  "warehouse.warehouseLabel": "Magazijn",
  "warehouse.warehouseTitle": "Magazijn {{name}}",
  "warehouse.warehouseValue": "{{name}}: {{value}}",
  "warehouse.widthLabel": "Breedte (cm)",
  "warehouse.zoneLabel": "Zone",
  "warehouse.adminOverride": "Je past gegevens van de klant aan. Dat mag bij uitzondering: in het logboek staat wat de klant stuurde en wat jij ervan maakte.",
  "warehouse.unitFromCustomerAdmin": "Deze eenheid komt van de klant. Als beheerder kun je bij uitzondering ook de waarden van de klant aanpassen; ze krijgen dan het label WLX en komen in het logboek.",
  "warehouse.adminOnly": "alleen beheerder",
  "warehouse.editWarehouse": "Magazijn bewerken",
  "warehouse.editWarehouseTitle": "Magazijn {{code}}",
  "warehouse.warehouseNameLabel": "Naam",
  "warehouse.addressLabel": "Adres",
  "warehouse.addressSearch": "Zoek het adres in Locaties: naam, straat of plaats",
  "warehouse.addressChange": "Ander adres",
  "warehouse.addressHelp": "Staat het adres er niet, maak het dan eerst aan onder Organisaties → Locaties. De locatiekaart laat daarna zien dat het een magazijn is.",
  "warehouse.branchLabel": "Vestiging",
  "warehouse.branchNone": "Geen vestiging",
  "warehouse.branchHelp": "Alleen als er wagens of chauffeurs gestationeerd zijn.",
  "warehouse.warehouseActiveLabel": "In gebruik",
  "warehouse.noAddress": "nog geen adres",
  "locations.warehouseChip": "Magazijn {{name}}",
  "warehouse.colSplittable": "Splitsbaar",
  "warehouse.colSplittableHint": "Zak of doos: mag hij open bij het picken? Pallet: mogen er zakken of dozen af? Zo niet, dan gaat hij heel de deur uit, behalve met een VAS-code die hem mag breken (een sample).",
  "warehouse.splittableLabel": "Mag open bij het picken (splitsbaar)",
  "warehouse.splittableLabelPallet": "Er mogen zakken of dozen af (splitsbaar)",
  "warehouse.property.allergens": "Allergenen",
  "warehouse.property.hum": "HUM",
  "warehouse.property.non_hum": "NON_HUM",
  "warehouse.property.pharma": "Pharma",
  "warehouse.property.pharma_non_hum": "Pharma NON_HUM",
  "warehouse.property.drum": "Drum",
  "warehouse.property.feed": "Feed",
  "warehouse.property.ground": "Grond",
  "warehouse.uom.ST_one": "stuk",
  "warehouse.uom.ST_other": "stuks",
  "warehouse.uom.BX_one": "doos",
  "warehouse.uom.BX_other": "dozen",
  "warehouse.uom.BD_one": "bundel",
  "warehouse.uom.BD_other": "bundels",
  "warehouse.uom.KT_one": "kit",
  "warehouse.uom.KT_other": "kits",
  "warehouse.check.palletType": "Palletsoort",
  "warehouse.checkSentence.palletType": "Waarop het binnenkomt en de deur uitgaat, tenzij de order iets anders vraagt.",
  "warehouse.importedFromScoretrace": "Overgenomen uit Scoretrace",
  "warehouse.stock.colBarcode": "SSCC",
  "warehouse.stock.colArticle": "Artikel",
  "warehouse.stock.colOwner": "Eigenaar",
  "warehouse.stock.colBatch": "Batch",
  "warehouse.stock.colBestBefore": "THT",
  "warehouse.stock.colLocation": "Opslaglocatie",
  "warehouse.stock.colQuantity": "Hoeveelheid",
  "warehouse.stock.colStockCode": "Klantsoort",
  "warehouse.stock.colLabel": "Label",
  "warehouse.stock.colReceivedAt": "Ontvangen",
  "warehouse.stock.labelOwn": "Eigen label",
  "warehouse.stock.labelCustomer": "Klantlabel",
  "warehouse.stock.blockOnLine": "Regel geblokkeerd",
  "warehouse.stock.blockOnUnit": "Pallet geblokkeerd",
  "warehouse.stock.blockOnPlace": "Opslaglocatie geblokkeerd",
  "warehouse.stock.pallet": "Pallet",
  "warehouse.stock.blockedSince": "Geblokkeerd sinds {{when}}.",
  "warehouse.stock.blockedBy": "Door {{who}}",
  "warehouse.stock.placeBlocked": "Opslaglocatie {{place}} is geblokkeerd.",
  "warehouse.stock.placeBlockedHint": "Vrijgeven gaat in Opslaglocaties",
  "warehouse.stock.externalBatch": "Batch leverancier",
  "warehouse.stock.externalBatchTitle": "Batch leverancier: {{batch}}",
  "warehouse.stock.stockCodeNone": "Standaard",
  "warehouse.stock.palletType": "Pallettype",
  "warehouse.stock.consignments": "Zendingen",
  "warehouse.stock.linesTitle_one": "{{count}} regel op deze pallet",
  "warehouse.stock.linesTitle_other": "{{count}} regels op deze pallet",
  "warehouse.stock.batchShort": "batch {{batch}}",
  "warehouse.stock.bestBeforeShort": "THT {{day}}",
  "warehouse.stock.history": "Geschiedenis",
  "warehouse.stock.historyNone": "Er is nog niets met deze pallet gebeurd.",
  "warehouse.stock.lastChanged": "Laatst gewijzigd {{when}} door {{who}}.",
  "warehouse.stock.mixed_one": "{{count}} regel",
  "warehouse.stock.mixed_other": "{{count}} regels",
  "warehouse.stock.search": "SSCC, artikel, batch of opslaglocatie",
  "warehouse.stock.summary_one": "{{count}} pallet · {{weight}}",
  "warehouse.stock.summary_other": "{{count}} pallets · {{weight}}",
  "warehouse.stock.withoutWeight_one": "Van {{count}} regel is het gewicht niet bekend",
  "warehouse.stock.withoutWeight_other": "Van {{count}} regels is het gewicht niet bekend",
  "warehouse.stock.noneYet": "Er staat nog geen voorraad in dit magazijn.",
  "warehouse.stock.none": "Geen voorraad die hierbij past.",
  "warehouse.stock.blockTitle_one": "{{count}} pallet blokkeren",
  "warehouse.stock.blockTitle_other": "{{count}} pallets blokkeren",
  "warehouse.stock.releaseTitle_one": "{{count}} pallet vrijgeven",
  "warehouse.stock.releaseTitle_other": "{{count}} pallets vrijgeven",
  "warehouse.stock.blockExplain": "Een geblokkeerde pallet wordt niet gereserveerd of gepickt. De reden komt in de geschiedenis van de pallet.",
  "warehouse.stock.releaseExplain": "De pallet kan weer gereserveerd en gepickt worden. Zeg waarom; het komt in de geschiedenis.",
  "warehouse.stock.blockedResult_one": "{{count}} pallet geblokkeerd.",
  "warehouse.stock.blockedResult_other": "{{count}} pallets geblokkeerd.",
  "warehouse.stock.blockedResultAlready": "Geblokkeerd: {{count}}; {{already}} was al geblokkeerd.",
  "warehouse.stock.releasedResult_one": "{{count}} pallet vrijgegeven.",
  "warehouse.stock.releasedResult_other": "{{count}} pallets vrijgegeven.",
  "warehouse.event.unpicked": "Teruggeboekt naar voorraad",
  "unpick.order": "Terugboeken naar voorraad",
  "unpick.pallet": "Terugboeken",
  "unpick.load": "Terugboeken",
  "unpick.title.order": "Order {{label}} terugboeken naar voorraad",
  "unpick.title.unit": "Pallet {{label}} terugboeken naar voorraad",
  "unpick.title.load": "Lading {{label}} terugboeken naar voorraad",
  "unpick.intro": "Wat gepickt, klaargezet, geladen of verzonden is, wordt weer vrije voorraad op de plek waar het nu staat. De orderregels zijn daarna weer open. Verplaats de pallets met de scanner.",
  "unpick.loadedHint": "Een geladen of verzonden pallet komt op de dock waaraan hij geladen werd, of op de plek waar hij daarvoor stond. Er gaat geen bericht naar de klant.",
  "unpick.place": "Plek waar de pallet nu staat",
  "unpick.placeHint": "Naam of barcode van de plek, bijvoorbeeld S01.",
  "unpick.submit": "Terugboeken",
  "unpick.done_one": "{{count}} pallet teruggeboekt naar vrije voorraad:",
  "unpick.done_other": "{{count}} pallets teruggeboekt naar vrije voorraad:",
  "unpick.doneUnit": "{{sscc}} op {{place}}",
  "unpick.doneShort_one": "{{count}} pallet teruggeboekt naar vrije voorraad op {{place}}.",
  "unpick.doneShort_other": "{{count}} pallets teruggeboekt naar vrije voorraad.",
  "unpick.reportSent": "Het verzendbericht van {{orders}} was al naar de klant gegaan. Dat kan WLX niet terugdraaien: mail de klant.",
  "unpick.withdrawn": "{{orders}} staat weer op Aangemaakt en houdt niets meer gereserveerd. Maak hem opnieuw pickbaar om opnieuw te reserveren, of meld hem met 0 gereed.",
  "unpick.refusal.NOTHING_TO_UNPICK": "Hier is niets gepickt, klaargezet, geladen of verzonden om terug te boeken.",
  "unpick.refusal.PALLET_BUSY": "Op pallet {{sscc}} wordt nog gepickt. Sluit eerst de drager op de scanner.",
  "unpick.refusal.SHARED_PALLET": "Op pallet {{sscc}} staan ook goederen van {{orders}}. Boek die pallet zelf terug; dan gaan alle orders erop mee.",
  "unpick.refusal.PLACE_NEEDED": "WLX weet niet waar pallet {{sscc}} nu staat. Vul de plek in.",
  "unpick.refusal.PLACE_UNKNOWN": "Plek {{place}} bestaat niet in dit magazijn.",
  "warehouse.event.staged": "Klaargezet",
  "warehouse.event.loaded": "Geladen",
  "warehouse.event.shipped": "Verzonden",
  "warehouse.event.received": "Ontvangen",
  "warehouse.event.put_away": "Weggezet",
  "warehouse.event.moved": "Verplaatst",
  "warehouse.event.picked": "Gepickt",
  "warehouse.event.adjusted": "Gecorrigeerd",
  "warehouse.event.owner_changed": "Andere eigenaar",
  "warehouse.event.batch_split": "Batch gesplitst",
  "warehouse.event.stock_code_changed": "Andere klantsoort",
  "warehouse.event.blocked": "Geblokkeerd",
  "warehouse.event.unblocked": "Vrijgegeven",
  "warehouse.event.counted": "Geteld",
  "warehouse.event.migrated": "Overgenomen uit Scoretrace",
  "warehouse.event.to_lost_found": "Naar lost & found",
  "warehouse.event.from_lost_found": "Uit lost & found",
  "warehouse.event.written_off": "Afgeboekt",
  "warehouse.event.increased": "Opgehoogd",
  "warehouse.event.status_changed": "Batch gewijzigd",
  "warehouse.event.onPlace": "op {{place}}",
  "warehouse.event.receipt": "ontvangst {{receipt}}",
  "warehouse.event.receivedOn": "ontvangen {{day}}",
  "warehouse.event.unitCorrected": "saldo stond in {{from}}, overgenomen als {{to}}",
  "warehouse.event.viaScanner": "scanner",
  "warehouse.event.viaCustomer": "klantkoppeling",
  "warehouse.event.changeBatch": "batch {{from}} → {{to}}",
  "warehouse.event.changeLhc": "klantsoort {{from}} → {{to}}",
  "warehouse.event.changeBestBefore": "THT {{from}} → {{to}}",
  "warehouse.event.changeArticle": "artikel {{from}} → {{to}}",
  "inbound.tabsLabel": "Weergave",
  "inbound.tab.receipts": "Per ontvangst",
  "inbound.tab.ownLabels": "Eigen labels",
  "inbound.announce": "Nieuwe ontvangst",
  "inbound.announceTitle": "Nieuwe ontvangst · {{warehouse}}",
  "inbound.choosePrincipal": "Kies de opdrachtgever",
  "inbound.deliveryNote": "Pakbon",
  "inbound.reference": "Referentie",
  "inbound.searchPlaceholder": "Nummer, pakbon, referentie of SSCC",
  "inbound.viewLabel": "Welke ontvangsten",
  "idt.arrival": "Aankomst",
  "idt.expectedOn": "verwacht {{day}}",
  "idt.viaTimeslot": "aangemeld via een tijdslot",
  "idt.viaOffice": "aangemeld door kantoor ({{name}})",
  "idt.pallets": "Pallets",
  "idt.palletsOf": "{{count}} van {{total}}",
  "idt.short_one": "{{count}} pallet te weinig",
  "idt.short_other": "{{count}} pallets te weinig",
  "idt.over_one": "{{count}} pallet te veel of niet aangemeld",
  "idt.over_other": "{{count}} pallets te veel of niet aangemeld",
  "idt.damaged_one": "{{count}} pallet met schade",
  "idt.damaged_other": "{{count}} pallets met schade",
  "idt.toCome_one": "nog {{count}} te komen",
  "idt.toCome_other": "nog {{count}} te komen",
  "idt.perLineChecks_one": "en {{count}} controle per regel (tabblad)",
  "idt.perLineChecks_other": "en {{count}} controles per regel (tabblad)",
  "idt.owners": "eigenaren: {{owners}}",
  "idt.stepsLabel": "Stappen van de ontvangst",
  "idt.next.created": "Wacht op aanmelding of activeren; geactiveerd komt hij op de scanner.",
  "idt.next.announced": "Aangemeld voor {{time}}; activeer hem als de wagen er is (of het gebeurt vanzelf).",
  "idt.next.activeEmpty": "Staat op de scanner; nog niets gescand.",
  "idt.next.active": "De vloer ontvangt: {{count}} van {{total}} pallets binnen.",
  "idt.next.activeCount_one": "De vloer ontvangt: {{count}} pallet binnen.",
  "idt.next.activeCount_other": "De vloer ontvangt: {{count}} pallets binnen.",
  "idt.next.reported": "Klaar gemeld zonder verschil: sluit hem af.",
  "idt.next.reportedDifferences_one": "Klaar gemeld met {{count}} verschil: controleer en sluit af.",
  "idt.next.reportedDifferences_other": "Klaar gemeld met {{count}} verschillen: controleer en sluit af.",
  "idt.next.done": "Afgesloten {{time}}.",
  "idt.next.cancelled": "Vervallen.",
  "idt.tab.articles": "Per artikel",
  "idt.tab.pallets": "Pallets",
  "idt.tab.checks": "Controles per regel",
  "idt.col.announced": "Aangemeld",
  "idt.showSscc": "De SSCC's tonen",
  "idt.missing": "niet gekomen",
  "idt.notYet": "nog niet",
  "idt.in": "binnen",
  "inbound.view.week": "Week",
  "inbound.labelsIntro": "De nummerreeks van onze eigen labels (de rol) en de teller: een sticker die nooit geprint is, weigert de scanner.",
  "inbound.week.col.time": "Tijd",
  "inbound.week.col.arrival": "Aankomst",
  "inbound.week.col.step": "Stap",
  "inbound.week.title": "Binnenkomst {{day}}",
  "inbound.week.titleToday": "Binnenkomst vandaag, {{day}}",
  "inbound.week.backlog": "Achterstand · nog open",
  "inbound.week.empty": "Geen ontvangsten op deze dag.",
  "inbound.week.emptyFiltered": "Geen ontvangsten op deze dag die bij het filter passen.",
  "inbound.week.col.expected": "Verwacht",
  "inbound.week.col.actions": "Acties",
  "inbound.week.expected": "verwacht",
  "inbound.week.announced": "Aangemeld",
  "inbound.week.close": "Afsluiten",
  "inbound.week.receipts_one": "{{count}} ontvangst",
  "inbound.week.receipts_other": "{{count}} ontvangsten",
  "inbound.week.palletsExpected_one": "{{count}} pallet aangemeld",
  "inbound.week.palletsExpected_other": "{{count}} pallets aangemeld",
  "inbound.week.notClosed_one": "{{count}} niet afgesloten",
  "inbound.week.notClosed_other": "{{count}} niet afgesloten",
  "inbound.week.allClosed": "Alles afgesloten",
  "inbound.week.arrived": "{{count}} van {{total}} binnen",
  "inbound.week.announcedCount": "{{count}} van {{total}} aangemeld",
  "inbound.week.attention.reported_one": "{{count}} klaar gemeld, wacht op afsluiten",
  "inbound.week.attention.reported_other": "{{count}} klaar gemeld, wachten op afsluiten",
  "inbound.week.attention.difference_one": "{{count}} met een verschil",
  "inbound.week.attention.difference_other": "{{count}} met een verschil",
  "inbound.week.attentionTitle.reported": "Klaar gemeld, wacht op afsluiten",
  "inbound.week.attentionTitle.difference": "Met een verschil",
  "inbound.view.open": "Open",
  "inbound.view.today": "Vandaag",
  "inbound.view.recent": "30 dagen",
  "inbound.view.all": "Alles",
  "inbound.periodLabel": "Periode",
  "inbound.periodFrom": "Aangemaakt van",
  "inbound.periodTo": "tot en met",
  "inbound.periodFromLabel": "Aangemaakt vanaf",
  "inbound.periodToLabel": "Aangemaakt tot en met",
  "inbound.periodClear": "Periode wissen",
  "inbound.limitReached": "Je ziet de nieuwste {{count}}. Maak de periode kleiner of zoek gerichter om oudere te vinden.",
  "inbound.col.number": "Ontvangst",
  "inbound.col.principal": "Opdrachtgever",
  "inbound.col.kind": "Soort",
  "inbound.col.owners": "Eigenaren",
  "inbound.col.announced": "Aangemaakt",
  "inbound.col.pallets": "Pallets",
  "inbound.col.scanned": "Gescand",
  "inbound.col.differences": "Verschil",
  "inbound.col.state": "Status",
  "inbound.col.sscc": "SSCC",
  "inbound.col.bestBefore": "THT",
  "inbound.col.lhc": "LHC",
  "inbound.detail.externalBatch": "leverancier {{batch}}",
  "inbound.detail.lhcUnknown": "onbekend in WLX",
  "inbound.col.article": "Artikel",
  "inbound.col.batch": "Batch",
  "inbound.col.palletType": "Palletsoort",
  "inbound.col.locationNow": "Locatie nu",
  "inbound.col.receivedAt": "Ontvangen",
  "inbound.col.line": "Regel",
  "inbound.col.announcedPallets": "Besteld",
  "inbound.col.received": "Ontvangen",
  "inbound.col.difference": "Verschil",
  "inbound.col.scannedAt": "Gescand",
  "inbound.col.amount": "Aantal",
  "inbound.col.by": "Door",
  "inbound.empty": "Geen ontvangsten.",
  "inbound.emptySearch": "Niets gevonden.",
  "inbound.footnote": "Klaar gemeld = de vloer is klaar. Afsluiten doet kantoor; in de schaduwperiode gaat er niets naar de klant.",
  "inbound.ownersCount_one": "{{count}} eigenaar",
  "inbound.ownersCount_other": "{{count}} eigenaren",
  "inbound.kind.receipt": "Ontvangst",
  "inbound.kind.transfer": "Pendel",
  "inbound.kind.production": "Van de band",
  "inbound.kind.return": "Retour",
  "inbound.state.announced": "Aangemeld",
  "inbound.state.active": "Actief",
  "inbound.state.reported": "Klaar gemeld",
  "inbound.state.reportedDifference": "Klaar gemeld · verschil",
  "inbound.state.done": "Afgesloten",
  "inbound.state.cancelled": "Vervallen",
  "inbound.state.created": "Aangemaakt",
  "inbound.detail.activate": "Activeren",
  "inbound.closeMissing.title": "Ontvangst {{number}} afsluiten met verschillen",
  "inbound.closeMissing.intro": "Deze ontvangst heeft verschillen met wat er aangemeld is. Kijk ze na voor je afsluit: na afsluiten gaan ze zo naar de klant.",
  "inbound.closeMissing.confirmDifferences": "Ik heb de verschillen gecontroleerd",
  "inbound.closeMissing.submitDifferences": "Afsluiten met verschillen",
  "inbound.closeMissing.what": "{{count}} aangemelde pallet(s) zijn niet gescand. Bij afsluiten gaan ze met hun SSCC en inhoud naar lost & found van {{warehouse}}, en is de ontvangst afgerond. Voor FC volgt dan een voorraadboeking naar de storage location van lost & found.",
  "inbound.closeMissing.confirm": "Ik heb gecontroleerd dat deze {{count}} pallet(s) er niet zijn",
  "inbound.closeMissing.submit": "Afsluiten, {{count}} naar lost & found",
  "inbound.detail.announce": "Aanmelden",
  "inbound.detail.announceChange": "Aanmelding wijzigen",
  "inbound.detail.announceTitle": "Aanmelden · {{number}}",
  "inbound.detail.announceHint": "Wat de vervoerder aanmeldt. Aanmelden activeert de ontvangst niet: pas na Activeren staat hij op de scanner.",
  "inbound.detail.announceSave": "Aanmelding opslaan",
  "inbound.detail.announcedForLabel": "Aangemeld voor",
  "inbound.detail.carrier": "Vervoerder",
  "inbound.detail.vehicle": "Truck of container",
  "inbound.detail.dockLabel": "Dock",
  "inbound.detail.noDock": "Nog geen dock",
  "inbound.detail.announcedFor": "voor {{time}}",
  "inbound.detail.announced": "aangemeld: {{what}} (door {{name}})",
  "inbound.detail.activated": "geactiveerd {{time}} door {{name}}",
  "inbound.detail.activatedAuto": "vanzelf geactiveerd {{time}}",
  "inbound.detail.closedAuto": "vanzelf afgesloten {{time}}, na de laatste aangemelde pallet",
  "inbound.notFound": "Ontvangst niet gevonden",
  "inbound.back": "Ontvangsten",
  "inbound.detail.title": "Ontvangst {{number}}",
  "inbound.differencesCount_one": "{{count}} verschil",
  "inbound.differencesCount_other": "{{count}} verschillen",
  "inbound.detail.cancel": "Vervalt",
  "inbound.detail.close": "Ontvangst afsluiten",
  "inbound.detail.deliveryNote": "pakbon {{number}}",
  "inbound.detail.started": "gestart {{time}} door {{name}}",
  "inbound.detail.reported": "klaar gemeld {{time}} door {{name}}",
  "inbound.detail.closed": "afgesloten {{time}} door {{name}}",
  "inbound.detail.shadow": "Schaduwperiode: Scoretrace is leidend. Afsluiten stuurt niets naar de klant.",
  "inbound.detail.temperature": "{{value}} °C",
  "inbound.detail.blocked": "pallets geblokkeerd",
  "inbound.detail.checks": "Controles bij ontvangst",
  "inbound.detail.checksNone": "Nog niet beantwoord",
  "inbound.detail.labels": "Labels",
  "inbound.detail.labelsValue": "{{customer}} klant · {{own}} eigen",
  "inbound.detail.receiving": "Ontvangstlocatie",
  "inbound.detail.noLines": "Nog niets ontvangen. Een regel ontstaat zodra de vloer een pallet scant.",
  "inbound.detail.notAnnounced": "niet aangemeld",
  "inbound.detail.noPallets": "Nog geen pallets gescand.",
  "inbound.detail.noPalletsFiltered": "Geen pallets die bij het filter passen.",
  "inbound.detail.differences": "Verschillen",
  "inbound.detail.differencesHint": "Gaan per mail naar {{principal}} bij afsluiten, zodra de berichten naar de klant er zijn.",
  "inbound.detail.noDifferences": "Geen verschillen.",
  "inbound.palletsCount_one": "{{count}} pallet",
  "inbound.palletsCount_other": "{{count}} pallets",
  "inbound.ownLabel": "eigen label",
  "inbound.damaged": "Schade",
  "inbound.bestBefore": "THT {{date}}",
  "inbound.difference.short_one": "{{count}} pallet te weinig",
  "inbound.difference.short_other": "{{count}} pallets te weinig",
  "inbound.difference.over_one": "{{count}} pallet te veel",
  "inbound.difference.over_other": "{{count}} pallets te veel",
  "inbound.difference.not_announced_one": "Niet aangemeld · {{count}} pallet",
  "inbound.difference.not_announced_other": "Niet aangemeld · {{count}} pallets",
  "inbound.difference.damaged_one": "Schade · {{count}} pallet",
  "inbound.difference.damaged_other": "Schade · {{count}} pallets",
  "inbound.check.vehicle_clean_dry": "Wagen schoon en droog",
  "inbound.check.load_undamaged": "Lading onbeschadigd",
  "inbound.answer.yes": "Ja",
  "inbound.answer.no": "Nee",
  "inbound.range.owner": "Eigenaar",
  "inbound.range.willems": "Willems",
  "inbound.range.prefix": "Prefix",
  "inbound.range.serials": "Volgnummers",
  "inbound.range.counter": "Teller",
  "inbound.range.noCounter": "niet bijgehouden",
  "inbound.range.free": "Nog vrij",
  "inbound.range.used": "Op pallets gebruikt",
  "inbound.range.edit": "Teller zetten",
  "inbound.range.editTitle": "Teller van de eigen labels",
  "inbound.range.counterHint": "Het hoogste volgnummer dat op een rol is geprint. Leeg: WLX controleert niet op de teller.",
  "inbound.range.badCounter": "Vul een volgnummer in, of laat het leeg.",
  "inbound.range.explain": "Een sticker uit deze reeks met een volgnummer boven {{counter}} is nooit geprint: de scanner weigert hem.",
  "inbound.range.explainNoCounter": "WLX houdt de teller nog niet bij: elke geldige sticker uit deze reeks wordt geaccepteerd. Rollen printen komt later.",
  "inbound.range.shared": "Scoretrace print uit dezelfde reeks zolang andere magazijnen daarin werken. Een nummer dat al op een pallet zit, weigert de scanner altijd.",
  "warehouse.maxPalletsLabel": "Palletplaatsen",
  "outbound.tabsLabel": "Orders of verzending",
  "outbound.tab.orders": "Orders",
  "outbound.col.asks": "Eisen",
  "outbound.asks.batch": "batch {{batch}}",
  "outbound.asks.bestBefore": "THT {{date}}",
  "outbound.asks.stockCodes": "LHC {{codes}}",
  "outbound.asks.load": "per pallet {{quantity}} {{unit}}",
  "outbound.asks.maxBatches_one": "max. {{count}} batch",
  "outbound.asks.maxBatches_other": "max. {{count}} batches",
  "outbound.line.change": "Wijzigen",
  "outbound.line.title": "Regel {{line}} · {{article}} wijzigen",
  "outbound.line.quantity": "Besteld ({{unit}})",
  "outbound.line.load": "Load quantity ({{unit}})",
  "outbound.line.batch": "Batch",
  "outbound.line.vas": "VAS-codes",
  "outbound.line.vasRetired": "VAS-code {{codes}} wordt niet gebruikt (Warehouse → VAS).",
  "outbound.line.vasUnknown": "VAS-code {{codes}} bestaat niet in WLX. Kijk de code na in Warehouse → VAS.",
  "outbound.activate.open": "Activeren",
  "outbound.activate.change": "Activering wijzigen",
  "outbound.activate.title": "Order {{number}} activeren",
  "outbound.activate.hint": "Activeren zet de order op laden. De scanner toont het kenteken of containernummer en de vloer bevestigt het; wijzigen kan alleen hier.",
  "outbound.activate.kindLabel": "Truck of container",
  "outbound.activate.kind.truck": "Truck",
  "outbound.activate.kind.container": "Container",
  "outbound.activate.containerNumber": "Containernummer",
  "outbound.activate.tare": "Tarra (kg)",
  "outbound.activate.trailerPlate": "Kenteken oplegger",
  "outbound.activate.truckPlate": "Kenteken trekker",
  "outbound.activate.submit": "Activeren",
  "outbound.activate.withdraw": "Activering intrekken",
  "outbound.activate.fact": "Activering",
  "outbound.activate.not": "Niet geactiveerd",
  "outbound.activate.via.wlx": "kantoor",
  "outbound.activate.via.itv": "iTV",
  "outbound.activate.via.portal": "portal",
  "outbound.activate.trip": "rit {{trip}}",
  "outbound.activate.dock": "dock {{dock}}",
  "outbound.activate.containerInvalid": "{{number}} is geen geldig containernummer: het controlecijfer klopt niet.",
  "outbound.activate.loading": "De order wordt al geladen; de activering kan niet meer veranderen.",
  "outbound.registrations.title": "Vastgelegd bij VAS-codes",
  "outbound.registrations.pallet": "pallet {{sscc}}",
  "outbound.registrations.order": "order",
  "outbound.asks.fixed": "Vast {{batch}} · {{quantity}}",
  "outbound.pickReport.button": "COKZ-reservering",
  "outbound.pickReport.sentNow": "PIC-bericht verstuurd: {{count}} batchregels vastgezet en de order vrijgegeven.",
  "outbound.pickReport.shortNow": "Geen PIC-bericht: te weinig geschikte voorraad. {{lines}}",
  "outbound.pickReport.shortLine": "regel {{line}} {{article}}: {{available}} van {{needed}}",
  "outbound.pickReport.fact": "PIC-bericht",
  "outbound.pickReport.sent": "Verstuurd, batches vast",
  "outbound.pickReport.failed": "Niet gelukt: te weinig geschikte voorraad",
  "outbound.line.vasHint": "Codes met een spatie ertussen. Een code weghalen of erbij zetten telt als wijziging.",
  "outbound.line.reason": "Waarom wijzig je deze regel?",
  "outbound.line.submit": "Opslaan",
  "outbound.line.quantityInvalid": "Vul een aantal groter dan 0 in.",
  "outbound.line.loadInvalid": "Vul een load quantity groter dan 0 in, of laat hem leeg.",
  "outbound.tab.changes": "Wijzigingen",
  "outbound.changes.period": "Periode",
  "outbound.changes.from": "Vanaf",
  "outbound.changes.to": "Tot en met",
  "outbound.changes.lastWeek": "Laatste 7 dagen",
  "outbound.changes.download": "Downloaden",
  "outbound.changes.fileName": "wijzigingen",
  "outbound.changes.empty": "Geen wijzigingen in deze periode.",
  "outbound.changes.col.order": "Order",
  "outbound.changes.col.owner": "Eigenaar",
  "outbound.changes.col.customerContact": "Contactpersoon klant",
  "outbound.changes.col.line": "Regel",
  "outbound.changes.col.what": "Wat",
  "outbound.changes.col.old": "Was",
  "outbound.changes.col.new": "Wordt",
  "outbound.changes.col.reason": "Reden",
  "outbound.changes.col.remark": "Opmerking",
  "outbound.changes.col.at": "Wanneer",
  "outbound.changes.col.by": "Door",
  "outbound.changes.col.orderNumber": "Ordernummer",
  "outbound.changes.col.reference": "Referentie klant",
  "outbound.changes.col.lineNumber": "Regelnummer",
  "outbound.changes.col.article": "Artikel",
  "outbound.changes.col.vasCode": "VAS-code",
  "outbound.changes.field.quantity": "Aantal gewijzigd",
  "outbound.changes.field.load_quantity": "Load quantity gewijzigd",
  "outbound.changes.field.batch": "Batch gewijzigd",
  "outbound.changes.field.vas_added": "VAS toegevoegd",
  "outbound.changes.field.vas_removed": "VAS verwijderd",
  "outbound.changes.field.reported_zero": "Met 0 gereed",
  "outbound.searchPlaceholder": "Zoek op order, referentie of losplaats",
  "outbound.viewLabel": "Welke orders",
  "outbound.view.week": "Week",
  "outbound.view.today": "Laden vandaag",
  "outbound.week.navLabel": "Week",
  "outbound.week.number": "Week {{week}}",
  "outbound.week.previous": "Vorige week",
  "outbound.week.next": "Volgende week",
  "outbound.week.thisWeek": "Deze week",
  "outbound.week.daysLabel": "Dagen van de week",
  "outbound.week.today": "vandaag",
  "outbound.week.orders_one": "{{count}} order",
  "outbound.week.orders_other": "{{count}} orders",
  "outbound.week.allLoaded": "Alles geladen",
  "outbound.week.notLoaded_one": "{{count}} niet geladen",
  "outbound.week.notLoaded_other": "{{count}} niet geladen",
  "outbound.week.readyCount": "{{count}} van {{total}} klaar",
  "outbound.week.lateCount_one": "{{count}} haalt {{time}} niet",
  "outbound.week.lateCount_other": "{{count}} halen {{time}} niet",
  "outbound.week.created_one": "{{count}} nog niet pickbaar",
  "outbound.week.created_other": "{{count}} nog niet pickbaar",
  "outbound.week.allReleased": "Alles pickbaar",
  "outbound.week.lateNoTime_one": "{{count}} te laat",
  "outbound.week.lateNoTime_other": "{{count}} te laat",
  "outbound.week.attention.lateNoTime_one": "{{count}} te laat",
  "outbound.week.attention.lateNoTime_other": "{{count}} te laat",
  "outbound.week.title.loadTodayNoTime": "Afhalen vandaag, {{day}}",
  "outbound.week.backlogCount_one": "+ {{count}} achterstand",
  "outbound.week.backlogCount_other": "+ {{count}} achterstand",
  "outbound.week.backlog": "Achterstand · nog niet geladen",
  "outbound.week.title.load": "Afhalen {{day}}",
  "outbound.week.title.loadToday": "Afhalen vandaag, {{day}} · klaar vóór {{time}}",
  "outbound.week.title.delivery": "Leveren {{day}}",
  "outbound.week.title.deliveryToday": "Leveren vandaag, {{day}}",
  "outbound.week.attentionLabel": "Aandacht",
  "outbound.week.attention.unlinked_one": "{{count}} adres niet gekoppeld",
  "outbound.week.attention.unlinked_other": "{{count}} adressen niet gekoppeld",
  "outbound.week.attention.unknownArticle_one": "{{count}} met een onbekend artikel",
  "outbound.week.attention.unknownArticle_other": "{{count}} met een onbekend artikel",
  "outbound.week.attention.late_one": "{{count}} haalt {{time}} niet",
  "outbound.week.attention.late_other": "{{count}} halen {{time}} niet",
  "outbound.week.attention.pickReport_one": "{{count}} PIC-bericht niet verstuurd",
  "outbound.week.attention.pickReport_other": "{{count}} PIC-berichten niet verstuurd",
  "outbound.week.attentionTitle.unlinked": "Adres niet gekoppeld",
  "outbound.week.attentionTitle.unknownArticle": "Met een onbekend artikel",
  "outbound.week.attentionTitle.late": "Haalt {{time}} niet",
  "outbound.week.attentionTitle.lateNoTime": "Te laat",
  "outbound.week.attentionTitle.pickReport": "PIC-bericht niet verstuurd",
  "outbound.week.markerLabel": "Kenmerk",
  "outbound.week.col.owner": "Klant",
  "outbound.week.col.markers": "Kenmerk",
  "outbound.week.col.weight": "Gewicht",
  "outbound.week.col.step": "Stap",
  "outbound.week.col.transport": "Vervoer",
  "outbound.week.kind.truck": "Truck",
  "outbound.week.kind.container": "Container",
  "outbound.week.carrierOrdered": "De vervoerder volgens de klant",
  "outbound.week.carrierCollects": "afhaler",
  "outbound.week.announced": "Aangemeld",
  "outbound.week.announcedFor": "Aangemeld {{time}}",
  "outbound.week.notAnnounced": "Niet aangemeld",
  "outbound.week.viaTimeslot": "Aangemeld via een tijdslot",
  "outbound.week.viaOffice": "Aangemeld door kantoor",
  "outbound.week.empty": "Geen orders op deze dag.",
  "outbound.week.emptyFiltered": "Geen orders op deze dag die bij het filter passen.",
  "outbound.week.pickCreated_one": "Kies de {{count}} drager die nog niet pickbaar is",
  "outbound.week.pickCreated_other": "Kies de {{count}} dragers die nog niet pickbaar zijn",
  "outbound.week.deliverOn": "leveren {{day}}",
  "outbound.week.pickupOn": "afhalen {{day}}",
  "outbound.week.fca": "FCA · de klant haalt af",
  "outbound.week.ownTransport": "Willems rijdt",
  "outbound.week.activated": "Geactiveerd",
  "outbound.marker.grootVas": "Groot VAS",
  "od.more": "Meer",
  "od.pickup": "Afhalen",
  "od.delivery": "Leveren",
  "od.to": "Naar",
  "od.transport": "Vervoer",
  "od.readyBy": "klaar vóór {{time}}",
  "od.minBestBefore": "THT minimaal {{day}}",
  "od.minBestBeforeChip": "THT ≥ {{day}}",
  "od.fca": "FCA · {{carrier}}",
  "od.carrierOrdered": "vervoerder volgens de klant",
  "od.booking": "boeking {{booking}}",
  "od.announced": "Aangemeld voor {{time}} · {{carrier}} ({{via}})",
  "od.viaTimeslot": "tijdslot",
  "od.viaOffice": "kantoor",
  "od.activated": "Geactiveerd: {{what}}",
  "od.grootVas": "Groot VAS {{code}} {{description}}",
  "od.stepsLabel": "Stappen van de order",
  "od.now": "Nu:",
  "od.next.link": "Koppel eerst het losadres; daarna kan de order pickbaar worden.",
  "od.next.release": "Maak de order pickbaar; dan komt hij op de scanner.",
  "od.next.releaseTogether_one": "Maak de order pickbaar, samen met {{count}} andere order voor dezelfde losplaats en losdag.",
  "od.next.releaseTogether_other": "Maak de order pickbaar, samen met {{count}} andere orders voor dezelfde losplaats en losdag.",
  "od.next.released": "Staat op de scanner en wacht op een picker.",
  "od.next.picking": "Wordt verzameld: {{percent}}% gepickt.",
  "od.next.vas": "Groot VAS: {{codes}}; daarna naar expeditie.",
  "od.next.load": "Klaar om te laden op {{vehicle}}.",
  "od.next.waitCarrier": "Klaar; wacht op de afhaler: nog niet aangemeld.",
  "od.next.activate": "Klaar om te laden; activeer met het kenteken of containernummer.",
  "od.next.picked": "Klaar om te laden.",
  "od.next.shipped": "Geladen {{time}}.",
  "od.next.cancelled": "Met 0 gereed gemeld.",
  "od.pickReportSent": "PIC-bericht verstuurd {{time}} (de batches liggen vast).",
  "od.pickReportFailed": "PIC-bericht niet verstuurd ({{time}}): {{problem}}",
  "od.tab.lines": "Regels",
  "od.tab.pallets": "Pallets",
  "od.tab.vas": "VAS en registraties",
  "od.forAllLines": "Voor alle regels:",
  "od.noPallets": "Nog geen pallets: niets gereserveerd of gepickt.",
  "od.noPalletsFiltered": "Geen pallets die bij het filter passen.",
  "od.noVas": "Geen VAS-codes op deze order.",
  "od.vas.code": "Code",
  "od.vas.what": "Wat",
  "od.vas.kind": "Soort",
  "od.vas.instruction": "Instructie",
  "od.vas.order": "hele order",
  "od.announce.open": "Aanmelden",
  "od.announce.change": "Aanmelding wijzigen",
  "od.announce.title": "Aanmelden · {{number}}",
  "od.announce.hint": "Een vervoerder meldde zich voor het afhalen. Leg vast voor wanneer en wie; aanmelden zet de order nog niet op laden (dat is Activeren). Via een tijdslot gebeurt dit vanzelf.",
  "od.announce.for": "Aangemeld voor",
  "od.announce.carrier": "Vervoerder die zich aanmeldde",
  "od.announce.ordered": "Volgens de klant: {{carrier}}",
  "od.announce.submit": "Aanmelding vastleggen",
  "od.announce.withdraw": "Aanmelding intrekken",
  "outbound.marker.grootVasCode": "Groot VAS {{code}}",
  "outbound.marker.fca": "FCA",
  "outbound.marker.container": "Container",
  "outbound.marker.ownTransport": "Eigen vervoer",
  "outbound.marker.batchPick": "Batchpicken",
  "outbound.marker.ownershipTransfer": "Eigenaarswissel",
  "outbound.view.open": "Open",
  "outbound.view.recent": "Laatste 30 dagen",
  "outbound.lateCount_one": "{{count}} order haalt {{time}} niet",
  "outbound.lateCount_other": "{{count}} orders halen {{time}} niet",
  "outbound.empty": "Geen orders. Een order van DataBridge komt hier vanzelf.",
  "outbound.emptySearch": "Geen order gevonden.",
  "outbound.footnote": "Leveren gaat in hele zakken of dozen; een big bag gaat als hele pallet. Een order met een onbekend artikel, of met een adres dat aan een locatie gekoppeld moet worden (waar de verzendvorm wordt berekend), staat in het rood.",
  "outbound.notFound": "Deze order bestaat niet.",
  "outbound.back": "Orders",
  "outbound.status.created": "Aangemaakt",
  "outbound.status.released": "Pickbaar",
  "outbound.status.picking": "Order verzamelen",
  "outbound.status.vas": "Klaar voor VAS",
  "outbound.status.picked": "Verzameld",
  "outbound.status.shipped": "Geladen",
  "outbound.status.cancelled": "Geannuleerd",
  "outbound.state.late": "Haalt {{time}} niet",
  "outbound.form.parcel": "Pakket",
  "outbound.form.half_pallet": "Halve pallet",
  "outbound.form.euro_pallet": "Europallet",
  "outbound.col.number": "Order",
  "outbound.col.place": "Losplaats",
  "outbound.col.form": "Verzendvorm",
  "outbound.col.lines": "Regels",
  "outbound.col.ordered": "Besteld",
  "outbound.col.deliver": "Levert",
  "outbound.col.picked": "Gepickt",
  "outbound.col.loadDate": "Laaddag",
  "outbound.col.deliveryDate": "Losdag",
  "outbound.col.state": "Status",
  "outbound.col.line": "Regel",
  "outbound.col.article": "Artikel",
  "outbound.col.orderedQty": "Besteld",
  "outbound.col.deliverIn": "Leveren in",
  "outbound.col.minBestBefore": "THT minimaal",
  "outbound.col.pickedQty": "Gepickt",
  "outbound.col.sscc": "SSCC",
  "outbound.col.unitKind": "Soort",
  "outbound.col.unitState": "Status",
  "outbound.col.locationNow": "Locatie nu",
  "outbound.placeUnknown": "adres niet gekoppeld",
  "outbound.together_one": "{{count}} order samen",
  "outbound.together_other": "{{count}} orders samen",
  "outbound.pickup": "Afhaler (FCA)",
  "outbound.noCarrier": "Geen vervoerder · via planning",
  "outbound.source.wlx": "WLX",
  "outbound.source.manual": "Aangepast",
  "outbound.source.manualBy": "Aangepast · {{name}}",
  "outbound.unknownArticles_one": "{{count}} artikel onbekend",
  "outbound.unknownArticles_other": "{{count}} artikelen onbekend",
  "outbound.channel.databridge": "DataBridge",
  "outbound.channel.scoretrace": "Overgenomen uit Scoretrace",
  "outbound.channel.manual": "Handmatig",
  "outbound.despatch.rule": "Onder {{parcel}} kg pakket ({{parcelCarrier}}), tot en met {{half}} kg halve pallet, daarboven europallet ({{palletCarrier}})",
  "outbound.despatch.carrier": "Vervoerder",
  "outbound.despatch.wlxWould": "WLX: {{form}} · {{carrier}}",
  "outbound.despatch.change": "Aanpassen",
  "outbound.despatch.reset": "Terug naar WLX",
  "outbound.despatch.forAll_one": "Geldt voor {{count}} order",
  "outbound.despatch.forAll_other": "Geldt voor alle {{count}} orders",
  "despatch.title": "Verzending · {{place}}",
  "despatch.notFound": "Deze verzending is er niet meer.",
  "despatch.what_one": "{{count}} order, samen {{weight}} kg, gaat in één keer weg.",
  "despatch.what_other": "{{count}} orders voor deze losplaats en losdag, samen {{weight}} kg, gaan samen weg.",
  "despatch.calculated": "WLX berekende de verzendvorm uit het gewicht.",
  "despatch.noParcel": "{{place}} krijgt nooit een pakket",
  "despatch.noParcelHint": "Willems rijdt zelf: onder de pakketgrens wordt het een europallet zonder vervoerder. Ook voor de andere dagen; de lijst staat in Instellingen.",
  "outbound.noParcel.title": "Nooit een pakket",
  "outbound.noParcel.hint": "Losplaatsen waar Willems zelf rijdt (was TaskCentre-taak 858): onder de pakketgrens wordt het een europallet zonder vervoerder. {{warehouse}} zelf en een adres met dezelfde postcode horen er altijd bij.",
  "outbound.noParcel.none": "Nog geen losplaatsen.",
  "outbound.noParcel.remove": "Weghalen",
  "outbound.noParcel.add": "Losplaats toevoegen: zoek op naam, plaats of postcode",
  "outbound.place.search": "Zoek op naam, code, plaats of postcode",
  "outbound.place.none": "Niets gevonden in het adresboek.",
  "outbound.detail.title": "Order {{number}} · {{reference}}",
  "outbound.detail.cancel": "Met 0 gereed melden",
  "outbound.zero.title": "Order {{number}} met 0 gereed melden",
  "outbound.zero.intro": "De order gaat niet weg: er wordt niets gepickt en de klant hoort dat er 0 geleverd is. Dit kan alleen zolang er niet gepickt wordt.",
  "outbound.zero.question": "Waarom wordt deze order met 0 gemeld?",
  "outbound.zero.choose": "Kies een reden",
  "outbound.zero.remark": "Opmerking",
  "outbound.zero.remarkNeeded": "Zeg in een paar woorden wat er is.",
  "outbound.zero.submit": "Met 0 gereed melden",
  "outbound.zero.done": "Met 0 gereed gemeld op {{time}}",
  "outbound.detail.debtor": "debiteur {{code}}",
  "outbound.detail.customerOrder": "order klant {{number}}",
  "outbound.detail.pickingStarted": "picken vanaf {{time}}",
  "outbound.detail.pickingDone": "gepickt {{time}}",
  "outbound.detail.released": "pickbaar {{time}}",
  "outbound.col.released": "Pickbaar gemaakt",
  "outbound.release.make": "Maak pickbaar",
  "outbound.release.makeCount_one": "Maak {{count}} verzending pickbaar",
  "outbound.release.makeCount_other": "Maak {{count}} verzendingen pickbaar",
  "outbound.release.withdraw": "Terugtrekken",
  "outbound.release.withdrawCount_one": "{{count}} verzending terugtrekken",
  "outbound.release.withdrawCount_other": "{{count}} verzendingen terugtrekken",
  "outbound.release.clear": "Wissen",
  "outbound.release.pickedOrders_one": "{{count}} order gekozen",
  "outbound.release.pickedOrders_other": "{{count}} orders gekozen",
  "outbound.release.pickedDespatches_one": "{{count}} verzending gekozen",
  "outbound.release.pickedDespatches_other": "{{count}} verzendingen gekozen",
  "outbound.release.wholeDespatch": "Een verzending gaat in zijn geheel: ook de andere orders naar die losplaats op die dag.",
  "outbound.release.waiting_one": "{{count}} order nog niet pickbaar",
  "outbound.release.waiting_other": "{{count}} orders nog niet pickbaar",
  "outbound.release.pickCreated_one": "Kies de aangemaakte order",
  "outbound.release.pickCreated_other": "Kies de {{count}} aangemaakte orders",
  "outbound.release.pickOrder": "Order {{number}} kiezen",
  "outbound.release.pickDespatch": "Verzending naar {{place}} kiezen",
  "outbound.release.done_one": "{{count}} order staat nu op de scanner.",
  "outbound.release.done_other": "{{count}} orders staan nu op de scanner.",
  "outbound.release.doneShort_one": "{{count}} order staat nu op de scanner; {{short}} regel(s) komen tekort.",
  "outbound.release.doneShort_other": "{{count}} orders staan nu op de scanner; {{short}} regel(s) komen tekort.",
  "outbound.release.reserved_one": "{{count}} pallet gereserveerd.",
  "outbound.release.reserved_other": "{{count}} pallets gereserveerd.",
  "outbound.reserve.again": "Opnieuw reserveren",
  "outbound.reserve.mode": "Gereserveerd bij pickbaar maken",
  "outbound.reserve.title": "Gereserveerde pallets",
  "outbound.reserve.col.place": "Plek",
  "outbound.reserve.col.batch": "Batch",
  "outbound.reserve.col.bestBefore": "THT",
  "outbound.reserve.col.quantity": "Hoeveelheid",
  "outbound.reserve.col.how": "Gaat",
  "outbound.reserve.col.state": "Status",
  "outbound.reserve.whole": "Hele pallet",
  "outbound.reserve.part": "Deel, de rest gaat terug",
  "outbound.reserve.state.active": "Gereserveerd",
  "outbound.reserve.state.picked": "Gepickt",
  "outbound.reserve.hint": "Een pallet die past in wat een regel nog nodig heeft, gaat heel; anders gaat er een deel van de oudste. Na een deel krijgt de pallet een retourtaak bij Wegzetten.",
  "outbound.reserve.done_one": "{{count}} pallet erbij gereserveerd.",
  "outbound.reserve.done_other": "{{count}} pallets erbij gereserveerd.",
  "outbound.reserve.doneShort_one": "{{count}} pallet erbij gereserveerd; {{short}} regel(s) komen nog tekort.",
  "outbound.reserve.doneShort_other": "{{count}} pallets erbij gereserveerd; {{short}} regel(s) komen nog tekort.",
  "outbound.release.withdrawn_one": "{{count}} order is van de scanner gehaald.",
  "outbound.release.withdrawn_other": "{{count}} orders zijn van de scanner gehaald.",
  "outbound.release.withdrawnBusy_one": "{{count}} order is van de scanner gehaald; {{busy}} wordt al gepickt en blijft staan.",
  "outbound.release.withdrawnBusy_other": "{{count}} orders zijn van de scanner gehaald; {{busy}} wordt al gepickt en blijft staan.",
  "outbound.release.mancoTitle_one": "{{count}} regel komt tekort",
  "outbound.release.mancoTitle_other": "{{count}} regels komen tekort",
  "outbound.release.mancoWhy": "Voor deze regels is niet genoeg voorraad, na wat de orders die eerder pickbaar zijn gemaakt al nodig hebben. Maak je ze toch pickbaar, dan gaan die eerdere orders voor en komen deze regels tekort.",
  "outbound.release.order": "Order",
  "outbound.release.article": "Artikel",
  "outbound.release.needed": "Nodig",
  "outbound.release.available": "Beschikbaar",
  "outbound.release.leave": "Niet pickbaar maken",
  "outbound.release.anyway": "Toch pickbaar maken",
  "outbound.detail.shadow": "Schaduwperiode: Scoretrace is leidend. Wat hier gepickt wordt, gaat niet naar de klant.",
  "outbound.detail.deliveryCode": "losadrescode {{code}}",
  "outbound.detail.together": "Samen met",
  "outbound.detail.ownTransport": "Het bericht zegt: eigen vervoer — Willems rijdt",
  "outbound.detail.fixedCarrier": "Het bericht zegt: altijd {{carrier}}",
  "outbound.detail.alone": "Alleen deze order",
  "outbound.detail.minBestBefore": "THT minimaal",
  "outbound.detail.noMinimum": "Geen eis",
  "outbound.detail.linkTitle": "Adres koppelen",
  "outbound.detail.linkHint": "WLX vond {{name}} ({{address}}) niet in het adresboek. Kies de losplaats; de order gaat dan mee in de verzending van die plaats en dag.",
  "outbound.detail.linkNoRight": "Koppelen kan kantoor met het recht om orders te wijzigen.",
  "outbound.detail.unknownArticle": "Onbekend artikel",
  "outbound.detail.wholePallet": "Hele pallet",
  "outbound.detail.deliverHint": "Leveren in: wat de vloer pakt. Kilo's worden hele zakken; een big bag rondt af naar de dichtstbijzijnde hele big bag, minstens één.",
  "outbound.lineState.open": "Open",
  "outbound.lineState.picked": "Gepickt",
  "outbound.lineState.short": "Minder",
  "outbound.lineState.cancelled": "Geannuleerd",
  "outbound.lineState.unknown_article": "Onbekend artikel",
  "outbound.unitKind.pallet": "Verzameldrager",
  "outbound.unitKind.box": "Verzenddoos",
  "outbound.unitKind.whole_pallet": "Hele pallet",
  "outbound.unitState.picked": "Gepickt",
  "outbound.unitState.staged": "Op expeditie",
  "outbound.unitState.loaded": "Geladen",
  "outbound.unitState.shipped": "Verzonden",
  "outbound.unitState.stored": "Opgeslagen",

  "counts.tabsLabel": "Pallets of telverschillen",
  "counts.tab.pallets": "Pallets",
  "counts.tab.counts": "Telverschillen",
  "counts.tab.lostfound": "Lost & found",
  "counts.increaseHint": "Lost & found dekt niet alles: kies de reden voor de klant om de rest op te hogen.",
  "lostFound.intro": "Wat mist, wacht hier: een deel van een pallet met een eigen nummer, of een hele pallet met zijn SSCC. Het telt mee in de voorraad van de klant en wordt niet gepickt. Gevonden: terugzetten of wegzetten. Niet gevonden: afboeken met de reden voor de klant.",
  "lostFound.empty": "Niets op lost & found.",
  "lostFound.footnote": "Meer geteld dan WLX heeft komt eerst uit lost & found. Pas bij afboeken en ophogen verandert de voorraad van de klant; die twee gaan met de reden mee in het mutatiebestand.",
  "lostFound.col.number": "Nummer",
  "lostFound.col.from": "Van",
  "lostFound.col.since": "Sinds",
  "lostFound.col.by": "Door",
  "lostFound.col.reason": "Waarom",
  "lostFound.col.actions": "Acties",
  "lostFound.kind.part": "Deel van een pallet",
  "lostFound.kind.pallet": "Hele pallet",
  "lostFound.moreLines_one": "+{{count}} regel",
  "lostFound.moreLines_other": "+{{count}} regels",
  "lostFound.days_zero": "vandaag",
  "lostFound.days_one": "{{count}} dag",
  "lostFound.days_other": "{{count}} dagen",
  "lostFound.state.missing": "Zoek",
  "lostFound.state.found": "Gevonden · wacht op heftruck",
  "lostFound.reason.not_found": "Pallet niet gevonden",
  "lostFound.chooseBookReason": "Kies de reden voor de klant",
  "lostFound.bookReasonLabel": "Reden voor de klant",
  "lostFound.reasonLabel": "Waarom",
  "lostFound.remarkLabel": "Opmerking",
  "lostFound.line": "Regel",
  "lostFound.adjust.action": "Aantal aanpassen",
  "lostFound.adjust.title": "Aantal aanpassen · {{pallet}}",
  "lostFound.adjust.submit": "Aanpassen",
  "lostFound.adjust.explain": "Wat er minder is, gaat naar lost & found. Wat er meer is, komt eerst uit lost & found; de rest wordt opgehoogd.",
  "lostFound.adjust.quantity": "Aantal in {{unit}} (nu {{now}})",
  "lostFound.adjust.toLostFound": "Naar lost & found: {{amount}}. De voorraad van de klant blijft gelijk.",
  "lostFound.adjust.fromLostFound": "Uit lost & found: {{amount}} ({{numbers}}).",
  "lostFound.adjust.increase": "Ophogen: {{amount}}. De voorraad van de klant gaat omhoog; kies de reden voor de klant.",
  "lostFound.adjust.increaseNotAllowed": "Ophogen: {{amount}}. Daarvoor is het recht Afboeken en ophogen nodig.",
  "lostFound.done.to": "{{amount}} naar lost & found ({{number}}).",
  "lostFound.done.from": "{{amount}} uit lost & found ({{number}}).",
  "lostFound.done.increased": "{{amount}} opgehoogd.",
  "lostFound.lost.action": "Pallet kwijt",
  "lostFound.lost.title": "Pallet kwijt · {{pallet}}",
  "lostFound.lost.submit": "Naar lost & found",
  "lostFound.lost.explain": "De pallet stond op {{place}}. Hij gaat met zijn SSCC naar lost & found en wordt niet meer gepickt. Scant de heftruck hem later, dan is hij gevonden en wordt hij weggezet. De voorraad van de klant blijft gelijk.",
  "lostFound.lost.done": "{{pallet}} staat op lost & found.",
  "lostFound.found.action": "Gevonden",
  "lostFound.found.done": "{{pallet}} is gevonden en staat klaar om weg te zetten.",
  "lostFound.return.action": "Terugzetten",
  "lostFound.return.title": "Terugzetten · {{number}}",
  "lostFound.return.submit": "Terugzetten",
  "lostFound.return.explain": "Geef de SSCC van de pallet waar het op komt, of de plek als daar één pallet met dit artikel staat. De voorraad van de klant blijft gelijk.",
  "lostFound.return.code": "Pallet of plek",
  "lostFound.returned": "{{number}} staat weer op {{pallet}}.",
  "lostFound.writeOff.action": "Afboeken",
  "lostFound.writeOff.title": "Afboeken · {{number}}",
  "lostFound.writeOff.submit": "Afboeken",
  "lostFound.writeOff.explain": "Afboeken haalt het uit de voorraad van de klant. De klant krijgt de reden terug in het mutatiebestand.",
  "lostFound.writeOff.explainAll": "Alles op deze pallet ({{count}} regels) gaat uit de voorraad van de klant. De klant krijgt de reden terug in het mutatiebestand.",
  "lostFound.writeOff.quantity": "Aantal in {{unit}} (nu {{now}})",
  "lostFound.writtenOff": "{{amount}} afgeboekt van {{number}}, reden {{code}}.",
  "lostFound.drawer.part": "Dit is een deel op lost & found: wat een pallet miste. Zet het terug op een pallet als het gevonden is, of boek het af.",
  "lostFound.drawer.pallet": "Deze pallet staat als kwijt op lost & found en wordt niet gepickt. Scant de heftruck hem, of kies Gevonden, dan wordt hij weggezet.",
  "lostFound.error.bookNotAllowed": "Ophogen van {{amount}} vraagt het recht Afboeken en ophogen.",
  "lostFound.error.bookReasonNeeded": "Lost & found dekt {{amount}} niet: kies de reden voor de klant om op te hogen.",
  "lostFound.error.noPlace": "Dit magazijn heeft geen lost & found-plek. Maak er een in Opslaglocaties.",
  "lostFound.error.unknownTarget": "Geen pallet of plek met code {{code}}.",
  "lostFound.error.emptyPlace": "Op {{place}} staat in WLX geen pallet.",
  "lostFound.error.ambiguousPlace": "Op {{place}} staan meer pallets: geef de SSCC.",
  "lostFound.error.wholePallet": "Een hele pallet zet je niet terug: kies Gevonden, dan zet de heftruck hem weg.",
  "lostFound.error.onLostFound": "Wat op lost & found staat, zet je terug of boek je af.",
  "lostFound.error.part": "Dit is een deel op lost & found, geen pallet: zet het terug op een pallet.",
  "lostFound.error.notATarget": "Zet het terug op een pallet in voorraad in hetzelfde magazijn.",
  "whwork.intro": "Wat er nu op de vloer gebeurt en wat er vandaag geladen is.",
  "whwork.tile.ready": "Klaar vóór {{time}}",
  "whwork.tile.readyNoTime": "Klaar vandaag",
  "whwork.tile.readyNote": "orders met laaddag vandaag, gepickt of verzonden",
  "whwork.tile.late": "Haalt {{time}} niet",
  "whwork.tile.lateNoTime": "Te laat",
  "whwork.tile.lateNote": "orders nog open van een eerdere laaddag of na de klaar-tijd",
  "whwork.tile.replenish": "Aanvullen · op",
  "whwork.tile.replenishNote": "picklocaties met een pallet klaar in bulk",
  "whwork.tile.counts": "Telverschillen",
  "whwork.tile.countsNote": "wachten op de teamleider",
  "whwork.tile.open": "Openen",
  "whwork.now": "Werk nu",
  "whwork.loadsToday": "Ladingen vandaag",
  "whwork.nothingNow": "Geen open werk.",
  "whwork.noLoads": "Vandaag nog niets geladen.",
  "whwork.kind.load": "Laden",
  "whwork.kind.replenish": "Aanvullen",
  "whwork.kind.pick": "Picken",
  "whwork.kind.count": "Tellen",
  "whwork.kind.putaway": "Wegzetten",
  "whwork.kind.fetch": "Halen",
  "whwork.state.open": "Open",
  "whwork.state.in_progress": "Bezig",
  "whwork.state.waiting": "Wacht",
  "whwork.loadState.open": "Bezig",
  "whwork.loadState.done": "Klaar",
  "whwork.loadState.cancelled": "Vervallen",
  "whwork.loadKind.own_transport": "Eigen vervoer",
  "whwork.loadKind.pickup": "Afhaler",
  "whwork.loadKind.carrier": "Vervoerder",
  "whwork.col.kind": "Soort",
  "whwork.col.what": "Waarvoor",
  "whwork.col.fromTo": "Van → naar",
  "whwork.col.who": "Medewerker",
  "whwork.col.since": "Sinds",
  "whwork.col.state": "Status",
  "whwork.col.load": "Lading",
  "whwork.col.forWhom": "Vervoerder of losplaats",
  "whwork.col.vehicle": "Kenteken",
  "whwork.col.units": "Pallets",
  "whwork.col.checks": "Controles",
  "whwork.col.started": "Begonnen",
  "whwork.col.done": "Klaar",
  "whwork.units_one": "{{count}} pallet",
  "whwork.units_other": "{{count}} pallets",
  "whwork.nobody": "Niemand",
  "whwork.clean": "Schoon",
  "whwork.notClean": "Niet schoon",
  "whwork.seal": "zegel {{seal}}",
  "replenishment.viewLabel": "Weergave",
  "replenishment.view.now": "Nu ({{count}})",
  "replenishment.view.done": "Vandaag gedaan ({{count}})",
  "replenishment.today_one": "Vandaag {{count}} aangevuld",
  "replenishment.today_other": "Vandaag {{count}} aangevuld",
  "replenishment.todayAverage_one": "Vandaag {{count}} aangevuld · gemiddeld {{minutes}} min van op tot gevuld",
  "replenishment.todayAverage_other": "Vandaag {{count}} aangevuld · gemiddeld {{minutes}} min van op tot gevuld",
  "replenishment.col.pickLocation": "Picklocatie",
  "replenishment.col.article": "Artikel",
  "replenishment.col.since": "Nog",
  "replenishment.col.pallet": "Pallet die erheen moet",
  "replenishment.col.why": "Waarom deze",
  "replenishment.col.task": "Taak",
  "replenishment.col.doneAt": "Tijd",
  "replenishment.col.palletPut": "Pallet",
  "replenishment.col.from": "Van",
  "replenishment.col.doneBy": "Door",
  "replenishment.col.minutes": "Op tot gevuld",
  "replenishment.why.fefo": "Oudste batch (FEFO)",
  "replenishment.why.countedZero": "Geteld op 0 · eerst telverschil corrigeren",
  "replenishment.why.noStock": "Geen pallet in voorraad",
  "replenishment.op": "Op",
  "replenishment.countedZero": "Geteld 0",
  "replenishment.bestBefore": "THT {{date}}",
  "replenishment.taskOpen": "Bezig",
  "replenishment.taskNobody": "Open · niemand",
  "replenishment.minutes_one": "{{count}} min",
  "replenishment.minutes_other": "{{count}} min",
  "replenishment.emptyNow": "Geen picklocatie op.",
  "replenishment.emptyDone": "Vandaag nog niets aangevuld.",
  "replenishment.how": "Hoe WLX kiest: een picklocatie is op als er geen pallet meer op staat (de laatste zak is gepickt) of als hij blind op 0 is geteld. De pallet die erheen gaat is de oudste batch (FEFO) uit bulk; een pallet met dezelfde batch en THT mag ook. De lege pallet is afgemeld bij de laatste zak. Een telling op 0 terwijl WLX nog voorraad heeft, wacht tot het telverschil is gecorrigeerd. Klaarzetten bij bijna op komt later.",
  "counts.intro": "Blind geteld na de laatste pick op een locatie, en anders dan WLX verwachtte. Corrigeer de voorraad met een reden, of laat de locatie opnieuw tellen.",
  "counts.viewLabel": "Welke tellingen",
  "counts.view.open": "Open",
  "counts.view.all": "Alle",
  "counts.empty": "Geen telverschillen.",
  "counts.emptyAll": "Nog niets geteld.",
  "counts.footnote": "Corrigeren zet het verschil van die telling op de locatie, zodat wat erna gepickt is gepickt blijft. Opnieuw laten tellen maakt een taak op de scanner; de nieuwste telling vervangt deze.",
  "counts.col.location": "Locatie",
  "counts.col.article": "Artikel en batch",
  "counts.col.expected": "Verwacht",
  "counts.col.counted": "Geteld",
  "counts.col.difference": "Verschil",
  "counts.col.by": "Geteld door",
  "counts.col.at": "Geteld op",
  "counts.col.state": "Status",
  "counts.col.action": "Afhandelen",
  "counts.col.reason": "Reden",
  "counts.state.open": "Verschil",
  "counts.state.recount": "Opnieuw tellen",
  "counts.state.matched": "Klopt",
  "counts.state.corrected": "Gecorrigeerd",
  "counts.state.superseded": "Opnieuw geteld",
  "counts.chooseReason": "Kies reden",
  "counts.reason.wrong_pick": "Verkeerd gepickt",
  "counts.reason.damaged": "Schade",
  "counts.reason.count_error": "Telfout eerder",
  "counts.reason.unknown": "Onbekend",
  "counts.correct": "Corrigeren",
  "counts.recount": "Opnieuw laten tellen",
  "counts.waitingScanner": "Staat als taak op de scanner",
  // Pallets (docs/tms-emballage.md)
  "pallets.kind.euro": "Euro's",
  "pallets.kind.disposable": "Wegwerp",
  "pallets.kind.various": "Diversen",
  "pallets.kind.eurochep": "Eurochep",
  "pallets.kind.ibc": "IBC",
  "pallets.kind.pc_iconic": "PC Iconic",
  "pallets.kind.blokchep": "Blokchep",
  "pallets.kind.tank": "Tank",
  "pallets.kind.magnum": "Magnum",
  "pallets.kind.tosca_euro": "Tosca euro",
  "pallets.kind.h1": "H1",
  "pallets.kind.pc_ultra": "PC Ultra",
  "pallets.kind.tosca_blok": "Tosca blok",
  "pallets.kind.h3": "H3",
  "pallets.kind.dusseldorfer": "Dusseldorfer",
  "pallets.kind.cbl17": "CBL 17",
  "pallets.kindColumn": "Soort",
  "pallets.planned": "Gepland",
  "pallets.actual": "Werkelijk",
  "pallets.unloaded": "Gelost",
  "pallets.loaded": "Geladen",
  "pallets.returned": "Retour",
  "pallets.removeKind": "Soort weghalen",
  "pallets.addKind": "Soort toevoegen…",
  "pallets.none": "Geen pallets",
  "pallets.atLoading": "Laden",
  "pallets.atUnloading": "Lossen",
  "pallets.orderIntro": "Per laad- en losadres de pallets die geruild worden. Gepland komt in vak 13 van de CMR; werkelijk is wat er op de getekende CMR staat.",
  "pallets.emballageNotAllReturned": "Niet alle emballage retour: {{amount}} · {{reason}}",
  "pallets.emballageAllReturned": "Alle emballage retour, zegt de chauffeur",
  "pallets.emballageScanned_one": "1 barcode teruggescand door de chauffeur (CHEP {{chep}}, overig {{other}})",
  "pallets.emballageScanned_other": "{{count}} barcodes teruggescand door de chauffeur (CHEP {{chep}}, overig {{other}})",
  "pallets.emballageKindEpw": "EPW",
  "pallets.emballageKindTank": "Tank, IBC of CHEP-pallet (GRAI)",
  "pallets.toCheck": "Nog te controleren",
  "pallets.checkedBy": "Gecontroleerd door {{who}}, {{when}}",
  "pallets.state.open": "Te controleren",
  "pallets.state.checked": "Gecontroleerd",
  "pallets.list.intro": "Alle zendingen met pallets die gelost zijn, ook zonder CMR. Klik op een regel om hem te bekijken of opnieuw te openen.",
  "pallets.list.colUnloaded": "Gelost",
  "pallets.list.colFrom": "Laadadres",
  "pallets.list.colTo": "Losadres",
  "pallets.list.colCustomer": "Klant",
  "pallets.list.colConsignment": "Order",
  "pallets.list.colTrip": "Rit",
  "pallets.list.colPallets": "Pallets",
  "pallets.list.colCmr": "CMR",
  "pallets.list.colChecked": "Gecontroleerd",
  "pallets.list.empty.open": "Niets te controleren.",
  "pallets.list.empty.checked": "Nog niets gecontroleerd.",
  "pallets.cmrThere": "Getekend",
  "pallets.cmrMissing": "Niet getekend",
  "pallets.cmrNone": "Geen CMR retour",
  "pallets.cmrArea": "Wat van de CMR",
  "pallets.area.box13": "Vak 13",
  "pallets.area.page": "Hele CMR",
  "pallets.openCmr": "CMR openen",
  "pallets.cmrPictureFailed": "De CMR kon niet getoond worden. Open hem los.",
  "pallets.cmrAlt": "CMR van zending {{number}}",
  "pallets.noCmr": "Er is nog geen CMR bij deze zending.",
  "pallets.noCmrReturn": "Van deze zending komt geen getekende CMR terug.",
  "pallets.prefilled": "Werkelijk staat op gepland. Pas aan wat de CMR anders zegt.",
  "pallets.reopen": "Opnieuw openen",
  "pallets.check": "Gecontroleerd",
  "purchaseInvoices.intro": "De facturen van onze leveranciers. Voeg de pdf toe, vul de factuur in en codeer hem, en stuur hem naar AFAS. Daar keurt de beoordelaar hem goed in de workflow inkoopfactuur.",
  "purchaseInvoices.add": "Inkoopfactuur toevoegen",
  "purchaseInvoices.uploading": "Bezig met toevoegen…",
  "purchaseInvoices.empty": "Nog geen inkoopfacturen.",
  "purchaseInvoices.notTypedIn": "Nog niet ingevuld",
  "purchaseInvoices.fromMail": "Per mail van {{from}} op {{at}}: {{subject}}",
  "purchaseInvoices.untitled": "Nieuwe inkoopfactuur",
  "purchaseInvoices.notFound": "Deze inkoopfactuur bestaat niet (meer).",
  "purchaseInvoices.colStatus": "Status",
  "purchaseInvoices.colSupplier": "Leverancier",
  "purchaseInvoices.colCreditor": "Crediteur",
  "purchaseInvoices.colNumber": "Factuurnummer",
  "purchaseInvoices.colInvoiceDate": "Factuurdatum",
  "purchaseInvoices.colTotal": "Totaal",
  "purchaseInvoices.colAfasInvoice": "Nummer in AFAS",
  "purchaseInvoices.colCreatedAt": "Toegevoegd",
  "purchaseInvoices.status.draft": "In te vullen",
  "purchaseInvoices.status.queued": "Onderweg naar AFAS",
  "purchaseInvoices.status.booked": "In AFAS",
  "purchaseInvoices.status.dry_run": "Proef, niet in AFAS",
  "purchaseInvoices.status.failed": "Mislukt",
  "purchaseInvoices.kind.invoice": "Factuur",
  "purchaseInvoices.kind.credit_note": "Creditnota",
  "purchaseInvoices.fieldKind": "Soort",
  "purchaseInvoices.fieldAdministration": "Administratie",
  "purchaseInvoices.administrationHelp": "De tenaamstelling op de factuur bepaalt het.",
  "purchaseInvoices.administrationChoose": "Kies…",
  "purchaseInvoices.administration.1": "1 · Holding Willems Logistics B.V.",
  "purchaseInvoices.administration.2": "2 · Willems Logistics B.V.",
  "purchaseInvoices.administration.3": "3 · Willems Logistics O.G. B.V.",
  "purchaseInvoices.fieldCreditor": "Crediteur (IR-nummer)",
  "purchaseInvoices.knownAs": "In WLX: {{name}}",
  "purchaseInvoices.fieldSupplier": "Leverancier",
  "purchaseInvoices.fieldNumber": "Factuurnummer leverancier",
  "purchaseInvoices.fieldNumberHelp": "Wordt het boekstuknummer in AFAS. Niet of verkeerd gelezen: Aanwijzen, en klik het nummer op de pdf aan.",
  "purchaseInvoices.fieldInvoiceDate": "Factuurdatum",
  "purchaseInvoices.fieldDueDate": "Vervaldatum",
  "purchaseInvoices.fieldDueDateHelp": "AFAS rekent de vervaldatum uit met de betaalvoorwaarde van de crediteur, ook als de factuur iets anders zegt.",
  "purchaseInvoices.fieldDescription": "Omschrijving van de boeking",
  "purchaseInvoices.fieldDescriptionHelp": "De leverancier, het factuurnummer en wat er geleverd is; aan te passen. Geen namen van personen.",
  "purchaseInvoices.fieldTotal": "Totaal incl. btw",
  "purchaseInvoices.linesTitle": "Boekregels",
  "purchaseInvoices.colAccount": "Rekening",
  "purchaseInvoices.colDim1": "Kostenplaats",
  "purchaseInvoices.colDim2": "Locatie",
  "purchaseInvoices.colDim3": "Kenteken",
  "purchaseInvoices.colCommitment": "Verplichting",
  "purchaseInvoices.commitmentNone": "Geen",
  "purchaseInvoices.dimRequired": "verplicht",
  "purchaseInvoices.dimNone": "niet",
  "purchaseInvoices.dimNotAllowedHere": "Deze code is in AFAS niet toegewezen aan rekening {{account}}. Kies een code uit de lijst.",
  "purchaseInvoices.pickNumber": "Aanwijzen",
  "purchaseInvoices.pickNumberTitle": "Het factuurnummer op de pdf aanwijzen",
  "purchaseInvoices.pickNumberPrompt": "Klik op de pdf op het factuurnummer van de leverancier. Uit twee stukken: klik het eerste, wijs opnieuw aan en klik het laatste met Shift. Esc stopt.",
  "purchaseInvoices.explainTitleHead": "Waarom wijzig je wat WLX las?",
  "costSplit.listTitle": "Verdeelsleutel Klopsteen 6",
  "costSplit.listIntro": "Per crediteur het deel dat naar Asian Food Group gaat, op 29700 met kostenplaats 2100 en locatie 01. Met een kenmerk verdeelt WLX vanzelf als het op de factuur staat; zonder kenmerk staat er een knop op de kaart.",
  "costSplit.colMarker": "Kenmerk",
  "costSplit.colPercentage": "Asian Food",
  "costSplit.colCoding": "Rekening / kostenplaats / locatie",
  "costSplit.byButton": "met de knop op de kaart",
  "purchaseInvoices.otherCreditor": "Andere crediteur",
  "purchaseInvoices.otherCreditorSearch": "IR-nummer of naam",
  "purchaseInvoices.otherCreditorHelp": "Kies de crediteur en sla op: WLX vraagt waarom, en leest de factuur dan opnieuw voor die crediteur.",
  "purchaseInvoices.pickDateTitle": "De factuurdatum op de pdf aanwijzen",
  "purchaseInvoices.pickDatePrompt": "Klik op de pdf op de factuurdatum. Esc stopt.",
  "purchaseInvoices.pickDateUnreadable": "WLX herkent \"{{text}}\" niet als datum. Wijs de datum aan.",
  "purchaseInvoices.pickTotalTitle": "Het totaal op de pdf aanwijzen",
  "purchaseInvoices.pickTotalPrompt": "Klik op de pdf op het totaal van de factuur. Esc stopt.",
  "purchaseInvoices.pickTotalUnreadable": "WLX herkent \"{{text}}\" niet als bedrag. Wijs het totaal aan.",
  "purchaseInvoices.vatMissing": "btw ontbreekt",
  "purchaseInvoices.vatMissingHelp": "Er is geen btw-regel. Tegen het tarief zou het {{amount}} zijn, maar dat gaat niet naar AFAS. Lees de factuur opnieuw.",
  "purchaseInvoices.codingField.invoiceDate": "factuurdatum",
  "purchaseInvoices.codingField.total": "totaal",
  "purchaseInvoices.codingField.creditorNumber": "crediteur",
  "purchaseInvoices.codingField.commitment": "verplichting",
  "purchaseInvoices.explainChangeHead": "{{field}}: {{from}} → {{to}}",
  "purchaseInvoices.readBy.chosen": "een keuze op deze kaart",
  "purchaseInvoices.readFlag.net_not_found": "Let op: WLX vond het netto en de btw niet in de tekst van de factuur. De regel staat daarom op 0,00; vul hem niet zelf in, maar lees de factuur opnieuw of meld Lezen klopt niet.",
  "purchaseInvoices.error.PURCHASE_INVOICE_UNKNOWN_CREDITOR": "Die crediteur kent AFAS niet, of hij is geblokkeerd.",
  "purchaseInvoices.error.PURCHASE_INVOICE_UNKNOWN_COMMITMENT": "Dat is geen open verplichting van deze crediteur.",
  "purchaseInvoices.error.PURCHASE_INVOICE_UNKNOWN_SPLIT": "Die verdeelsleutel hoort niet bij deze crediteur.",
  "purchaseInvoices.error.PURCHASE_INVOICE_ALREADY_SPLIT": "De factuur is al verdeeld, of heeft geen regels.",
  "purchaseInvoices.error.MOTOR_TAX_SPEC_UNREADABLE": "Dit is geen specificatie van GWH, of de regels tellen niet op tot het totaal.",
  "purchaseInvoices.error.MOTOR_TAX_SPEC_OTHER_NOTICE": "Deze specificatie hoort bij kenmerk {{specification}}, de aankondiging heeft {{invoice}}.",
  "purchaseInvoices.error.MOTOR_TAX_SPEC_TOTAL": "De specificatie telt op tot {{specification}}, de aankondiging is {{invoice}}.",
  "purchaseInvoices.error.MOTOR_TAX_SPEC_NO_LINE": "De aankondiging heeft nog geen regel om de kentekens op te coderen. Lees hem eerst.",
  "costSplit.title": "Doorbelasting Klopsteen 6",
  "costSplit.intro": "Hoort deze factuur bij Klopsteen 6 in Haps? Dan gaat een deel naar Asian Food Group op 29700. Schrijf waarom en kies de verdeling.",
  "costSplit.explanation": "Uitleg (verplicht)",
  "costSplit.apply": "Verdelen volgens sleutel ({{percentage}} % Asian Food)",
  "costSplit.applyMarker": "Verdelen: {{marker}} ({{percentage}} % Asian Food)",
  "costSplit.done": "Verdeeld volgens de verdeelsleutel: {{percentage}} % naar Asian Food op 29700, herkend aan {{marker}}.",
  "motorTax.title": "Motorrijtuigenbelasting",
  "motorTax.intro": "Kenmerk {{kenmerk}}. De bedragen per kenteken staan in de specificatie van GWH (het tekstbestand). Komt die in de mailbox, dan zet WLX hem er vanzelf bij; anders voeg je hem hier toe.",
  "motorTax.summary": "Specificatie {{file}}: {{vehicles}} kentekens, per kenteken een regel per maand.",
  "motorTax.upload": "Specificatie toevoegen",
  "motorTax.uploadOther": "Andere specificatie",
  "purchaseInvoices.pickNoText": "WLX vond geen woorden op deze pdf om aan te wijzen. Meld het met Lezen klopt niet.",
  "purchaseInvoices.pickFallback": "In de viewer van de browser valt niets aan te wijzen: typ het nummer over.",
  "purchaseInvoices.accountUnknown": "Onbekend in AFAS",
  "purchaseInvoices.commitmentsTitle": "Open verplichtingen in AFAS",
  "purchaseInvoices.commitmentsHelp": "Van deze crediteur. Een regel met een verplichting boekt die af in AFAS.",
  "purchaseInvoices.colCommitmentNumber": "Nummer",
  "purchaseInvoices.colReference": "Referentie",
  "purchaseInvoices.colCoding": "Rekening · as",
  "purchaseInvoices.colAmount": "Bedrag",
  "purchaseInvoices.colBalance": "Saldo",
  "purchaseInvoices.colOnInvoice": "Op deze factuur",
  "purchaseInvoices.colRemaining": "Verschil",
  "purchaseInvoices.commitmentNamed": "op de factuur",
  "purchaseInvoices.colVatCode": "Btw-code",
  "purchaseInvoices.colLineDescription": "Omschrijving",
  "purchaseInvoices.colNet": "Netto",
  "purchaseInvoices.colActions": "Acties",
  "purchaseInvoices.addLine": "Regel toevoegen",
  "purchaseInvoices.removeLine": "Weg",
  "purchaseInvoices.vatLine": "Btw over {{net}}",
  "purchaseInvoices.sum": "Regels plus btw:",
  "purchaseInvoices.difference": "Verschil met het totaal: {{amount}}",
  "purchaseInvoices.vat.4": "4 · 21 %",
  "purchaseInvoices.vat.5": "5 · 9 %",
  "purchaseInvoices.vat.6": "6 · 0 %",
  "purchaseInvoices.vat.32": "32 · verlegd",
  "purchaseInvoices.vat.36": "36 · import buiten EU",
  "purchaseInvoices.vat.37": "37 · IC-verwerving 21 %",
  "purchaseInvoices.vat.38": "38 · IC-verwerving 9 %",
  "purchaseInvoices.vat.39": "39 · IC-verwerving 0 %",
  "purchaseInvoices.vat.99": "99 · geen btw",
  "purchaseInvoices.problemsTitle": "Nog niet klaar voor AFAS:",
  "purchaseInvoices.problem.no_creditor": "De crediteur (IR-nummer) ontbreekt.",
  "purchaseInvoices.problem.no_invoice_number": "Het factuurnummer van de leverancier ontbreekt.",
  "purchaseInvoices.problem.no_invoice_date": "De factuurdatum ontbreekt.",
  "purchaseInvoices.problem.no_total": "Het totaal ontbreekt.",
  "purchaseInvoices.problem.no_lines": "Er is nog geen boekregel.",
  "purchaseInvoices.problem.line_incomplete": "Een boekregel heeft geen rekening of geen btw-code.",
  "purchaseInvoices.problem.unknown_vat_code": "Een btw-code is geen inkoopcode van AFAS.",
  "purchaseInvoices.problem.vat_not_on_invoice": "Er staat btw bij een code zonder btw op de factuur.",
  "purchaseInvoices.problem.sum_mismatch": "De regels plus de btw zijn niet gelijk aan het totaal.",
  "purchaseInvoices.problem.duplicate": "Deze crediteur heeft al een inkoopfactuur met dit factuurnummer in WLX.",
  "purchaseInvoices.problem.no_administration": "De administratie ontbreekt.",
  "purchaseInvoices.problem.dim_unknown": "Een kostenplaats, locatie of kenteken kent AFAS niet.",
  "purchaseInvoices.problem.dim_required": "De rekening vraagt een kostenplaats, locatie of kenteken die nog leeg is.",
  "purchaseInvoices.problem.dim_not_used": "Er staat een code op een as die de rekening niet gebruikt.",
  "purchaseInvoices.problem.dim_not_allowed": "Een code bij kostenplaats, locatie of kenteken is in AFAS niet toegewezen aan de grootboekrekening van die regel (rood omrand). Kies een code uit de lijst bij het veld.",
  "purchaseInvoices.problem.commitment_unknown": "Een verplichting op een regel staat in AFAS niet open voor deze crediteur en administratie.",
  "purchaseInvoices.delete": "Verwijderen",
  "purchaseInvoices.deleteConfirm": "Deze inkoopfactuur en de pdf verwijderen?",
  "purchaseInvoices.book": "Naar AFAS",
  "purchaseInvoices.bookAgain": "Opnieuw naar AFAS",
  "purchaseInvoices.saveFirst": "Sla eerst je wijzigingen op.",
  "purchaseInvoices.bookingOff": "Naar AFAS sturen staat nog uit.",
  "purchaseInvoices.afasTitle": "AFAS",
  "purchaseInvoices.queuedText": "Onderweg naar AFAS. Het antwoord komt vanzelf.",
  "purchaseInvoices.noAnswer": "Geen antwoord",
  "purchaseInvoices.noAnswerTitle": "Geen antwoord van AFAS",
  "purchaseInvoices.noAnswerText": "Sinds {{at}} onderweg, en nog geen antwoord. Het bericht is misschien niet bij de DataBridge aangekomen. Kijk eerst in AFAS of de factuur er toch staat. Staat hij er niet, zet hem dan terug en stuur hem opnieuw naar AFAS.",
  "purchaseInvoices.noAnswerReset": "Terugzetten",
  "purchaseInvoices.dryRunText": "De DataBridge heeft hem als proef behandeld: niet geboekt. De boeking staat in de log van de DataBridge.",
  "purchaseInvoices.bookedText": "Geboekt in AFAS met de pdf erbij. De workflow inkoopfactuur loopt nu in AFAS.",
  "purchaseInvoices.stage.entry": "AFAS weigerde de boeking.",
  "purchaseInvoices.stage.attachment": "Geboekt, maar zonder pdf en zonder workflow. Blokkeer hem in AFAS voor betaling en voeg de pdf toe.",
  "purchaseInvoices.stage.send": "Het bericht kon niet naar de DataBridge.",
  "purchaseInvoices.stage.no_answer": "Geen antwoord van AFAS; teruggezet. Staat hij niet in AFAS, stuur hem dan opnieuw.",
  "purchaseInvoices.afasInvoice": "Intern factuurnummer",
  "purchaseInvoices.afasEntry": "Journaalpost",
  "purchaseInvoices.afasSubject": "Dossieritem",
  "purchaseInvoices.queuedAt": "Naar AFAS gestuurd",
  "purchaseInvoices.answeredAt": "Antwoord",
  "purchaseInvoices.error.PURCHASE_INVOICE_NOT_A_PDF": "Dit bestand is geen pdf.",
  "purchaseInvoices.error.PURCHASE_INVOICE_PDF_TOO_LARGE": "De pdf is groter dan 10 MB.",
  "purchaseInvoices.error.PURCHASE_INVOICE_LOCKED": "Deze inkoopfactuur is onderweg naar AFAS of staat er al in.",
  "purchaseInvoices.error.PURCHASE_INVOICE_NOT_WAITING": "Deze factuur wacht niet (meer) op een antwoord van AFAS.",
  "purchaseInvoices.error.PURCHASE_INVOICE_BOOKING_OFF": "Naar AFAS sturen staat nog uit.",
  "purchaseInvoices.error.PURCHASE_INVOICE_INCOMPLETE": "Deze inkoopfactuur is nog niet klaar voor AFAS.",
  "purchaseInvoices.error.amount": "Een bedrag klopt niet. Schrijf het als 1234,56.",
  "purchaseInvoices.reading": "WLX leest de factuur…",
  "purchaseInvoices.readAgain": "Opnieuw lezen",
  "purchaseInvoices.readFailed": "Lezen is mislukt. Vul de factuur zelf in, of probeer het opnieuw.",
  "purchaseInvoices.readNoText": "Er staat geen tekst in deze pdf die WLX kan lezen. Vul de factuur zelf in.",
  "purchaseInvoices.readCreditor": "Herkend als {{name}} ({{number}}), op {{by}}.",
  "purchaseInvoices.readCandidates": "Meer crediteuren passen ({{numbers}}). Kies zelf.",
  "purchaseInvoices.readNoCreditor": "Geen crediteur herkend. Kies hem met Andere crediteur, met uitleg.",
  "purchaseInvoices.readFilled": "Ingevuld: {{fields}}. Controleer het naast de pdf.",
  "purchaseInvoices.readUncertain": "Niet overgenomen, want niet zo in de tekst gevonden: {{fields}}.",
  "purchaseInvoices.readTotalFromParts": "Het totaal ({{total}}) staat niet leesbaar in de tekst, netto en btw wel: samen komen die op de cent op het totaal. Controleer het naast de pdf.",
  "purchaseInvoices.readWithAi": "Gelezen met AI.",
  "purchaseInvoices.readWithoutAi": "Gelezen zonder AI: alleen btw-nummer, IBAN en KvK.",
  "purchaseInvoices.readAiFailed": "Het AI-model gaf geen antwoord: alleen btw-nummer, IBAN en KvK gelezen.",
  "purchaseInvoices.readOcr": "De pdf was een scan: de tekst komt uit OCR.",
  "purchaseInvoices.readBy.vat": "het btw-nummer",
  "purchaseInvoices.readBy.iban": "de IBAN",
  "purchaseInvoices.readBy.coc": "het KvK-nummer",
  "purchaseInvoices.readBy.name": "de naam",
  "purchaseInvoices.readBy.learned": "een eerdere keuze in WLX (btw- of KvK-nummer)",
  "purchaseInvoices.readBy.domain": "het web- of mailadres",
  "purchaseInvoices.readBy.charter_vat": "het btw- of KvK-nummer van een charter in WLX",
  "purchaseInvoices.readFlag.iban_mismatch": "Let op: de IBAN op deze factuur kent AFAS niet voor deze crediteur. Controleer bij de leverancier of het rekeningnummer klopt voordat je hem naar AFAS stuurt.",
  "purchaseInvoices.readFlag.creditor_blocked": "Let op: deze crediteur is in AFAS geblokkeerd.",
  "purchaseInvoices.readFlag.payment_terms_mismatch": "Let op: op de factuur staat een betaaltermijn van {{invoice}} dagen, bij de crediteur in AFAS staat betaalvoorwaarde {{afas}}. Pas de betaalvoorwaarde van de crediteur in AFAS aan, dan rekent AFAS de vervaldatum goed uit.",
  "purchaseInvoices.readFlag.administration_unclear": "Let op: WLX kon de administratie niet uit de tenaamstelling halen. Kies hem zelf.",
  "purchaseInvoices.readFlag.dim_unknown": "Let op: de codering had een kostenplaats, locatie of kenteken die AFAS niet kent. Dat vak is leeg gelaten.",
  "purchaseInvoices.readFlag.commitments_several": "Let op: de factuur noemt meer verplichtingen en hun saldo's tellen niet op tot het netto bedrag. Kies per regel de verplichting.",
  "purchaseInvoices.readField.creditorNumber": "crediteur",
  "purchaseInvoices.readField.supplierName": "leverancier",
  "purchaseInvoices.readField.supplierInvoiceNumber": "factuurnummer",
  "purchaseInvoices.readField.invoiceNumber": "factuurnummer",
  "purchaseInvoices.readField.invoiceDate": "factuurdatum",
  "purchaseInvoices.readField.dueDate": "vervaldatum",
  "purchaseInvoices.readField.total": "totaal",
  "purchaseInvoices.readField.kind": "soort",
  "purchaseInvoices.readField.lines": "boekregels",
  "purchaseInvoices.readField.vatLines": "btw-regels",
  "purchaseInvoices.readField.currency": "valuta (niet EUR)",
  "purchaseInvoices.readField.administration": "administratie",
  "purchaseInvoices.readCodingDefault": "Gecodeerd met de voorkeursrekening en de assen van de crediteur in AFAS.",
  "purchaseInvoices.readCodingHistory_one": "Gecodeerd zoals de vorige factuur van deze crediteur in AFAS.",
  "purchaseInvoices.readCodingHistory_other": "Gecodeerd zoals de laatste {{count}} facturen van deze crediteur in AFAS.",
  "purchaseInvoices.readNever": "WLX heeft deze factuur nog niet gelezen.",
  "purchaseInvoices.documentType.invoice": "Factuur",
  "purchaseInvoices.documentType.credit_note": "Creditnota",
  "purchaseInvoices.documentType.reminder": "Betalingsherinnering",
  "purchaseInvoices.documentType.statement": "Overzicht",
  "purchaseInvoices.documentType.order_confirmation": "Orderbevestiging",
  "purchaseInvoices.documentType.other": "Geen factuur",
  "purchaseInvoices.colDocument": "Document",
  "purchaseInvoices.notAnInvoice": "WLX denkt dat dit een {{type}} is, geen factuur: hij gaat niet naar AFAS. Is het toch een factuur, zet hem dan terug. Zo niet, verwijder hem.",
  "purchaseInvoices.notAnInvoiceOther": "WLX denkt dat dit geen factuur is: hij gaat niet naar AFAS. Is het toch een factuur, zet hem dan terug. Is het de CMR bij een factuur, koppel hem hieronder. Zo niet, verwijder hem.",
  "purchaseInvoices.notAnInvoiceButton": "Toch een factuur",
  "purchaseInvoices.problem.not_an_invoice": "Dit is geen factuur of creditnota.",
  "purchaseInvoices.readUbl": "Gelezen uit de e-factuur (UBL) die de leverancier meestuurde.",
  "purchaseInvoices.readField.documentType": "soort document",
  "purchaseInvoices.feedback.button": "Lezen klopt niet",
  "purchaseInvoices.feedback.title": "Wat klopte er niet?",
  "purchaseInvoices.feedback.note": "Toelichting: wat stond er, en wat had het moeten zijn?",
  "purchaseInvoices.feedback.send": "Melden",
  "purchaseInvoices.feedback.cancel": "Annuleren",
  "purchaseInvoices.feedback.needField": "Kies wat er niet klopte.",
  "purchaseInvoices.feedback.open": "Gemeld op {{date}}, nog niet bekeken.",
  "purchaseInvoices.feedback.handled": "Gemeld op {{date}}, bekeken.",
  "purchaseInvoices.feedbackField.creditor": "Crediteur",
  "purchaseInvoices.feedbackField.number": "Factuurnummer",
  "purchaseInvoices.feedbackField.dates": "Datums",
  "purchaseInvoices.feedbackField.amounts": "Bedragen of btw",
  "purchaseInvoices.feedbackField.coding": "Rekening of assen",
  "purchaseInvoices.feedbackField.administration": "Administratie",
  "purchaseInvoices.feedbackField.commitment": "Verplichting",
  "purchaseInvoices.feedbackField.document_type": "Soort document",
  "purchaseInvoices.feedbackField.other": "Anders",
  "nav.readFeedback": "Leesmeldingen",
  "readFeedback.title": "Leesmeldingen",
  "readFeedback.intro": "Wat collega's meldden met \"Lezen klopt niet\". Bekijk het, verbeter het lezen waar dat nodig is, en zet de melding op bekeken.",
  "readFeedback.showHandled": "Ook bekeken meldingen",
  "readFeedback.colInvoice": "Factuur",
  "readFeedback.colFields": "Wat",
  "readFeedback.colNote": "Toelichting",
  "readFeedback.colRead": "Gelezen",
  "readFeedback.colBy": "Gemeld door",
  "readFeedback.colAt": "Gemeld op",
  "readFeedback.handle": "Bekeken",
  "readFeedback.handledBy": "Bekeken door {{name}}",
  "readFeedback.empty": "Geen open meldingen.",
  "readFeedback.read.text": "tekst",
  "readFeedback.read.ocr": "OCR",
  "readFeedback.read.ubl": "UBL",
  "readFeedback.read.none": "geen tekst",
  "readFeedback.withAi": "met AI",
  "readFeedback.withoutAi": "zonder AI",
  "nav.fuelCardProducts": "Tankpasproducten",
  "fuelCard.title": "BP-tankpasfactuur",
  "fuelCard.intro": "De boekregels komen uit de specificatie van deze factuur: download hem in het BP-portaal (Toon gefactureerde transacties, Download naar excel) en zet hem hier.",
  "fuelCard.upload": "Specificatie toevoegen",
  "fuelCard.uploadOther": "Andere specificatie",
  "fuelCard.rebuild": "Regels opnieuw maken",
  "fuelCard.summary": "Specificatie {{file}}: {{rows}} transacties, {{plates}} kentekens. Netto {{net}}, btw {{vat}}.",
  "fuelCard.country": "{{name}} {{net}} + btw {{vat}}",
  "fuelCard.countryUnknown": "land onbekend",
  "fuelCard.unknown": "Nog geen rekening voor: {{products}}. Geef ze een rekening en maak de regels opnieuw.",
  "fuelCard.toProducts": "Naar tankpasproducten",
  "fuelCard.productsTitle": "Tankpasproducten",
  "fuelCard.productsIntro": "Op welke grootboekrekening een product van een BP-factuur geboekt wordt. Een product dat hier niet staat, houdt de factuur tegen tot het een rekening heeft.",
  "fuelCard.unmappedTitle": "Op een specificatie, nog zonder rekening",
  "fuelCard.link": "Koppelen",
  "fuelCard.colProduct": "Product (zoals in de specificatie)",
  "fuelCard.colAccount": "Rekening",
  "fuelCard.colAccountName": "Naam in AFAS",
  "fuelCard.colActions": "Acties",
  "fuelCard.newProduct": "Nieuw product",
  "fuelCard.add": "Toevoegen",
  "fuelCard.save": "Opslaan",
  "fuelCard.delete": "Verwijderen",
  "fuelCard.deleteConfirm": "{{product}} uit de tabel halen? Een factuur met dit product kan dan niet naar AFAS tot het weer een rekening heeft.",
  "purchaseInvoices.problem.fuel_card_unknown_product": "Een product van de tankpasfactuur heeft nog geen rekening (Finance → Tankpasproducten).",
  "purchaseInvoices.error.FUEL_CARD_SPEC_FORMAT": "Dit is niet de specificatie van BP (een Excel met onder meer B2M factuurnummer, Product omschrijving, Nettobedrag VV en BTW bedrag VV).",
  "purchaseInvoices.error.FUEL_CARD_SPEC_EMPTY": "Er staan geen transacties in deze specificatie.",
  "purchaseInvoices.error.FUEL_CARD_SPEC_CURRENCY": "Deze specificatie is niet in euro.",
  "purchaseInvoices.error.FUEL_CARD_SPEC_MORE_INVOICES": "Deze specificatie bevat meer facturen ({{numbers}}). Download hem per factuur.",
  "purchaseInvoices.error.FUEL_CARD_SPEC_OTHER_INVOICE": "Deze specificatie hoort bij factuur {{specification}}, niet bij {{invoice}}.",
  "purchaseInvoices.error.FUEL_CARD_SPEC_TOTAL": "De specificatie telt op tot {{specification}}, de factuur is {{invoice}}.",
  "purchaseInvoices.error.FUEL_CARD_SPEC_TOO_LARGE": "De specificatie is groter dan 10 MB.",
  "purchaseInvoices.error.FUEL_CARD_SPEC_NONE": "Deze factuur heeft nog geen specificatie.",
  "purchaseInvoices.readCodingCommitment": "Gecodeerd met de rekening en de assen van de verplichting in AFAS.",
  "purchaseInvoices.readAdministrationAddressee": "Administratie {{name}}, op de tenaamstelling.",
  "purchaseInvoices.readAdministrationCommitment": "Administratie {{name}}, van de verplichting.",
  "purchaseInvoices.readCommitments_one": "De factuur noemt verplichting {{numbers}}.",
  "purchaseInvoices.readCommitments_other": "De factuur noemt verplichtingen {{numbers}}.",
  "purchaseInvoices.readPlate": "Kenteken {{plate}} gevonden.",
  "purchaseInvoices.colCmr": "CMR",
  "purchaseInvoices.documentType.cmr": "CMR",
  "purchaseInvoices.cmr.missingShort": "CMR ontbreekt",
  "purchaseInvoices.cmr.requestedShort": "CMR opgevraagd",
  "purchaseInvoices.cmr.title": "CMR",
  "purchaseInvoices.cmr.missingTitle": "CMR ontbreekt",
  "purchaseInvoices.cmr.missingText": "Transportfactuur op verplichting {{commitments}} (rekening 41500): zonder CMR gaat hij niet naar AFAS.",
  "purchaseInvoices.cmr.requiredText": "Transportfactuur op verplichting {{commitments}} (rekening 41500): de CMR gaat met de factuur mee naar AFAS, in dezelfde pdf.",
  "purchaseInvoices.cmr.inPdf_one": "De CMR zit in de pdf: pagina {{pages}}.",
  "purchaseInvoices.cmr.inPdf_other": "De CMR zit in de pdf: pagina's {{pages}}.",
  "purchaseInvoices.cmr.source.mail": "uit dezelfde mail",
  "purchaseInvoices.cmr.source.reply": "uit een latere mail",
  "purchaseInvoices.cmr.source.manual": "met de hand toegevoegd",
  "purchaseInvoices.cmr.remove": "Weghalen",
  "purchaseInvoices.cmr.requested": "Opgevraagd bij {{to}} op {{at}} door {{by}}.",
  "purchaseInvoices.cmr.ask": "CMR opvragen",
  "purchaseInvoices.cmr.askAgain": "Nog eens opvragen",
  "purchaseInvoices.cmr.askTo": "Aan",
  "purchaseInvoices.cmr.askPreview": "WLX antwoordt vanuit het postvak op de mail van de factuur, in het Nederlands en het Engels: “Wij hebben uw factuur {{number}} ontvangen. Bij een transportfactuur hoort de CMR van de rit, en die ontbreekt. Zonder CMR kunnen wij de factuur niet verwerken. Wilt u de CMR als antwoord op deze mail sturen?” Zodra het antwoord in de map van de inkoopfacturen staat, hangt WLX de CMR aan deze factuur.",
  "purchaseInvoices.cmr.askSend": "Versturen",
  "purchaseInvoices.cmr.add": "CMR of foto toevoegen",
  "purchaseInvoices.cmr.isCmr": "Dit is een CMR, geen factuur. WLX kon niet vinden bij welke factuur hij hoort. Kies de factuur: de CMR verdwijnt dan uit de lijst en gaat met die factuur mee naar AFAS.",
  "purchaseInvoices.cmr.linkTo": "Kies de factuur…",
  "purchaseInvoices.cmr.noneWaiting": "Geen factuur wacht op een CMR",
  "purchaseInvoices.cmr.link": "Koppelen",
  "purchaseInvoices.cmr.maybeCmr": "Is dit de CMR bij een factuur? Kies de factuur: het document verdwijnt dan uit de lijst en gaat als CMR met die factuur mee naar AFAS.",
  "purchaseInvoices.cmr.linkAsCmr": "Als CMR koppelen",
  "purchaseInvoices.cmr.sameMail": "In dezelfde mail: {{file}}",
  "purchaseInvoices.cmr.optionSameMail": "Uit dezelfde mail: {{name}}",
  "purchaseInvoices.problem.cmr_missing": "De CMR ontbreekt: een transportfactuur op een verplichting op 41500 gaat alleen met CMR naar AFAS.",
  "purchaseInvoices.problem.pdf_too_large": "De factuur en de CMR zijn samen groter dan 10 MB.",
  "purchaseInvoices.error.PURCHASE_INVOICE_IS_CMR": "Dit is een CMR, geen factuur.",
  "purchaseInvoices.error.PURCHASE_INVOICE_NOT_A_CMR": "Alleen een CMR, of een document dat geen factuur is, kan aan een factuur gekoppeld worden.",
  "purchaseInvoices.error.PURCHASE_INVOICE_MAIL_OFF": "Het postvak van de inkoopfacturen is niet ingesteld.",
  "purchaseInvoices.error.PURCHASE_INVOICE_NO_MAIL": "Deze factuur kwam niet per mail binnen: er is niets om op te antwoorden.",
  "purchaseInvoices.error.PURCHASE_INVOICE_CMR_NOT_MISSING": "Deze factuur heeft geen CMR nodig, of heeft hem al.",
  "purchaseInvoices.error.PURCHASE_INVOICE_MAIL_GONE": "De mail van deze factuur staat niet meer in het postvak.",
  "nav.codingRules": "Geleerde codering",
  "purchaseInvoices.pdfPages_one": "1 pagina",
  "purchaseInvoices.pdfPages_other": "{{count}} pagina's",
  "purchaseInvoices.pdfMarked": "geel: wat WLX las",
  "purchaseInvoices.pdfNotFound": "niet gevonden op de pdf",
  "purchaseInvoices.pdfZoomIn": "Groter",
  "purchaseInvoices.pdfZoomOut": "Kleiner",
  "purchaseInvoices.pdfOpen": "Openen",
  "purchaseInvoices.pdfFallback": "WLX kon de pdf niet zelf tekenen; dit is de viewer van de browser, zonder markering en loep.",
  "purchaseInvoices.fieldAutoPay": "Automatisch betalen",
  "purchaseInvoices.fromAfas": "Zoals bij de crediteur in AFAS.",
  "purchaseInvoices.fieldGAccount": "G-rekening",
  "purchaseInvoices.gAccountHelp": "Percentage uit AFAS × totaal incl. btw: dat deel gaat naar de G-rekening.",
  "purchaseInvoices.gAccountNoPercentage": "geen percentage in AFAS",
  "purchaseInvoices.colPeriod": "Periode",
  "purchaseInvoices.periodHead": "Kop ({{period}})",
  "purchaseInvoices.periodHeadNone": "Kop",
  "purchaseInvoices.periodVia": "{{period}} via {{account}}",
  "purchaseInvoices.periodTransit": "Geboekt via tussenrekening {{account}}",
  "purchaseInvoices.correctionsTitle": "Met de hand aangepast",
  "purchaseInvoices.correction": "Regel {{line}}: {{field}} {{from}} → {{to}}. {{explanation}}",
  "purchaseInvoices.correctionNumber": "Factuurnummer {{from}} → {{to}}. {{explanation}}",
  "purchaseInvoices.correctionLearned": "geleerd",
  "purchaseInvoices.codingField.account": "rekening",
  "purchaseInvoices.codingField.dim1": "kostenplaats",
  "purchaseInvoices.codingField.dim2": "locatie",
  "purchaseInvoices.codingField.dim3": "kenteken",
  "purchaseInvoices.codingField.vatCode": "btw-code",
  "purchaseInvoices.codingField.period": "periode",
  "purchaseInvoices.codingField.supplierInvoiceNumber": "factuurnummer",
  "purchaseInvoices.explainTitle": "Waarom pas je de codering aan?",
  "purchaseInvoices.explainChange": "Regel {{line}}: {{field}} {{from}} → {{to}}",
  "purchaseInvoices.explainChangeNumber": "Factuurnummer: {{from}} → {{to}}",
  "purchaseInvoices.explainTitleNumber": "Waarom wijzig je het factuurnummer?",
  "purchaseInvoices.explainEmpty": "leeg",
  "purchaseInvoices.explainWhy": "Uitleg (verplicht)",
  "purchaseInvoices.explainPlaceholder": "Bijvoorbeeld: kenmerk Borculo hoort bij locatie 09 Borculo",
  "purchaseInvoices.explainLearn": "Waarvoor geldt dit?",
  "purchaseInvoices.explainLearnAll": "voor alle facturen van {{creditor}}",
  "purchaseInvoices.explainLearnReference": "alleen bij kenmerk {{reference}}",
  "purchaseInvoices.explainNoCreditor": "Zonder crediteur leert WLX niets; de uitleg wordt wel bewaard.",
  "purchaseInvoices.explainPeriodOnly": "De periode wordt bewaard met de uitleg. WLX leert hem niet: hij hoort bij deze factuur.",
  "purchaseInvoices.explainNotLearned": "WLX bewaart het met de uitleg, maar leert het niet: het hoort bij deze factuur.",
  "purchaseInvoices.readLocation": "Locatie {{code}} uit kenmerk {{reference}}.",
  "purchaseInvoices.readCostPeriods": "Kosten per periode: {{periods}}.",
  "purchaseInvoices.readLearned": "Geleerd: {{field}} {{value}}. {{explanation}} ({{by}})",
  "purchaseInvoices.readLearnedReference": "Geleerd bij kenmerk {{reference}}: {{field}} {{value}}. {{explanation}} ({{by}})",
  "purchaseInvoices.readFlag.g_account_no_percentage": "Let op: op de factuur staat een G-rekening, maar bij de crediteur staat in AFAS geen G-rekeningpercentage. Zet het percentage in AFAS en lees de factuur opnieuw.",
  "purchaseInvoices.readFlag.g_account_unknown_iban": "Let op: de G-rekening op de factuur is in AFAS geen G-rekening van deze crediteur. AFAS betaalt op de G-rekening die het kent; controleer het bij de leverancier.",
  "purchaseInvoices.readFlag.cost_periods_unsure": "Let op: WLX kon de weken of datums op de factuur niet sluitend maken met het netto bedrag. Alles staat in de periode van de factuurdatum; pas de periode per regel aan als dat niet klopt.",
  "purchaseInvoices.documentType.specification": "Specificatie",
  "purchaseInvoices.readBy.rule": "een vaste regel van financiën",
  "purchaseInvoices.readFlag.plate_unknown": "Let op: kenteken {{plate}} op de factuur staat niet in AFAS. Het vak kenteken is leeg gelaten.",
  "purchaseInvoices.readFlag.department_unknown": "Let op: bij een afdeling op de factuur vond WLX geen locatie. Vul de locatie op die regel zelf in.",
  "purchaseInvoices.readFlag.vehicles_unsure": "Let op: de bedragen per kenteken tellen niet op tot het totaal. Alles staat op één regel.",
  "purchaseInvoices.readFlag.fuel_card_unsure": "Let op: WLX kon de kaarten van deze tankpasfactuur niet sluitend lezen. Alles staat op één regel.",
  "purchaseInvoices.readField.gAccountPercentage": "G-rekeningpercentage",
  "purchaseInvoices.readField.description": "omschrijving",
  "purchaseInvoices.notice.transport_without_commitment": "Transportfactuur zonder verplichting: er staat een regel op 41500 of de crediteur is een charter, maar de factuur noemt geen verplichting in AFAS.",
  "purchaseInvoices.mail": "Mailen",
  "purchaseInvoices.mailed": "Gemaild aan {{to}} op {{at}} door {{by}}",
  "purchaseInvoices.mailTitle": "Factuur mailen",
  "purchaseInvoices.mailHelp_one": "De mail gaat uit het postvak van de inkoopfacturen, met de factuur als bijlage.",
  "purchaseInvoices.mailHelp_other": "De mail gaat uit het postvak van de inkoopfacturen, met {{count}} bijlagen: de factuur en wat erbij hoort.",
  "purchaseInvoices.mailTo": "Aan",
  "purchaseInvoices.mailSubjectLabel": "Onderwerp",
  "purchaseInvoices.mailSubject": "Uw factuur {{number}}",
  "purchaseInvoices.mailBody": "Tekst",
  "purchaseInvoices.mailSend": "Versturen",
  "purchaseInvoices.explainLearnOnce": "alleen deze factuur",
  "purchaseInvoices.spread": "Verdelen over maanden",
  "purchaseInvoices.spreadTitle": "Regel {{line}} verdelen over maanden",
  "purchaseInvoices.spreadIntro": "Elke maand hetzelfde bedrag. Een maand buiten de factuurdatum gaat via 29100.",
  "purchaseInvoices.spreadFrom": "Van",
  "purchaseInvoices.spreadTo": "Tot en met",
  "purchaseInvoices.perArticle": "Per artikel: een regel per artikel",
  "purchaseInvoices.perArticleHelp": "Elk artikel van de factuur een eigen regel, als de bedragen samen het netto zijn. Geldt vanaf de volgende keer lezen.",
  "purchaseInvoices.colMailed": "Gemaild",
  "purchaseInvoices.countsLabel": "Aantal per status",
  "purchaseInvoices.cmr.deadFreight": "Geen CMR nodig: foutvracht.",
  "purchaseInvoices.cmr.optionInAfas": "staat in AFAS",
  "purchaseInvoices.cmr.afas.queued": "Onderweg naar AFAS",
  "purchaseInvoices.cmr.afas.done": "In AFAS",
  "purchaseInvoices.cmr.afas.failed": "AFAS weigerde",
  "purchaseInvoices.cmr.afas.dry_run": "Op proef, niet in AFAS",
  "purchaseInvoices.cmr.afasAgain": "Opnieuw naar AFAS",
  "purchaseInvoices.readFlag.article_lines_unsure": "Let op: WLX kon de artikelen niet sluitend lezen. De factuur staat per btw-tarief.",
  "purchaseInvoices.error.PURCHASE_INVOICE_NO_OWN_CODING": "Alle eerdere boekingen van deze crediteur staan op deze rekening. Zet de regel eerst op de rekening van Willems.",
  "purchaseInvoices.error.PURCHASE_INVOICE_NO_AFAS_DOSSIER": "WLX kent het dossieritem van deze factuur in AFAS niet. Voeg het document daar met de hand toe.",
  "purchaseInvoices.error.PURCHASE_INVOICE_BAD_SPREAD": "Kies minstens twee maanden en hooguit 36.",
  "motorTax.part": "Eerste specificatie staat erbij ({{file}}), maar die is niet het hele bedrag. WLX wacht op de tweede.",
  "purchaseInvoices.tempAgency": "Uitzendbureau: per afdeling",
  "purchaseInvoices.tempAgencyHelp": "Per afdeling een regel op kostenplaats 1100 met de locatie van de afdeling. Geldt vanaf de volgende keer lezen.",
  "purchaseInvoices.afasTerm": "Volgens AFAS ({{days}} dagen): {{date}}",
  "purchaseInvoices.pickReadingScan": "De woorden op de scan worden gelezen…",
  "purchaseInvoices.cmrPageSet": "Deze pagina is de CMR",
  "purchaseInvoices.cmrPageUnset": "Geen CMR",
  "purchaseInvoices.cmrPageChip": "CMR",
  "purchaseInvoices.colCommitmentPeriod": "Periode",
  "purchaseInvoices.cmr.specification": "Specificatie",
  "purchaseInvoices.cmr.maybeSpecification": "Deze pdf heeft geen eigen factuurnummer. Is het de specificatie van een factuur uit dezelfde mail? Koppel hem: hij gaat dan mee naar AFAS, achter de factuur.",
  "purchaseInvoices.cmr.linkAsSpecification": "Als specificatie koppelen",
  "purchaseInvoices.error.PURCHASE_INVOICE_NOT_AN_IMAGE": "Dit bestand is geen pdf en geen foto (jpg, png of heic).",
  "fuelCard.supplier.BP": "BP",
  "fuelCard.supplier.VAN_KESSEL": "Van Kessel",
  "fuelCard.productsIntroVanKessel": "Laden (kWh) gaat vanzelf op 41030, brandstof op 41020 en paskosten op 44100. Hier zet je een product dat WLX niet kent, of een andere rekening. Een product zonder rekening houdt de factuur tegen.",
  "codingRules.word": "Woord op de factuur",
  "codingRules.wordPlaceholder": "bijv. Garantieprovisie",
  "codingRules.add": "Regel toevoegen",
  "purchaseInvoices.problem.g_account_percentage_missing": "Er staat een G-rekening op de factuur, maar in AFAS geen percentage bij de crediteur.",
  "purchaseInvoices.problem.cost_period_invalid": "Een regel heeft een periode die niet klopt.",
  "purchaseInvoices.error.PURCHASE_INVOICE_EXPLANATION_REQUIRED": "Zeg waarom je de codering aanpast.",
  "purchaseInvoices.error.PURCHASE_INVOICE_LINES_FIXED": "Regels toevoegen of weghalen kan niet: alleen de codering verandert.",
  "purchaseInvoices.error.PURCHASE_INVOICE_UNKNOWN_REFERENCE": "Dat kenmerk staat niet op deze factuur.",
  "purchaseInvoices.error.PURCHASE_INVOICE_NOT_ON_PDF": "Dat nummer staat niet in de tekst van de pdf. Wijs het nummer op de pdf aan.",
  "codingRules.title": "Geleerde codering",
  "codingRules.intro": "Wat WLX leerde van aanpassingen met de hand op inkoopfacturen, met de uitleg die erbij gegeven is, en regels met de hand op een woord in de factuur. WLX past ze toe als het de volgende factuur van die crediteur leest. Klopt een regel niet, haal hem dan weg.",
  "codingRules.colCreditor": "Crediteur",
  "codingRules.colWhen": "Wanneer",
  "codingRules.colField": "Veld",
  "codingRules.colValue": "Wordt",
  "codingRules.colExplanation": "Uitleg",
  "codingRules.colBy": "Door",
  "codingRules.colActions": "Acties",
  "codingRules.whenAll": "alle facturen",
  "codingRules.whenReference": "kenmerk {{reference}}",
  "codingRules.openInvoice": "factuur",
  "codingRules.delete": "Weghalen",
  "codingRules.deleteConfirm": "Deze geleerde codering weghalen? De volgende factuur van deze crediteur wordt dan weer gecodeerd zoals AFAS het zegt.",
  "codingRules.empty": "WLX heeft nog niets geleerd.",
  "batchPick.button": "Batchpicken",
  "batchPick.buttonBusy_one": "Batchpicken · {{count}} ronde bezig",
  "batchPick.buttonBusy_other": "Batchpicken · {{count}} rondes bezig",
  "batchPick.title": "Batchpicken · {{warehouse}}",
  "batchPick.newRound": "Nieuwe ronde",
  "batchPick.intro": "WLX neemt de orders van de losdag die nog niet pickbaar zijn (die van P&O op hun laaddag), reserveert precies wat ze vragen en zet het met batchpicktaken klaar op een pickplek. Zijn alle taken van de ronde klaar, dan staan de orders op de scanner. Een tweede ronde voor dezelfde dag neemt alleen de orders die later kwamen.",
  "batchPick.day": "Losdag",
  "batchPick.look": "Bekijken",
  "batchPick.noOrders": "Geen orders voor {{day}} die in een ronde kunnen.",
  "batchPick.atLoading_one": "{{count}} regel komt bij het laden uit de stelling (palletbox of niet te splitsen).",
  "batchPick.atLoading_other": "{{count}} regels komen bij het laden uit de stelling (palletbox of niet te splitsen).",
  "batchPick.short_one": "{{count}} regel komt tekort:",
  "batchPick.short_other": "{{count}} regels komen tekort:",
  "batchPick.notInRound": "Niet in de ronde: Niet batchpicken op het adres",
  "batchPick.start": "Ronde starten",
  "batchPick.startAnyway": "Toch starten",
  "batchPick.nothing": "Er zijn geen orders meer voor deze dag.",
  "batchPick.changed": "Er komt nu iets tekort dat niet in het voorbeeld stond. Bekijk de ronde opnieuw.",
  "batchPick.rounds": "Rondes",
  "batchPick.noRounds": "Geen rondes in de afgelopen twee weken.",
  "batchPick.colDay": "Losdag",
  "batchPick.colSetOut": "Klaargezet",
  "batchPick.setOut": "{{done}} van {{total}}",
  "batchPick.orders_one": "{{count}} order",
  "batchPick.orders_other": "{{count}} orders",
  "batchPick.linesToSetOut_one": "{{count}} regel klaarzetten",
  "batchPick.linesToSetOut_other": "{{count}} regels klaarzetten",
  "batchPick.fromPallets_one": "van {{count}} pallet",
  "batchPick.fromPallets_other": "van {{count}} pallets",
  "batchPick.palletsToSetOut_one": "{{count}} pallet klaar te zetten",
  "batchPick.palletsToSetOut_other": "{{count}} pallets klaar te zetten",
  "batchPick.summary": "{{orders}} voor {{day}}: {{lines}} {{pallets}}.",
  "batchPick.started": "Ronde voor {{day}} gestart: {{orders}}, {{pallets}}.",
  "batchPick.startedBy": "gestart {{when}} · {{who}}",
  "batchPick.startedAt": "gestart {{when}}",
  "batchPick.ready": "Op de scanner",
  "batchPick.busy_one": "{{count}} pallet onderweg",
  "batchPick.busy_other": "{{count}} pallets onderweg",
  "batchPick.open": "Klaar te zetten",
  "batchPick.fact": "Batchpicken",
  "batchPick.factValue": "Ronde {{day}}",
  "batchPick.atLoadingChip": "Bij laden",
  "batchPick.atLoadingHint": "Wordt bij het laden uit de stelling gepakt: niet gereserveerd en niet gepickt.",

  // Transport → Magazijnorders (portal step 8).
  "warehouseOrders.search": "Zoek op nummer, klant of referentie",
  "warehouseOrders.count_one": "{{count}} magazijnorder",
  "warehouseOrders.count_other": "{{count}} magazijnorders",
  "warehouseOrders.new": "Nieuwe magazijnorder",
  "warehouseOrders.empty": "Nog geen magazijnorders.",
  "warehouseOrders.col.number": "Nummer",
  "warehouseOrders.col.customer": "Klant",
  "warehouseOrders.col.kind": "Soort",
  "warehouseOrders.col.warehouse": "Magazijn",
  "warehouseOrders.col.reference": "Referentie klant",
  "warehouseOrders.col.day": "Dag",
  "warehouseOrders.col.transport": "Vervoer",
  "warehouseOrders.col.status": "In Scoretrace",
  "warehouseOrders.col.document": "Nummer in Scoretrace",
  "warehouseOrders.col.transportOrder": "Transportorder",
  "warehouseOrders.col.channel": "Ingevoerd in",
  "warehouseOrders.col.createdAt": "Ingevoerd op",
  "warehouseOrders.kind.outbound": "Uitleveren",
  "warehouseOrders.kind.inbound": "Aanleveren",
  "warehouseOrders.channel.portal": "Portaal",
  "warehouseOrders.channel.manual": "Back-office",
  "warehouseOrders.transport.willems": "Willems rijdt",
  "warehouseOrders.transport.collected": "Wordt afgehaald",
  "warehouseOrders.transport.brought": "Wordt gebracht",
  "warehouseOrders.status.sending": "Wordt verstuurd",
  "warehouseOrders.status.created": "Staat in Scoretrace",
  "warehouseOrders.status.dry": "Droog (acceptatie)",
  "warehouseOrders.status.refused": "Geweigerd",
  "warehouseOrders.status.outside_wms": "Buiten voorraad",
  "warehouseOrders.outsideStock.new": "Afhalen buiten voorraad",
  "warehouseOrders.outsideStock.newTitle": "Afhalen buiten voorraad",
  "warehouseOrders.outsideStock.explain": "Voor wat bij het magazijn wordt opgehaald maar niet in de voorraad staat, meestal emballage. De order gaat niet naar het WMS; de CMR print je vanaf de order.",
  "warehouseOrders.outsideStock.submit": "Afhaalorder maken",
  "warehouseOrders.outsideStock.day": "Dag van afhalen",
  "warehouseOrders.outsideStock.kind": "Soort",
  "warehouseOrders.outsideStock.other": "Overig",
  "warehouseOrders.outsideStock.otherHint": "Wat het is, bijvoorbeeld rolcontainers",
  "warehouseOrders.outsideStock.cardExplain": "Afgehaald buiten de voorraad: deze order gaat niet naar het WMS. De CMR print je hier.",
  "warehouseOrders.outsideStock.cmrPrinted": "CMR geprint",
  "warehouseOrders.outsideStock.print": "CMR printen",
  "warehouseOrders.outsideStock.printTitle": "CMR van {{number}} printen",
  "warehouseOrders.outsideStock.printHelp": "Vak 16 en 23, de vervoerder, vul je bij het laden met de hand in.",
  "warehouseOrders.outsideStock.printed": "De CMR gaat naar {{place}}.",
  "warehouseOrders.cardTitle": "Magazijnorder {{number}}",
  "warehouseOrders.refusedBecause": "Scoretrace weigerde de order: {{reason}}",
  "warehouseOrders.dryExplain": "Op acceptatie gaat er niets naar Scoretrace: de order staat in de log van DataBridge zoals hij verstuurd zou worden.",
  "warehouseOrders.dayOut": "Dag uit het magazijn",
  "warehouseOrders.dayIn": "Dag van aankomst",
  "warehouseOrders.deliveryDay": "Afleverdag",
  "warehouseOrders.owner": "Eigenaar in Scoretrace",
  "warehouseOrders.deliverTo": "Afleveren bij",
  "warehouseOrders.collectFrom": "Ophalen bij",
  "warehouseOrders.dossier": "Dossier",
  "warehouseOrders.sent": "Verstuurd",
  "warehouseOrders.answered": "Antwoord van Scoretrace",
  "warehouseOrders.resend": "Opnieuw versturen",
  "warehouseOrders.addressMissing": "Deze afhaalorder heeft geen afleveradres. Scoretrace weigert hem zonder, en de CMR heeft het nodig: vul in waar het heen gaat en verstuur hem opnieuw.",
  "warehouseOrders.line.article": "Artikel",
  "warehouseOrders.line.description": "Omschrijving",
  "warehouseOrders.line.quantity": "Aantal",
  "warehouseOrders.line.unit": "Eenheid",
  "warehouseOrders.line.free": "Vrij",
  "warehouseOrders.line.batch": "Batch",
  "warehouseOrders.line.pallets": "Pallets",
  "warehouseOrders.line.pallet": "Pallet",
  "warehouseOrders.line.vas": "VAS",
  "warehouseOrders.vas.label": "VAS-codes",
  "warehouseOrders.vas.placeholder": "Zoek een code",
  "warehouseOrders.vas.none": "Geen VAS-codes voor een order",
  "warehouseOrders.vas.order": "VAS voor de hele order",
  "warehouseOrders.form.choosePallets": "Kies pallets",
  "warehouseOrders.form.palletsChosen_one": "{{count}} pallet",
  "warehouseOrders.form.palletsChosen_other": "{{count}} pallets",
  "warehouseOrders.form.perPallet": "Per pallet",
  "warehouseOrders.form.palletNumber": "Palletnr. {{n}}",
  "warehouseOrders.form.bestBefore": "THT {{date}}",
  "warehouseOrders.form.batchFree": "vrij {{n}}",
  "warehouseOrders.form.submit": "Versturen naar Scoretrace",
  "warehouseOrders.form.noOwner": "Deze klant heeft geen WMS-kenmerk (Systeemkenmerken op de relatiekaart): een magazijnorder kan dan niet.",
  "warehouseOrders.form.chooseOwner": "Kies een eigenaar",
  "warehouseOrders.form.collectDay": "Ophaaldag",
  "warehouseOrders.form.deliveryDay": "Afleverdag",
  "warehouseOrders.form.name": "Naam",
  "warehouseOrders.form.street": "Straat",
  "warehouseOrders.form.houseNumber": "Nr.",
  "warehouseOrders.form.postalCode": "Postcode",
  "warehouseOrders.form.city": "Plaats",
  "warehouseOrders.form.country": "Land",
  "warehouseOrders.form.from": "Van",
  "warehouseOrders.form.to": "Tot",
  "warehouseOrders.form.pallets": "Pallets",
  "warehouseOrders.form.carrier": "Drager",
  "warehouseOrders.form.weight": "Gewicht (kg)",
  "warehouseOrders.form.lines": "Artikelen",
  "warehouseOrders.form.stockAsOf": "Voorraad: stand van {{time}}",
  "warehouseOrders.form.stockFailed": "De voorraad is nu niet op te halen: typ de artikelcodes zelf.",
  "warehouseOrders.form.stockLoading": "Voorraad ophalen…",
  "warehouseOrders.form.refresh": "Vernieuwen",
  "warehouseOrders.form.notInStock": "Niet in de voorraad",
  "warehouseOrders.form.notAnArticle": "Geen artikel van deze klant",
  "warehouseOrders.form.pickFromList_one": "1 regel zonder artikel uit de lijst: kies het artikel",
  "warehouseOrders.form.pickFromList_other": "{{count}} regels zonder artikel uit de lijst: kies het artikel",
  "warehouseOrders.form.removeLine": "Regel weghalen",
  "warehouseOrders.form.addLine": "Regel toevoegen",
  "warehouseOrders.form.remark": "Opmerking voor het magazijn",
  "warehouseOrders.form.forWarehouse": "Voor het magazijn",
  "warehouseOrders.form.remarkLabel": "Opmerking",
  "warehouseOrders.carrier.europallet": "Europallet",
  "warehouseOrders.carrier.block_pallet": "Blokpallet 0,5 lm",
  "warehouseOrders.carrier.block_pallet_06": "Blokpallet 0,6 lm",
  "warehouseOrders.carrier.block_pallet_09": "Blokpallet 0,9 lm",
  "warehouseOrders.carrier.ibc_02": "IBC 0,2 lm",
  "warehouseOrders.carrier.ibc_04": "IBC 0,4 lm",
  "warehouseOrders.carrier.ibc": "IBC 0,5 lm",
  "warehouseOrders.carrier.ibc_06": "IBC 0,6 lm",
  "warehouseOrders.carrier.big_bag": "Big Bag 0,5 lm",
  "warehouseOrders.card.order": "Klant en order",
  "warehouseOrders.form.ownArticles_one": "{{count}} artikel van de klant",
  "warehouseOrders.form.ownArticles_other": "{{count}} artikelen van de klant",
  "warehouseOrders.form.batchChoose": "Kies of typ",
  "warehouseOrders.form.palletsHint": "Vink de pallets aan die uitgeleverd worden; het aantal wordt wat erop staat",
  "warehouseOrders.form.palletsHintBatch": "Vink de pallets met batch {{batch}} aan die uitgeleverd worden; het aantal wordt wat erop staat",
  "warehouseOrders.form.noPalletsOfBatch": "Geen vrije pallets met deze batch",
  "warehouseOrders.transport.delivers": "Willems levert af",
  "warehouseOrders.transport.collects": "Willems haalt op",
  "warehouseOrders.form.place": "Locatie of adres",
  "warehouseOrders.form.collectedAddressHint": "Waar het heen gaat: nodig voor de CMR en voor Scoretrace.",
  "warehouseOrders.form.stopReference": "Referentie daar",
  "warehouseOrders.form.goods": "Lading",
  "warehouseOrders.form.count": "Aantal",
  "warehouseOrders.form.addGoods": "Nog een regel lading",
  "warehouseOrders.form.goodsTotal": "Samen {{pallets}} stuks, {{meters}} m laadmeter",
  "warehouseOrders.carrier.roll_container": "Rolcontainer",
  "warehouseOrders.carrier.box": "Colli of dozen",
  "warehouseOrders.carrier.other": "Overig",
  "standingOrders.intro": "Orders die elke week op dezelfde dagen terugkomen. WLX maakt ze elke nacht voor de komende 14 dagen.",
  "standingOrders.new": "Nieuwe vaste order",
  "standingOrders.none": "Nog geen vaste orders.",
  "standingOrders.back": "← Vaste orders",
  "standingOrders.col.name": "Naam",
  "standingOrders.col.customer": "Klant",
  "standingOrders.col.days": "Dagen",
  "standingOrders.col.route": "Van → naar",
  "standingOrders.col.upcoming": "Gemaakt",
  "standingOrders.col.valid": "Geldig",
  "standingOrders.moreLines_one": "en nog {{count}} regel",
  "standingOrders.moreLines_other": "en nog {{count}} regels",
  "standingOrders.upcomingUntil_one": "{{count}} order t/m {{until}}",
  "standingOrders.upcomingUntil_other": "{{count}} orders t/m {{until}}",
  "standingOrders.validFrom": "Vanaf {{from}}",
  "standingOrders.validFromUntil": "{{from}} t/m {{until}}",
  "standingOrders.day.1": "ma",
  "standingOrders.day.2": "di",
  "standingOrders.day.3": "wo",
  "standingOrders.day.4": "do",
  "standingOrders.day.5": "vr",
  "standingOrders.day.6": "za",
  "standingOrders.day.7": "zo",
  "standingOrders.everyDay": "Elke dag",
  "standingOrders.card.head": "Vaste order",
  "standingOrders.reference": "Referentie",
  "standingOrders.referenceHelp": "Elke order krijgt als factuurreferentie deze tekst met de datum erachter, bijvoorbeeld Pendels Roquette 02-11-2026.",
  "standingOrders.validFromLabel": "Geldig vanaf",
  "standingOrders.validUntilLabel": "Geldig tot en met",
  "standingOrders.validUntilHelp": "Leeg: zonder einddatum.",
  "standingOrders.priority": "Prioriteit",
  "standingOrders.pendelText": "Elke order van deze vaste order is een fabriekspendel",
  "pendelRoutes.from": "Laadt in",
  "pendelRoutes.to": "Lost in",
  "pendelRoutes.fromHelp": "Waar de fabriekspendels laden, bijvoorbeeld FrieslandCampina NCB-laan 80 in Veghel. Meer dan één mag.",
  "pendelRoutes.toHelp": "Waar ze lossen, bijvoorbeeld Doornhoek en Kempkens. Een volle lading die terugkomt, rijdt andersom en hoort bij hetzelfde traject.",
  "pendelRoutes.departure": "Vertrekplaats",
  "pendelRoutes.departureNone": "Geen vaste vertrekplaats",
  "pendelRoutes.vehicles": "Vaste wagens",
  "pendelRoutes.vehiclesPlaceholder": "Zoek een wagen op vlootnummer of kenteken",
  "pendelRoutes.vehiclesHelp": "Met vaste wagens zet WLX elke order op dit traject vanzelf op de rit van een van deze wagens, om en om: één rit per wagen per dag, de eerste wagen krijgt de eerste order. Stap 1 laat het traject dan liggen. Haalt de planner een order van de rit, dan zet WLX hem niet opnieuw. Zonder vaste wagens plant de planner het traject zelf.",
  "pendelRoutes.departureHelp": "Waar een rit op dit traject begint en eindigt zolang er nog geen wagen op staat, bijvoorbeeld Haps bij Nutrifeed. Daarna telt de standplaats van de wagen, en een depot dat de planner op de rit kiest gaat altijd voor. Zonder vertrekplaats begint de rit bij de eigen vestiging waar hij laadt of lost, of anders bij de vestiging het dichtst bij.",
  "pendelRoutes.rounds": "Rondes per rit",
  "pendelRoutes.minutes": "Laden en lossen",
  "pendelRoutes.unlimited": "alles op één rit",
  "pendelRoutes.roundsSame": "{{count}}× heen en weer",
  "pendelRoutes.roundsBoth": "{{with}}× met retour, {{without}}× zonder",
  "pendelRoutes.placeRemove": "Weg",
  "pendelRoutes.deleteConfirm": "Traject {{name}} verwijderen? Op inactief zetten bewaart het om later terug te kijken.",
  "pendelRoutes.newTitle": "Nieuw traject",
  "pendelRoutes.newRoute": "Nieuw traject",
  "pendelRoutes.namePlaceholder": "RFC Veghel → Doornhoek/Kempkens",
  "pendelRoutes.unlimitedLabel": "Alles op één rit, zonder maximum",
  "pendelRoutes.withReturn": "Rondes met retour",
  "pendelRoutes.withReturnHelp": "Zoveel keer heen en weer als er een volle lading terug op de rit staat.",
  "pendelRoutes.withoutReturn": "Rondes zonder retour",
  "pendelRoutes.withoutReturnHelp": "Zoveel keer als de wagen steeds leeg terugrijdt; minstens zoveel als met retour.",
  "pendelRoutes.acrossDaysLabel": "Laden en lossen mogen op verschillende dagen vallen",
  "pendelRoutes.acrossDaysHelp": "Voor een lange afstand, zoals naar Nörten-Hardenberg: stap 1 deelt een zending dan ook in als ze de dag ervoor laadt of pas de dag erna lost. Zonder dit vinkje wordt zo'n zending een eigen rit.",
  "pendelRoutes.acrossDaysShort": "over meer dagen",
  "pendelRoutes.loadMinutes": "Laden (minuten)",
  "pendelRoutes.unloadMinutes": "Lossen (minuten)",
  "pendelRoutes.minutesHelp": "De chauffeur laadt en lost zelf: standaard 45 en 30 minuten; Nuenen koppelen en laden 60.",
  "pendelRoutes.minutesCell": "{{load}} / {{unload}} min",
  "pendelRoutes.hours": "Openingstijden",
  "pendelRoutes.hoursBoth": "laad- en losadres",
  "pendelRoutes.hoursFrom": "laadadres",
  "pendelRoutes.hoursTo": "losadres",
  "pendelRoutes.fromOpeningHoursLabel": "Rekening houden met de openingstijden van het laadadres",
  "pendelRoutes.toOpeningHoursLabel": "Rekening houden met de openingstijden van het losadres",
  "pendelRoutes.openingHoursHelp": "Standaard uit: een pendel wacht niet tot het adres opengaat en is er nooit te laat. De tijd op de order zegt dan alleen wanneer de rit er is, en de orderinvoer geeft geen opmerking over de openingstijden van dat adres. Aan: het adres telt zoals elke stop. Een retour laadt aan het losadres en lost aan het laadadres: het vinkje hoort bij het adres, niet bij laden of lossen.",
  "pendelRoutes.remark": "Opmerking",
  "pendelRoutes.sortOrder": "Volgorde",
  "pendelRoutes.delete": "Verwijderen",
  "pendelRoutes.count_one": "1 traject",
  "pendelRoutes.count_other": "{{count}} trajecten",
  "pendelRoutes.none": "Nog geen trajecten. Zonder pendelschema gaan fabriekspendels in stap 1 heen en weer zolang het op tijd past.",
  "standingOrders.skipDates": "Overslaan op",
  "standingOrders.skipDatesHelp": "Dagen waarop WLX geen order maakt, bijvoorbeeld een feestdag.",
  "standingOrders.skipAdd": "Toevoegen",
  "standingOrders.skipRemove": "Weghalen",
  "standingOrders.remark": "Opmerking",
  "standingOrders.active": "Actief",
  "standingOrders.activeHelp": "Uit: WLX maakt geen nieuwe orders meer. Wat er al is, blijft staan.",
  "standingOrders.line": "Zending {{n}}",
  "standingOrders.lineAdd": "Zending toevoegen",
  "standingOrders.lineRemove": "Zending weghalen",
  "standingOrders.load": "Laden",
  "standingOrders.unload": "Lossen",
  "standingOrders.unloadDay": "Losdag",
  "standingOrders.sameDay": "Dezelfde dag",
  "standingOrders.daysLater_one": "{{count}} dag later",
  "standingOrders.daysLater_other": "{{count}} dagen later",
  "standingOrders.from": "Van",
  "standingOrders.to": "Tot",
  "standingOrders.stopReference": "Referentie",
  "standingOrders.description": "Omschrijving",
  "standingOrders.pallets": "Pallets",
  "standingOrders.loadingMeters": "Laadmeter",
  "standingOrders.weightKg": "Gewicht (kg)",
  "standingOrders.noInvoice": "Niet factureren",
  "standingOrders.noInvoiceHelp": "De zending komt niet op een factuur, met de reden erbij.",
  "standingOrders.noInvoiceReason": "Reden",
  "standingOrders.noInvoiceDefault": "Vaste order",
  "standingOrders.noCmrReturn": "Geen CMR retour",
  "standingOrders.noCmrReturnHelp": "Er komt geen getekende CMR terug: WLX wacht er niet op. De CMR wordt wel geprint.",
  "standingOrders.delete": "Verwijderen",
  "standingOrders.deleteConfirm": "Ja, verwijderen",
  "standingOrders.orders": "Gemaakte orders (de komende {{days}} dagen)",
  "standingOrders.noOrders": "Nog geen orders: WLX maakt ze bij het opslaan en daarna elk uur.",
  "standingOrders.orderDay": "Dag",
  "standingOrders.orderNumber": "Order",
  "standingOrders.saved_one": "Opgeslagen. {{count}} order gemaakt.",
  "standingOrders.saved_other": "Opgeslagen. {{count}} orders gemaakt.",
  "standingOrders.failed": "Niet gelukt: {{days}}",
  "standingOrders.missing.name": "Geef de vaste order een naam.",
  "standingOrders.missing.customer": "Kies de klant.",
  "standingOrders.missing.reference": "Vul de referentie in.",
  "standingOrders.missing.validFrom": "Vul in vanaf wanneer hij geldt.",
  "standingOrders.missing.days": "Kies bij zending {{n}} minstens één dag.",
  "standingOrders.missing.place": "Kies bij zending {{n}} het laad- en losadres uit het adresboek.",
  "standingOrders.missing.time": "Een tijd bij zending {{n}} klopt niet: schrijf hem als 16:30.",
  "standingOrders.missing.loadingMeters": "Vul bij zending {{n}} de laadmeter in: zonder laadmeter plant WLX de orders niet.",
  // The scantafel (docs/scantafel.md §4)
  "documentCheck.palletOverview": "Overzicht",
  "documentCheck.view.work": "Werken",
  "documentCheck.view.queue": "Rij",
  "documentCheck.stat.open": "Nog te doen",
  "documentCheck.stat.late": "Ouder dan 2 dagen",
  "documentCheck.stat.today": "Vandaag gedaan · {{count}} door jou",
  "documentCheck.readOnly": "Je kijkt mee. Koppelen en afvinken vraagt de rechten Dossiers bewerken en Orders bewerken.",
  "documentCheck.kind.link": "Koppelen",
  "documentCheck.kind.pallets": "Pallets afvinken",
  "documentCheck.scan": "Scan",
  "documentCheck.work": "Het werk bij deze scan",
  "documentCheck.area.page": "Pagina",
  "documentCheck.area.box13": "Vak 13",
  "documentCheck.page": "{{page}} / {{count}}",
  "documentCheck.pagePrev": "Vorige pagina",
  "documentCheck.pageNext": "Volgende pagina",
  "documentCheck.pages": "pagina {{pages}}",
  "documentCheck.turn": "Draaien",
  "documentCheck.openFile": "Scan openen in een nieuw tabblad",
  "documentCheck.scanAlt": "Scan {{file}}",
  "documentCheck.pictureFailed": "De scan kon niet getoond worden. Open hem los.",
  "documentCheck.consignment": "Zending",
  "documentCheck.trip.title": "Rit",
  "documentCheck.trip.open": "Rit openen",
  "documentCheck.trip.none": "Deze zending staat nog op geen rit.",
  "documentCheck.trip.unloads": "lost bij de klant",
  "documentCheck.trip.before": "ervoor",
  "documentCheck.trip.number": "Ritnummer",
  "documentCheck.trip.date": "Ritdatum",
  "documentCheck.trip.lines_one": "{{count}} activiteit op deze rit",
  "documentCheck.trip.lines_other": "{{count}} activiteiten op deze rit",
  "documentCheck.trip.customer": "Klant",
  "documentCheck.trip.location": "Adres",
  "documentCheck.trip.choose": "Kies zending {{number}}",
  "documentCheck.trip.depotLoad": "Laden depot",
  "documentCheck.trip.depotUnload": "Lossen depot",
  "documentCheck.pallets": "Pallets",
  "documentCheck.candidates": "Mogelijke zendingen",
  "documentCheck.noCandidates": "WLX vond geen zending. Zoek op zendingnummer, referentie of kenteken.",
  "documentCheck.searchPlaceholder": "Zoek op zending, referentie, kenteken, plaats, adres of naam",
  "documentCheck.foundAtUnloading": "Gevonden op losplaats:",
  "documentCheck.foundAtLoading": "Gevonden op laadplaats:",
  "documentCheck.foundAtCustomer": "Gevonden op klant:",
  "documentCheck.searchNone": "Niets gevonden voor {{q}}.",
  "documentCheck.readNumber": "gelezen: {{number}}",
  "documentCheck.behindTrip": "achter ritlijst {{trip}}",
  "documentCheck.found.barcode": "Gevonden op de barcode {{barcode}}",
  "documentCheck.found.barcodeNone": "Gevonden op de barcode",
  "documentCheck.found.combined": "Op de CMR van een andere zending (meer zendingen op één CMR)",
  "documentCheck.found.text": "Gevonden op de tekst: {{reference}}",
  "documentCheck.found.textPostcode": "Gevonden op de tekst: {{reference}} en postcode {{postcode}}",
  "documentCheck.found.hand": "Met de hand gekoppeld door {{who}}",
  "documentCheck.found.databridge": "Gekoppeld op het nummer dat met de scan meekwam",
  "documentCheck.orderCancelled": "Geannuleerd",
  "documentCheck.orderRejected": "Afgewezen",
  "documentCheck.col.planned": "Gepland",
  "documentCheck.col.driver": "Chauffeur",
  "documentCheck.col.box13": "Vak 13",
  "documentCheck.col.verdict": "Klopt",
  "documentCheck.box.unloaded": "gelost",
  "documentCheck.box.loaded": "geladen",
  "documentCheck.box.returned": "retour",
  "documentCheck.noPallets": "Geen pallets gepland of gemeld. Staat er iets in vak 13, voeg dan de soort toe.",
  "documentCheck.addKind": "Soort toevoegen…",
  "documentCheck.noExchange": "Geen ruil",
  "documentCheck.alreadyChecked": "Deze pallets zijn al gecontroleerd door {{who}}, {{when}}. Goedkeuren koppelt alleen de scan.",
  "documentCheck.chooseFirst": "Kies eerst de zending.",
  "documentCheck.link": "Koppelen",
  "documentCheck.toType_one": "Nog 1 vakje intikken: gepland en chauffeur verschillen",
  "documentCheck.toType_other": "Nog {{count}} vakjes intikken: gepland en chauffeur verschillen",
  "documentCheck.ready": "Klaar om goed te keuren",
  "documentCheck.approve": "Goedkeuren",
  "documentCheck.skip": "Overslaan",
  "documentCheck.discard": "Weggooien",
  "documentCheck.discardConfirm": "Deze scan weggooien? Hij blijft bewaard, maar komt niet meer in de rij.",
  "documentCheck.skipTitle": "Overslaan, met een reden",
  "documentCheck.skipReason.order_missing": "Order nog niet binnen",
  "documentCheck.skipReason.unreadable": "Scan onleesbaar",
  "documentCheck.skipReason.ask_colleague": "Vraag voor een collega",
  "documentCheck.skipReason.other": "Anders",
  "documentCheck.skipNote": "Toelichting (mag leeg)",
  "documentCheck.skippedBy": "Overgeslagen door {{who}}: {{reason}}",
  "documentCheck.lost": "{{who}} heeft deze scan nu open. Ga door naar de volgende.",
  "documentCheck.claimedBy": "{{who}} heeft deze scan open.",
  "documentCheck.prevClaimed": "{{who}} heeft de vorige scan nu open.",
  "documentCheck.prevGone": "De vorige scan is al afgehandeld.",
  "documentCheck.noOther": "Er is geen andere scan vrij.",
  "documentCheck.done": "Goedgekeurd: {{number}}",
  "documentCheck.doneLinked": "Gekoppeld: {{number}}",
  "documentCheck.skipped": "Overgeslagen",
  "documentCheck.discarded": "Weggegooid",
  "documentCheck.empty.title": "Niets meer te doen",
  "documentCheck.empty.text.link": "Alle scans zijn gekoppeld. Een nieuwe scan opent hier vanzelf.",
  "documentCheck.empty.text.pallets": "De pallets van alle gekoppelde CMR's zijn gecontroleerd. Een nieuwe CMR opent hier vanzelf.",
  "documentCheck.empty.refresh": "Opnieuw kijken",
  "documentCheck.lateFlag": "laat",
  "documentCheck.queue.at": "Binnen",
  "documentCheck.queue.what": "Scan of zending",
  "documentCheck.queue.customer": "Klant",
  "documentCheck.queue.why": "Waarom",
  "documentCheck.queue.who": "Open bij",
  "documentCheck.queue.mine": "Jij",
  "documentCheck.queue.noMatch": "Niets gevonden met deze filters.",
  "documentCheck.hint.move": "volgende, vorige",
  "documentCheck.hint.box13": "vak 13",
  "documentCheck.hint.choose": "kies",
  "documentCheck.hint.all": "alle toetsen",
  "documentCheck.kb.approve": "Goedkeuren en door naar de volgende",
  "documentCheck.kb.link": "Koppelen en door naar de volgende",
  "documentCheck.kb.next": "Volgende scan",
  "documentCheck.kb.previous": "Vorige scan",
  "documentCheck.kb.nextAlways": "Volgende scan, ook tijdens het typen (Ctrl + ↑ de vorige)",
  "documentCheck.kb.box13": "Vak 13 of de hele pagina",
  "documentCheck.kb.turn": "Scan een halve slag draaien",
  "documentCheck.kb.page": "Volgende pagina (PgUp de vorige)",
  "documentCheck.kb.search": "Zoeken naar de zending",
  "documentCheck.kb.choose": "Zending kiezen uit de lijst",
  "documentCheck.kb.noExchange": "Geen ruil: niets leeg achtergelaten of retour",
  "documentCheck.kb.skip": "Overslaan met een reden",
  "documentCheck.kb.open": "Scan openen in een nieuw tabblad",
  "documentCheck.kb.escape": "Uit het vakje, zodat de letters weer werken",
  "nav.secrets": "Geheimen",
  "secrets.intro": "Elk geheim waar WLX in deze omgeving op leunt: waar het staat, wie het vernieuwt en wanneer het verloopt. Die van de API zelf komen er vanzelf in en de datum van een Entra-app leest WLX uit Entra; de rest vul je zelf in. WLX mailt 60, 30 en 7 dagen vooraf en op de dag zelf.",
  "secrets.mailTo": "De waarschuwingen gaan naar {{to}}.",
  "secrets.mailOff": "De waarschuwingen gaan nu nergens heen: zet SECRET_EXPIRY_MAIL_TO of CHANNEL_SILENCE_MAIL_TO, een afzender en de mail-app.",
  "secrets.entraOff": "De Graph-app is in deze omgeving niet ingesteld.",
  "secrets.checkNow": "Entra nu lezen",
  "secrets.checkedNow_one": "1 app gelezen uit Entra.",
  "secrets.checkedNow_other": "{{count}} apps gelezen uit Entra.",
  "secrets.new": "Nieuw geheim",
  "secrets.save": "Opslaan",
  "secrets.edit": "Wijzigen",
  "secrets.delete": "Weghalen",
  "secrets.deleteConfirm": "{{name}} uit het register halen?",
  "secrets.empty": "Nog niets in het register.",
  "secrets.colName": "Geheim",
  "secrets.colStatus": "Stand",
  "secrets.colExpiresAt": "Verloopt op",
  "secrets.colKind": "Soort",
  "secrets.colLocation": "Waar staat het",
  "secrets.colOwner": "Wie vernieuwt",
  "secrets.colRenewal": "Hoe vernieuwen",
  "secrets.colChecked": "Gelezen uit Entra",
  "secrets.colActions": "Acties",
  "secrets.kind.entra_app": "Entra-app",
  "secrets.kind.manual": "Datum met de hand",
  "secrets.appId": "Application (client) ID",
  "secrets.noExpiry": "Verloopt niet",
  "secrets.envLocation": "Omgeving van de API (Portainer)",
  "secrets.locationPlaceholder": "Bijvoorbeeld Drone → Secrets",
  "secrets.neverValue": "Zet hier nooit het geheim zelf neer, alleen waar het staat.",
  "secrets.notCheckedYet": "Nog niet gelezen",
  "secrets.checkedWith_one": "{{at}} · {{name}} (1 geheim op de app)",
  "secrets.checkedWith_other": "{{at}} · {{name}} ({{count}} geheimen op de app)",
  "secrets.status.refused": "Geweigerd door Microsoft",
  "secrets.status.notConfigured": "Niet meer ingesteld",
  "secrets.status.noExpiry": "Verloopt niet",
  "secrets.status.unknown": "Datum onbekend",
  "secrets.status.expired": "Verlopen",
  "secrets.status.today": "Verloopt vandaag",
  "secrets.status.days_one": "Verloopt morgen",
  "secrets.status.days_other": "Nog {{count}} dagen",
  "secrets.status.ok": "In orde",
  "secrets.checkError.no_permission": "Geen recht om Entra te lezen: de Graph-app mist Application.Read.All",
  "secrets.checkError.app_not_found": "Deze app bestaat niet in Entra",
  "secrets.checkError.secret_not_on_app": "Het geheim in de omgeving staat niet (meer) op de app",
  "secrets.checkError.no_secret": "De app heeft geen geheim of certificaat",
  "secrets.checkError.failed": "Entra lezen mislukt; WLX probeert het opnieuw",
  "secrets.checkError.not_configured": "Entra lezen staat uit: de Graph-app is niet ingesteld",
  "secrets.system.ENTRA_CLIENT_SECRET.name": "Inloggen in WLX (Entra-app)",
  "secrets.system.ENTRA_CLIENT_SECRET.renewal": "Entra → App-registraties → de inlog-app → Certificaten en geheimen: nieuw clientgeheim. Zet het als ENTRA_CLIENT_SECRET in de stack (productie: beide nodes), rol uit, probeer in te loggen en haal dan pas het oude geheim weg.",
  "secrets.system.GRAPH_CLIENT_SECRET.name": "SharePoint en agenda's (Graph-app)",
  "secrets.system.GRAPH_CLIENT_SECRET.renewal": "Entra → App-registraties → de Graph-app → Certificaten en geheimen: nieuw clientgeheim. Zet het als GRAPH_CLIENT_SECRET in de stack (productie: beide nodes), rol uit, open een dossier en haal dan pas het oude geheim weg.",
  "secrets.system.GRAPH_MAIL_CLIENT_SECRET.name": "Gedeelde postvakken en systeemmail (mail-app)",
  "secrets.system.GRAPH_MAIL_CLIENT_SECRET.renewal": "Entra → App-registraties → de mail-app → Certificaten en geheimen: nieuw clientgeheim. Zet het als GRAPH_MAIL_CLIENT_SECRET in de stack (productie: beide nodes), rol uit, open een gedeeld postvak en haal dan pas het oude geheim weg.",
  "secrets.system.HERE_API_KEY.name": "Adrescontrole, kaart en routes (HERE)",
  "secrets.system.HERE_API_KEY.renewal": "HERE platform → de app → API-sleutels: maak de tweede sleutel aan, zet hem als HERE_API_KEY in de stack, rol uit en zet dan de oude uit. Heeft de sleutel geen einddatum, vink dan Verloopt niet aan.",
  "secrets.system.AZURE_OPENAI_API_KEY.name": "AI-hulp (Azure OpenAI)",
  "secrets.system.AZURE_OPENAI_API_KEY.renewal": "Azure-portal → de OpenAI-resource → Sleutels en eindpunt: zet sleutel 2 als AZURE_OPENAI_API_KEY in de stack, rol uit en genereer dan sleutel 1 opnieuw.",
  "secrets.system.RDW_APP_TOKEN.name": "Kentekengegevens (RDW)",
  "secrets.system.RDW_APP_TOKEN.renewal": "opendata.rdw.nl → het profiel → app-tokens: nieuw token, als RDW_APP_TOKEN in de stack, uitrollen.",
  "secrets.system.DATADOCS_API_KEY.name": "DataDocs",
  "secrets.system.DATADOCS_API_KEY.renewal": "Een nieuwe sleutel afspreken met Datow, als DATADOCS_API_KEY in de stack, uitrollen.",
  "secrets.system.SESSION_SECRET.name": "Sessies van WLX",
  "secrets.system.SESSION_SECRET.renewal": "Verloopt niet. Een nieuwe waarde (minstens 32 tekens) logt iedereen uit; op beide productienodes dezelfde.",
  "secrets.system.REFRESH_TOKEN_ENC_KEY.name": "Sleutel van de Outlook-koppelingen",
  "secrets.system.REFRESH_TOKEN_ENC_KEY.renewal": "Verloopt niet en is niet te herstellen: kwijt betekent dat iedereen Outlook opnieuw koppelt. Bewaar een kopie buiten DigitalOcean (docs/backup.md §8.3); op beide productienodes dezelfde.",
  // A document on the wrong consignment, moved (docs/scantafel.md §6.2)
  "documents.inbox.reason.unlinked": "Losgekoppeld: kies de goede zending",
  "documents.relink.open": "Verplaatsen",
  "documents.relink.title": "Document verplaatsen",
  "documents.relink.explain": "{{file}} staat bij {{from}}. Waar hoort hij bij?",
  "documents.relink.toConsignment": "Naar een andere zending",
  "documents.relink.numberPlaceholder": "Zending-, order- of dossiernummer",
  "documents.relink.toQueue": "Terug naar de werkbak Scans zonder zending",
  "documents.relink.reopen": "Palletcontrole van {{from}} heropenen",
  "documents.relink.submit": "Verplaatsen",
  "documents.relink.numberRequired": "Vul de zending in waar hij bij hoort.",
  "documents.relink.doneTo": "Verplaatst van {{from}} naar {{to}}.",
  "documents.relink.doneQueue": "Losgekoppeld van {{from}}: de scan staat in de werkbak.",
  "documents.relink.reopened": "De palletcontrole is weer open.",
  "documentCheck.relink": "Andere zending",
  "documentCheck.relinkCancel": "Toch deze zending",
  "documentCheck.relinkFrom": "Nu gekoppeld aan {{number}}: kies de goede zending",
  "documentCheck.relinkSearch": "Zoek de zending waar deze CMR bij hoort",
  "documentCheck.unlink": "Loskoppelen",
  "documentCheck.unlinkConfirm": "Deze CMR loskoppelen van {{number}}? Hij gaat terug naar Documentcontrole om opnieuw te koppelen.",
  "documentCheck.unlinked": "Losgekoppeld van {{number}}: de scan staat weer in Documentcontrole",
  "documentCheck.kb.relink": "Andere zending kiezen",
  // Pages put together or apart at the scantafel (docs/scantafel.md §6.2)
  "documents.inbox.reason.split": "Afgeknipt van een andere scan",
  "documents.inbox.reason.merged": "Achter de vorige scan gevoegd",
  "documentCheck.mergeButton": "Achter de vorige: {{what}}",
  "documentCheck.lookBack": "Vorige bekijken",
  "documentCheck.lookBackDone": "Terug naar deze scan",
  "documentCheck.lookingBack": "De vorige scan: {{what}}",
  "documentCheck.mergeConfirm": "Deze scan achter de vorige voegen ({{what}})? De pagina's komen achteraan in die pdf, en deze scan gaat uit de rij.",
  "documentCheck.merged": "Achter {{what}} gevoegd",
  "documentCheck.splitButton": "Knippen",
  "documentCheck.splitHere": "Vanaf pagina {{page}} een eigen scan",
  "documentCheck.splitFirstPage": "Blader naar de pagina waar de tweede scan begint",
  "documentCheck.splitToLink": "Geknipt: vanaf pagina {{page}} staat een eigen scan in Documentcontrole.",
  "documentCheck.splitConfirm": "Knippen vóór pagina {{page}} van {{count}}? Vanaf daar wordt het een eigen scan in de rij, direct hierachter.",
  "documentCheck.split": "Geknipt: vanaf pagina {{page}} staat een eigen scan in de rij, direct hierachter.",
  "documentCheck.kb.merge": "Achter de vorige scan voegen",
  "documentCheck.kb.lookBack": "De vorige scan bekijken, en weer terug",
  "documentCheck.kb.split": "Knippen vóór de pagina op het scherm",
  // The pallet account (docs/scantafel.md §5)
  "nav.palletAccounts": "Palletadministratie",
  "palletAccounts.view.accounts": "Saldi",
  "palletAccounts.view.purchases": "Euro's gekocht",
  "palletAccounts.intro": "Per relatie het saldo van Euro, H1 en H3 uit de goedgekeurde palletcontroles en wat met de hand geboekt is. Een rij opent de mutaties.",
  "palletAccounts.purchases.intro": "Bij klanten van wie Willems de europallets van binnenkomende goederen koopt: binnengekomen min niet retour bij aflevering, per maand. Binnengekomen in Scoretrace staat niet in WLX: tik het aantal in voor je boekt.",
  "palletAccounts.role.principal": "Opdrachtgever",
  "palletAccounts.role.charter": "Charter",
  "palletAccounts.col.party": "Relatie",
  "palletAccounts.col.code": "Code",
  "palletAccounts.col.role": "Rol",
  "palletAccounts.col.agreement": "Afspraak",
  "palletAccounts.col.lastAt": "Laatste mutatie",
  "palletAccounts.col.mutations": "Mutaties",
  "palletAccounts.col.date": "Datum",
  "palletAccounts.col.kind": "Soort",
  "palletAccounts.col.quantity": "Aantal",
  "palletAccounts.col.balance": "Saldo",
  "palletAccounts.col.reason": "Reden",
  "palletAccounts.col.stop": "Stop",
  "palletAccounts.col.consignment": "Zending",
  "palletAccounts.col.trip": "Rit",
  "palletAccounts.col.evidence": "Bewijs",
  "palletAccounts.col.note": "Opmerking",
  "palletAccounts.col.settlement": "Tekort",
  "palletAccounts.col.by": "Door",
  "palletAccounts.agreement.title": "Afspraak",
  "palletAccounts.agreement.edit": "Wijzigen",
  "palletAccounts.agreement.none": "Ruilt niet",
  "palletAccounts.agreement.all": "Ruilt Euro, H1 en H3",
  "palletAccounts.agreement.some": "Ruilt alleen {{kinds}}",
  "palletAccounts.agreement.default": "geen eigen afspraak",
  "palletAccounts.agreement.buys": "koopt euro's",
  "palletAccounts.agreement.buysLong": "Willems koopt de europallets waarop de goederen van deze klant binnenkomen",
  "palletAccounts.agreement.explain": "Wat de relatie afsprak, geldt voor de palletcontroles die vanaf nu goedgekeurd worden; wat al geboekt is, blijft staan.",
  "palletAccounts.agreement.exchanges": "Ruilt pallets",
  "palletAccounts.onlyOpen": "Alleen met een saldo",
  "palletAccounts.sign": "+ is wat de relatie Willems schuldig is, − wat Willems de relatie schuldig is.",
  "palletAccounts.empty": "Nog geen palletrekening: die begint bij de eerste goedgekeurde palletcontrole of een mutatie met de hand.",
  "palletAccounts.emptyOpen": "Geen relatie met een saldo. Zet het vinkje uit om alles te zien.",
  "palletAccounts.noMutations": "Nog geen mutaties.",
  "palletAccounts.notFound": "Deze relatie is niet gevonden.",
  "palletAccounts.bySystem": "WLX",
  "palletAccounts.toAccount": "Naar de palletadministratie",
  "palletAccounts.onPartyCard": "Palletadministratie",
  "palletAccounts.balanceAsPrincipal": "Saldo als opdrachtgever",
  "palletAccounts.balanceAsCharter": "Saldo als charter (in te leveren)",
  "palletAccounts.purchases.month": "Maand",
  "palletAccounts.purchases.inbound": "Binnengekomen",
  "palletAccounts.purchases.notReturned": "Niet retour",
  "palletAccounts.purchases.proposed": "Gekocht",
  "palletAccounts.purchases.booked": "Geboekt",
  "palletAccounts.purchases.book": "Boeken",
  "palletAccounts.purchases.bookedOn": "op {{date}}",
  "palletAccounts.purchases.empty": "Geen klant van wie Willems de europallets koopt. Zet het in de afspraak op de palletrekening van de klant.",
  "palletAccounts.purchases.confirm": "{{quantity}} euro's van {{party}} boeken als gekocht in {{month}}?",
  "palletAccounts.reason.check": "Palletcontrole",
  "palletAccounts.reason.check_correction": "Palletcontrole, opnieuw goedgekeurd",
  "palletAccounts.reason.pallet_slip": "Palletbon",
  "palletAccounts.reason.correction": "Correctie",
  "palletAccounts.reason.purchased": "Gekocht",
  "palletAccounts.reason.charged": "Doorbelast",
  "palletAccounts.reason.opening_balance": "Beginsaldo",
  "palletAccounts.settlement.charge": "Doorbelasten",
  "palletAccounts.settlement.keep": "Laten staan",
  "palletAccounts.settlement.open": "Nog te kiezen",
  "palletAccounts.settlement.undo": "Ongedaan maken",
  "palletAccounts.evidence.cmr": "Getekende CMR",
  "palletAccounts.add.open": "Mutatie toevoegen",
  "palletAccounts.add.title": "Mutatie met de hand",
  "palletAccounts.add.submit": "Boeken",
  "palletAccounts.add.amount": "Aantal",
  "palletAccounts.add.amountRequired": "Vul een aantal in, groter dan 0.",
  "palletAccounts.add.noteRequired": "Een correctie zegt waarom: vul de opmerking in.",
  "palletAccounts.add.direction.less": "{{party}} leverde in, of Willems is meer schuldig (−)",
  "palletAccounts.add.direction.owes": "{{party}} kreeg pallets mee, of is Willems meer schuldig (+)",
  "palletAccounts.add.notePlaceholder": "Bonnummer, wat er gebeurde",
  "palletAccounts.add.attach": "Palletbon toevoegen",
  "palletAccounts.add.attachHint": "Een pdf of een foto, tot 10 MB",
  "perm.row.palletAccounts": "Palletadministratie boeken",
  "perm.hint.palletAccounts": "Mutaties met de hand, tekorten doorbelasten, afspraken per relatie, en een charterfactuur vrijgeven met open pallets. Bekijken mag wie orders mag lezen.",
  "perm.row.orderIntake": "Orderintake",
  "perm.row.carryOver": "Hager doorzetten",
  "perm.hint.carryOver": "Transport → Doorzetten: wat van Hager de dag vóór het lossen niet binnen is gescand, naar de volgende leverdag zetten. Beheerders hebben het vanzelf.",
  "perm.hint.orderIntake": "De orderintake: mails erheen zetten, de orderintake op een tweede scherm, en orders uit een tabel of met een voorstel van AI. De ordermail per klant maakt en wijzigt alleen een beheerder, op de relatiekaart. Vraagt ook orders invoeren.",
  "purchaseInvoices.problem.pallets_not_returned": "Pallets niet ingeleverd: de charter heeft nog pallets in te leveren, en dan gaat de factuur niet naar AFAS.",
  "purchaseInvoices.pallets.held": "Pallets niet ingeleverd: {{balance}}. De factuur gaat niet naar AFAS tot de charter ze inleverde.",
  "purchaseInvoices.pallets.released": "Vrijgegeven door {{who}} op {{when}}, met nog {{balance}} in te leveren.",
  "purchaseInvoices.pallets.toAccount": "Palletadministratie",
  "purchaseInvoices.pallets.release": "Toch vrijgeven",
  "purchaseInvoices.pallets.hold": "Weer tegenhouden",
} as const;
